
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3B1VX", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var Text = /** @class */ function(_super) {
    __extends(Text, _super);
    function Text(ref, transform) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "span", ref) || this;
        _this.transform = transform;
        _this.defaultText = "";
        _this.Refresh();
        return _this;
    }
    Text.prototype.DefaultText = function(text) {
        this.defaultText = text;
        this.SetText();
        return this;
    };
    Text.prototype.SetText = function() {
        var _a, _b;
        var text = (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.call(this, this.ref.value)) !== null && _b !== void 0 ? _b : this.ref.value != null ? String(this.ref.value) : "";
        if (this.defaultText != "" && text === "") text = this.defaultText;
        this.Text(text);
    };
    Text.prototype.Refresh = function() {
        this.SetText();
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    Text.Name = "Text";
    return Text;
}($k6KGm.RefComponentBase);
exports.Text = Text;

});
parcelRegister("k6KGm", function(module, exports) {
"use strict";
var $ea389448cd545331$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefComponentBase = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $ea389448cd545331$var$RefComponentBase = /** @class */ function(_super) {
    $ea389448cd545331$var$__extends(RefComponentBase, _super);
    function RefComponentBase(baseElement, ref) {
        var _this = _super.call(this, baseElement) || this;
        _this.ref = ref;
        _this.showThatChanged = RefComponentBase.ShowThatChanged;
        _this.IsRefComponent = true;
        if (ref) ref.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(RefComponentBase.prototype, "Value", {
        get: function() {
            if (!this.ref) return undefined;
            return this.ref.value;
        },
        set: function(value) {
            if (!this.ref) return;
            this.ref.value = value;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.SetValue = function(value) {
        if (!value) return this;
        if (!this.ref) return this;
        this.ref.value = value;
        return this;
    };
    Object.defineProperty(RefComponentBase.prototype, "Ref", {
        get: function() {
            return this.ref;
        },
        enumerable: false,
        configurable: true
    });
    RefComponentBase.prototype.ShowThatChanged = function(showOrNot) {
        if (showOrNot === void 0) showOrNot = true;
        this.showThatChanged = showOrNot;
        return this;
    };
    RefComponentBase.prototype.Dispose = function() {
        var _a;
        (_a = this.ref) === null || _a === void 0 || _a.RemoveControl(this);
    };
    RefComponentBase.ShowThatChanged = false;
    return RefComponentBase;
}($aKtiT.ComponentBase);
module.exports.RefComponentBase = $ea389448cd545331$var$RefComponentBase;

});
parcelRegister("aKtiT", function(module, exports) {
"use strict";
var $7d34ee63d945b320$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7d34ee63d945b320$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentBase = void 0;

var $6wI3m = parcelRequire("6wI3m");
parcelRequire("fg7nO");

var $8lUZH = parcelRequire("8lUZH");

var $5uACL = parcelRequire("5uACL");
var $7d34ee63d945b320$var$ComponentBase = /** @class */ function() {
    function ComponentBase(baseElement) {
        this.baseElement = baseElement;
        this.id = -1;
        this.Name = "";
        this.IsRefComponent = false; // TODO: xxx
        this.Children = new $8lUZH.ChildrenCollection(this);
        this.displayAs = "";
        this.toggableStyles = {};
        this.isVisible = true;
        ComponentBase.Id += 1;
        this.id = ComponentBase.Id;
        this.element = ComponentBase.Create(baseElement);
        this.events = new $5uACL.EventsContainer(this.element);
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
    }
    ComponentBase.prototype.toString = function() {
        var _a;
        return "".concat(this.ID, ": parent=").concat((_a = this.Parent) === null || _a === void 0 ? void 0 : _a.ID, ", children=").concat(this.Children.toString());
    };
    Object.defineProperty(ComponentBase.prototype, "ID", {
        get: function() {
            return "[#".concat(this.id, ":").concat(this.baseElement).concat(this.Name ? ":" + this.Name : "").concat(this.IsRefComponent ? "(REF)" : "", "]");
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.LOG = function(str) {
        if (ComponentBase.LogEn) console.log(str);
    };
    ComponentBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    //#endregion
    //#region CORE
    ComponentBase.prototype.React = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Reacts = function(valueOrRef, callback) {
        if (valueOrRef == undefined) return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof Array) {
            var values_1 = [];
            valueOrRef.forEach(function(r, i) {
                values_1.push(r.value);
                r.OnChange(function(v) {
                    values_1[i] = v;
                    callback.apply(void 0, values_1);
                });
            });
            callback.apply(void 0, values_1);
        } else if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    ComponentBase.prototype.Clear = function() {
        var _this = this;
        this.Children.Clone.forEach(function(c) {
            _this.Remove(c);
        });
        return this;
    };
    ComponentBase.prototype.Dispose = function() {
    // this.LOG(`💥 Disposing ${this.ID}...`);
    };
    ComponentBase.prototype.Remove = function(component) {
        var _a;
        if (!component) throw new Error("Parameter is mandatory");
        // this.LOG(`➖ Removing ${component.ID} from ${this.ID} (children: ${this.Children.map(x=>"#"+x.Id)})...`);
        this.LOG("\u2796 ".concat(this.ID, " -= ").concat(component.ID));
        if (!this.Children.Has(component)) throw new Error("This is not your (".concat(this.ID, ") kid (").concat(component.ID, ")"));
        (_a = component.OnRemove) === null || _a === void 0 || _a.call(component); // czemu to jest jeszcze przed usunięciem a nie po?
        component.Children.Clone.forEach(function(c) {
            component.Remove(c);
        });
        if (this.Children.Remove(component)) {
            component.Dispose();
            this.element.Remove(component.element);
        }
        return this;
    };
    ComponentBase.prototype.AddComponent = function(component) {
        if (!component) throw new Error("[TRUFFLE] Parameter/component to add is mandatory (Forget return 'this' from your component method?)");
        if (component == this) throw new Error("[TRUFFLE] You can't be child of yourself");
        if (this.Children.Has(component)) throw new Error("[TRUFFLE] ".concat(component.ID, " was already added to ").concat(this.ID));
        component.Parent = this;
        // this.LOG(`➕ ${this.ID} += ${component.ID}`);
        this.Children.Add(component);
    };
    ComponentBase.prototype.Prepend = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_1 = str.split("\n");
                if (splitted_1.length > 1) splitted_1.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                    // Put NewLine (<br>) between strings except last one
                    if (i != splitted_1.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Prepend(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Prepend(span.Element);
                }
            } else {
                _this.AddComponent(component); // AddChild?
                _this.element.Prepend(component.Element);
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    // public Append(...components: (string | boolean | number | undefined | null | ComponentBase<HTMLElement>)[]): this
    ComponentBase.prototype.Append = function() {
        var _this = this;
        var components = [];
        for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
        components.forEach(function(component) {
            var _a;
            if (component == undefined || component == null) ;
            else if (typeof component == "boolean") ;
            else if (typeof component == "number") {
                var num = component;
                var span = new ComponentBase("span");
                span.Text(num.toString());
                _this.AddComponent(span);
                _this.element.Append(span.Element);
            } else if (typeof component == "string") {
                var str = component;
                var splitted_2 = str.split("\n");
                if (splitted_2.length > 1) splitted_2.forEach(function(s, i) {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(s);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                    // Put NewLine between strings except last one
                    if (i != splitted_2.length - 1) {
                        // We can't use NewLine (<br>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                        var br = new ComponentBase("br");
                        _this.AddComponent(br);
                        _this.element.Append(br.Element);
                    }
                });
                else {
                    // We can't use Span (<span>) component here (because it derives from this ComponentBase) so we need to create it on the fly
                    var span = new ComponentBase("span");
                    span.Text(str);
                    _this.AddComponent(span);
                    _this.element.Append(span.Element);
                }
            } else {
                _this.AddComponent(component);
                _this.element.Append(component.Element);
                if (_this.element instanceof HTMLElement) {
                    var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(_this.element);
                    _this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
                }
                (_a = component.OnAppend) === null || _a === void 0 || _a.call(component);
            }
        });
        return this;
    };
    ComponentBase.prototype.LoadContent = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        return (_a = this.Clear()).Append.apply(_a, content);
    };
    ComponentBase.prototype.RemoveSelf = function() {
        var _a, _b, _c;
        if ((_b = (_a = this.Parent) === null || _a === void 0 ? void 0 : _a.Children) === null || _b === void 0 ? void 0 : _b.Has(this)) (_c = this.Parent) === null || _c === void 0 || _c.Remove(this);
        return this;
    };
    ComponentBase.prototype.SearchUp = function(predicate) {
        var p = this.Parent;
        if (p == undefined) return undefined;
        while(!predicate(p)){
            p = p === null || p === void 0 ? void 0 : p.Parent;
            if (p == undefined) return undefined;
        }
        return p;
    };
    ComponentBase.prototype.SearchDown = function(predicate) {
        return this.Children.Search(predicate);
    };
    Object.defineProperty(ComponentBase.prototype, "HasAnyChildren", {
        get: function() {
            return this.Children.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentBase.prototype, "Element", {
        get: function() {
            return this.element;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.Create = function(htmlElement) {
        return document.createElement(htmlElement);
    };
    ComponentBase.prototype.DisplayAs = function(as) {
        this.displayAs = as;
        return this;
    };
    //#endregion CORE
    //#region STYLING-ATTRIBUTES
    ComponentBase.prototype.Attribute = function(key, value) {
        var _this = this;
        if (!key) return this;
        if (!value) {
            this.element.setAttribute(key, "");
            return this;
        }
        this.React(value, function(v) {
            return _this.element.setAttribute(key, v || "");
        });
        return this;
    };
    ComponentBase.prototype.GetAttribute = function(key) {
        return this.element.getAttribute(key);
    };
    ComponentBase.prototype.RemoveAttribute = function(key) {
        this.element.removeAttribute(key);
        return this;
    };
    ComponentBase.prototype.TestAttr = function(id) {
        return this.Attribute('data-test', id);
    };
    ComponentBase.prototype.SetStyle = function(property, value, postfix) {
        var _this = this;
        if (postfix === void 0) postfix = "";
        this.React(value, function(v) {
            return _this.SetSingleStyle(property, v.toString() + postfix);
        });
        return this;
    };
    //#endregion
    //#region STYLING-CLASS
    ComponentBase.prototype.Class = function(cssClassesToAdd) {
        var _this = this;
        this.React(cssClassesToAdd, function(v) {
            return v.split(" ").filter(function(x) {
                return x.length > 0;
            }).forEach(function(c) {
                return _this.element.classList.add(c);
            });
        });
        return this;
    };
    ComponentBase.prototype.RemoveAllClasses = function() {
        while(this.element.classList.length > 0)this.element.classList.remove(this.element.classList.item(0) || "");
        return this;
    };
    ComponentBase.prototype.RemoveClass = function(cssClassName) {
        if (cssClassName) this.element.classList.remove(cssClassName);
        return this;
    };
    // TODO: remove
    ComponentBase.prototype.AddClass = function(cssClassName) {
        if (cssClassName) this.element.classList.add(cssClassName);
        return this;
    };
    ComponentBase.prototype.ToggleClasses = function(classA, classB) {
        if (this.element.classList.contains(classA)) {
            this.element.classList.remove(classA);
            this.element.classList.add(classB);
        } else {
            this.element.classList.remove(classB);
            this.element.classList.add(classA);
        }
        return this;
    };
    //#endregion
    //#region STYLING-UTILS
    ComponentBase.prototype.Style = function(propertyOrCss, val) {
        var _this = this;
        if (!propertyOrCss) return this;
        else if (propertyOrCss instanceof $6wI3m.Ref) propertyOrCss.OnChange(function(v) {
            v.split(";").map(function(x) {
                return x.trim();
            }).forEach(function(x) {
                return _this.SetSingleStyle(x);
            });
        }, true);
        else if (propertyOrCss.includes(";")) propertyOrCss.split(";").map(function(x) {
            return x.trim();
        }).forEach(function(x) {
            return _this.SetSingleStyle(x);
        });
        else this.SetSingleStyle(propertyOrCss, val);
        return this;
    };
    ComponentBase.prototype.SetSingleStyle = function(propertyOrCss, val) {
        if (val !== undefined) this.element.style[propertyOrCss] = val;
        else {
            var _a = propertyOrCss.split(":").map(function(x) {
                return x.trim();
            }), key = _a[0], value = _a[1];
            this.element.style[key] = value;
        }
        return this;
    };
    ComponentBase.prototype.ApplyStyle = function(val, is, property, value, elseValue, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            v == is ? _this.Style(property, value) : _this.Style(property, elseValue);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ApplyClass = function(val, predicate, className, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        val.OnChange(function(v) {
            predicate(v, val, _this) ? _this.AddClass(className) : _this.RemoveClass(className);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.When = function(ref, predicate, whenTrue, whenFalse, callRightaway) {
        var _this = this;
        if (callRightaway === void 0) callRightaway = true;
        ref.OnChange(function(v) {
            predicate(v, ref, _this) ? whenTrue(_this, ref) : whenFalse === null || whenFalse === void 0 || whenFalse(_this, ref);
        }, callRightaway);
        return this;
    };
    ComponentBase.prototype.ToggleStyle = function(prop, val, elseVal) {
        /* COMPUTED VALUE IS COMPLETELY DIFFERENT FROM SET. THAT'S WHY. */ if (this.toggableStyles[prop] !== val) this.toggableStyles[prop] = val;
        else this.toggableStyles[prop] = elseVal;
        this.element.style[prop] = this.toggableStyles[prop];
        return this;
    };
    //#endregion
    //#region STYLING-MISC
    ComponentBase.prototype.Cursor = function(cursor) {
        this.element.style.cursor = cursor;
        return this;
    };
    ComponentBase.prototype.CursorPointer = function() {
        return this.Cursor("pointer");
    };
    ComponentBase.prototype.CursorDefault = function() {
        return this.Cursor("default");
    };
    ComponentBase.prototype.Focus = function() {
        this.element.Focus();
        return this;
    };
    ComponentBase.prototype.ScrollToBottom = function() {
        this.element.scrollTop = this.element.scrollHeight;
        return this;
    };
    //#endregion
    //#region STYLING-VISUAL
    ComponentBase.prototype.ZIndex = function(index) {
        return this.SetStyle("zIndex", index);
    };
    ComponentBase.prototype.Opacity = function(opacity) {
        return this.SetStyle("opacity", opacity);
    };
    ComponentBase.prototype.Blur = function(value, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(value, function(v) {
            return _this.SetSingleStyle("filter: blur(".concat(value).concat(unit, ")"));
        });
        return this;
    };
    //#endregion
    //#region STYLING-TEXT
    ComponentBase.prototype.Bold = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-weight", "bold") : _this.SetSingleStyle("font-weight", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontBold = function(enable) {
        if (enable === void 0) enable = true;
        return this.Bold(enable);
    };
    ComponentBase.prototype.Normal = function(enable) {
        if (enable === void 0) enable = true;
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontNormal = function() {
        return this.Style("font-weight: normal; font-style: normal");
    };
    ComponentBase.prototype.FontWeight = function(value) {
        return this.SetStyle("font-weight", value);
    };
    ComponentBase.prototype.FontWeightNormal = function() {
        return this.Style("font-weight", "normal");
    };
    ComponentBase.prototype.FontWeightBold = function() {
        return this.Style("font-weight", "bold");
    };
    ComponentBase.prototype.Italic = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        this.React(enable, function(v) {
            return v ? _this.SetSingleStyle("font-style", "italic") : _this.SetSingleStyle("font-style", "normal");
        });
        return this;
    };
    ComponentBase.prototype.FontItalic = function(enable) {
        if (enable === void 0) enable = true;
        return this.Italic(enable);
    };
    ComponentBase.prototype.FontSize = function(size, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("font-size", size, unit);
    };
    ComponentBase.prototype.TextAlign = function(align) {
        return this.SetStyle('text-align', align);
    };
    ComponentBase.prototype.TextAlignLeft = function() {
        this.element.style.textAlign = "left";
        return this;
    };
    ComponentBase.prototype.TextAlignRight = function() {
        this.element.style.textAlign = "right";
        return this;
    };
    ComponentBase.prototype.TextAlignCenter = function() {
        this.element.style.textAlign = "center";
        return this;
    };
    //#endregion STYLING-TEXT
    //#region STYLING-POSITION
    ComponentBase.prototype.Position = function(position) {
        this.element.style.position = position;
        return this;
    };
    ComponentBase.prototype.PositionAbsolute = function() {
        this.element.style.position = "absolute";
        return this;
    };
    ComponentBase.prototype.PositionRelative = function() {
        this.element.style.position = "relative";
        return this;
    };
    ComponentBase.prototype.PositionFixed = function() {
        this.element.style.position = "fixed";
        return this;
    };
    ComponentBase.prototype.Left = function(left, unit) {
        var _this = this;
        if (left === void 0) left = 0;
        if (unit === void 0) unit = "px";
        this.React(left, function(v) {
            return _this.element.style.left = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.LeftPercent = function(left) {
        var _this = this;
        if (left === void 0) left = 0;
        this.React(left, function(v) {
            return _this.Left(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Right = function(right, unit) {
        var _this = this;
        if (right === void 0) right = 0;
        if (unit === void 0) unit = "px";
        this.React(right, function(v) {
            return _this.element.style.right = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.RightPercent = function(right) {
        var _this = this;
        if (right === void 0) right = 0;
        this.React(right, function(v) {
            return _this.Right(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Top = function(top, unit) {
        var _this = this;
        if (top === void 0) top = 0;
        if (unit === void 0) unit = "px";
        this.React(top, function(v) {
            return _this.element.style.top = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.TopPercent = function(top) {
        var _this = this;
        if (top === void 0) top = 0;
        this.React(top, function(v) {
            return _this.Top(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.Bottom = function(bottom, unit) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        if (unit === void 0) unit = "px";
        this.React(bottom, function(v) {
            return _this.element.style.bottom = v + unit;
        });
        return this;
    };
    ComponentBase.prototype.BottomPercent = function(bottom) {
        var _this = this;
        if (bottom === void 0) bottom = 0;
        this.React(bottom, function(v) {
            return _this.Bottom(v, "%");
        });
        return this;
    };
    ComponentBase.prototype.FloatLeft = function() {
        this.element.style.float = "left";
        return this;
    };
    ComponentBase.prototype.FloatRight = function() {
        this.element.style.float = "right";
        return this;
    };
    ComponentBase.prototype.ClearBoth = function() {
        this.element.style.clear = "both";
        return this;
    };
    ComponentBase.prototype.ClearLeft = function() {
        this.element.style.clear = "left";
        return this;
    };
    ComponentBase.prototype.ClearRight = function() {
        this.element.style.clear = "right";
        return this;
    };
    //#endregion STYLING-POSITION
    //#region STYLING-DISPLAY
    ComponentBase.prototype.Display = function(as) {
        return this.SetSingleStyle("display: " + as);
    };
    ComponentBase.prototype.Inline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.DisplayInline = function() {
        return this.SetSingleStyle("display: inline");
    };
    ComponentBase.prototype.Block = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.DisplayBlock = function() {
        return this.SetSingleStyle("display: block");
    };
    ComponentBase.prototype.InlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    ComponentBase.prototype.DisplayInlineBlock = function() {
        return this.SetSingleStyle("display: inline-block");
    };
    //#endregion STYLING-DISPLAY
    //#region STYLING-BORDER
    ComponentBase.prototype.Border = function(width, color, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (radius === void 0) radius = 0;
        this.Style("border: ".concat(width, "px solid ").concat(color, "; border-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderNone = function() {
        this.Style("border: none");
        return this;
    };
    ComponentBase.prototype.BorderStyling = function(edge, width, color, radius, style) {
        if (radius === void 0) radius = 0;
        if (style === void 0) style = "solid";
        this.Style("border-".concat(edge, ": ").concat(width, "px ").concat(style, " ").concat(color, "; border-").concat(edge, "-radius: ").concat(radius, "px"));
        return this;
    };
    ComponentBase.prototype.BorderBottom = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("bottom", width, color, radius, style);
    };
    ComponentBase.prototype.BorderTop = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("top", width, color, radius, style);
    };
    ComponentBase.prototype.BorderLeft = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("left", width, color, radius, style);
    };
    ComponentBase.prototype.BorderRight = function(width, color, style, radius) {
        if (width === void 0) width = 1;
        if (color === void 0) color = "#888";
        if (style === void 0) style = "solid";
        if (radius === void 0) radius = 0;
        return this.BorderStyling("right", width, color, radius, style);
    };
    ComponentBase.prototype.BorderWidth = function(width, unit) {
        var _this = this;
        if (unit === void 0) unit = "px";
        this.React(width, function(v) {
            return _this.Style("border-width: ".concat(v).concat(unit));
        });
        return this;
    };
    ComponentBase.prototype.BorderColor = function(color) {
        var _this = this;
        this.React(color, function(v) {
            return _this.Style("border-color: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyle = function(style) {
        var _this = this;
        this.React(style, function(v) {
            return _this.Style("border-style: ".concat(v));
        });
        return this;
    };
    ComponentBase.prototype.BorderStyleSolid = function() {
        return this.BorderStyle("solid");
    };
    ComponentBase.prototype.BorderStyleDotted = function() {
        return this.BorderStyle("dotted");
    };
    ComponentBase.prototype.BorderStyleDashed = function() {
        return this.BorderStyle("dashed");
    };
    ComponentBase.prototype.BorderRadius = function(radius, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle('borderRadius', radius, unit);
    };
    //#endregion STYLING-BORDER
    //#region STYLING-SIZE
    ComponentBase.prototype.Width = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("width", val, unit);
    };
    ComponentBase.prototype.WidthPercent = function(val) {
        return this.SetStyle("width", val, "%");
    };
    ComponentBase.prototype.WidthAuto = function() {
        this.element.style.width = "auto";
        return this;
    };
    ComponentBase.prototype.HalfWidth = function() {
        this.element.style.width = "50%";
        return this;
    };
    ComponentBase.prototype.FullWidth = function() {
        this.element.style.width = "100%";
        return this;
    };
    ComponentBase.prototype.Height = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("height", val, unit);
    };
    ComponentBase.prototype.HeightPercent = function(val) {
        return this.SetStyle("height", val, "%");
    };
    ComponentBase.prototype.HeightAuto = function() {
        this.element.style.height = "auto";
        return this;
    };
    ComponentBase.prototype.MaxWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MinWidth = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minWidth = val + unit;
        return this;
    };
    ComponentBase.prototype.MaxHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.maxHeight = val + unit;
        return this;
    };
    ComponentBase.prototype.MinHeight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.minHeight = val + unit;
        return this;
    };
    //#endregion STYLING-SIZE
    //#region STYLING-MARGIN
    ComponentBase.prototype.Margin = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("margin", val, unit);
    };
    ComponentBase.prototype.MarginAuto = function() {
        this.element.style.margin = "auto";
        return this;
    };
    ComponentBase.prototype.MarginTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginTop", val, unit);
    };
    ComponentBase.prototype.MarginBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginBottom", val, unit);
    };
    ComponentBase.prototype.MarginTopBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginTop = val + unit;
        this.element.style.marginBottom = val + unit;
        return this;
    };
    ComponentBase.prototype.MarginLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginLeft", val, unit);
    };
    ComponentBase.prototype.MarginRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("marginRight", val, unit);
    };
    ComponentBase.prototype.MarginLeftRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        this.element.style.marginLeft = val + unit;
        this.element.style.marginRight = val + unit;
        return this;
    };
    //#endregion STYLING-MARGIN
    //#region STYLING-COLORS
    ComponentBase.prototype.Color = function(color) {
        return this.SetStyle("color", color);
    };
    ComponentBase.prototype.Background = function(color) {
        return this.SetStyle("background", color);
    };
    //#endregion STYLING-COLORS
    //#region STYLING-PADDING
    ComponentBase.prototype.Padding = function(val, secondVal) {
        if (!secondVal) this.SetStyle("padding", val, "px");
        else this.element.style.padding = "".concat(val, "px ").concat(secondVal, "px");
        return this;
    };
    ComponentBase.prototype.PaddingLeft = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingLeft", val, unit);
    };
    ComponentBase.prototype.PaddingRight = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingRight", val, unit);
    };
    ComponentBase.prototype.PaddingTop = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingTop", val, unit);
    };
    ComponentBase.prototype.PaddingBottom = function(val, unit) {
        if (unit === void 0) unit = "px";
        return this.SetStyle("paddingBottom", val, unit);
    };
    //#endregion STYLING-PADDING
    //#region STYLING-OVERFLOW
    ComponentBase.prototype.OverflowX = function(val) {
        this.element.style.overflowX = val;
        return this;
    };
    ComponentBase.prototype.OverflowY = function(val) {
        this.element.style.overflowY = val;
        return this;
    };
    ComponentBase.prototype.OverflowYScroll = function() {
        return this.OverflowY("scroll");
    };
    //#endregion STYLING-OVERFLOW
    //#region PROPS
    ComponentBase.prototype.Id = function(id) {
        return this.Attribute("id", id);
    };
    ComponentBase.prototype.Text = function(text) {
        var _this = this;
        this.React(text, function(v) {
            return _this.element.innerText = v;
        });
        return this;
    };
    ComponentBase.prototype.GetText = function() {
        return this.element.innerText;
    };
    ComponentBase.prototype.Html = function(html) {
        var _this = this;
        this.React(html, function(v) {
            return _this.element.innerHTML = v;
        });
        return this;
    };
    ComponentBase.prototype.GetHtml = function() {
        return this.element.innerHTML;
    };
    ComponentBase.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.RemoveAttribute("disabled") : _this.Attribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.EnableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Enable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.DisableWhen = function(toWatch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return _this.Disable(predicate.apply(void 0, vals));
        });
        return this;
    };
    ComponentBase.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Attribute("disabled") : _this.RemoveAttribute("disabled");
        });
        return this;
    };
    ComponentBase.prototype.Enabled = function() {
        return this.Enable(true);
    };
    ComponentBase.prototype.Disabled = function() {
        return this.Enable(false);
    };
    Object.defineProperty(ComponentBase.prototype, "Events", {
        get: function() {
            return this.events;
        },
        enumerable: false,
        configurable: true
    });
    ComponentBase.prototype.On = function(event, handler) {
        this.events.Add(event, handler);
        return this;
    };
    ComponentBase.prototype.Off = function(event) {
        this.events.Off(event);
        return this;
    };
    ComponentBase.prototype.CallEvent = function(event) {
        this.events.Call(event);
        return this;
    };
    ComponentBase.prototype.OnClick = function(handler, preventDefault, stopPropagation) {
        var _this = this;
        if (preventDefault === void 0) preventDefault = true;
        if (stopPropagation === void 0) stopPropagation = true;
        this.On('click', function(e) {
            if (e) {
                if (preventDefault) e.preventDefault();
                if (stopPropagation) e.stopPropagation();
            }
            handler(_this, e);
        });
        return this;
    };
    ComponentBase.prototype.OffClick = function() {
        this.Off('click');
        return this;
    };
    ComponentBase.prototype.Click = function() {
        this.events.Call('click');
        return this;
    };
    ComponentBase.prototype.ClickAsync = function() {
        return $7d34ee63d945b320$var$__awaiter(this, void 0, void 0, function() {
            return $7d34ee63d945b320$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.events.CallAsync('click')
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ComponentBase.prototype.OnHover = function(handler) {
        var _this = this;
        return this.On('mouseover', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnMouseOut = function(handler) {
        var _this = this;
        return this.On('mouseout', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnRightClick = function(handler) {
        var _this = this;
        this.On('contextmenu', function(e) {
            e.preventDefault();
            handler(_this);
        });
        return this;
    };
    ComponentBase.prototype.OnFocus = function(handler) {
        var _this = this;
        return this.On('focus', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnBlur = function(handler) {
        var _this = this;
        return this.On('blur', function() {
            return handler(_this);
        });
    };
    ComponentBase.prototype.OnEnterKeyPressed = function(handler) {
        var _this = this;
        return this.On('keyup', function(ke) {
            if (ke.key === "Enter") handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyUp = function(handler) {
        var _this = this;
        return this.On('keyup', function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyDown = function(handler) {
        var _this = this;
        return this.On('keydown', function(ke) {
            return handler(_this, ke);
        });
    };
    ComponentBase.prototype.OnKeyPress = function(handler) {
        var _this = this;
        return this.On('keypress', function(ke) {
            return handler(_this, ke);
        });
    };
    //#endregion EVENTS
    //#region VISIBILITY
    ComponentBase.prototype.Exist = function(component) {
        return this.element.Exist(component.Element);
    };
    ComponentBase.prototype.Visible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.Invisible = function(toWatch, showAs) {
        var _this = this;
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return vals.every(function(v) {
                return v == true;
            }) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.VisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Show(showAs) : _this.Hide();
        });
        return this;
    };
    ComponentBase.prototype.InvisibleWhen = function(toWatch, predicate, showAs) {
        var _this = this;
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        if (showAs === void 0) showAs = "inline-block";
        this.Reacts(toWatch, function() {
            var vals = [];
            for(var _i = 0; _i < arguments.length; _i++)vals[_i] = arguments[_i];
            return predicate.apply(void 0, vals) ? _this.Hide() : _this.Show(showAs);
        });
        return this;
    };
    ComponentBase.prototype.Hide = function() {
        var _a;
        if (this.element instanceof HTMLElement) {
            var style = window === null || window === void 0 ? void 0 : window.getComputedStyle(this.element);
            if ((style === null || style === void 0 ? void 0 : style.display) && (style === null || style === void 0 ? void 0 : style.display) != "none") this.displayAs = (style === null || style === void 0 ? void 0 : style.display) || "";
        }
        (_a = this.OnHide) === null || _a === void 0 || _a.call(this);
        this.element.Hide();
        this.isVisible = false;
        return this;
    };
    ComponentBase.prototype.IsVisible = function() {
        return this.isVisible;
    // return this.element.IsVisible();
    };
    // private showAs;
    ComponentBase.prototype.Show = function(as) {
        var _a;
        if (as === void 0) as = this.displayAs || "block";
        // this.showAs = as;
        // console.log(as, ' on show');
        this.isVisible = true;
        // this.element.Show(as);
        this.element.Show(as);
        (_a = this.OnShow) === null || _a === void 0 || _a.call(this);
        return this;
    };
    ComponentBase.prototype.Toggle = function(as) {
        // if (as)
        //     this.showAs = as;
        // this.isVisible = !this.isVisible;
        this.isVisible ? this.Hide() : this.Show();
        // this.isVisible ? this.Hide() : this.Show(this.showAs)
        // this.element.Toggle();
        return this;
    };
    //#region LOGS
    ComponentBase.LogEn = false;
    ComponentBase.Id = 0;
    return ComponentBase;
}();
module.exports.ComponentBase = $7d34ee63d945b320$var$ComponentBase;

});
parcelRegister("6wI3m", function(module, exports) {
"use strict";
var $4c07e745af36d0f8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Ref = void 0;
parcelRequire("fg7nO");

var $22Wrn = parcelRequire("22Wrn");
var $4c07e745af36d0f8$var$Ref = /** @class */ function(_super) {
    $4c07e745af36d0f8$var$__extends(Ref, _super);
    function Ref(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this.initialValue = _value;
        return _this;
    }
    Ref.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        this.OnChange(function(v) {
            return stor.setItem(key, v.toString());
        });
        var valueInStorage = stor.getItem(key);
        if (!valueInStorage) return this;
        if (this._value instanceof Date) this.Set(new Date(valueInStorage || this._value || 0));
        else if (typeof this._value == "string") this.Set(valueInStorage || this._value || "");
        else if (typeof this._value == "number") this.Set(+(valueInStorage || 0) || +this._value || 0);
        else if (typeof this._value == "boolean") switch(valueInStorage){
            case "true":
                this.Set(true);
                break;
            default:
            case null:
            case "":
            case "false":
                this.Set(false);
                break;
        }
        return this;
    };
    Ref.prototype.Compare = function(ref, valueOrRef, op) {
        if (valueOrRef instanceof Ref) return op(ref.value, valueOrRef.value);
        return op(ref.value, valueOrRef);
    };
    Ref.prototype.Is = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a == b;
        });
    };
    Ref.prototype.IsNot = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a != b;
        });
    };
    Object.defineProperty(Ref.prototype, "IsSet", {
        get: function() {
            if (this._value instanceof Date) return +this._value !== +this.ZeroValue;
            return this._value !== this.ZeroValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ref.prototype, "IsNotSet", {
        get: function() {
            return !this.IsSet;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsInitial = function() {
        return this.value == this.initialValue;
    };
    Ref.prototype.IsNotInitial = function() {
        return this.value != this.initialValue;
    };
    Object.defineProperty(Ref.prototype, "HasChanged", {
        get: function() {
            return this._value !== this.initialValue;
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.IsEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a === b;
        });
    };
    Ref.prototype.IsIn = function(values) {
        return values.includes(this.value);
    };
    Ref.prototype.IsNotEqual = function(value) {
        return this.value !== value;
    };
    Ref.prototype.Set = function(val, excludeControlForRefresh) {
        if (this.value === val) return false;
        this._value = val;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._value);
        return true;
    };
    Ref.prototype.SetValue = function(val) {
        if (val === undefined) return this;
        if (this.value === val) return this;
        this._value = val;
        this.RefreshSubscribers();
        // NOTICE: no onChangeHandler call
        return this;
    };
    Ref.prototype.SetTo = function(valueOrRef) {
        if (valueOrRef instanceof Ref) this.value = valueOrRef.value;
        else this.value = valueOrRef;
        return this;
    };
    Ref.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._value);
        return this;
    };
    Object.defineProperty(Ref.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(val) {
            this.Set(val);
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Restore = function() {
        this.value = this.initialValue;
        return this;
    };
    Ref.prototype.OverrideInitialValue = function(val) {
        this.initialValue = val;
        return this;
    };
    Ref.prototype.Initialize = function(val) {
        this.initialValue = val;
        this._value = val;
        return this;
    };
    Object.defineProperty(Ref.prototype, "ZeroValue", {
        get: function() {
            if (this._value instanceof Date) return new Date(0);
            else if (typeof this._value == "string") return "";
            else if (typeof this._value == "number") return 0; // TODO: 0? not infinity or something?
            else if (typeof this._value == "boolean") return false;
            throw new Error("No zero value for given type");
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.Clear = function() {
        if (typeof this._value == "string") this.Set("");
        else if (typeof this._value == "number") this.Set(0);
        else if (typeof this._value == "boolean") this.Set(false);
        else if (this._value instanceof Date) this.Set(new Date(0));
        return this;
    };
    Ref.prototype.ToString = function() {
        var _a, _b;
        // console.log('ttt');
        // return `${this._value?.toString()} [${this.watchers?.map(w=>w.Id)?.join(", ")}]`;
        // if (typeof this._value === "string")
        //     return `Ref<${typeof this._value}>#${this.Id}${this.Name ? ":" + this.Name : ""} = "${this._value}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "Date")
        // return `Ref<${typeof this._value}> = "${this._value?.toString()}" [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        // if (typeof this._value === "boolean")
        //     return `Ref<${typeof this._value}> = ${this._value?.toString() ? "true" : "false"} [${this.watchers?.map(w => w.Id)?.join(", ")}]`;
        // else
        return "Ref<".concat(typeof this._value, ">#").concat(this.Id).concat(this.Name ? ":" + this.Name : "", " = ").concat(this._value != null ? String(this._value) : "null", " [watchers: ").concat(((_b = (_a = this.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(w) {
            return w.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "none", "][").concat(this.onChangeHandler.Count, " subs]");
    };
    Ref.prototype.Combine = function(anotherRef, operation) {
        var _this = this;
        var result = new Ref(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    Ref.prototype.CombineValue = function(anotherValue, operation) {
        var result = new Ref(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    Ref.prototype.Mix = function(x, operation) {
        if (x instanceof Ref) return this.Combine(x, operation);
        else return this.CombineValue(x, operation);
    };
    return Ref;
}($22Wrn.RefBase);
module.exports.Ref = $4c07e745af36d0f8$var$Ref;

});
parcelRegister("fg7nO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Array.prototype.ToString = function() {
    var _a;
    return (_a = this.join(", ")) !== null && _a !== void 0 ? _a : "(empty)";
};
Array.prototype.Remove = function(item) {
    var index = this.indexOf(item);
    if (index >= 0) {
        this.splice(index, 1);
        return true;
    }
    return false;
};

});

parcelRegister("22Wrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBase = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");
var $17d919bca1bb95f0$var$RefBase = /** @class */ function() {
    function RefBase() {
        this.Id = -1;
        this.Name = "";
        this.onChangeHandler = new $8PO3e.HandlersCollection();
        this.watchers = new Set();
        $6wI3m.Ref.Id += 1;
        this.Id = $6wI3m.Ref.Id;
    }
    Object.defineProperty(RefBase.prototype, "OnChangeHandler", {
        get: function() {
            return this.onChangeHandler;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RefBase.prototype, "Watchers", {
        get: function() {
            return Array.from(this.watchers);
        },
        enumerable: false,
        configurable: true
    });
    RefBase.prototype.NameIt = function(name) {
        this.Name = name;
        return this;
    };
    RefBase.prototype.AddSubscriber = function(control) {
        this.watchers.add(control);
    };
    RefBase.prototype.RemoveControl = function(control) {
        this.watchers.delete(control);
    };
    RefBase.prototype.RefreshSubscribers = function(except) {
        for(var _i = 0, _a = this.Watchers; _i < _a.length; _i++){
            var watcher = _a[_i];
            if (watcher !== except) watcher.Refresh();
        }
    };
    RefBase.prototype.ClearHandlers = function() {
        this.onChangeHandler.Reset();
        return this;
    };
    RefBase.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._value, true);
        return this;
    };
    RefBase.Id = 0;
    return RefBase;
}();
module.exports.RefBase = $17d919bca1bb95f0$var$RefBase;

});
parcelRegister("8PO3e", function(module, exports) {
"use strict";
var $66e9e94085efdd7b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $66e9e94085efdd7b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HandlersCollection = void 0;
function $66e9e94085efdd7b$var$UniqueId() {
    return 'id-' + Math.floor(Math.random() * 1e16).toString(36);
}
var $66e9e94085efdd7b$var$HandlersCollection = /** @class */ function() {
    function HandlersCollection() {
        this.handlers = new Map();
        this.serializedHandlers = [];
        this.inOnHold = false;
    }
    HandlersCollection.prototype.Add = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        if (this.handlers.has(handlerId)) {
            console.warn("Handler with this id (".concat(handlerId, ") was already added"));
            return this;
        }
        if (handler) this.handlers.set(handlerId, handler);
        if (HandlersCollection.MANY_HANDLERS_WARNING && this.Count > HandlersCollection.MANY_HANDLERS_LIMIT) {
            console.warn("Many handlers is not recommended, they might be set by mistake. Warning limit is ".concat(HandlersCollection.MANY_HANDLERS_LIMIT, ". You can change it or turn this message off by setting MANY_HANDLERS_WARNING to false. Remember to clear handlers when not needed anymore."));
            if (HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING) throw new Error("Too many handlers! @ Add(handler, id=".concat(handlerId, ")"));
        }
        return this;
    };
    HandlersCollection.prototype.Subscribe = function(handler, handlerId) {
        if (handlerId === void 0) handlerId = $66e9e94085efdd7b$var$UniqueId();
        this.Add(handler, handlerId);
        return handlerId;
    };
    HandlersCollection.prototype.Unsubscribe = function(handlerId) {
        this.handlers.delete(handlerId);
        return this;
    };
    HandlersCollection.prototype.AddUnique = function(handler) {
        var serializedHandler = handler.toString();
        if (this.serializedHandlers.includes(serializedHandler)) return this;
        this.serializedHandlers.push(serializedHandler);
        this.Add(handler);
        return this;
    };
    HandlersCollection.prototype.Reset = function() {
        this.handlers.clear();
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "AreAny", {
        get: function() {
            return this.handlers.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HandlersCollection.prototype, "Count", {
        get: function() {
            return this.handlers.size;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Hold = function() {
        this.inOnHold = true;
        return this;
    };
    HandlersCollection.prototype.Release = function() {
        this.inOnHold = false;
        return this;
    };
    Object.defineProperty(HandlersCollection.prototype, "IsOnHold", {
        get: function() {
            return this.inOnHold;
        },
        enumerable: false,
        configurable: true
    });
    HandlersCollection.prototype.Call = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return this;
        this.handlers.forEach(function(h) {
            return h.apply(void 0, params);
        });
        return this;
    };
    HandlersCollection.prototype.CallAsync = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        return $66e9e94085efdd7b$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, handlerId, handler;
            return $66e9e94085efdd7b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.inOnHold) return [
                            2 /*return*/ 
                        ];
                        _a = 0, _b = Array.from(this.handlers.keys());
                        _c.label = 1;
                    case 1:
                        if (!(_a < _b.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        handlerId = _b[_a];
                        handler = this.handlers.get(handlerId);
                        if (!handler) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            handler.apply(void 0, params)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _a++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    HandlersCollection.prototype.CallAndGatherReturnValue = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (this.inOnHold) return [];
        var returnValues = [];
        this.handlers.forEach(function(h) {
            var result = h.apply(void 0, params);
            returnValues.push(result);
        });
        return returnValues;
    };
    HandlersCollection.MANY_HANDLERS_WARNING = true;
    HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING = false;
    HandlersCollection.MANY_HANDLERS_LIMIT = 10;
    return HandlersCollection;
}();
module.exports.HandlersCollection = $66e9e94085efdd7b$var$HandlersCollection;

});



parcelRegister("8lUZH", function(module, exports) {
"use strict";
var $614c7eb942e95d4e$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildrenCollection = void 0;
var $614c7eb942e95d4e$var$ChildrenCollection = /** @class */ function() {
    function ChildrenCollection(Parent) {
        this.Parent = Parent;
        this.components = [];
        this.found = undefined;
        this.allFound = [];
    }
    ChildrenCollection.prototype.GetByTestAttr = function(id) {
        return this.All.find(function(x) {
            return x.GetAttribute("data-test") == id;
        });
    };
    ChildrenCollection.prototype.SearchByTestAttr = function(id) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInComponentByTestAttr(c, id);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByPredicate = function(c, predicate) {
        var _this = this;
        if (predicate(c)) {
            this.found = c;
            return this.found;
        } else c.Children.All.forEach(function(c) {
            if (predicate(c)) {
                _this.found = c;
                return _this.found;
            } else _this.SearchByPredicate(c, predicate);
        });
    };
    ChildrenCollection.prototype.Search = function(predicate) {
        var _this = this;
        this.found = undefined;
        if (predicate(this.Parent)) return this.Parent;
        this.components.forEach(function(c) {
            return _this.SearchByPredicate(c, predicate);
        });
        return this.found;
    };
    ChildrenCollection.prototype.SearchByText = function(text, exact) {
        if (exact === void 0) exact = false;
        if (exact) return this.Search(function(x) {
            return x.GetText() == text;
        });
        else return this.Search(function(x) {
            var _a, _b;
            return (_b = (_a = x.GetText()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(text.toLowerCase());
        });
    };
    Object.defineProperty(ChildrenCollection.prototype, "All", {
        get: function() {
            return this.components;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Count", {
        get: function() {
            return this.components.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildrenCollection.prototype, "Clone", {
        get: function() {
            return $614c7eb942e95d4e$var$__spreadArray([], this.components, true);
        },
        enumerable: false,
        configurable: true
    });
    ChildrenCollection.prototype.Add = function(component) {
        this.components.push(component);
    };
    ChildrenCollection.prototype.Has = function(component) {
        return this.components.includes(component);
    };
    ChildrenCollection.prototype.Remove = function(component) {
        return this.components.Remove(component);
    };
    ChildrenCollection.prototype.FindInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c instanceof type) {
                _this.found = c;
                return _this.found;
            } else _this.FindInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindInComponentByTestAttr = function(component, id) {
        var _this = this;
        if (component.GetAttribute("data-test") == id) {
            this.found = component;
            return this.found;
        } else component.Children.All.forEach(function(c) {
            if (c.GetAttribute("data-test") == id) {
                _this.found = c;
                return _this.found;
            } else _this.FindInComponentByTestAttr(c, id);
        });
    };
    ChildrenCollection.prototype.FindFirstOfType = function(type) {
        var _this = this;
        this.found = undefined;
        this.components.forEach(function(c) {
            return _this.FindInObj(c, type);
        });
        return this.found;
    };
    ChildrenCollection.prototype.FindAllInObj = function(component, type) {
        var _this = this;
        if (component instanceof type) this.allFound.push(component);
        else component.Children.All.forEach(function(c) {
            if (c instanceof type) _this.allFound.push(c);
            else _this.FindAllInObj(c, type);
        });
    };
    ChildrenCollection.prototype.FindAllOfType = function(type) {
        var _this = this;
        this.allFound = [];
        this.components.forEach(function(c) {
            return _this.FindAllInObj(c, type);
        });
        return this.allFound;
    };
    ChildrenCollection.prototype.toString = function() {
        return this.components.map(function(x) {
            return "".concat(x.ID);
        });
    };
    return ChildrenCollection;
}();
module.exports.ChildrenCollection = $614c7eb942e95d4e$var$ChildrenCollection;

});

parcelRegister("5uACL", function(module, exports) {
"use strict";
var $3ffc29ebf0907b8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ffc29ebf0907b8e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventsContainer = void 0;

var $8PO3e = parcelRequire("8PO3e");
var $3ffc29ebf0907b8e$var$EventsContainer = /** @class */ function() {
    function EventsContainer(element) {
        this.element = element;
        this.events = {}; // string because TS does not allow GlobalEventHandlersEventMap as type
        this.listeners = {};
    }
    EventsContainer.prototype.Add = function(event, handler) {
        var _this = this;
        if (!handler) return;
        if (Array.isArray(event)) event.forEach(function(ev) {
            return _this.AddOne(ev, handler);
        });
        else this.AddOne(event, handler);
    };
    EventsContainer.prototype.AddOne = function(event, handler) {
        var _this = this;
        if (!this.events[event]) this.events[event] = new $8PO3e.HandlersCollection();
        this.events[event].Add(handler);
        if (this.listeners[event]) return;
        this.listeners[event] = function(e) {
            _this.Call(event, e);
        };
        this.element.addEventListener(event, function(e) {
            return _this.listeners[event](e);
        });
    };
    EventsContainer.prototype.Call = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this.events[event]) === null || _a === void 0 || _a.Call.apply(_a, args);
    };
    EventsContainer.prototype.CallAsync = function(event) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $3ffc29ebf0907b8e$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $3ffc29ebf0907b8e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.CallAsync.apply(_a, args)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsContainer.prototype.Off = function(event) {
        var _a;
        if (!this.events.Keys().includes(event)) return;
        (_a = this.events[event]) === null || _a === void 0 || _a.Reset();
        this.element.addEventListener(event, this.listeners[event]);
    };
    Object.defineProperty(EventsContainer.prototype, "Info", {
        get: function() {
            var _this = this;
            var t = "";
            this.listeners.Keys().forEach(function(k) {
                t += "- " + k + ": " + _this.events[k].Count + " handlers\n";
            });
            return t;
        },
        enumerable: false,
        configurable: true
    });
    return EventsContainer;
}();
module.exports.EventsContainer = $3ffc29ebf0907b8e$var$EventsContainer;

});




parcelRegister("bOiUu", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Radio = exports.RadioConfig = exports.RadioOption = exports.RadioInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");

var $fAOYH = parcelRequire("fAOYH");
var RadioInput = /** @class */ function(_super) {
    __extends(RadioInput, _super);
    function RadioInput(ref, value, uniqueId) {
        var _this = _super.call(this, "input", ref) || this;
        _this.value = value;
        _this.Attribute("type", "radio");
        _this.Attribute("name", uniqueId);
        _this.Attribute("value", value != null ? String(value) : "");
        _this.Refresh();
        return _this;
    }
    RadioInput.prototype.Refresh = function() {
        this.element.checked = this.ref.value == this.value;
    };
    return RadioInput;
}($k6KGm.RefComponentBase);
exports.RadioInput = RadioInput;
var RadioOption = /** @class */ function(_super) {
    __extends(RadioOption, _super);
    function RadioOption(ref, value, label, uniqueId, config) {
        var _a;
        var _this = _super.call(this, "radio-item") || this;
        _this.ref = ref;
        _this.value = value;
        _this.label = label;
        _this.uniqueId = uniqueId;
        _this.config = config;
        _this.isEnabled = true;
        _this.RadioInput = new RadioInput(_this.ref, _this.value, _this.uniqueId).Style(_this.config.RadioStyle);
        _this.Label = new $fAOYH.Label().Style(_this.config.LabelStyleWhenEnabled);
        var bondId = "input-label-bond-id-" + Math.random().toString().substring(2);
        _this.RadioInput.Id(bondId);
        _this.Label.Id(bondId);
        _this.Append(_this.RadioInput, _this.Label);
        if (Array.isArray(_this.label)) (_a = _this.Label).Append.apply(_a, _this.label);
        else _this.Label.Append(_this.label);
        _this.RadioInput.On('input', function(e) {
            if (_this.isEnabled) _this.ref.value = value;
        });
        _this.Label.OnClick(function() {
            if (_this.isEnabled) _this.ref.value = value;
        });
        return _this;
    }
    RadioOption.prototype.Enable = function(isEnabled) {
        var _this = this;
        this.React(isEnabled, function(v) {
            return v ? _this.Enabled() : _this.Disabled();
        });
        return this;
    };
    RadioOption.prototype.Disable = function(isDisabled) {
        var _this = this;
        this.React(isDisabled, function(v) {
            return v ? _this.Disabled() : _this.Enabled();
        });
        return this;
    };
    RadioOption.prototype.EnableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Enable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.DisableWhen = function(watch, predicate) {
        var _this = this;
        if (predicate === void 0) predicate = function(value) {
            return !!value;
        };
        this.React(watch, function(v) {
            return _this.Disable(predicate(v));
        });
        return this;
    };
    RadioOption.prototype.Disabled = function() {
        this.isEnabled = false;
        this.RadioInput.Disabled();
        this.Label.CursorDefault().Style(this.config.LabelStyleWhenDisabled);
        return this;
    };
    RadioOption.prototype.Enabled = function() {
        this.isEnabled = true;
        this.RadioInput.Enabled();
        this.Label.CursorPointer().Style(this.config.LabelStyleWhenEnabled);
        return this;
    };
    return RadioOption;
}($joGvE.Div);
exports.RadioOption = RadioOption;
var RadioConfig = /** @class */ function() {
    function RadioConfig() {
        this.RadioStyle = "";
        this.LabelStyleWhenEnabled = "color: #222";
        this.LabelStyleWhenDisabled = "color: #ccc";
    }
    return RadioConfig;
}();
exports.RadioConfig = RadioConfig;
var Radio = /** @class */ function(_super) {
    __extends(Radio, _super);
    function Radio(ref, config) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.Config = new RadioConfig();
        _this.uniqueName = "radio-id-" + Math.random().toString().substring(2);
        if (config) {
            var keys = Object.keys(config);
            keys.forEach(function(k) {
                _this.Add(config[k], k);
            });
        }
        return _this;
    }
    Radio.prototype.Add = function(value, label, thisOption) {
        var item = new RadioOption(this.ref, value, label, this.uniqueName, this.Config);
        thisOption === null || thisOption === void 0 || thisOption(item);
        this.Append(item);
        return this;
    };
    // public Add(value: primitive, content: appendable | appendable[], thisOption?: (input: RadioInput, label: Label) => void): this
    // {
    //     const uniqueId = "input-label-bond-id-" + Math.random().toString().substring(2);
    //     const input = new RadioInput(this.ref, value, this.uniqueName).Id(uniqueId)
    //     const label = new Label(content, uniqueId)
    //     input.On('input',e =>
    //     {
    //     //     // console.log("input")
    //     //     // e.element.preventDefault();
    //     //     // console.log("input clicked", this.ref.value, value)
    //     //     // e.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     label.OnClick(e =>
    //     {
    //         // console.log("label clicked", this.ref.value, value)
    //         // input.element.checked = true;
    //         this.ref.value = value;
    //     })
    //     thisOption?.(input, label);
    //     this.Append(
    //         new Div().Class("radio-item").Append(
    //             input,
    //             label
    //         )
    //     )
    //     return this;
    // }
    Radio.prototype.Configure = function(callback) {
        callback(this.Config);
        return this;
    };
    Radio.Name = "Radio";
    return Radio;
}($joGvE.Div);
exports.Radio = Radio;

});
parcelRegister("joGvE", function(module, exports) {
"use strict";
var $e1f13bb48051effb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Div = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e1f13bb48051effb$var$Div = /** @class */ function(_super) {
    $e1f13bb48051effb$var$__extends(Div, _super);
    function Div(classes) {
        var _this = _super.call(this, "div") || this;
        if (classes) _this.Class(classes);
        return _this;
    }
    Div.Name = "Div";
    return Div;
}($aKtiT.ComponentBase);
module.exports.Div = $e1f13bb48051effb$var$Div;

});

parcelRegister("fAOYH", function(module, exports) {
"use strict";
var $b5a1c2f6e538199d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Label = void 0;

var $2s69t = parcelRequire("2s69t");
var $b5a1c2f6e538199d$var$Label = /** @class */ function(_super) {
    $b5a1c2f6e538199d$var$__extends(Label, _super);
    function Label(content, forId) {
        var _this = _super.call(this, "label") || this;
        if (forId) _this.Attribute("for", forId);
        if (Array.isArray(content)) _this.Append.apply(_this, content);
        else _this.Append(content);
        return _this;
    }
    Label.Name = "Label";
    return Label;
}($2s69t.ComponentBase);
module.exports.Label = $b5a1c2f6e538199d$var$Label;

});
parcelRegister("2s69t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = module.exports.CollectionViewer = module.exports.ListItem = module.exports.OrderedList = module.exports.UnorderedList = module.exports.Paragraph = module.exports.Line = module.exports.NewLine = module.exports.ClickableImage = module.exports.Canvas = module.exports.ImageSource = module.exports.ImageInfo = module.exports.Image = module.exports.Link = module.exports.Button = module.exports.TwoFloatingColumns = module.exports.TwinColumns = module.exports.AutoWidthTwoColumns = module.exports.Pre = module.exports.Span = module.exports.Label = module.exports.Div = module.exports.Root = module.exports.RefWatcher = module.exports.ValidationResult = module.exports.Validator = module.exports.PatternExtractor = module.exports.RegexExtractor = module.exports.HandlersCollection = module.exports.Filters = module.exports.CollectionTemplate = module.exports.ArrayTemplate = module.exports.RefSerializer = module.exports.RefReflector = module.exports.Sorter = module.exports.Dumper = module.exports.ComponentBase = module.exports.RefComponentBase = module.exports.CollectionView = module.exports.Collection = module.exports.HashRef = module.exports.RefObject = module.exports.RefNumber = module.exports.RefString = module.exports.RefBool = module.exports.RefDate = module.exports.RV = module.exports.RefBase = module.exports.Ref = module.exports.$ = void 0;
module.exports.TableHeaderCell = module.exports.TableHeaderV2 = module.exports.TableHeader = module.exports.TableCell = module.exports.TableBody = module.exports.Table = module.exports.TableBuilder = module.exports.ProgressBar = module.exports.BlinkMode = module.exports.Led = module.exports.VerticalButtonTabs = module.exports.ButtonTabs = module.exports.HidingContentSwitcher = module.exports.DestroyingPatternContentSwitcher = module.exports.DestroyingContentSwitcher = module.exports.RadioSwitchesBuilder = module.exports.ModalWindow = module.exports.SearchableItem = module.exports.ClearableTextInput = module.exports.TextCombo = module.exports.PopupMenu = module.exports.Menu = module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.LabeledSelect = module.exports.LabeledNumberInput = module.exports.LabeledTextInput = module.exports.MultilineInput = module.exports.EditableTextarea = module.exports.EditableDateLabel = module.exports.DateTimeInput = module.exports.TimeInput = module.exports.DateInput = module.exports.RateStar = module.exports.RateConfig = module.exports.Rate = module.exports.Radio = module.exports.Checkbox = module.exports.SelectOption = module.exports.Select = module.exports.Range = module.exports.NumericRange = module.exports.NumberInput = module.exports.PasswordInput = module.exports.TextInput = module.exports.EditableLabel = module.exports.Text = module.exports.TabsSwitcher = module.exports.Tabs = module.exports.CopyIcon = void 0;
module.exports.Switch = module.exports.UploadResult = module.exports.OnlineStorage = module.exports.Pie = module.exports.Spinner = module.exports.CollectionPaginatorOptions = module.exports.CollectionPaginator = module.exports.PaginatorBrainOptions = module.exports.PaginatorBrain = module.exports.SimplePaginator = module.exports.BasicPaginator = module.exports.Snack = module.exports.RefJsonViewer = module.exports.JsonViewer = module.exports.JsonViewerConfig = module.exports.TableColumn = module.exports.TableRow = module.exports.TableHeaderRow = void 0;

var $iqyiC = parcelRequire("iqyiC");
Object.defineProperty(module.exports, "$", {
    enumerable: true,
    get: function() {
        return $iqyiC.$;
    }
});

var $6wI3m = parcelRequire("6wI3m");
Object.defineProperty(module.exports, "Ref", {
    enumerable: true,
    get: function() {
        return $6wI3m.Ref;
    }
});

var $22Wrn = parcelRequire("22Wrn");
Object.defineProperty(module.exports, "RefBase", {
    enumerable: true,
    get: function() {
        return $22Wrn.RefBase;
    }
});

var $afOau = parcelRequire("afOau");
Object.defineProperty(module.exports, "RV", {
    enumerable: true,
    get: function() {
        return $afOau.RV;
    }
});

var $2Vdhf = parcelRequire("2Vdhf");
Object.defineProperty(module.exports, "RefDate", {
    enumerable: true,
    get: function() {
        return $2Vdhf.RefDate;
    }
});

var $dzlP0 = parcelRequire("dzlP0");
Object.defineProperty(module.exports, "RefBool", {
    enumerable: true,
    get: function() {
        return $dzlP0.RefBool;
    }
});

var $brAEr = parcelRequire("brAEr");
Object.defineProperty(module.exports, "RefString", {
    enumerable: true,
    get: function() {
        return $brAEr.RefString;
    }
});

var $epBKP = parcelRequire("epBKP");
Object.defineProperty(module.exports, "RefNumber", {
    enumerable: true,
    get: function() {
        return $epBKP.RefNumber;
    }
});

var $9JbVp = parcelRequire("9JbVp");
Object.defineProperty(module.exports, "RefObject", {
    enumerable: true,
    get: function() {
        return $9JbVp.RefObject;
    }
});

var $8OWnY = parcelRequire("8OWnY");
Object.defineProperty(module.exports, "HashRef", {
    enumerable: true,
    get: function() {
        return $8OWnY.HashRef;
    }
});

var $6IcxB = parcelRequire("6IcxB");
Object.defineProperty(module.exports, "Collection", {
    enumerable: true,
    get: function() {
        return $6IcxB.Collection;
    }
});

var $8y6Fd = parcelRequire("8y6Fd");
Object.defineProperty(module.exports, "CollectionView", {
    enumerable: true,
    get: function() {
        return $8y6Fd.CollectionView;
    }
});

var $k6KGm = parcelRequire("k6KGm");
Object.defineProperty(module.exports, "RefComponentBase", {
    enumerable: true,
    get: function() {
        return $k6KGm.RefComponentBase;
    }
});

var $aKtiT = parcelRequire("aKtiT");
Object.defineProperty(module.exports, "ComponentBase", {
    enumerable: true,
    get: function() {
        return $aKtiT.ComponentBase;
    }
});

var $hiDht = parcelRequire("hiDht");
Object.defineProperty(module.exports, "Dumper", {
    enumerable: true,
    get: function() {
        return $hiDht.Dumper;
    }
});

var $4Og3n = parcelRequire("4Og3n");
Object.defineProperty(module.exports, "Sorter", {
    enumerable: true,
    get: function() {
        return $4Og3n.Sorter;
    }
});

var $6krno = parcelRequire("6krno");
Object.defineProperty(module.exports, "RefReflector", {
    enumerable: true,
    get: function() {
        return $6krno.RefReflector;
    }
});

var $9Fnts = parcelRequire("9Fnts");
Object.defineProperty(module.exports, "RefSerializer", {
    enumerable: true,
    get: function() {
        return $9Fnts.RefSerializer;
    }
});

var $9ngW8 = parcelRequire("9ngW8");
Object.defineProperty(module.exports, "ArrayTemplate", {
    enumerable: true,
    get: function() {
        return $9ngW8.ArrayTemplate;
    }
});

var $k4rJZ = parcelRequire("k4rJZ");
Object.defineProperty(module.exports, "CollectionTemplate", {
    enumerable: true,
    get: function() {
        return $k4rJZ.CollectionTemplate;
    }
});

var $3Z5yA = parcelRequire("3Z5yA");
Object.defineProperty(module.exports, "Filters", {
    enumerable: true,
    get: function() {
        return $3Z5yA.Filters;
    }
});

var $8PO3e = parcelRequire("8PO3e");
Object.defineProperty(module.exports, "HandlersCollection", {
    enumerable: true,
    get: function() {
        return $8PO3e.HandlersCollection;
    }
});

var $2UVc2 = parcelRequire("2UVc2");
Object.defineProperty(module.exports, "RegexExtractor", {
    enumerable: true,
    get: function() {
        return $2UVc2.RegexExtractor;
    }
});

var $3CTSE = parcelRequire("3CTSE");
Object.defineProperty(module.exports, "PatternExtractor", {
    enumerable: true,
    get: function() {
        return $3CTSE.PatternExtractor;
    }
});

var $8B6cm = parcelRequire("8B6cm");
Object.defineProperty(module.exports, "Validator", {
    enumerable: true,
    get: function() {
        return $8B6cm.Validator;
    }
});
Object.defineProperty(module.exports, "ValidationResult", {
    enumerable: true,
    get: function() {
        return $8B6cm.ValidationResult;
    }
});

var $iwAjC = parcelRequire("iwAjC");
Object.defineProperty(module.exports, "RefWatcher", {
    enumerable: true,
    get: function() {
        return $iwAjC.RefWatcher;
    }
});

var $7mcBr = parcelRequire("7mcBr");
Object.defineProperty(module.exports, "Root", {
    enumerable: true,
    get: function() {
        return $7mcBr.Root;
    }
});

var $joGvE = parcelRequire("joGvE");
Object.defineProperty(module.exports, "Div", {
    enumerable: true,
    get: function() {
        return $joGvE.Div;
    }
});

var $fAOYH = parcelRequire("fAOYH");
Object.defineProperty(module.exports, "Label", {
    enumerable: true,
    get: function() {
        return $fAOYH.Label;
    }
});

var $gkD0R = parcelRequire("gkD0R");
Object.defineProperty(module.exports, "Span", {
    enumerable: true,
    get: function() {
        return $gkD0R.Span;
    }
});

var $aUfnT = parcelRequire("aUfnT");
Object.defineProperty(module.exports, "Pre", {
    enumerable: true,
    get: function() {
        return $aUfnT.Pre;
    }
});

var $1h8RE = parcelRequire("1h8RE");
Object.defineProperty(module.exports, "AutoWidthTwoColumns", {
    enumerable: true,
    get: function() {
        return $1h8RE.AutoWidthTwoColumns;
    }
});

var $gOMMX = parcelRequire("gOMMX");
Object.defineProperty(module.exports, "TwinColumns", {
    enumerable: true,
    get: function() {
        return $gOMMX.TwinColumns;
    }
});

var $hPtm1 = parcelRequire("hPtm1");
Object.defineProperty(module.exports, "TwoFloatingColumns", {
    enumerable: true,
    get: function() {
        return $hPtm1.TwoFloatingColumns;
    }
});

var $2S24U = parcelRequire("2S24U");
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $2S24U.Button;
    }
});

var $5PIlt = parcelRequire("5PIlt");
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function() {
        return $5PIlt.Link;
    }
});

var $eONQW = parcelRequire("eONQW");
Object.defineProperty(module.exports, "Image", {
    enumerable: true,
    get: function() {
        return $eONQW.Image;
    }
});

var $d5iKF = parcelRequire("d5iKF");
Object.defineProperty(module.exports, "ImageInfo", {
    enumerable: true,
    get: function() {
        return $d5iKF.ImageInfo;
    }
});

var $CJCrq = parcelRequire("CJCrq");
Object.defineProperty(module.exports, "ImageSource", {
    enumerable: true,
    get: function() {
        return $CJCrq.ImageSource;
    }
});

var $iuQir = parcelRequire("iuQir");
Object.defineProperty(module.exports, "Canvas", {
    enumerable: true,
    get: function() {
        return $iuQir.Canvas;
    }
});

var $8a2qt = parcelRequire("8a2qt");
Object.defineProperty(module.exports, "ClickableImage", {
    enumerable: true,
    get: function() {
        return $8a2qt.ClickableImage;
    }
});

var $gyVEa = parcelRequire("gyVEa");
Object.defineProperty(module.exports, "NewLine", {
    enumerable: true,
    get: function() {
        return $gyVEa.NewLine;
    }
});

var $gwSD4 = parcelRequire("gwSD4");
Object.defineProperty(module.exports, "Line", {
    enumerable: true,
    get: function() {
        return $gwSD4.Line;
    }
});

var $bQA5y = parcelRequire("bQA5y");
Object.defineProperty(module.exports, "Paragraph", {
    enumerable: true,
    get: function() {
        return $bQA5y.Paragraph;
    }
});

var $8fPhC = parcelRequire("8fPhC");
Object.defineProperty(module.exports, "UnorderedList", {
    enumerable: true,
    get: function() {
        return $8fPhC.UnorderedList;
    }
});

var $2yjo2 = parcelRequire("2yjo2");
Object.defineProperty(module.exports, "OrderedList", {
    enumerable: true,
    get: function() {
        return $2yjo2.OrderedList;
    }
});

var $2MZa4 = parcelRequire("2MZa4");
Object.defineProperty(module.exports, "ListItem", {
    enumerable: true,
    get: function() {
        return $2MZa4.ListItem;
    }
});

var $9ewxt = parcelRequire("9ewxt");
Object.defineProperty(module.exports, "CollectionViewer", {
    enumerable: true,
    get: function() {
        return $9ewxt.CollectionViewer;
    }
});

var $4TgXd = parcelRequire("4TgXd");
Object.defineProperty(module.exports, "CollectionPrinter", {
    enumerable: true,
    get: function() {
        return $4TgXd.CollectionPrinter;
    }
});

var $8UMl5 = parcelRequire("8UMl5");
Object.defineProperty(module.exports, "CopyIcon", {
    enumerable: true,
    get: function() {
        return $8UMl5.CopyIcon;
    }
});

var $7LfyP = parcelRequire("7LfyP");
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $7LfyP.Tabs;
    }
});

var $gYRyj = parcelRequire("gYRyj");
Object.defineProperty(module.exports, "TabsSwitcher", {
    enumerable: true,
    get: function() {
        return $gYRyj.TabsSwitcher;
    }
});

var $3B1VX = parcelRequire("3B1VX");
Object.defineProperty(module.exports, "Text", {
    enumerable: true,
    get: function() {
        return $3B1VX.Text;
    }
});

var $hIO35 = parcelRequire("hIO35");
Object.defineProperty(module.exports, "EditableLabel", {
    enumerable: true,
    get: function() {
        return $hIO35.EditableLabel;
    }
});

var $etGN3 = parcelRequire("etGN3");
Object.defineProperty(module.exports, "TextInput", {
    enumerable: true,
    get: function() {
        return $etGN3.TextInput;
    }
});

var $jCElc = parcelRequire("jCElc");
Object.defineProperty(module.exports, "PasswordInput", {
    enumerable: true,
    get: function() {
        return $jCElc.PasswordInput;
    }
});

var $4ytZ3 = parcelRequire("4ytZ3");
Object.defineProperty(module.exports, "NumberInput", {
    enumerable: true,
    get: function() {
        return $4ytZ3.NumberInput;
    }
});

var $2Q6Ax = parcelRequire("2Q6Ax");
Object.defineProperty(module.exports, "NumericRange", {
    enumerable: true,
    get: function() {
        return $2Q6Ax.NumericRange;
    }
});

var $2OnCU = parcelRequire("2OnCU");
Object.defineProperty(module.exports, "Range", {
    enumerable: true,
    get: function() {
        return $2OnCU.Range;
    }
});

var $bGQX2 = parcelRequire("bGQX2");
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function() {
        return $bGQX2.Select;
    }
});

var $eBSeP = parcelRequire("eBSeP");
Object.defineProperty(module.exports, "SelectOption", {
    enumerable: true,
    get: function() {
        return $eBSeP.SelectOption;
    }
});

var $7fnxp = parcelRequire("7fnxp");
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $7fnxp.Checkbox;
    }
});

var $bOiUu = parcelRequire("bOiUu");
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function() {
        return $bOiUu.Radio;
    }
});

var $5duNI = parcelRequire("5duNI");
Object.defineProperty(module.exports, "Rate", {
    enumerable: true,
    get: function() {
        return $5duNI.Rate;
    }
});

var $85QoO = parcelRequire("85QoO");
Object.defineProperty(module.exports, "RateConfig", {
    enumerable: true,
    get: function() {
        return $85QoO.RateConfig;
    }
});

var $1gg6H = parcelRequire("1gg6H");
Object.defineProperty(module.exports, "RateStar", {
    enumerable: true,
    get: function() {
        return $1gg6H.RateStar;
    }
});

var $8Q6S6 = parcelRequire("8Q6S6");
Object.defineProperty(module.exports, "DateInput", {
    enumerable: true,
    get: function() {
        return $8Q6S6.DateInput;
    }
});

var $5ACZp = parcelRequire("5ACZp");
Object.defineProperty(module.exports, "TimeInput", {
    enumerable: true,
    get: function() {
        return $5ACZp.TimeInput;
    }
});

var $3UiF9 = parcelRequire("3UiF9");
Object.defineProperty(module.exports, "DateTimeInput", {
    enumerable: true,
    get: function() {
        return $3UiF9.DateTimeInput;
    }
});

var $2Tv9C = parcelRequire("2Tv9C");
Object.defineProperty(module.exports, "EditableDateLabel", {
    enumerable: true,
    get: function() {
        return $2Tv9C.EditableDateLabel;
    }
});

var $fGn1O = parcelRequire("fGn1O");
Object.defineProperty(module.exports, "EditableTextarea", {
    enumerable: true,
    get: function() {
        return $fGn1O.EditableTextarea;
    }
});

var $37QPp = parcelRequire("37QPp");
Object.defineProperty(module.exports, "MultilineInput", {
    enumerable: true,
    get: function() {
        return $37QPp.MultilineInput;
    }
});

var $hEMp0 = parcelRequire("hEMp0");
Object.defineProperty(module.exports, "LabeledTextInput", {
    enumerable: true,
    get: function() {
        return $hEMp0.LabeledTextInput;
    }
});

var $kUDwd = parcelRequire("kUDwd");
Object.defineProperty(module.exports, "LabeledNumberInput", {
    enumerable: true,
    get: function() {
        return $kUDwd.LabeledNumberInput;
    }
});

var $iBXy5 = parcelRequire("iBXy5");
Object.defineProperty(module.exports, "LabeledSelect", {
    enumerable: true,
    get: function() {
        return $iBXy5.LabeledSelect;
    }
});

var $6dx9g = parcelRequire("6dx9g");
Object.defineProperty(module.exports, "FileInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.FileInput;
    }
});
Object.defineProperty(module.exports, "MultipleFilesInput", {
    enumerable: true,
    get: function() {
        return $6dx9g.MultipleFilesInput;
    }
});

var $bL1Ff = parcelRequire("bL1Ff");
Object.defineProperty(module.exports, "Menu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.Menu;
    }
});
Object.defineProperty(module.exports, "PopupMenu", {
    enumerable: true,
    get: function() {
        return $bL1Ff.PopupMenu;
    }
});

var $5BSVz = parcelRequire("5BSVz");
Object.defineProperty(module.exports, "TextCombo", {
    enumerable: true,
    get: function() {
        return $5BSVz.TextCombo;
    }
});

var $azQFq = parcelRequire("azQFq");
Object.defineProperty(module.exports, "ClearableTextInput", {
    enumerable: true,
    get: function() {
        return $azQFq.ClearableTextInput;
    }
});

var $7Kd03 = parcelRequire("7Kd03");
Object.defineProperty(module.exports, "SearchableItem", {
    enumerable: true,
    get: function() {
        return $7Kd03.SearchableItem;
    }
});

var $bEnZu = parcelRequire("bEnZu");
Object.defineProperty(module.exports, "ModalWindow", {
    enumerable: true,
    get: function() {
        return $bEnZu.ModalWindow;
    }
});

var $fMKT6 = parcelRequire("fMKT6");
Object.defineProperty(module.exports, "RadioSwitchesBuilder", {
    enumerable: true,
    get: function() {
        return $fMKT6.RadioSwitchesBuilder;
    }
});

var $a9HcF = parcelRequire("a9HcF");
Object.defineProperty(module.exports, "DestroyingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $a9HcF.DestroyingContentSwitcher;
    }
});

var $3slAG = parcelRequire("3slAG");
Object.defineProperty(module.exports, "DestroyingPatternContentSwitcher", {
    enumerable: true,
    get: function() {
        return $3slAG.DestroyingPatternContentSwitcher;
    }
});

var $4yfSX = parcelRequire("4yfSX");
Object.defineProperty(module.exports, "HidingContentSwitcher", {
    enumerable: true,
    get: function() {
        return $4yfSX.HidingContentSwitcher;
    }
});

var $3700g = parcelRequire("3700g");
Object.defineProperty(module.exports, "ButtonTabs", {
    enumerable: true,
    get: function() {
        return $3700g.ButtonTabs;
    }
});

var $fhrT0 = parcelRequire("fhrT0");
Object.defineProperty(module.exports, "VerticalButtonTabs", {
    enumerable: true,
    get: function() {
        return $fhrT0.VerticalButtonTabs;
    }
});

var $4YE9f = parcelRequire("4YE9f");
Object.defineProperty(module.exports, "Led", {
    enumerable: true,
    get: function() {
        return $4YE9f.Led;
    }
});
Object.defineProperty(module.exports, "BlinkMode", {
    enumerable: true,
    get: function() {
        return $4YE9f.BlinkMode;
    }
});

var $1bL1j = parcelRequire("1bL1j");
Object.defineProperty(module.exports, "ProgressBar", {
    enumerable: true,
    get: function() {
        return $1bL1j.ProgressBar;
    }
});

var $8BrJA = parcelRequire("8BrJA");
Object.defineProperty(module.exports, "TableBuilder", {
    enumerable: true,
    get: function() {
        return $8BrJA.TableBuilder;
    }
});

var $1lG8E = parcelRequire("1lG8E");
Object.defineProperty(module.exports, "Table", {
    enumerable: true,
    get: function() {
        return $1lG8E.Table;
    }
});

var $1lIsG = parcelRequire("1lIsG");
Object.defineProperty(module.exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $1lIsG.TableBody;
    }
});

var $pCapU = parcelRequire("pCapU");
Object.defineProperty(module.exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $pCapU.TableCell;
    }
});

var $bdjAM = parcelRequire("bdjAM");
Object.defineProperty(module.exports, "TableHeader", {
    enumerable: true,
    get: function() {
        return $bdjAM.TableHeader;
    }
});

var $3lnvs = parcelRequire("3lnvs");
Object.defineProperty(module.exports, "TableHeaderV2", {
    enumerable: true,
    get: function() {
        return $3lnvs.TableHeaderV2;
    }
});

var $kWKxK = parcelRequire("kWKxK");
Object.defineProperty(module.exports, "TableHeaderCell", {
    enumerable: true,
    get: function() {
        return $kWKxK.TableHeaderCell;
    }
});

var $dLmKH = parcelRequire("dLmKH");
Object.defineProperty(module.exports, "TableHeaderRow", {
    enumerable: true,
    get: function() {
        return $dLmKH.TableHeaderRow;
    }
});

var $cUBMo = parcelRequire("cUBMo");
Object.defineProperty(module.exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $cUBMo.TableRow;
    }
});

var $7Fc9Q = parcelRequire("7Fc9Q");
Object.defineProperty(module.exports, "TableColumn", {
    enumerable: true,
    get: function() {
        return $7Fc9Q.TableColumn;
    }
});

var $2ZZKK = parcelRequire("2ZZKK");
Object.defineProperty(module.exports, "JsonViewerConfig", {
    enumerable: true,
    get: function() {
        return $2ZZKK.JsonViewerConfig;
    }
});

var $eBKPc = parcelRequire("eBKPc");
Object.defineProperty(module.exports, "JsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.JsonViewer;
    }
});
Object.defineProperty(module.exports, "RefJsonViewer", {
    enumerable: true,
    get: function() {
        return $eBKPc.RefJsonViewer;
    }
});

var $e6E17 = parcelRequire("e6E17");
Object.defineProperty(module.exports, "Snack", {
    enumerable: true,
    get: function() {
        return $e6E17.Snack;
    }
});

var $50yqK = parcelRequire("50yqK");
Object.defineProperty(module.exports, "BasicPaginator", {
    enumerable: true,
    get: function() {
        return $50yqK.BasicPaginator;
    }
});

var $et3h1 = parcelRequire("et3h1");
Object.defineProperty(module.exports, "SimplePaginator", {
    enumerable: true,
    get: function() {
        return $et3h1.SimplePaginator;
    }
});

var $kanmU = parcelRequire("kanmU");
Object.defineProperty(module.exports, "PaginatorBrain", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrain;
    }
});
Object.defineProperty(module.exports, "PaginatorBrainOptions", {
    enumerable: true,
    get: function() {
        return $kanmU.PaginatorBrainOptions;
    }
});

var $5snGY = parcelRequire("5snGY");
Object.defineProperty(module.exports, "CollectionPaginator", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginator;
    }
});
Object.defineProperty(module.exports, "CollectionPaginatorOptions", {
    enumerable: true,
    get: function() {
        return $5snGY.CollectionPaginatorOptions;
    }
});

var $bjWq6 = parcelRequire("bjWq6");
Object.defineProperty(module.exports, "Spinner", {
    enumerable: true,
    get: function() {
        return $bjWq6.Spinner;
    }
});

var $ckMZV = parcelRequire("ckMZV");
Object.defineProperty(module.exports, "Pie", {
    enumerable: true,
    get: function() {
        return $ckMZV.Pie;
    }
});

var $djLWA = parcelRequire("djLWA");
Object.defineProperty(module.exports, "OnlineStorage", {
    enumerable: true,
    get: function() {
        return $djLWA.OnlineStorage;
    }
});

var $cOIL8 = parcelRequire("cOIL8");
Object.defineProperty(module.exports, "UploadResult", {
    enumerable: true,
    get: function() {
        return $cOIL8.UploadResult;
    }
});

var $aq9Em = parcelRequire("aq9Em");
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $aq9Em.Switch;
    }
});

});
parcelRegister("iqyiC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.$ = void 0;
function $d6a542d33b147c1c$var$$(query) {
    return document.querySelector(query);
}
module.exports.$ = $d6a542d33b147c1c$var$$;
Object.prototype.Keys = function() {
    if (this === undefined) return [];
    return Object.keys(this);
};
Object.prototype.Values = function() {
    if (this === undefined) return [];
    return Object.values(this);
};
HTMLElement.prototype.Hide = function() {
    this.style.display = "none";
};
HTMLElement.prototype.Show = function(as) {
    if (as === void 0) as = "inline-block";
    this.style.display = as;
};
HTMLElement.prototype.Visibility = function(show, as) {
    if (as === void 0) as = "inline-block";
    if (show) this.Show(as);
    else this.Hide();
};
HTMLElement.prototype.IsVisible = function() {
    var bounding = this.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= window.innerHeight && bounding.right <= window.innerWidth;
};
HTMLElement.prototype.Toggle = function() {
    this.IsVisible() ? this.Hide() : this.Show();
};
HTMLElement.prototype.Append = function(child) {
    this.appendChild(child);
    return this;
};
HTMLElement.prototype.Prepend = function(child) {
    this.prepend(child);
    return this;
};
HTMLElement.prototype.Exist = function(child) {
    var ch = Array.from(this.children);
    return !!ch.find(function(c) {
        return c === child;
    });
};
HTMLElement.prototype.Remove = function(child) {
    this.removeChild(child);
    return this;
};
HTMLElement.prototype.Clear = function() {
    this.innerHTML = "";
    return this;
};
HTMLInputElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLInputElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLButtonElement.prototype.Enabled = function() {
    this.disabled = false;
    return this;
};
HTMLButtonElement.prototype.Disabled = function() {
    this.disabled = true;
    return this;
};
HTMLElement.prototype.Text = function(text) {
    this.innerText = text;
    return this;
};
HTMLElement.prototype.GetText = function() {
    return this.innerText;
};
HTMLInputElement.prototype.Value = function(text) {
    this.value = text;
};
HTMLInputElement.prototype.Focus = function() {
    this.focus();
    return this;
};

});

parcelRegister("afOau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RV = void 0;

var $6wI3m = parcelRequire("6wI3m");
/*
    Ref or Value

    DLACZEGO TO NIE JEST ZASZYTE W KLASACH BAZOWYCH?????????????
*/ var $7772386e437c2b55$var$RV = /** @class */ function() {
    function RV() {}
    RV.Use = function(valueOrRef, callback) {
        if (valueOrRef == undefined) // throw new Error("Value or Ref must be provided");
        return;
        if (!callback) throw new Error("Callback must be provided");
        if (valueOrRef instanceof $6wI3m.Ref) valueOrRef.OnChange(function(v) {
            callback(v);
        }, true);
        else callback(valueOrRef);
    };
    return RV;
}();
module.exports.RV = $7772386e437c2b55$var$RV;

});

parcelRegister("2Vdhf", function(module, exports) {
"use strict";
var $220b34358cb60465$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDate = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $220b34358cb60465$var$RefDate = /** @class */ function(_super) {
    $220b34358cb60465$var$__extends(RefDate, _super);
    function RefDate(initialDate) {
        if (initialDate === void 0) initialDate = new Date(0);
        var _this = this;
        if (initialDate instanceof Date) _this = _super.call(this, initialDate) || this;
        else if (typeof initialDate === "number") _this = _super.call(this, new Date(initialDate)) || this;
        else if (typeof initialDate === "string") _this = _super.call(this, new Date(initialDate)) || this;
        return _this;
    }
    Object.defineProperty(RefDate.prototype, "IsToday", {
        get: function() {
            var now = new Date();
            return this.value.getFullYear() === now.getFullYear() && this.value.getMonth() === now.getMonth() && this.value.getDate() === now.getDate();
        },
        enumerable: false,
        configurable: true
    });
    return RefDate;
}($6wI3m.Ref);
module.exports.RefDate = $220b34358cb60465$var$RefDate;

});

parcelRegister("dzlP0", function(module, exports) {
"use strict";
var $9e0f7898db26d6f1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefBool = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $9e0f7898db26d6f1$var$RefBool = /** @class */ function(_super) {
    $9e0f7898db26d6f1$var$__extends(RefBool, _super);
    function RefBool(initialBool) {
        if (initialBool === void 0) initialBool = false;
        return _super.call(this, initialBool) || this;
    }
    RefBool.prototype.CombineRefBool = function(anotherRef, operation) {
        var _this = this;
        var result = new RefBool(operation(this.value, anotherRef.value));
        this.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        anotherRef.OnChange(function(v) {
            return result.value = operation(_this.value, anotherRef.value);
        });
        return result;
    };
    RefBool.prototype.CombineRefBoolValue = function(anotherValue, operation) {
        var result = new RefBool(operation(this.value, anotherValue));
        this.OnChange(function(v) {
            return result.value = operation(v, anotherValue);
        }, true);
        return result;
    };
    RefBool.prototype.MixRefBool = function(x, operation) {
        if (x instanceof $6wI3m.Ref) return this.CombineRefBool(x, operation);
        else return this.CombineRefBoolValue(x, operation);
    };
    RefBool.prototype.And = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a && b;
        });
    };
    RefBool.prototype.Or = function(anotherRef) {
        return this.MixRefBool(anotherRef, function(a, b) {
            return a || b;
        });
    };
    RefBool.prototype.Toggle = function() {
        this.value = !this.value;
        return this;
    };
    RefBool.prototype.True = function() {
        this.value = true;
        return this;
    };
    RefBool.prototype.IsTrue = function() {
        return this.value == true;
    };
    RefBool.prototype.IsFalse = function() {
        return this.value == false;
    };
    RefBool.prototype.False = function() {
        this.value = false;
        return this;
    };
    return RefBool;
}($6wI3m.Ref);
module.exports.RefBool = $9e0f7898db26d6f1$var$RefBool;

});

parcelRegister("brAEr", function(module, exports) {
"use strict";
var $854ea58599fdd688$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefString = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $854ea58599fdd688$var$RefString = /** @class */ function(_super) {
    $854ea58599fdd688$var$__extends(RefString, _super);
    function RefString(initialString) {
        if (initialString === void 0) initialString = "";
        return _super.call(this, initialString) || this;
    }
    RefString.prototype.Includes = function(toCompare) {
        // return value.includes(this.value as string);
        return this.Compare(this, toCompare, function(a, b) {
            return a.includes(b);
        });
    };
    return RefString;
}($6wI3m.Ref);
module.exports.RefString = $854ea58599fdd688$var$RefString;

});

parcelRegister("epBKP", function(module, exports) {
"use strict";
var $a7e0afb408ba02ac$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefNumber = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $a7e0afb408ba02ac$var$RefNumber = /** @class */ function(_super) {
    $a7e0afb408ba02ac$var$__extends(RefNumber, _super);
    function RefNumber(initialNumber) {
        if (initialNumber === void 0) initialNumber = 0;
        return _super.call(this, initialNumber) || this;
    }
    RefNumber.prototype.IsBigger = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a > b;
        });
    };
    RefNumber.prototype.IsBiggerOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a >= b;
        });
    };
    RefNumber.prototype.IsSmaller = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a < b;
        });
    };
    RefNumber.prototype.IsSmallerrOrEqual = function(toCompare) {
        return this.Compare(this, toCompare, function(a, b) {
            return a <= b;
        });
    };
    RefNumber.prototype.Plus = function(x) {
        return this.Mix(x, function(a, b) {
            return a + b;
        });
    };
    RefNumber.prototype.Minus = function(x) {
        return this.Mix(x, function(a, b) {
            return a - b;
        });
    };
    RefNumber.prototype.Multiply = function(x) {
        return this.Mix(x, function(a, b) {
            return a * b;
        });
    };
    RefNumber.prototype.Divide = function(x) {
        return this.Mix(x, function(a, b) {
            return a / b;
        });
    };
    return RefNumber;
}($6wI3m.Ref);
module.exports.RefNumber = $a7e0afb408ba02ac$var$RefNumber;

});

parcelRegister("9JbVp", function(module, exports) {
"use strict";
var $7151910ed7a0ffae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefObject = void 0;

var $22Wrn = parcelRequire("22Wrn");
var $7151910ed7a0ffae$var$RefObject = /** @class */ function(_super) {
    $7151910ed7a0ffae$var$__extends(RefObject, _super);
    function RefObject(_obj) {
        var _this = _super.call(this) || this;
        _this._obj = _obj;
        return _this;
    }
    RefObject.prototype.Set = function(obj, excludeControlForRefresh) {
        this._obj = obj;
        this.RefreshSubscribers(excludeControlForRefresh);
        this.onChangeHandler.Call(this._obj);
    };
    RefObject.prototype.ForceOnChange = function() {
        this.RefreshSubscribers();
        this.onChangeHandler.Call(this._obj);
    };
    Object.defineProperty(RefObject.prototype, "object", {
        get: function() {
            return this._obj;
        },
        set: function(object) {
            this.Set(object);
        },
        enumerable: false,
        configurable: true
    });
    RefObject.prototype.Call = function(fn) {
        fn(this._obj);
        this.onChangeHandler.Call(this._obj);
        this.RefreshSubscribers();
        return this;
    };
    RefObject.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this._obj, true);
        return this;
    };
    RefObject.prototype.toString = function() {
        if (this.Name) return "RefObject named ".concat(this.Name);
        else return "RefObject";
    };
    RefObject.prototype.Storable = function(key, storage) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var value = JSON.parse(stor.getItem(key));
        this.Set(value);
        this.OnChange(function(v) {
            return stor.setItem(key, JSON.stringify(v));
        });
        return this;
    };
    return RefObject;
}($22Wrn.RefBase);
module.exports.RefObject = $7151910ed7a0ffae$var$RefObject;

});

parcelRegister("8OWnY", function(module, exports) {
"use strict";
var $66c04871e0226872$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashRef = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $66c04871e0226872$var$HashRef = /** @class */ function(_super) {
    $66c04871e0226872$var$__extends(HashRef, _super);
    function HashRef() {
        var _this = _super.call(this, window.location.hash.slice(1)) || this;
        _this.preventOnChange = false;
        window.onpopstate = function(e) {
            var hash = window.location.hash.split("#")[1];
            _this.Set(hash, _this);
        };
        window.onhashchange = function(e) {
            _this.preventOnChange = true;
            var hash = e.newURL.split("#")[1];
            _this.Set(hash, _this);
            _this.preventOnChange = false;
        };
        _this.OnChange(function(v) {
            if (_this.preventOnChange) return;
            window.location.hash = v;
        });
        return _this;
    }
    return HashRef;
}($6wI3m.Ref);
module.exports.HashRef = $66c04871e0226872$var$HashRef;

});

parcelRegister("6IcxB", function(module, exports) {
"use strict";
var $4e309485f53641b8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $8PO3e = parcelRequire("8PO3e");
var $4e309485f53641b8$var$Collection = /** @class */ function(_super) {
    $4e309485f53641b8$var$__extends(Collection, _super);
    function Collection(items) {
        if (items === void 0) items = [];
        var _this = _super.call(this) || this;
        _this.items = items;
        _this.onAddHandlers = new $8PO3e.HandlersCollection();
        _this.onRemoveHandlers = new $8PO3e.HandlersCollection();
        _this.CountRef = new $6wI3m.Ref(_this.items.length);
        return _this;
    }
    Collection.prototype.Storable = function(key, storage, serialize, deserialize) {
        if (storage === void 0) storage = "local";
        if (!key) return this;
        var stor;
        switch(storage){
            case "local":
                stor = window.localStorage;
                break;
            case "session":
                stor = window.sessionStorage;
                break;
        }
        var valueFromStorage = stor.getItem(key);
        if (valueFromStorage) this.items = deserialize(valueFromStorage);
        this.OnChange(function(items) {
            var serialized = serialize(items);
            stor.setItem(key, serialized);
        });
        return this;
    };
    Object.defineProperty(Collection.prototype, "IsEmpty", {
        get: function() {
            return this.Count == 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "IsNotEmpty", {
        get: function() {
            return this.Count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "Items", {
        get: function() {
            return this.items;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnAdd = function(handler) {
        this.onAddHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Add = function() {
        var _this = this;
        var newItems = [];
        for(var _i = 0; _i < arguments.length; _i++)newItems[_i] = arguments[_i];
        newItems.forEach(function(x) {
            _this.items.push(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        this.onAddHandlers.Call(newItems);
        return this;
    };
    Collection.prototype.Load = function() {
        // TODO: jeśli pierwszy argument jest tablicą to traktuj jak tablice, tylko co z tablicą tablic wtedy?
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        this.items = [];
        return this.Add.apply(this, items);
    };
    Collection.prototype.OnRemove = function(handler) {
        this.onRemoveHandlers.Add(handler);
        return this;
    };
    Collection.prototype.Remove = function(item) {
        if (item == undefined) return this;
        this.onRemoveHandlers.Call(item);
        return this.Call(function(items) {
            return items.Remove(item);
        });
    };
    Collection.prototype.RemoveAll = function() {
        var _this = this;
        this.items.forEach(function(item) {
            return _this.onRemoveHandlers.Call(item);
        });
        return this.Modify(function(items) {
            return [];
        });
    };
    Collection.prototype.Clear = function() {
        return this.RemoveAll();
    };
    Collection.prototype.Contains = function(item) {
        return this.items.includes(item);
    };
    Collection.prototype.Modify = function(fn) {
        this.items = fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        // TODO: a co z onRemoveHandlers?????
        return this;
    };
    Collection.prototype.ModifyOne = function(predicate, modify) {
        var found = this.items.find(predicate);
        if (!found) return this;
        modify(found);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.Call = function(fn) {
        fn(this.items);
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForceOnChange = function() {
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.ForEach = function(callback) {
        this.items.forEach(function(x, i, a) {
            callback(x, i, a);
        });
        return this;
    };
    Collection.prototype.Filter = function(callback) {
        return this.items.filter(callback);
    };
    Collection.prototype.Find = function(callback) {
        return this.items.find(callback);
    };
    Collection.prototype.Map = function(callback) {
        return this.items.map(callback);
    };
    Collection.prototype.Reduce = function(callback, initialValue) {
        return this.items.reduce(callback, initialValue);
    };
    Collection.prototype.First = function() {
        return this.items[0];
    };
    Collection.prototype.Last = function() {
        return this.items[this.Count - 1];
    };
    Collection.prototype.RemoveMany = function(items) {
        var _this = this;
        items.forEach(function(x) {
            _this.onRemoveHandlers.Call(x);
            _this.items.Remove(x);
        });
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Object.defineProperty(Collection.prototype, "Count", {
        get: function() {
            return this.items.length;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.Take = function(start, count) {
        if (count > 0) return this.items.slice(start, start + count);
        else return this.items.slice(start);
    };
    Collection.prototype.Swap = function(a, b) {
        var _a;
        if (a < 0 || b >= this.items.length) return this;
        _a = [
            this.items[b],
            this.items[a]
        ], this.items[a] = _a[0], this.items[b] = _a[1];
        this.CountRef.value = this.items.length;
        this.onChangeHandler.Call(this.items);
        this.RefreshSubscribers();
        return this;
    };
    Collection.prototype.SwapUp = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemAbove = itemIndex - 1;
        if (itemAbove < 0) return this;
        this.Swap(itemIndex, itemAbove);
        return this;
    };
    Collection.prototype.SwapDown = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        if (itemIndex == -1) return this;
        var itemBelow = itemIndex + 1;
        if (itemBelow >= this.Count) return this;
        this.Swap(itemIndex, itemBelow);
        return this;
    };
    Collection.prototype.CanSwapUp = function(item) {
        return !this.IsFirst(item);
    };
    Collection.prototype.CanSwapDown = function(item) {
        return !this.IsLast(item);
    };
    Collection.prototype.IsFirst = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == 0;
    };
    Collection.prototype.IsLast = function(item) {
        var itemIndex = this.items.findIndex(function(x) {
            return x == item;
        });
        return itemIndex == this.Count - 1;
    };
    Object.defineProperty(Collection.prototype, "FirstItem", {
        get: function() {
            return this.items[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "LastItem", {
        get: function() {
            return this.items[this.Count - 1];
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        if (callThisCallbackRightAway === void 0) callThisCallbackRightAway = false;
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.items, true);
        return this;
    };
    Collection.prototype.toString = function() {
        if (this.Name) return "Collection of ".concat(this.Name, " (").concat(this.Count, " items)");
        else return "Collection (".concat(this.Count, " items)");
    };
    return Collection;
}($22Wrn.RefBase);
module.exports.Collection = $4e309485f53641b8$var$Collection;

});

parcelRegister("8y6Fd", function(module, exports) {
"use strict";
var $6396aaf96491eb4a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionView = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $22Wrn = parcelRequire("22Wrn");

var $6IcxB = parcelRequire("6IcxB");
var $6396aaf96491eb4a$var$CollectionView = /** @class */ function(_super) {
    $6396aaf96491eb4a$var$__extends(CollectionView, _super);
    function CollectionView(data) {
        var _this = _super.call(this) || this;
        _this.Items = [];
        _this.filtersRefs = [];
        _this.filters = [];
        _this.FilteredCount = new $6wI3m.Ref(0);
        _this.collection = new $6IcxB.Collection();
        if (Array.isArray(data)) _this.collection = new $6IcxB.Collection(data);
        else if (data instanceof $6IcxB.Collection) _this.collection = data;
        _this.collection.AddSubscriber(_this);
        return _this;
    }
    Object.defineProperty(CollectionView.prototype, "Collection", {
        get: function() {
            return this.collection;
        },
        enumerable: false,
        configurable: true
    });
    CollectionView.prototype.OnChange = function(handler, callThisCallbackRightAway) {
        this.onChangeHandler.Add(handler);
        if (callThisCallbackRightAway == true) handler(this.Items, true);
        return this;
    };
    CollectionView.prototype.ForEach = function(fn) {
        this.onRefresh = fn; //???????
        return this;
    };
    CollectionView.prototype.Refresh = function() {
        var _this = this;
        this.Items = this.collection.Items;
        this.filters.forEach(function(filterPredicate, index) {
            var filterRef = _this.filtersRefs[index];
            var refValue = filterRef instanceof $6wI3m.Ref ? filterRef.value : filterRef.Items;
            _this.Items = _this.Items.filter(function(item) {
                return filterPredicate(item, refValue);
            });
        });
        this.FilteredCount.value = this.Items.length;
        if (this.start && this.count) this.Items = this.Items.slice(this.start.value, this.start.value + this.count.value);
        if (this.onRefresh) this.Items.forEach(function(record, index, array) {
            return _this.onRefresh(record, index, array);
        });
        this.onChangeHandler.Call(this.Items);
        this.RefreshSubscribers();
        return this;
    };
    CollectionView.prototype.Filter = function(ref, predicate) {
        ref.AddSubscriber(this);
        this.filtersRefs.push(ref);
        this.filters.push(predicate);
        return this;
    };
    CollectionView.prototype.Take = function(predicate) {
        this.Items = this.Items.filter(predicate);
        return this;
    };
    CollectionView.prototype.See = function(start, count) {
        start.AddSubscriber(this);
        count.AddSubscriber(this);
        this.start = start;
        this.count = count;
        return this;
    };
    return CollectionView;
}($22Wrn.RefBase);
module.exports.CollectionView = $6396aaf96491eb4a$var$CollectionView;

});

parcelRegister("hiDht", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dumper = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $c982967191c09fe2$var$Dumper = /** @class */ function() {
    function Dumper() {}
    Dumper.Dump = function(obj) {
        var out = "";
        // obj.forEach(o=>  DumpObj(obj, o));
        out = Dumper.DumpObj2(obj, out);
        // console.log(out);
        return out;
    };
    Dumper.DumpObj2 = function(obj, out, prefix) {
        // console.log('DumpObj2');
        // if (prefix)
        //     out += prefix
        // out += `\n[[[[[${typeof obj}]]]]]\n`
        switch(typeof obj){
            case "string":
                out += ":string";
                break;
            case "number":
                out += ":number";
                break;
            case "boolean":
                out += ":boolean";
                break;
            case "object":
                if (obj instanceof $6wI3m.Ref) out += obj === null || obj === void 0 ? void 0 : obj.ToString();
                else if (obj instanceof $6IcxB.Collection) {
                    out += obj === null || obj === void 0 ? void 0 : obj.toString();
                    obj.Items.forEach(function(e, i) {
                        out += "\n[".concat(i, "]\n");
                        var cc = "";
                        cc = Dumper.DumpObj2(e, cc);
                        out += cc;
                    });
                } else Object.keys(obj).forEach(function(k, i) {
                    out += "__ ".concat(k);
                    var v = obj[k];
                    // switch (typeof v)
                    // {
                    //     case "string": out += `:string = "${v}"`; break;
                    //     case "number": out += `:number = ${v}`; break;
                    //     case "boolean": out += `:boolean = ${v ? "true" : "false"}`; break;
                    // default: out += `:unknown-type = ${v}`; break;
                    // }
                    out += ": ".concat(v);
                    out += "\n";
                // out += DumpObj2(obj[k], out)
                });
                break;
            default:
                out += "unknown type: " + typeof obj;
        }
        // console.log('DumpObj2 end');
        return out;
    };
    Dumper.DumpObj = function(obj, out) {
        // console.log(obj);
        // if ((typeof obj === "string") || (typeof obj === "number")
        // || (typeof obj === "boolean"))
        // {
        //     out += `${k}: ${v || "(empty)"}\n`;
        // }
        // else
        // out+=typeof(obj) + ": "
        var _this = this;
        Object.keys(obj).forEach(function(k, i) {
            var v = obj[k];
            // console.log(k, typeof v);
            out += "\uD83D\uDD38 ";
            // console.log(`#${i} k=${k} v=${v}`, 'isarr', Array.isArray(v));
            if (typeof v === "string" || typeof v === "number") out += "".concat(k, ": ").concat(v || "(empty)", "\n");
            else if (v instanceof $6wI3m.Ref) {
                // console.log(`REF ${k}: ${v.value}`);
                if (typeof v.value === "boolean") // console.log('V IS BOOL');
                out += "".concat(k, ":bool : ").concat(v.value ? "true" : "false", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "string") out += "".concat(k, ":string : \"").concat(v.value, "\" ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else if (typeof v.value === "number") out += "".concat(k, ":number : ").concat(v.value, " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
                else // console.log('V IS NOT BOOL', typeof(v.value));
                out += "".concat(k, " (").concat(typeof v.value, "): ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            } else if (v instanceof $6wI3m.Ref) // console.log(`REF ${k}: ${v.value}`);
            out += "".concat(k, ": ").concat(v.value || "(empty)", " ").concat(v.HasChanged ? "*" : "", " [").concat(_this.WatchersInfo(v), "]\n");
            else if (v instanceof $6IcxB.Collection) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                out += "" + k + ":collection(" + v.Count + ")\n";
                out += "___" + _this.DumpObj(v.Items, out);
            } else if (Array.isArray(v)) {
                // console.log('ARRAY');
                // out += "" + k + ": " + this.Dump(v)+"\n";
                // out += "" + k + ": " + Dump(v);
                out += "" + k + ":array(" + v.length + ")\n";
                v.forEach(function(e, i) {
                    out += "___ [" + i + "]: " + _this.DumpObj(e, out);
                });
            } else if (Object.keys(v).length > 0) ;
            else // console.log('?????', k);  
            out += "" + k + ":" + typeof v + "\n";
        });
        out += "\n";
        // console.log(out);
        return out;
    };
    Dumper.WatchersInfo = function(v) {
        var _a, _b;
        return ((_b = (_a = v.Watchers) === null || _a === void 0 ? void 0 : _a.map(function(c) {
            return c.Id;
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "no watchers";
    };
    return Dumper;
}();
module.exports.Dumper = $c982967191c09fe2$var$Dumper;

});

parcelRegister("4Og3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sorter = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $380848d711c07323$var$Sorter = /** @class */ function() {
    function Sorter(collection, selected) {
        if (selected === void 0) selected = new $6wI3m.Ref("");
        var _this = this;
        this.collection = collection;
        this.selected = selected;
        this.sorts = [];
        this.selected.OnChange(function(_) {
            _this.Refresh();
        }); // second parameter of OnChange will not take action here cause sort functions are not registered (with Add) at this point yet
    }
    Sorter.prototype.Refresh = function() {
        var _this = this;
        this.collection.Call(function(items) {
            return _this.SortBySelectedFunction(items);
        });
        return this;
    };
    Sorter.prototype.Add = function(label, sortFunction) {
        this.sorts.push({
            label: label,
            sortFunction: sortFunction
        });
        return this;
    };
    Sorter.prototype.Reset = function() {
        this.selected.Restore();
        return this;
    };
    Object.defineProperty(Sorter.prototype, "SelectedValue", {
        get: function() {
            return this.selected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sorter.prototype, "Labels", {
        get: function() {
            return this.sorts.map(function(x) {
                return x.label;
            });
        },
        enumerable: false,
        configurable: true
    });
    Sorter.prototype.SortBySelectedFunction = function(items) {
        var _this = this;
        var _a;
        var sortingFunction = (_a = this.sorts.find(function(x) {
            return x.label === _this.selected.value;
        })) === null || _a === void 0 ? void 0 : _a.sortFunction;
        if (sortingFunction) return items.sort(sortingFunction);
        else return items;
    };
    return Sorter;
}();
module.exports.Sorter = $380848d711c07323$var$Sorter;

});

parcelRegister("6krno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefReflector = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");
var $49b9d8b12639cf1e$var$RefReflector = /** @class */ function() {
    function RefReflector() {}
    RefReflector.FindAllRefs = function(record) {
        this.refs = [];
        this.FindAllRefsInObject(record);
        return this.refs;
    };
    RefReflector.FindAllRefsInObject = function(obj) {
        var _this = this;
        obj.Keys().forEach(function(k) {
            var v = obj[k];
            if (v instanceof $6wI3m.Ref) _this.refs.push(v);
            else if (v instanceof Object) _this.FindAllRefsInObject(v);
            else if (v instanceof Array) v.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
            else if (v instanceof $6IcxB.Collection) v.Items.forEach(function(item) {
                return _this.FindAllRefsInObject(item);
            });
        });
    };
    RefReflector.refs = [];
    return RefReflector;
}();
module.exports.RefReflector = $49b9d8b12639cf1e$var$RefReflector;

});

parcelRegister("9Fnts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefSerializer = void 0;

var $1uOZx = parcelRequire("1uOZx");

var $gSLVI = parcelRequire("gSLVI");
var $709a26e2709195f3$var$RefSerializer = /** @class */ function() {
    function RefSerializer() {}
    RefSerializer.Serialize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return JSON.stringify(flat);
    };
    RefSerializer.Deserialize = function(source, template) {
        var sourceAsObject = JSON.parse(source);
        var target = $1uOZx.RefDeflattener.Deflat(sourceAsObject, template);
        return target;
    };
    RefSerializer.Flatenize = function(source) {
        var flat = $gSLVI.RefFlattener.Flat(source);
        return flat;
    };
    RefSerializer.Deflatenize = function(source, template) {
        var target = $1uOZx.RefDeflattener.Deflat(source, template);
        return target;
    };
    return RefSerializer;
}();
module.exports.RefSerializer = $709a26e2709195f3$var$RefSerializer;

});
parcelRegister("1uOZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefDeflattener = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $6IcxB = parcelRequire("6IcxB");

var $k4rJZ = parcelRequire("k4rJZ");

var $9ngW8 = parcelRequire("9ngW8");
var $117025a935c433a7$var$RefDeflattener = /** @class */ function() {
    function RefDeflattener() {}
    RefDeflattener.Deflat = function(source, target, options) {
        if (options === void 0) options = {
            throw: true
        };
        if (target instanceof $6wI3m.Ref) {
            if (target.value instanceof Date) target.value = new Date(source);
            else target.value = source;
        } else if (target instanceof Date) target = new Date(source);
        else if (target instanceof $9ngW8.ArrayTemplate) target = source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        });
        else if (target instanceof Array) {
            if (target.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define array type by putting one item into array template (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target[0] instanceof Date) target = source.map(function(x) {
                return new Date(x);
            });
            else if (target[0] instanceof $6wI3m.Ref) {
                if (target[0].value instanceof Date) target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "string") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "number") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
                else if (typeof target[0].value == "boolean") target = source.map(function(x) {
                    return new $6wI3m.Ref(x);
                });
            } else if (target[0] instanceof Object) target = source.map(function(x) {
                return RefDeflattener.Deflat(x, target[0], options);
            });
            else target = source;
        } else if (target instanceof $k4rJZ.CollectionTemplate) target = new $6IcxB.Collection(source.map(function(x) {
            return RefDeflattener.Deflat(x, target.CreateFn(), options);
        }));
        else if (target instanceof $6IcxB.Collection) {
            if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("PLEASE USE CollectionTemplate INSTEAD! This approach will work only for Collection<Ref> or Collection<primitive>, not for Collection<Object>!");
            if (target.Items.length != 1) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("You need to define collection type by putting one item into collection (otherwise it won't know to what type deserialize). You can disable this message by setting third parameter of this method to { options.throw: false }");
            }
            if (target.Items[0] instanceof $6wI3m.Ref) {
                if (target.Items[0].value instanceof Date) {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "string") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "number") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                } else if (typeof target.Items[0].value == "boolean") {
                    var items = source.map(function(x) {
                        return new $6wI3m.Ref(x);
                    });
                    target.Load.apply(target, items);
                }
            } else if (target.Items[0] instanceof Object) {
                if (options === null || options === void 0 ? void 0 : options.throw) throw new Error("Sorry, but deserializing to Collection<Object> is not possible now. This is due to limitation of Javascript. Target like new Collection([new Foo()]) will always reference to the same Foo for every item of collection. You don't wanna this. You can disable this message by setting third parameter of this method to { options.throw: false }");
            } else {
                var items = source.map(function(x) {
                    if (x instanceof $6wI3m.Ref) return x.value;
                    else return x;
                });
                target.Load.apply(target, items);
            }
        } else if (target instanceof Object) Object.keys(target).forEach(function(k) {
            if (target[k] instanceof Date) target[k] = new Date(source[k]);
            else if (target[k] instanceof $6wI3m.Ref) {
                if (target[k].value instanceof Date) target[k].value = new Date(source[k]);
                else target[k].value = source[k];
            } else if (target[k] instanceof Object) target[k] = RefDeflattener.Deflat(source[k], target[k], options);
            else target[k] = source[k];
        });
        else target = source;
        return target;
    };
    return RefDeflattener;
}();
module.exports.RefDeflattener = $117025a935c433a7$var$RefDeflattener;

});
parcelRegister("k4rJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionTemplate = void 0;
var $03c55157358e0895$var$CollectionTemplate = /** @class */ function() {
    function CollectionTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return CollectionTemplate;
}();
module.exports.CollectionTemplate = $03c55157358e0895$var$CollectionTemplate;

});

parcelRegister("9ngW8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayTemplate = void 0;
var $6d33665475ad970d$var$ArrayTemplate = /** @class */ function() {
    function ArrayTemplate(CreateFn) {
        this.CreateFn = CreateFn;
    }
    return ArrayTemplate;
}();
module.exports.ArrayTemplate = $6d33665475ad970d$var$ArrayTemplate;

});


parcelRegister("gSLVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefFlattener = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $6wI3m = parcelRequire("6wI3m");

var $9JbVp = parcelRequire("9JbVp");
var $c4a6de63480f73c4$var$RefFlattener = /** @class */ function() {
    function RefFlattener() {}
    RefFlattener.Flat = function(obj) {
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else return this.FlatObject(obj);
    };
    RefFlattener.FlatArray = function(array) {
        var _this = this;
        var flat = [];
        if (array instanceof Array) flat = array.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.FlatCollection = function(collection) {
        var _this = this;
        var flat = [];
        if (collection instanceof $6IcxB.Collection) flat = collection.Items.map(function(i) {
            return _this.FlatObject(i);
        });
        return flat;
    };
    RefFlattener.IsDateValid = function(date) {
        return !isNaN(date.getTime());
    };
    RefFlattener.FlatObject = function(obj) {
        var _this = this;
        if (obj instanceof $6IcxB.Collection) return this.FlatCollection(obj);
        else if (obj instanceof Array) return this.FlatArray(obj);
        else if (obj instanceof Object) {
            var flat_1 = {};
            obj.Keys().forEach(function(k) {
                var v = obj[k];
                if (v instanceof $6wI3m.Ref && v.value instanceof Date) {
                    if (!_this.IsDateValid(v.value)) throw new Error("Date \"".concat(v.value, "\" is invalid"));
                    flat_1[k] = v.value.toISOString();
                } else if (v instanceof Date) {
                    if (!_this.IsDateValid(v)) throw new Error("Date \"".concat(v, "\" is invalid"));
                    flat_1[k] = v.toISOString();
                } else if (v instanceof $6wI3m.Ref) flat_1[k] = v.value;
                else if (v instanceof $6IcxB.Collection) flat_1[k] = v.Items.map(function(x) {
                    return _this.FlatObject(x);
                });
                else if (v instanceof $9JbVp.RefObject) flat_1[k] = v.object;
                else if (v instanceof Object) flat_1[k] = _this.FlatObject(v);
                else flat_1[k] = v;
            });
            return flat_1;
        } else return obj;
    };
    return RefFlattener;
}();
module.exports.RefFlattener = $c4a6de63480f73c4$var$RefFlattener;

});


parcelRegister("3Z5yA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Filters = void 0;
var $2e6b611460cd984f$var$Filters = /** @class */ function() {
    function Filters() {}
    Filters.TextContains = function(filter, field) {
        if (Array.isArray(field)) return filter.value.trim() ? field.some(function(f) {
            return f.trim().toLowerCase().includes(filter.value.trim().toLowerCase());
        }) : true;
        return filter.value.trim() ? field.trim().toLowerCase().includes(filter.value.trim().toLowerCase()) : true;
    };
    return Filters;
}();
module.exports.Filters = $2e6b611460cd984f$var$Filters;

});

parcelRegister("2UVc2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegexExtractor = void 0;
var $21fd2d1778928b41$var$RegexExtractor = /** @class */ function() {
    function RegexExtractor(regex) {
        this.regex = regex;
    }
    RegexExtractor.prototype.Extract = function(str) {
        try {
            var m = this.regex.exec(str);
            return (m === null || m === void 0 ? void 0 : m[1]) || "";
        } catch (error) {
            throw new Error(error);
        }
    };
    RegexExtractor.prototype.ExtractAll = function(str) {
        var m;
        var matches = [];
        while((m = this.regex.exec(str)) !== null){
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === this.regex.lastIndex) this.regex.lastIndex++;
            // The result can be accessed through the `m`-variable.
            m.forEach(function(match, groupIndex) {
                if (groupIndex === 1) matches.push(match);
            });
        }
        return matches;
    };
    return RegexExtractor;
}();
module.exports.RegexExtractor = $21fd2d1778928b41$var$RegexExtractor;

});

parcelRegister("3CTSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PatternExtractorV2 = module.exports.PatternExtractor = void 0;
var $2a404462d8fb984c$var$PatternExtractor = /** @class */ function() {
    function PatternExtractor(pattern) {
        this.pattern = pattern;
    }
    PatternExtractor.prototype.Extract = function(url) {
        if (!url) return null;
        if (!this.pattern) return null;
        var urlParts = url.split('/');
        var patternParts = this.pattern.split('/');
        var params = {};
        if (urlParts.length !== patternParts.length) return null;
        for(var i = 0; i < urlParts.length; i++){
            if (patternParts[i].startsWith(':')) {
                var paramName = patternParts[i].substring(1);
                params[paramName] = urlParts[i];
            } else if (urlParts[i] !== patternParts[i]) return null;
        }
        return params;
    };
    return PatternExtractor;
}();
module.exports.PatternExtractor = $2a404462d8fb984c$var$PatternExtractor;
/*
    TO JEST DO DUPY BO ZAWSZE COŚ ZAJDZIE WIĘC NIE NADAJE SIE DO CotentSwitchera!!!!!!!!!
*/ var $2a404462d8fb984c$var$PatternExtractorV2 = /** @class */ function() {
    function PatternExtractorV2(pattern) {
        this.pattern = pattern;
    }
    PatternExtractorV2.prototype.Extract = function(input) {
        var patternSegments = this.pattern.split("/");
        var inputSegments = input.split("/");
        var params = {};
        for(var i = 0; i < patternSegments.length; i++){
            var patternSegment = patternSegments[i];
            var inputSegment = inputSegments[i];
            if (patternSegment.startsWith(":?")) {
                var paramName = patternSegment.substring(2);
                if (paramName != "") params[paramName] = inputSegment || null;
            } else if (patternSegment.startsWith(":")) {
                var paramName = patternSegment.substring(1);
                if (paramName != "") params[paramName] = inputSegment || null;
            }
        }
        return params;
    };
    return PatternExtractorV2;
}();
module.exports.PatternExtractorV2 = $2a404462d8fb984c$var$PatternExtractorV2;

});

parcelRegister("8B6cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = module.exports.ValidationResult = void 0;

var $afOau = parcelRequire("afOau");

var $6wI3m = parcelRequire("6wI3m");

var $dzlP0 = parcelRequire("dzlP0");
var $64269651993f5a6a$var$ValidationResult = /** @class */ function() {
    function ValidationResult(IsValid, IsNotValid, FirstError) {
        if (IsValid === void 0) IsValid = new $dzlP0.RefBool();
        if (IsNotValid === void 0) IsNotValid = new $dzlP0.RefBool(true);
        if (FirstError === void 0) FirstError = new $6wI3m.Ref("");
        this.IsValid = IsValid;
        this.IsNotValid = IsNotValid;
        this.FirstError = FirstError;
    }
    return ValidationResult;
}();
module.exports.ValidationResult = $64269651993f5a6a$var$ValidationResult;
var $64269651993f5a6a$var$ValidationRule = /** @class */ function() {
    function ValidationRule(predicate, message) {
        this.predicate = predicate;
        this.message = message;
    }
    return ValidationRule;
}();
var $64269651993f5a6a$var$Validator = /** @class */ function() {
    function Validator(valueToValidate, isEnabled) {
        if (isEnabled === void 0) isEnabled = true;
        var _this = this;
        this.valueToValidate = valueToValidate;
        this.isEnabled = isEnabled;
        this.isValid = new $dzlP0.RefBool();
        this.isNotValid = new $dzlP0.RefBool(true);
        this.firstErrorMessage = new $6wI3m.Ref("");
        this.rules = [];
        this.wasInitiallyValidated = false;
        this.valueToValidate.OnChange(function(v) {
            if (_this.isEnabled) _this.Validate();
        });
    }
    Validator.prototype.Enable = function(enable) {
        var _this = this;
        if (enable === void 0) enable = true;
        $afOau.RV.Use(enable, function(v) {
            _this.isEnabled = v;
            if (_this.isEnabled) _this.Validate();
        });
        return this;
    };
    Validator.prototype.Enabled = function() {
        this.isEnabled = true;
        this.Validate();
        return this;
    };
    Validator.prototype.Disabled = function() {
        this.isEnabled = false;
        return this;
    };
    Validator.prototype.Validate = function() {
        for(var _i = 0, _a = this.rules; _i < _a.length; _i++){
            var rule = _a[_i];
            var isValid = rule.predicate(this.valueToValidate.value);
            if (isValid == false) {
                this.firstErrorMessage.value = rule.message;
                this.isValid.value = false;
                this.isNotValid.value = true;
                return this;
            }
        }
        this.firstErrorMessage.value = "";
        this.isValid.value = true;
        this.isNotValid.value = false;
        return this;
    };
    Validator.prototype.MustBeNotEmpty = function(message) {
        if (message === void 0) message = "Value can not be empty";
        this.AddRule(function(v) {
            return !!v;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerThan = function(value, message) {
        if (message === void 0) message = "Value must be lower than " + value;
        this.AddRule(function(v) {
            return +v < value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeLowerOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be lower or equal to " + value;
        this.AddRule(function(v) {
            return +v <= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterThan = function(value, message) {
        if (message === void 0) message = "Value must be greater than " + value;
        this.AddRule(function(v) {
            return +v > value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeGraterOrEqualThan = function(value, message) {
        if (message === void 0) message = "Value must be greater or equal to " + value;
        this.AddRule(function(v) {
            return +v >= value;
        }, message);
        return this;
    };
    Validator.prototype.MustBeOneOf = function(options, message) {
        if (message === void 0) message = "Must be ".concat(options.join(" or "));
        this.AddRule(function(v) {
            return options.includes(v);
        }, message);
        return this;
    };
    Validator.prototype.AddRule = function(predicate, messageIfNotValid) {
        this.rules.push(new $64269651993f5a6a$var$ValidationRule(predicate, messageIfNotValid));
        return this;
    };
    Object.defineProperty(Validator.prototype, "IsValid", {
        get: function() {
            return this.Result.IsValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "IsNotValid", {
        get: function() {
            return this.Result.IsNotValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "FirstError", {
        get: function() {
            return this.Result.FirstError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validator.prototype, "Result", {
        get: function() {
            if (this.wasInitiallyValidated === false && this.isEnabled) {
                this.Validate();
                this.wasInitiallyValidated = true;
            }
            return new $64269651993f5a6a$var$ValidationResult(this.isValid, this.isNotValid, this.firstErrorMessage);
        },
        enumerable: false,
        configurable: true
    });
    return Validator;
}();
module.exports.Validator = $64269651993f5a6a$var$Validator;

});

parcelRegister("iwAjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefWatcher = void 0;
var $d7c762a3ad6d7260$var$RefWatcher = /** @class */ function() {
    function RefWatcher() {}
    RefWatcher.Watch = function(refs, doWhenAnyRefChange, callRightaway) {
        if (callRightaway === void 0) callRightaway = true;
        refs.forEach(function(ref) {
            ref.OnChange(function(v) {
                return doWhenAnyRefChange();
            });
        });
        if (callRightaway) doWhenAnyRefChange();
    };
    return RefWatcher;
}();
module.exports.RefWatcher = $d7c762a3ad6d7260$var$RefWatcher;

});

parcelRegister("7mcBr", function(module, exports) {
"use strict";
var $55b45d2339b48f9b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Root = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $joGvE = parcelRequire("joGvE");
var $55b45d2339b48f9b$var$Root = /** @class */ function(_super) {
    $55b45d2339b48f9b$var$__extends(Root, _super);
    function Root(hook, divClass) {
        if (divClass === void 0) divClass = "";
        var _a;
        var _this = _super.call(this, divClass) || this;
        (_a = (0, $iqyiC.$)(hook !== null && hook !== void 0 ? hook : Root.Hook)) === null || _a === void 0 || _a.Append(_this.Element);
        return _this;
    }
    Root.Hook = "body";
    return Root;
}($joGvE.Div);
module.exports.Root = $55b45d2339b48f9b$var$Root;

});

parcelRegister("gkD0R", function(module, exports) {
"use strict";
var $be3cc6b835bdc563$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Span = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $be3cc6b835bdc563$var$Span = /** @class */ function(_super) {
    $be3cc6b835bdc563$var$__extends(Span, _super);
    function Span(text) {
        var _this = _super.call(this, "span") || this;
        if (text) _this.Text(text);
        return _this;
    }
    Span.Name = "Span";
    return Span;
}($aKtiT.ComponentBase);
module.exports.Span = $be3cc6b835bdc563$var$Span;

});

parcelRegister("aUfnT", function(module, exports) {
"use strict";
var $7f0b115c103f2e8e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pre = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $7f0b115c103f2e8e$var$Pre = /** @class */ function(_super) {
    $7f0b115c103f2e8e$var$__extends(Pre, _super);
    function Pre() {
        return _super.call(this, "pre") || this;
    }
    return Pre;
}($aKtiT.ComponentBase);
module.exports.Pre = $7f0b115c103f2e8e$var$Pre;

});

parcelRegister("1h8RE", function(module, exports) {
"use strict";
var $0ede4142b3defe6a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoWidthTwoColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $0ede4142b3defe6a$var$AutoWidthTwoColumns = /** @class */ function(_super) {
    $0ede4142b3defe6a$var$__extends(AutoWidthTwoColumns, _super);
    function AutoWidthTwoColumns() {
        var _this = _super.call(this, "tf-stretch") || this;
        _this.LeftColumn = new $joGvE.Div("tf-min-width-column");
        _this.RightColumn = new $joGvE.Div("tf-wide-column");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    AutoWidthTwoColumns.prototype.Show = function() {
        _super.prototype.Show.call(this, "inline-flex");
        return this;
    };
    return AutoWidthTwoColumns;
}($joGvE.Div);
module.exports.AutoWidthTwoColumns = $0ede4142b3defe6a$var$AutoWidthTwoColumns;

});

parcelRegister("gOMMX", function(module, exports) {
"use strict";
var $c3e7294051227311$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwinColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $c3e7294051227311$var$TwinColumns = /** @class */ function(_super) {
    $c3e7294051227311$var$__extends(TwinColumns, _super);
    function TwinColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.RightColumn = new $joGvE.Div().HalfWidth().InlineBlock().Style("vertical-align: top");
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwinColumns.prototype.AppendToLeft = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.LeftColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.AppendToRight = function() {
        var _a;
        var content = [];
        for(var _i = 0; _i < arguments.length; _i++)content[_i] = arguments[_i];
        (_a = this.RightColumn).Append.apply(_a, content);
        return this;
    };
    TwinColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwinColumns;
}($joGvE.Div);
module.exports.TwinColumns = $c3e7294051227311$var$TwinColumns;

});

parcelRegister("hPtm1", function(module, exports) {
"use strict";
var $cfadf83aa2467e9d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwoFloatingColumns = void 0;

var $joGvE = parcelRequire("joGvE");
var $cfadf83aa2467e9d$var$TwoFloatingColumns = /** @class */ function(_super) {
    $cfadf83aa2467e9d$var$__extends(TwoFloatingColumns, _super);
    function TwoFloatingColumns() {
        var _this = _super.call(this) || this;
        _this.LeftColumn = new $joGvE.Div() //.Style("border: 3px dotted green")
        .FloatLeft(); //.Background("lightblue")
        _this.RightColumn = new $joGvE.Div() //.Style("border: 3px dotted blue")
        .FloatLeft(); //.Border(1, "lightyellow")
        _this.ClearBoth();
        _this.Append(_this.LeftColumn);
        _this.Append(_this.RightColumn);
        return _this;
    }
    TwoFloatingColumns.prototype.Show = function() {
        _super.prototype.Show.call(this);
        return this;
    };
    return TwoFloatingColumns;
}($joGvE.Div);
module.exports.TwoFloatingColumns = $cfadf83aa2467e9d$var$TwoFloatingColumns;

});

parcelRegister("2S24U", function(module, exports) {
"use strict";
var $21723c9d67724d86$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");
var $21723c9d67724d86$var$Button = /** @class */ function(_super) {
    $21723c9d67724d86$var$__extends(Button, _super);
    function Button(label, onClick) {
        if (label === void 0) label = "Button";
        var _this = _super.call(this, "button") || this;
        _this.label = label;
        _this.InitialLabel = "";
        if (label instanceof $6wI3m.Ref) _this.InitialLabel = label.value;
        else _this.InitialLabel = label;
        _this.Class(Button.DefaultCssClasses);
        if (onClick) _this.OnClick(function() {
            return onClick(_this);
        });
        _this.Label(_this.label);
        return _this;
    }
    Button.prototype.Label = function(label, transform) {
        var _this = this;
        this.React(label, function(v) {
            return _this.element.innerHTML = transform ? transform(v) : v.toString();
        });
        return this;
    };
    Button.prototype.RestoreInitialLabel = function() {
        return this.Label(this.InitialLabel);
    };
    Button.Name = "Button";
    Button.DefaultCssClasses = "";
    return Button;
}($aKtiT.ComponentBase);
module.exports.Button = $21723c9d67724d86$var$Button;

});

parcelRegister("5PIlt", function(module, exports) {
"use strict";
var $43f41d38fca657e1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Link = void 0;

var $2s69t = parcelRequire("2s69t");
var $43f41d38fca657e1$var$Link = /** @class */ function(_super) {
    $43f41d38fca657e1$var$__extends(Link, _super);
    function Link(label, url, openInNewCard) {
        if (openInNewCard === void 0) openInNewCard = false;
        var _this = _super.call(this, "a") || this;
        _this.React(label, function(v) {
            return _this.Label(v);
        });
        _this.React(url, function(v) {
            return _this.Url(v);
        });
        if (url === undefined && typeof label === "string" && label.startsWith("http")) _this.Url(label);
        if (openInNewCard) _this.OpenInNewCard();
        return _this;
    }
    Link.prototype.Label = function(label) {
        this.Text(label);
        return this;
    };
    Link.prototype.Url = function(url) {
        this.Attribute("href", url);
        return this;
    };
    Link.prototype.OpenInNewCard = function() {
        this.Attribute("target", "_blank");
        return this;
    };
    Link.prototype.DoNotOpenInNewCard = function() {
        this.RemoveAttribute("target");
        return this;
    };
    Link.prototype.NoDecorationOnHover = function() {
        this.Style("text-decoration: none");
        return this;
    };
    Link.Name = "Link";
    return Link;
}($2s69t.ComponentBase);
module.exports.Link = $43f41d38fca657e1$var$Link;

});

parcelRegister("eONQW", function(module, exports) {
"use strict";
var $ac9c67f290a10e7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Image = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $d5iKF = parcelRequire("d5iKF");

var $CJCrq = parcelRequire("CJCrq");
var $ac9c67f290a10e7d$var$Image = /** @class */ function(_super) {
    $ac9c67f290a10e7d$var$__extends(Image, _super);
    function Image(src, alt) {
        var _this = _super.call(this, "img") || this;
        _this.Info = new $d5iKF.ImageInfo(); // Do not use directly! Use OnInfoReady event instead
        _this.OnInfoReady = new $8PO3e.HandlersCollection();
        _this.blobUrl = "";
        _this.busy = false;
        if (src instanceof Blob) _this.FromBlob(src);
        else if (src) _this.React(src, function(v) {
            return v && _this.Src(v);
        });
        if (alt) _this.React(alt, function(v) {
            return _this.Alt(v);
        });
        _this.element.onload = function() {
            _this.Info.Width = _this.element.naturalWidth;
            _this.Info.Height = _this.element.naturalHeight;
            _this.OnInfoReady.Call(_this.Info);
            if (_this.Info.LoadMethod == $CJCrq.ImageSource.Blob) URL.revokeObjectURL(_this.blobUrl); // For memory clean up
            _this.busy = false;
        };
        return _this;
    }
    Image.prototype.FromBlob = function(blob) {
        if (this.busy) return this;
        this.busy = true;
        this.blobUrl = URL.createObjectURL(blob);
        this.Attribute("src", this.blobUrl);
        this.Info.LoadMethod = $CJCrq.ImageSource.Blob;
        this.Info.Size = blob.size;
        return this;
    };
    Image.prototype.Src = function(src) {
        if (!src) return this;
        if (this.busy) return this;
        this.busy = true;
        this.Attribute("src", src);
        this.Info.LoadMethod = $CJCrq.ImageSource.Http;
        this.Info.Size = -1;
        return this;
    };
    Image.prototype.GetAlt = function() {
        var _a;
        return (_a = this.GetAttribute("alt")) !== null && _a !== void 0 ? _a : "";
    };
    Object.defineProperty(Image.prototype, "IsEmpty", {
        get: function() {
            return this.GetAttribute("src") === "";
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.FromBase64 = function(base64) {
        if (!base64) return this;
        if (this.busy) return this;
        this.busy = true;
        var base64prefix = "data:image/png;base64,";
        if (!base64.startsWith(base64prefix)) base64 = base64prefix + base64;
        this.Attribute("src", base64);
        this.Info.LoadMethod = $CJCrq.ImageSource.Base64;
        this.Info.Size = this.Base64Size;
        return this;
    };
    Object.defineProperty(Image.prototype, "IsBase64", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("data:image")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "IsHttp", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.GetAttribute("src")) === null || _a === void 0 ? void 0 : _a.startsWith("http")) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.Load = function(source) {
        if (source instanceof Blob) this.FromBlob(source);
        else if (this.IsHttp) this.Src(source);
        else if (this.IsBase64) this.FromBase64(source);
        return this;
    };
    Image.prototype.Alt = function(description) {
        if (description) this.Attribute("alt", description);
        return this;
    };
    Image.prototype.ObjectPosition = function(xAxis, yAxis) {
        var _this = this;
        this.React(xAxis, function(x) {
            return _this.Style("object-position", "".concat(x, "% ").concat(yAxis.value, "%"));
        });
        this.React(yAxis, function(y) {
            return _this.Style("object-position", "".concat(xAxis.value, "% ").concat(y, "%"));
        });
        return this;
    };
    Image.prototype.ObjectFit = function(fit) {
        var _this = this;
        this.React(fit, function(x) {
            return _this.Style("object-fit", x);
        });
        return this;
    };
    Object.defineProperty(Image.prototype, "SourceInfo", {
        get: function() {
            var src = this.GetAttribute("src");
            if (!src) return $CJCrq.ImageSource.Unset;
            if (src.startsWith("http")) return $CJCrq.ImageSource.Http;
            if (src.startsWith("data:image")) return $CJCrq.ImageSource.Base64;
            return $CJCrq.ImageSource.Unset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "Base64Size", {
        get: function() {
            var base64 = this.GetAttribute("src");
            var size = base64.length * (3 / 4);
            return Number(size);
        },
        enumerable: false,
        configurable: true
    });
    Image.Name = "Image";
    return Image;
}($aKtiT.ComponentBase);
module.exports.Image = $ac9c67f290a10e7d$var$Image;

});
parcelRegister("d5iKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageInfo = void 0;

var $CJCrq = parcelRequire("CJCrq");
var $986a49b1f35547d3$var$ImageInfo = /** @class */ function() {
    function ImageInfo() {
        this.Width = 0;
        this.Height = 0;
        this.Size = 0;
        this.LoadMethod = $CJCrq.ImageSource.Unset;
    }
    Object.defineProperty(ImageInfo.prototype, "AsString", {
        get: function() {
            return "".concat(this.Width, "\u00D7").concat(this.Height, "px, ").concat((this.Size / 1024).toFixed(1), "kb");
        },
        enumerable: false,
        configurable: true
    });
    return ImageInfo;
}();
module.exports.ImageInfo = $986a49b1f35547d3$var$ImageInfo;

});
parcelRegister("CJCrq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageSource = void 0;
var $0746efb636b3d380$var$ImageSource;
(function(ImageSource) {
    ImageSource["Unset"] = "Unset";
    ImageSource["Http"] = "http";
    ImageSource["Base64"] = "base64";
    ImageSource["Blob"] = "blob";
})($0746efb636b3d380$var$ImageSource || (module.exports.ImageSource = $0746efb636b3d380$var$ImageSource = {}));

});



parcelRegister("iuQir", function(module, exports) {
"use strict";
var $d7739854c757ee07$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d7739854c757ee07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d7739854c757ee07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Canvas = void 0;

var $2s69t = parcelRequire("2s69t");
var $d7739854c757ee07$var$Canvas = /** @class */ function(_super) {
    $d7739854c757ee07$var$__extends(Canvas, _super);
    function Canvas() {
        var _this = _super.call(this, "canvas") || this;
        _this.busy = false;
        return _this;
    }
    Object.defineProperty(Canvas.prototype, "Context", {
        get: function() {
            var context = this.element.getContext("2d", {
                alpha: false,
                desynchronized: true
            });
            if (!context) throw new Error("Failed to get context");
            context.imageSmoothingEnabled = false;
            return context;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.Draw = function(picture) {
        return $d7739854c757ee07$var$__awaiter(this, void 0, void 0, function() {
            var bitmap;
            return $d7739854c757ee07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.busy) return [
                            2 /*return*/ 
                        ];
                        this.busy = true;
                        return [
                            4 /*yield*/ ,
                            createImageBitmap(picture)
                        ];
                    case 1:
                        bitmap = _a.sent();
                        this.Context.clearRect(0, 0, bitmap.width, bitmap.height);
                        this.element.width = bitmap.width;
                        this.element.height = bitmap.height;
                        this.Context.drawImage(bitmap, 0, 0);
                        bitmap.close();
                        this.busy = false;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Canvas.Name = "Canvas";
    return Canvas;
}($2s69t.ComponentBase);
module.exports.Canvas = $d7739854c757ee07$var$Canvas;

});

parcelRegister("8a2qt", function(module, exports) {
"use strict";
var $5f1123a90b240cf7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClickableImage = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $eONQW = parcelRequire("eONQW");
var $5f1123a90b240cf7$var$ClickableImage = /** @class */ function(_super) {
    $5f1123a90b240cf7$var$__extends(ClickableImage, _super);
    function ClickableImage(src, url, alt) {
        var _this = _super.call(this, "a") || this;
        _this.CursorPointer();
        _this.image = new $eONQW.Image(src);
        _this.Append(_this.image);
        if (url) _this.Url(url);
        if (alt) _this.Alt(alt);
        return _this;
    }
    ClickableImage.prototype.Src = function(src) {
        return this.Attribute("src", src);
    };
    ClickableImage.prototype.Url = function(url) {
        return this.Attribute("href", url);
    };
    ClickableImage.prototype.Alt = function(description) {
        return this.Attribute("alt", description);
    };
    ClickableImage.Name = "ClickableImage";
    return ClickableImage;
}($aKtiT.ComponentBase);
module.exports.ClickableImage = $5f1123a90b240cf7$var$ClickableImage;

});

parcelRegister("gyVEa", function(module, exports) {
"use strict";
var $c0ec89c624c3e597$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NewLine = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c0ec89c624c3e597$var$NewLine = /** @class */ function(_super) {
    $c0ec89c624c3e597$var$__extends(NewLine, _super);
    function NewLine() {
        return _super.call(this, "br") || this;
    }
    return NewLine;
}($aKtiT.ComponentBase);
module.exports.NewLine = $c0ec89c624c3e597$var$NewLine;

});

parcelRegister("gwSD4", function(module, exports) {
"use strict";
var $c08a02bb9f008e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Line = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $c08a02bb9f008e92$var$Line = /** @class */ function(_super) {
    $c08a02bb9f008e92$var$__extends(Line, _super);
    function Line() {
        var _this = _super.call(this, "hr") || this;
        _this.ClearBoth();
        return _this;
    }
    return Line;
}($aKtiT.ComponentBase);
module.exports.Line = $c08a02bb9f008e92$var$Line;

});

parcelRegister("bQA5y", function(module, exports) {
"use strict";
var $8a008b807e25ba4c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Paragraph = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $8a008b807e25ba4c$var$Paragraph = /** @class */ function(_super) {
    $8a008b807e25ba4c$var$__extends(Paragraph, _super);
    function Paragraph(klass) {
        var _this = _super.call(this, "p") || this;
        _this.Class(klass);
        return _this;
    }
    return Paragraph;
}($aKtiT.ComponentBase);
module.exports.Paragraph = $8a008b807e25ba4c$var$Paragraph;

});

parcelRegister("8fPhC", function(module, exports) {
"use strict";
var $6027813168e64ccb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnorderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $6027813168e64ccb$var$UnorderedList = /** @class */ function(_super) {
    $6027813168e64ccb$var$__extends(UnorderedList, _super);
    function UnorderedList(initialItems) {
        var _this = _super.call(this, "ul") || this;
        if (initialItems && initialItems instanceof Array) _this.LoadItems(initialItems);
        if (initialItems && initialItems instanceof $2s69t.Collection) initialItems.OnChange(function(items) {
            return _this.LoadItems(items);
        });
        return _this;
    }
    UnorderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    UnorderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    UnorderedList.Name = "UnorderedList";
    return UnorderedList;
}($2s69t.ComponentBase);
module.exports.UnorderedList = $6027813168e64ccb$var$UnorderedList;

});
parcelRegister("2MZa4", function(module, exports) {
"use strict";
var $207f81d6353d7e92$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListItem = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $207f81d6353d7e92$var$ListItem = /** @class */ function(_super) {
    $207f81d6353d7e92$var$__extends(ListItem, _super);
    function ListItem(item) {
        var _this = _super.call(this, "li") || this;
        _this.Append(item);
        return _this;
    }
    return ListItem;
}($aKtiT.ComponentBase);
module.exports.ListItem = $207f81d6353d7e92$var$ListItem;

});


parcelRegister("2yjo2", function(module, exports) {
"use strict";
var $1dbdcb8929a6339d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedList = void 0;

var $2s69t = parcelRequire("2s69t");

var $2MZa4 = parcelRequire("2MZa4");
var $1dbdcb8929a6339d$var$OrderedList = /** @class */ function(_super) {
    $1dbdcb8929a6339d$var$__extends(OrderedList, _super);
    function OrderedList(initialItems, type) {
        if (type === void 0) type = "1";
        var _this = _super.call(this, "ol") || this;
        _this.Attribute("type", type);
        if (initialItems) _this.LoadItems(initialItems);
        return _this;
    }
    OrderedList.prototype.Add = function(item) {
        this.Append(new $2MZa4.ListItem(item));
        return this;
    };
    OrderedList.prototype.LoadItems = function(items) {
        var _this = this;
        this.Clear();
        items.forEach(function(i) {
            return _this.Add(i);
        });
        return this;
    };
    OrderedList.Name = "OrderedList";
    return OrderedList;
}($2s69t.ComponentBase);
module.exports.OrderedList = $1dbdcb8929a6339d$var$OrderedList;

});

parcelRegister("9ewxt", function(module, exports) {
"use strict";
var $6b8ea9689e3c7664$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionViewer = void 0;

var $joGvE = parcelRequire("joGvE");
var $6b8ea9689e3c7664$var$CollectionViewer = /** @class */ function(_super) {
    $6b8ea9689e3c7664$var$__extends(CollectionViewer, _super);
    function CollectionViewer(collection) {
        var _this = _super.call(this) || this;
        collection.OnChange(function(v) {
            _this.Clear().Append(JSON.stringify(v));
        }, true);
        return _this;
    }
    return CollectionViewer;
}($joGvE.Div);
module.exports.CollectionViewer = $6b8ea9689e3c7664$var$CollectionViewer;

});

parcelRegister("4TgXd", function(module, exports) {
"use strict";
var $38f97332e8486431$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPrinter = void 0;

var $6IcxB = parcelRequire("6IcxB");

var $8y6Fd = parcelRequire("8y6Fd");

var $joGvE = parcelRequire("joGvE");
var $38f97332e8486431$var$CollectionPrinter = /** @class */ function(_super) {
    $38f97332e8486431$var$__extends(CollectionPrinter, _super);
    function CollectionPrinter(data, itemPrinter, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        if (data && data instanceof $6IcxB.Collection) data = new $8y6Fd.CollectionView(data).Refresh();
        data.OnChange(function(items) {
            _this.Clear();
            if (options.reverse == true) _this.Prepend.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
            else _this.Append.apply(_this, items.map(function(item) {
                return itemPrinter(item);
            }));
        }, true);
        return _this;
    }
    return CollectionPrinter;
}($joGvE.Div);
module.exports.CollectionPrinter = $38f97332e8486431$var$CollectionPrinter;

});

parcelRegister("8UMl5", function(module, exports) {
"use strict";
var $67d90cd94994eb0c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $67d90cd94994eb0c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $67d90cd94994eb0c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CopyIcon = void 0;

var $dv39x = parcelRequire("dv39x");
/*
    NIE WIEM O CO KAMAN ALE KIEDY TA KLASA DZIEDZICZY PO Link TO DOSTAJE:
    Cannot access 'Link' before initialization
    CO CIEKAWE KIEDY ZADEKLARUJE SIE TE KLASE ZARAZ POD Link (W PLIKU Link.ts) TO WSZYSTKO DZIAŁA!
    LUB KIEDY ZROBI SIĘ DOKŁADNĄ KOPIE Link I TYLKO INACZEJ NAZWIE TO TEŻ DZIAŁA!
    ŻADNE CZYSZCZENIE, ZMIENIANIE IMPORTÓW, REINSTALACJA NARZĘDZI NIE POMAGA. NIE WIEM O CO CHODZI :(
*/ var $67d90cd94994eb0c$var$CopyIcon = /** @class */ function(_super) {
    $67d90cd94994eb0c$var$__extends(CopyIcon, _super); // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
    function CopyIcon(value, icon) {
        if (icon === void 0) icon = "\uD83D\uDCCB";
        var _this = _super.call(this, icon) || this;
        _this.MarginLeft(8).OnClick(function() {
            return $67d90cd94994eb0c$var$__awaiter(_this, void 0, void 0, function() {
                return $67d90cd94994eb0c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.CopyToClipboard(value)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        });
        return _this;
    }
    CopyIcon.prototype.CopyToClipboard = function(textToCopy) {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) return new Promise(function(res, rej) {
            // navigator clipboard api method'
            navigator.clipboard.writeText(textToCopy);
            res("Success");
        });
        else {
            // text area method
            var textArea_1 = document.createElement("textarea");
            textArea_1.value = textToCopy;
            // make the textarea out of viewport
            textArea_1.style.position = "fixed";
            textArea_1.style.left = "-999999px";
            textArea_1.style.top = "-999999px";
            document.body.appendChild(textArea_1);
            textArea_1.focus();
            textArea_1.select();
            return new Promise(function(res, rej) {
                // here the magic happens
                document.execCommand('copy') ? res("Copy to clipboard succeeded") : rej("Copy to clipboard failed");
                textArea_1.remove();
            });
        }
    };
    return CopyIcon;
}($dv39x.A // 'extends A' because when trying to 'extend Link' it throws 'Cannot access 'Link' before initialization', which does not make sense!!!
);
module.exports.CopyIcon = $67d90cd94994eb0c$var$CopyIcon;

});
parcelRegister("dv39x", function(module, exports) {
"use strict";
var $9d409db7c74604f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.A = void 0;

var $2s69t = parcelRequire("2s69t");
var $9d409db7c74604f2$var$A = /** @class */ function(_super) {
    $9d409db7c74604f2$var$__extends(A, _super);
    function A(label) {
        var _this = _super.call(this, "a") || this;
        _this.Text(label);
        return _this;
    }
    A.Name = "A";
    return A;
}($2s69t.ComponentBase);
module.exports.A = $9d409db7c74604f2$var$A;

});


parcelRegister("7LfyP", function(module, exports) {
"use strict";
var $5a68fe3a0b69bef6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = void 0;

var $2s69t = parcelRequire("2s69t");

var $gYRyj = parcelRequire("gYRyj");
var $5a68fe3a0b69bef6$var$Tabs = /** @class */ function(_super) {
    $5a68fe3a0b69bef6$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $gYRyj.TabsSwitcher(_this.ref);
        _this.content = new $2s69t.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    Tabs.Name = "Tabs";
    return Tabs;
}($2s69t.Div);
module.exports.Tabs = $5a68fe3a0b69bef6$var$Tabs;

});
parcelRegister("gYRyj", function(module, exports) {
"use strict";
var $c5cbca57d8bc3bdc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TabsSwitcher = void 0;

var $2s69t = parcelRequire("2s69t");
var $c5cbca57d8bc3bdc$var$TabsSwitcher = /** @class */ function(_super) {
    $c5cbca57d8bc3bdc$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2s69t.ListItem(new $2s69t.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    TabsSwitcher.Name = "TabsSwitcher";
    return TabsSwitcher;
}($2s69t.RefComponentBase);
module.exports.TabsSwitcher = $c5cbca57d8bc3bdc$var$TabsSwitcher;

});


parcelRegister("hIO35", function(module, exports) {
"use strict";
var $ce6d5e5be4be20de$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefEditableLabel = module.exports.EditableLabel = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $gkD0R = parcelRequire("gkD0R");

var $3B1VX = parcelRequire("3B1VX");

var $etGN3 = parcelRequire("etGN3");
var $ce6d5e5be4be20de$var$EditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(EditableLabel, _super);
    function EditableLabel(ref) {
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show().OnClick(function() {
            _this.EditMode();
        });
        _this.textInput = new $etGN3.TextInput(ref);
        _this.textInput.OnBlur(function() {
            return _this.EndOfEdit();
        }).OnEnterKeyPressed(function() {
            return _this.EndOfEdit();
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    EditableLabel.prototype.EditMode = function() {
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6).Focus();
    };
    Object.defineProperty(EditableLabel.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableLabel.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableLabel.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableLabel.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableLabel.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableLabel.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableLabel.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableLabel.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableLabel.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableLabel.Name = "EditableLabel";
    return EditableLabel;
}($aKtiT.ComponentBase);
module.exports.EditableLabel = $ce6d5e5be4be20de$var$EditableLabel;
var $ce6d5e5be4be20de$var$NonRefEditableLabel = /** @class */ function(_super) {
    $ce6d5e5be4be20de$var$__extends(NonRefEditableLabel, _super);
    function NonRefEditableLabel(value, onChange) {
        var _this = _super.call(this, "div") || this;
        _this.value = "";
        _this.label = new $gkD0R.Span(value);
        _this.label.Show().OnClick(function() {
            var labelWidth = getComputedStyle(_this.label.Element).width;
            var w = +labelWidth.replace("px", "");
            if (w < 100) w += 20;
            _this.label.Hide();
            _this.textInput.Show().Width(w).Padding(2, 6).Focus();
        });
        _this.textInput = new $etGN3.NonRefTextInput(value, function(v) {
            _this.value = v;
            onChange(v);
        });
        _this.textInput.OnBlur(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).OnEnterKeyPressed(function() {
            _this.textInput.Hide();
            _this.label.Show();
            _this.label.Text(_this.value);
        }).Hide();
        _this.Append(_this.label);
        _this.Append(_this.textInput);
        return _this;
    }
    NonRefEditableLabel.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    NonRefEditableLabel.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    return NonRefEditableLabel;
}($aKtiT.ComponentBase);
module.exports.NonRefEditableLabel = $ce6d5e5be4be20de$var$NonRefEditableLabel;

});
parcelRegister("etGN3", function(module, exports) {
"use strict";
var $a8a4f76189473a77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefTextInput = module.exports.TextInput = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $8PO3e = parcelRequire("8PO3e");
var $a8a4f76189473a77$var$TextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(TextInput, _super);
    function TextInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this, "input", ref) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Class(TextInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = e.target.value;
            _this.onChange.Call(_this.ref.value, e);
        });
        _this.Refresh();
        return _this;
    }
    TextInput.prototype.Placeholder = function(placeholderText) {
        var _this = this;
        if (placeholderText) this.React(placeholderText, function(v) {
            return _this.element.setAttribute("placeholder", v);
        });
        return this;
    };
    TextInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    TextInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TextInput.Name = "TextInput";
    TextInput.DefaultCssClasses = "";
    return TextInput;
}($k6KGm.RefComponentBase);
module.exports.TextInput = $a8a4f76189473a77$var$TextInput;
var $a8a4f76189473a77$var$NonRefTextInput = /** @class */ function(_super) {
    $a8a4f76189473a77$var$__extends(NonRefTextInput, _super);
    function NonRefTextInput(value, onChange) {
        var _this = _super.call(this, "input") || this;
        _this.value = value;
        _this.Class($a8a4f76189473a77$var$TextInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            // this.ref.SetValue(e.target.value, this);
            onChange(e.target.value);
        });
        _this.Refresh();
        return _this;
    }
    NonRefTextInput.prototype.Placeholder = function(placeholder) {
        this.element.setAttribute("placeholder", placeholder);
        return this;
    };
    NonRefTextInput.prototype.Refresh = function() {
        this.element.value = this.value;
    // if (this.showThatChanged)
    //     this.ref.HasChanged
    //         ? this.element.classList.add("tf-value-changed")
    //         : this.element.classList.remove("tf-value-changed");
    };
    NonRefTextInput.DefaultCssClasses = "";
    return NonRefTextInput;
}($aKtiT.ComponentBase);
module.exports.NonRefTextInput = $a8a4f76189473a77$var$NonRefTextInput;

});


parcelRegister("jCElc", function(module, exports) {
"use strict";
var $e490dbcb2c83c831$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PasswordInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $e490dbcb2c83c831$var$PasswordInput = /** @class */ function(_super) {
    $e490dbcb2c83c831$var$__extends(PasswordInput, _super);
    function PasswordInput(passwordRef) {
        if (passwordRef === void 0) passwordRef = new $6wI3m.Ref("");
        var _this = _super.call(this, "") || this;
        _this.passwordRef = passwordRef;
        _this.showPasswordBtn = new $gkD0R.Span("\uD83D\uDC40").PositionAbsolute().Top(8).Right(6).Opacity(0.5).CursorPointer().Hide();
        _this.PositionRelative();
        _this.passwordInput = new $etGN3.TextInput(_this.passwordRef).Class($etGN3.TextInput.DefaultCssClasses).Attribute("type", "password");
        _this.Append(_this.passwordInput, _this.showPasswordBtn);
        return _this;
    }
    PasswordInput.prototype.SetupInput = function(setup) {
        setup(this.passwordInput);
        return this;
    };
    PasswordInput.prototype.SetupButton = function(setup) {
        setup(this.showPasswordBtn);
        return this;
    };
    PasswordInput.prototype.StyleInput = function(style) {
        this.passwordInput.Style(style);
        return this;
    };
    PasswordInput.prototype.StyleButton = function(style) {
        this.showPasswordBtn.Style(style);
        return this;
    };
    PasswordInput.prototype.ShowPasswordOnTouch = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        this.showPasswordBtn.On([
            'mousedown',
            'touchstart'
        ], function() {
            _this.passwordInput.Attribute("type", "text");
            _this.showPasswordBtn.Opacity(1);
        }).On([
            'mouseup',
            'touchend'
        ], function() {
            _this.passwordInput.Attribute("type", "password");
            _this.showPasswordBtn.Opacity(0.5);
        });
        return this;
    };
    PasswordInput.prototype.TogglePasswordView = function() {
        var _this = this;
        this.showPasswordBtn.Show();
        var passwordVisible = new $6wI3m.Ref(false);
        this.showPasswordBtn.OnClick(function() {
            passwordVisible.value = !passwordVisible.value;
            _this.passwordInput.Attribute("type", passwordVisible.value ? "text" : "password");
            _this.showPasswordBtn.Opacity(passwordVisible.value ? 1 : 0.5);
        });
        return this;
    };
    PasswordInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.passwordInput.Placeholder(v);
        });
        return this;
    };
    PasswordInput.Name = "PasswordInput";
    return PasswordInput;
}($joGvE.Div);
module.exports.PasswordInput = $e490dbcb2c83c831$var$PasswordInput;

});

parcelRegister("4ytZ3", function(module, exports) {
"use strict";
var $3511988913dff7b1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumberInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $3511988913dff7b1$var$NumberInput = /** @class */ function(_super) {
    $3511988913dff7b1$var$__extends(NumberInput, _super);
    function NumberInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(NumberInput.DefaultCssClasses);
        _this.element.setAttribute("type", "number");
        _this.element.setAttribute("value", _this.ref.value.toString());
        _this.element.addEventListener('input', function(e) {
            // console.log(this.ID, 'input',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value; // TODO: zwalidować czy to nie powoduje zapętlenia refreshy
        });
        _this.element.addEventListener('mousewheel', function(e) {
            // e.preventDefault();
            // console.log(this.ID, 'mousewheel',e.target.value, this.ref.value)
            _this.ref.value = +e.target.value;
        }, {
            passive: false
        });
        return _this;
    }
    NumberInput.prototype.Step = function(step) {
        var _this = this;
        this.React(step, function(v) {
            return _this.Attribute("step", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    NumberInput.prototype.Range = function(min, max) {
        this.Min(min);
        this.Max(max);
        return this;
    };
    NumberInput.prototype.Refresh = function() {
        // console.log(this.ID, 'refresh', this.ref.value)
        this.element.value = this.ref.value.toString();
        if (this.min !== undefined && this.max !== undefined) {
            if (this.min !== this.max && this.ref.value >= this.min && this.ref.value <= this.max) this.Style("background", "");
            else this.Style("background", "pink");
        }
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    NumberInput.Name = "NumberInput";
    NumberInput.DefaultCssClasses = "";
    return NumberInput;
}($k6KGm.RefComponentBase);
module.exports.NumberInput = $3511988913dff7b1$var$NumberInput;

});

parcelRegister("2Q6Ax", function(module, exports) {
"use strict";
var $21158c68a1869eda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericRange = void 0;

var $2s69t = parcelRequire("2s69t");
var $21158c68a1869eda$var$NumericRange = /** @class */ function(_super) {
    $21158c68a1869eda$var$__extends(NumericRange, _super);
    function NumericRange(min, max, range) {
        var _this = _super.call(this) || this;
        _this.min = min;
        _this.max = max;
        _this.minInput = new $2s69t.NumberInput(_this.min).HalfWidth();
        _this.maxInput = new $2s69t.NumberInput(_this.max).HalfWidth();
        if (range) {
            _this.minInput.Min(range[0]);
            _this.maxInput.Max(range[1]);
        }
        _this.Append(_this.minInput, _this.maxInput);
        return _this;
    }
    NumericRange.prototype.ShowThatChanged = function(showOrNot) {
        this.minInput.ShowThatChanged(showOrNot);
        this.maxInput.ShowThatChanged(showOrNot);
        return this;
    };
    NumericRange.Name = "NumericRange";
    return NumericRange;
}($2s69t.Div);
module.exports.NumericRange = $21158c68a1869eda$var$NumericRange;

});

parcelRegister("2OnCU", function(module, exports) {
"use strict";
var $20c2940b48787776$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Range = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $20c2940b48787776$var$Range = /** @class */ function(_super) {
    $20c2940b48787776$var$__extends(Range, _super);
    function Range(ref, range) {
        if (ref === void 0) ref = new $6wI3m.Ref(0);
        if (range === void 0) range = [
            0,
            100
        ];
        var _this = _super.call(this, "input", ref) || this;
        _this.min = undefined;
        _this.max = undefined;
        _this.Class(Range.DefaultCssClasses);
        if (range && range.length == 2) {
            _this.Min(range[0]);
            _this.Max(range[1]);
        }
        _this.Attribute("type", "range");
        _this.Attribute("value", _this.ref.value.toString());
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = +e.target.value;
        });
        return _this;
    }
    Range.prototype.Min = function(min) {
        var _this = this;
        this.React(min, function(v) {
            return _this.Attribute("min", v.toString());
        });
        return this;
    };
    Range.prototype.Max = function(max) {
        var _this = this;
        this.React(max, function(v) {
            return _this.Attribute("max", v.toString());
        });
        return this;
    };
    Range.prototype.Refresh = function() {
        this.element.value = this.ref.value.toString();
    };
    Range.Name = "Range";
    Range.DefaultCssClasses = "";
    return Range;
}($k6KGm.RefComponentBase);
module.exports.Range = $20c2940b48787776$var$Range;

});

parcelRegister("bGQX2", function(module, exports) {
"use strict";
var $882cb0f4f90f3af3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $882cb0f4f90f3af3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Select = void 0;

var $2s69t = parcelRequire("2s69t");

var $k6KGm = parcelRequire("k6KGm");
var $882cb0f4f90f3af3$var$Select = /** @class */ function(_super) {
    $882cb0f4f90f3af3$var$__extends(Select, _super);
    function Select(ref, initialOptions, optionsReloadTrigger) {
        if (ref === void 0) ref = new $2s69t.Ref("");
        if (initialOptions === void 0) initialOptions = [];
        var _this = _super.call(this, "select", ref) || this;
        _this.options = [];
        _this.InitialOptions = [];
        _this.clickHandler = function() {
            _this.RemoveDefaultOption();
            _this.element.removeEventListener('click', _this.clickHandler);
            _this.ref.value = _this.element.value; // BEZ TEGO PO KLIKNIĘCU KONTROLKA POKAZUJE PIERWSZĄ WARTOŚĆ ALE ref SIĘ NIE USTAWIA NA TE WARTOŚĆ
        };
        _this.modifyValueAfterChangeFn = function(t) {
            return t;
        };
        _this.DefaultValue = "__default__";
        _this.wasDefaultValueEverSet = false;
        _this.removeItOnFirstClick = false;
        _this.AddClass(Select.DefaultCssClasses);
        _this.WidthAuto();
        if (initialOptions instanceof $2s69t.Collection) initialOptions.OnChange(function() {
            return _this.LoadOptions(initialOptions.Items);
        });
        else if (typeof initialOptions === "function") {
            var options = initialOptions();
            _this.LoadOptions(options);
            if (!optionsReloadTrigger) _this.element.addEventListener('click', function(e) {
                var options = initialOptions();
                _this.LoadOptions(options);
            });
            else optionsReloadTrigger.OnChange(function() {
                return _this.LoadOptions(initialOptions());
            });
        } else if (Array.isArray(initialOptions)) {
            if (initialOptions[0] instanceof $2s69t.SelectOption) initialOptions.forEach(function(opt) {
                return _this.AddOption(opt);
            });
            else if (typeof initialOptions[0] == "string") initialOptions.forEach(function(opt) {
                return _this.AddOption(new $2s69t.SelectOption(opt));
            });
        } else if (initialOptions instanceof Object) {
            var entries = Object.entries(initialOptions);
            entries.map(function(_a) {
                var key = _a[0], value = _a[1];
                return _this.AddOption(new $2s69t.SelectOption(key, value));
            });
        }
        _this.InitialOptions = $882cb0f4f90f3af3$var$__spreadArray([], _this.options, true);
        _this.element.addEventListener('change', function(e) {
            var _a, _b;
            _this.ref.value = _this.modifyValueAfterChangeFn(e.target.value);
            var index = _this.options.findIndex(function(x) {
                return x.Value === e.target.value;
            });
            var key = ((_a = _this.options.find(function(x) {
                return x.Value === e.target.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = _this.onChangeCallback) === null || _b === void 0 || _b.call(_this, _this.ref.value, index, key);
        });
        _this.element.value = ref.value != null ? String(ref.value) : "";
        if (_this.removeItOnFirstClick) _this.RemoveDefaultOptionOnFirstClick();
        return _this;
    }
    Object.defineProperty(Select.prototype, "Index", {
        get: function() {
            var _this = this;
            return this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Key", {
        get: function() {
            var _this = this;
            var _a;
            return ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || this.defaultOptionText;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.SetValue = function(value) {
        var _this = this;
        var _a, _b;
        _super.prototype.SetValue.call(this, value);
        var index = this.options.findIndex(function(x) {
            return x.Value === _this.ref.value;
        });
        var key = ((_a = this.options.find(function(x) {
            return x.Value === _this.ref.value;
        })) === null || _a === void 0 ? void 0 : _a.Text) || "";
        (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        return this;
    };
    Select.prototype.RemoveDefaultOptionOnFirstClick = function() {
        /*
            UŻYCIE TEJ OPCJI SPOWODUJE USUNIĘCIE WARTOŚCI DOMYŚLNEJ Z LISTY OPCJI
            ALE RÓWNIEŻ USTAWI PIERWSZĄ OPCJĘ. DEFAULTOWA JUŻ SIĘ WIĘCEJ NIE POJAWI.
            NIE WIEM CZY NIE LEPIEJ BYŁO BY Z TEGO ZREZYGNOWAĆ.
        */ this.element.addEventListener('click', this.clickHandler);
        // this.OnClick(this.handler)
        return this;
    };
    Object.defineProperty(Select.prototype, "IsOpen", {
        get: function() {
            return document.activeElement === this.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "Options", {
        get: function() {
            return this.options;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.ModifyAfterChange = function(fn) {
        this.modifyValueAfterChangeFn = fn;
        return this;
    };
    Select.prototype.CreateOption = function(option) {
        var optionElement = document.createElement("option");
        optionElement.text = option.Text;
        optionElement.value = option.Value != null ? String(option.Value) : "";
        return optionElement;
    };
    Select.prototype.PrependOption = function(option) {
        this.options.unshift(option);
        var optionElement = this.CreateOption(option);
        this.element.Prepend(optionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.AddOption = function(option) {
        this.options.push(option);
        var optionElement = this.CreateOption(option);
        this.element.Append(optionElement);
        this.Refresh();
        return this;
    };
    Object.defineProperty(Select.prototype, "IsDefault", {
        get: function() {
            return !this.IsValueInOptions();
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.AddDefaultOption = function(text, removeItOnFirstClick) {
        if (removeItOnFirstClick === void 0) removeItOnFirstClick = false;
        this.removeItOnFirstClick = removeItOnFirstClick;
        this.wasDefaultValueEverSet = true;
        this.defaultOptionText = text;
        this.defaultOptionElement = document.createElement("option");
        this.defaultOptionElement.text = text;
        this.defaultOptionElement.value = this.DefaultValue;
        this.element.Append(this.defaultOptionElement);
        this.Refresh();
        return this;
    };
    Select.prototype.RemoveDefaultOption = function() {
        if (this.defaultOptionElement) {
            this.element.removeChild(this.defaultOptionElement);
            this.defaultOptionElement = null;
        }
        return this;
    };
    Select.prototype.ClearOptions = function() {
        this.options = [];
        this.element.textContent = '';
        if (this.wasDefaultValueEverSet) this.AddDefaultOption(this.defaultOptionText);
        return this;
    };
    Select.prototype.AddOptions = function(options) {
        var _this = this;
        options.forEach(function(o) {
            return _this.AddOption(o);
        });
        return this;
    };
    Select.prototype.LoadOptions = function(options) {
        var _this = this;
        this.ClearOptions();
        if (options[0] instanceof $2s69t.SelectOption) options.forEach(function(o) {
            return _this.AddOption(o);
        });
        else options.forEach(function(o) {
            return _this.AddOption(new $2s69t.SelectOption(o));
        });
        this.Refresh();
        return this;
    };
    Select.prototype.ReplaceOption = function(predicate, replacement) {
        var optionsCopy = $882cb0f4f90f3af3$var$__spreadArray([], this.Options, true);
        var foundIndex = optionsCopy.findIndex(function(x) {
            return predicate(x);
        });
        optionsCopy[foundIndex] = replacement;
        this.LoadOptions(optionsCopy);
        return this;
    };
    Select.prototype.LoadInitialOptions = function() {
        return this.LoadOptions(this.InitialOptions);
    };
    Select.prototype.OnChange = function(callback, callRightaway) {
        var _this = this;
        var _a, _b;
        if (callRightaway === void 0) callRightaway = false;
        this.onChangeCallback = callback;
        if (callRightaway) {
            var index = this.options.findIndex(function(x) {
                return x.Value === _this.ref.value;
            });
            var key = ((_a = this.options.find(function(x) {
                return x.Value === _this.ref.value;
            })) === null || _a === void 0 ? void 0 : _a.Text) || "";
            (_b = this.onChangeCallback) === null || _b === void 0 || _b.call(this, this.ref.value, index, key);
        }
        return this;
    };
    Select.prototype.Refresh = function() {
        if (this.IsValueInOptions()) this.element.value = this.ref.value != null ? String(this.ref.value) : "";
        else this.element.value = this.DefaultValue;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
        return this;
    };
    Select.prototype.IsValueInOptions = function() {
        var refValue = this.ref.value != null ? String(this.ref.value) : "";
        return this.options.map(function(x) {
            var _a;
            return (_a = x.Value) === null || _a === void 0 ? void 0 : _a.toString();
        }).includes(refValue);
    };
    Select.Name = "Select";
    Select.DefaultCssClasses = "";
    return Select;
}($k6KGm.RefComponentBase);
module.exports.Select = $882cb0f4f90f3af3$var$Select;

});

parcelRegister("eBSeP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectOption = void 0;
var $aa2e97fb58a44c38$var$SelectOption = /** @class */ function() {
    function SelectOption(Text, Value) {
        this.Text = Text;
        this.Value = Value;
        if (this.Value === undefined) this.Value = this.Text;
    }
    return SelectOption;
}();
module.exports.SelectOption = $aa2e97fb58a44c38$var$SelectOption;

});

parcelRegister("7fnxp", function(module, exports) {
"use strict";
var $546c313ef87b9e01$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonRefCheckboxV2 = module.exports.NonRefCheckbox = module.exports.Checkbox = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $jHilJ = parcelRequire("jHilJ");

var $6wI3m = parcelRequire("6wI3m");

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");

var $gkD0R = parcelRequire("gkD0R");
var $546c313ef87b9e01$var$Checkbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(Checkbox, _super);
    function Checkbox(ref, label) {
        if (ref === void 0) ref = new $6wI3m.Ref(false);
        var _this = _super.call(this, "label", ref) || this;
        _this.ref = ref;
        _this.onCheckHandlers = new $8PO3e.HandlersCollection();
        _this.onUncheckHandlers = new $8PO3e.HandlersCollection();
        _this.onChangeHandlers = new $8PO3e.HandlersCollection();
        _this.Class("tf-checkbox");
        _this.Input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (ref.value) _this.Input.Attribute("checked", ref.value ? "checked" : "");
        _this.element.addEventListener('click', function(e) {
            _this.ref.value = _this.Input.element.checked; // czemu nie target.checked?
            _this.onChangeHandlers.Call(_this.ref.value);
            if (_this.ref.value == true) _this.onCheckHandlers.Call();
            else _this.onUncheckHandlers.Call();
        });
        _this.Append(_this.Input);
        if (label) _this.Append(new $gkD0R.Span(label).Class("checkbox-text"));
        return _this;
    }
    Checkbox.prototype.OnCheck = function(handler) {
        this.onCheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnUncheck = function(handler) {
        this.onUncheckHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.OnChange = function(handler) {
        this.onChangeHandlers.Add(handler);
        return this;
    };
    Checkbox.prototype.Refresh = function() {
        this.Input.element.checked = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.Input.element.classList.add("tf-value-changed") : this.Input.element.classList.remove("tf-value-changed");
    };
    Checkbox.prototype.Enabled = function() {
        this.Input.Enabled();
        return this;
    };
    Checkbox.prototype.Disabled = function() {
        this.Input.Disabled();
        return this;
    };
    Checkbox.prototype.Enable = function(isEnabled) {
        this.Input.Enable(isEnabled);
        return this;
    };
    Checkbox.prototype.EnableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.EnableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.DisableWhen = function(toWatch, predicate) {
        if (predicate === void 0) predicate = function(v) {
            return !!v;
        };
        this.Input.DisableWhen(toWatch, predicate);
        return this;
    };
    Checkbox.prototype.Disable = function(isDisabled) {
        this.Input.Disable(isDisabled);
        return this;
    };
    Checkbox.Name = "Checkbox";
    return Checkbox;
}($k6KGm.RefComponentBase);
module.exports.Checkbox = $546c313ef87b9e01$var$Checkbox;
var $546c313ef87b9e01$var$NonRefCheckbox = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckbox, _super);
    function NonRefCheckbox(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value()) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener('click', function(e) {
            // console.log('!', this.input.element.checked);
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckbox.prototype.Refresh = function() {
        this.input.element.checked = this.value();
    };
    return NonRefCheckbox;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckbox = $546c313ef87b9e01$var$NonRefCheckbox;
var $546c313ef87b9e01$var$NonRefCheckboxV2 = /** @class */ function(_super) {
    $546c313ef87b9e01$var$__extends(NonRefCheckboxV2, _super);
    function NonRefCheckboxV2(value, onChange, label) {
        var _this = _super.call(this, "label") || this;
        _this.value = value;
        _this.input = new $jHilJ.GenericComponent("input").AddClass("uk-checkbox").Attribute("type", "checkbox");
        if (value) _this.input.Attribute("checked");
        else _this.input.RemoveAttribute("checked");
        _this.element.addEventListener('click', function(e) {
            onChange(_this.input.element.checked);
        });
        _this.Append(_this.input);
        if (label) _this.Append(new $gkD0R.Span(" " + label));
        return _this;
    }
    NonRefCheckboxV2.prototype.Refresh = function() {
        this.input.element.checked = this.value;
    };
    return NonRefCheckboxV2;
}($aKtiT.ComponentBase);
module.exports.NonRefCheckboxV2 = $546c313ef87b9e01$var$NonRefCheckboxV2;

});
parcelRegister("jHilJ", function(module, exports) {
"use strict";
var $e570444aa1c3a529$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericComponent = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $e570444aa1c3a529$var$GenericComponent = /** @class */ function(_super) {
    $e570444aa1c3a529$var$__extends(GenericComponent, _super);
    function GenericComponent(element) {
        return _super.call(this, element) || this;
    }
    return GenericComponent;
}($aKtiT.ComponentBase);
module.exports.GenericComponent = $e570444aa1c3a529$var$GenericComponent;

});


parcelRegister("5duNI", function(module, exports) {
"use strict";
var $3cc60f0ae7725ed1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3cc60f0ae7725ed1$var$__assign = module.exports && module.exports.__assign || function() {
    $3cc60f0ae7725ed1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3cc60f0ae7725ed1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rate = void 0;

var $joGvE = parcelRequire("joGvE");

var $85QoO = parcelRequire("85QoO");

var $1gg6H = parcelRequire("1gg6H");
var $3cc60f0ae7725ed1$var$Rate = /** @class */ function(_super) {
    $3cc60f0ae7725ed1$var$__extends(Rate, _super);
    function Rate(rating, config) {
        var _this = _super.call(this) || this;
        _this.Config = new $85QoO.RateConfig();
        if (config) _this.Config = $3cc60f0ae7725ed1$var$__assign($3cc60f0ae7725ed1$var$__assign({}, _this.Config), config);
        var _loop_1 = function(i) {
            var star = new $1gg6H.RateStar(rating, i, this_1.Config);
            if (this_1.Config.Readonly == false) star.OnClick(function() {
                return rating.value = i;
            });
            this_1.Append(star);
        };
        var this_1 = this;
        for(var i = 1; i <= _this.Config.Count; i++)_loop_1(i);
        return _this;
    }
    Rate.Name = "Rate";
    return Rate;
}($joGvE.Div);
module.exports.Rate = $3cc60f0ae7725ed1$var$Rate;

});
parcelRegister("85QoO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateConfig = void 0;
var $5e476fc5648d347a$var$RateConfig = /** @class */ function() {
    function RateConfig() {
        this.Count = 5;
        this.SelectedSymbol = "\u2B50";
        this.SelectedStyle = "opacity: 1;";
        this.DeselectedSymbol = "\u2B50";
        this.DeselectedStyle = "opacity: 0.4;";
        this.Readonly = false;
    }
    return RateConfig;
}();
module.exports.RateConfig = $5e476fc5648d347a$var$RateConfig;

});

parcelRegister("1gg6H", function(module, exports) {
"use strict";
var $0eb3c79bca772948$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateStar = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $0eb3c79bca772948$var$RateStar = /** @class */ function(_super) {
    $0eb3c79bca772948$var$__extends(RateStar, _super);
    function RateStar(rating, showWhenLowerOrEqual, config) {
        var _this = _super.call(this) || this;
        _this.showWhenLowerOrEqual = showWhenLowerOrEqual;
        _this.config = config;
        _this.selected = new $gkD0R.Span(_this.config.SelectedSymbol).Style(_this.config.SelectedStyle).Hide();
        _this.deselected = new $gkD0R.Span(_this.config.DeselectedSymbol).Style(_this.config.DeselectedStyle);
        _this.DisplayInlineBlock();
        if (_this.config.Readonly == false) _this.CursorPointer();
        _this.Append(_this.selected, _this.deselected);
        rating.OnChange(function(v) {
            if (v >= _this.showWhenLowerOrEqual) {
                _this.selected.Show();
                _this.deselected.Hide();
            } else {
                _this.selected.Hide();
                _this.deselected.Show();
            }
        }, true);
        return _this;
    }
    return RateStar;
}($joGvE.Div);
module.exports.RateStar = $0eb3c79bca772948$var$RateStar;

});


parcelRegister("8Q6S6", function(module, exports) {
"use strict";
var $66f882a3097101e7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $66f882a3097101e7$var$DateInput = /** @class */ function(_super) {
    $66f882a3097101e7$var$__extends(DateInput, _super);
    function DateInput(value) {
        var _this = this;
        if (value instanceof $6wI3m.Ref) _this = _super.call(this, "input", value) || this;
        else if (value instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(value)) || this;
        else if (typeof value === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(value))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "date");
        _this.element.addEventListener('change', function(e) {
            var _a;
            var v = new Date(e.target.value);
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v);
        });
        _this.Refresh();
        return _this;
    }
    DateInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    DateInput.prototype.Refresh = function() {
        this.element.valueAsDate = new Date(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, '0');
    };
    DateInput.prototype.FormatDate = function(date) {
        return [
            date.getFullYear(),
            this.PadTo2Digits(date.getMonth() + 1),
            this.PadTo2Digits(date.getDate())
        ].join('-');
    };
    DateInput.Name = "DateInput";
    return DateInput;
}($k6KGm.RefComponentBase);
module.exports.DateInput = $66f882a3097101e7$var$DateInput;

});

parcelRegister("5ACZp", function(module, exports) {
"use strict";
var $411e8f08c0ff235c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $411e8f08c0ff235c$var$TimeInput = /** @class */ function(_super) {
    $411e8f08c0ff235c$var$__extends(TimeInput, _super);
    function TimeInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref(TimeInput.DefaultTime);
        var _this = _super.call(this, "input", ref) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "time");
        _this.element.addEventListener('change', function(e) {
            var _a;
            var v = e.target.value;
            var _b = v.split(":"), hour = _b[0], minute = _b[1];
            _this.ref.value = v;
            (_a = _this.onChange) === null || _a === void 0 || _a.call(_this, v, +hour, +minute);
        });
        _this.Refresh();
        return _this;
    }
    TimeInput.prototype.OnChange = function(callback) {
        this.onChange = callback;
        return this;
    };
    TimeInput.prototype.Refresh = function() {
        this.element.value = this.FormatTime(this.ref.value);
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    TimeInput.prototype.AddTime = function(hours, minutes) {
        var _a, _b, _c;
        if (minutes === void 0) minutes = 0;
        var _d = ((_b = (_a = this.Value) === null || _a === void 0 ? void 0 : _a.split(":")) === null || _b === void 0 ? void 0 : _b.map(function(x) {
            return +x;
        })) || [
            0,
            0
        ], hh = _d[0], mm = _d[1];
        hh = (hh + hours) % 24;
        hh < 0 && (hh = 23);
        mm = (mm + minutes) % 60;
        mm < 0 && (mm = 59);
        var v = hh + ":" + mm;
        this.Value = v;
        (_c = this.onChange) === null || _c === void 0 || _c.call(this, v, hh, mm);
        return this;
    };
    TimeInput.prototype.SetTime = function(hours, minutes) {
        var _a;
        if (minutes === void 0) minutes = 0;
        var v = hours + ":" + minutes;
        this.Value = v;
        (_a = this.onChange) === null || _a === void 0 || _a.call(this, v, hours, minutes);
        return this;
    };
    TimeInput.prototype.PadTo2Digits = function(num) {
        return num.toString().padStart(2, '0');
    };
    TimeInput.prototype.FormatTime = function(time) {
        var _a = time.split(":"), hour = _a[0], minute = _a[1];
        return [
            this.PadTo2Digits(hour),
            this.PadTo2Digits(minute)
        ].join(':');
    };
    TimeInput.Name = "TimeInput";
    TimeInput.DefaultTime = "12:00";
    return TimeInput;
}($k6KGm.RefComponentBase);
module.exports.TimeInput = $411e8f08c0ff235c$var$TimeInput;

});

parcelRegister("3UiF9", function(module, exports) {
"use strict";
var $2d851419d9636d90$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimeInput = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");
var $2d851419d9636d90$var$DateTimeInput = /** @class */ function(_super) {
    $2d851419d9636d90$var$__extends(DateTimeInput, _super);
    function DateTimeInput(ref) {
        var _this = this;
        if (ref instanceof $6wI3m.Ref) _this = _super.call(this, "input", ref) || this;
        else if (ref instanceof Date) _this = _super.call(this, "input", new $6wI3m.Ref(ref)) || this;
        else if (typeof ref === "number") _this = _super.call(this, "input", new $6wI3m.Ref(new Date(ref))) || this;
        else _this = _super.call(this, "input", new $6wI3m.Ref(new Date())) || this;
        _this.Class("uk-input");
        _this.Attribute("type", "datetime-local");
        // this.Attribute("type", "datetime");
        _this.element.addEventListener('change', function(e) {
            var v = e.target.value;
            // console.log('onchange', v)
            _this.ref.value = new Date(v);
        });
        _this.Refresh();
        return _this;
    }
    DateTimeInput.prototype.Refresh = function() {
        // Uzyskanie aktualnej daty i godziny w czasie uniwersalnym (UTC)
        var t = this.ref.value;
        // const tzoh = new Date().getTimezoneOffset() / 60;
        // console.log('TZO', tzoh)
        var year = t.getFullYear();
        var month = t.getMonth() + 1; // Pamiętaj, że miesiące są indeksowane od 0
        var day = t.getDate();
        // console.log(t.getHours(), tzoh)
        var hours = t.getHours(); //- tzoh;
        var minutes = t.getMinutes();
        // // Formatowanie daty i godziny do ISO string
        var dateWithoutTimezone = "".concat(year, "-").concat(month.toString().padStart(2, '0'), "-").concat(day.toString().padStart(2, '0'), "T").concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'));
        // console.log('CCCCCCCCc', currentISOString)
        this.element.value = dateWithoutTimezone;
        // console.log('REFR1', this.ref.value)
        // // console.log('REFR iso', this.ref.value.toISOString())
        // // console.log('REFR utc', this.ref.value.toUTCString())
        // console.log('REFR iii', currentISOString)
        // this.element.value =currentISOString// this.ref.value.toISOString().slice(0, 16);
        // console.log('REFR', this.element.value)
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    DateTimeInput.Name = "DateTimeInput";
    return DateTimeInput;
}($k6KGm.RefComponentBase);
module.exports.DateTimeInput = $2d851419d9636d90$var$DateTimeInput;

});

parcelRegister("2Tv9C", function(module, exports) {
"use strict";
var $21b8e266d708dd19$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableDateLabel = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $8Q6S6 = parcelRequire("8Q6S6");

var $joGvE = parcelRequire("joGvE");

var $8PO3e = parcelRequire("8PO3e");

var $2Vdhf = parcelRequire("2Vdhf");

var $2s69t = parcelRequire("2s69t");
var $21b8e266d708dd19$var$EditableDateLabel = /** @class */ function(_super) {
    $21b8e266d708dd19$var$__extends(EditableDateLabel, _super);
    function EditableDateLabel(ref, printer) {
        if (ref === void 0) ref = new $2Vdhf.RefDate(0);
        if (printer === void 0) printer = function(value) {
            return +value == 0 ? "unset" : value.getDate() + "." + (value.getMonth() + 1) + "." + value.getFullYear();
        };
        var _this = _super.call(this) || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Label = new $3B1VX.Text(ref, function(v) {
            return printer(v);
        }).CursorPointer().OnClick(function() {
            _this.Label.Hide();
            _this.DateInput.Show();
            _this.OffButton.Show();
        });
        _this.DateInput = new $8Q6S6.DateInput(ref).DisplayInline().WidthAuto().Hide().OnChange(function(date) {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
            _this.onChange.Call(date);
        }).OnBlur(function() {
            _this.DateInput.Hide();
            _this.OffButton.Hide();
            _this.Label.Show();
        });
        _this.OffButton = new $2s69t.Button("\u2716").CursorPointer().Inline().Hide();
        _this.OffButton.OnClick(function() {
            _this.Label.Show();
            _this.DateInput.Hide();
            _this.OffButton.Hide();
        });
        // this.DateInput.Width(85, "%")
        _this.OffButton.MarginLeft(6);
        // NIE DA SIE KLIKNĄĆ W KONTROLKE BO ŁAPIE BLURA :(
        // this.SetAttribute("tabindex", "0");
        // this.OnBlur(() =>
        // {
        //     this.DateInput.Hide();
        //     this.Label.Show();
        // });
        _this.Append(_this.Label, _this.DateInput, _this.OffButton);
        return _this;
    }
    EditableDateLabel.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    EditableDateLabel.prototype.DateInputConfig = function(config) {
        config(this.DateInput);
        return this;
    };
    EditableDateLabel.prototype.OffButtonConfig = function(config) {
        config(this.OffButton);
        return this;
    };
    EditableDateLabel.prototype.LabelConfig = function(config) {
        config(this.Label);
        return this;
    };
    EditableDateLabel.Name = "EditableDateLabel";
    return EditableDateLabel;
}($joGvE.Div);
module.exports.EditableDateLabel = $21b8e266d708dd19$var$EditableDateLabel;

});

parcelRegister("fGn1O", function(module, exports) {
"use strict";
var $b6aca43425439cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableTextarea = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $3B1VX = parcelRequire("3B1VX");

var $37QPp = parcelRequire("37QPp");
var $b6aca43425439cfe$var$EditableTextarea = /** @class */ function(_super) {
    $b6aca43425439cfe$var$__extends(EditableTextarea, _super);
    function EditableTextarea(ref, config) {
        if (config === void 0) config = {
            editOnClick: true
        };
        var _this = _super.call(this, "div") || this;
        _this.ref = ref;
        _this.config = config;
        _this.valueBeforeEdit = "";
        _this.label = new $3B1VX.Text(ref).CursorPointer().Show();
        if (config.editOnClick) _this.label.OnClick(function() {
            if (config.editOnClick) _this.EditMode();
        });
        _this.textInput = new $37QPp.MultilineInput(ref).Hide();
        if (config.editOnClick) _this.textInput.OnBlur(function() {
            if (config.editOnClick) _this.EndOfEdit();
        });
        _this.Append(_this.label, _this.textInput);
        return _this;
    }
    EditableTextarea.prototype.EditMode = function() {
        var linesCount = this.ref.value.split("\n").length;
        this.textInput.Rows(linesCount);
        this.valueBeforeEdit = this.ref.value;
        var labelWidth = getComputedStyle(this.label.Element).width;
        var w = +labelWidth.replace("px", "");
        if (w < 100) w += 32;
        this.label.Hide();
        this.textInput.Show().Width(w).Padding(2, 6);
    };
    EditableTextarea.prototype.EnableEditMode = function() {
        this.config.editOnClick = true;
    };
    EditableTextarea.prototype.DisableEditMode = function() {
        this.config.editOnClick = false;
    };
    Object.defineProperty(EditableTextarea.prototype, "IsEditMode", {
        get: function() {
            return this.textInput.IsVisible();
        },
        enumerable: false,
        configurable: true
    });
    EditableTextarea.prototype.ToggleEditMode = function() {
        if (this.IsEditMode) this.CloseEditMode();
        else this.EditMode();
        return this;
    };
    EditableTextarea.prototype.OpenEditMode = function() {
        this.EditMode();
        return this;
    };
    EditableTextarea.prototype.CloseEditMode = function() {
        this.EndOfEdit();
        return this;
    };
    EditableTextarea.prototype.LabelConfig = function(config) {
        config(this.label);
        return this;
    };
    EditableTextarea.prototype.TextInputConfig = function(config) {
        config(this.textInput);
        return this;
    };
    EditableTextarea.prototype.OnEditEnd = function(callback) {
        this.editEnd = callback;
        return this;
    };
    EditableTextarea.prototype.EndOfEdit = function() {
        var _a;
        if (!this.textInput.IsVisible()) return; // To prevent double call
        this.textInput.Hide();
        this.label.Show();
        (_a = this.editEnd) === null || _a === void 0 || _a.call(this, this.valueBeforeEdit, this.ref.value);
    };
    EditableTextarea.prototype.DefaultText = function(text) {
        this.label.DefaultText(text);
        return this;
    };
    EditableTextarea.prototype.Placeholder = function(placeholder) {
        this.textInput.Placeholder(placeholder);
        return this;
    };
    EditableTextarea.prototype.Style = function(prop, val) {
        this.label.Style(prop, val);
        this.textInput.Style(prop, val);
        return this;
    };
    EditableTextarea.Name = "EditableTextarea";
    return EditableTextarea;
}($aKtiT.ComponentBase);
module.exports.EditableTextarea = $b6aca43425439cfe$var$EditableTextarea;

});
parcelRegister("37QPp", function(module, exports) {
"use strict";
var $246b012041d45c9e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultilineInput = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $6wI3m = parcelRequire("6wI3m");
var $246b012041d45c9e$var$MultilineInput = /** @class */ function(_super) {
    $246b012041d45c9e$var$__extends(MultilineInput, _super);
    function MultilineInput(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = this;
        if (typeof ref === "string") ref = new $6wI3m.Ref(ref);
        _this = _super.call(this, "textarea", ref) || this;
        _this.Class(MultilineInput.DefaultCssClasses);
        _this.element.addEventListener('input', function(e) {
            _this.ref.value = e.target.value;
        });
        _this.Refresh();
        return _this;
    }
    MultilineInput.prototype.Placeholder = function(placeholder) {
        var _this = this;
        this.React(placeholder, function(v) {
            return _this.Attribute("placeholder", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Readonly = function() {
        this.Attribute("readonly");
        return this;
    };
    MultilineInput.prototype.Rows = function(count) {
        var _this = this;
        this.React(count, function(v) {
            return _this.Attribute("rows", v.toString());
        });
        return this;
    };
    MultilineInput.prototype.Refresh = function() {
        this.element.value = this.ref.value;
        if (this.showThatChanged) this.ref.HasChanged ? this.element.classList.add("tf-value-changed") : this.element.classList.remove("tf-value-changed");
    };
    MultilineInput.Name = "MultilineInput";
    MultilineInput.DefaultCssClasses = "";
    return MultilineInput;
}($k6KGm.RefComponentBase);
module.exports.MultilineInput = $246b012041d45c9e$var$MultilineInput;

});


parcelRegister("hEMp0", function(module, exports) {
"use strict";
var $cdabb7ce117dd32c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledTextInput2 = module.exports.LabeledTextInput = void 0;

var $etGN3 = parcelRequire("etGN3");

var $6wI3m = parcelRequire("6wI3m");

var $gkD0R = parcelRequire("gkD0R");

var $joGvE = parcelRequire("joGvE");
var $cdabb7ce117dd32c$var$LabeledTextInput = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput, _super);
    function LabeledTextInput(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this, "LabeledTextInput") || this;
        _this.Append(new $gkD0R.Span(label).Class("label"));
        _this.Append(new $etGN3.TextInput(variable).Placeholder(label).Class("input"));
        return _this;
    }
    return LabeledTextInput;
}($joGvE.Div);
module.exports.LabeledTextInput = $cdabb7ce117dd32c$var$LabeledTextInput;
var $cdabb7ce117dd32c$var$LabeledTextInput2 = /** @class */ function(_super) {
    $cdabb7ce117dd32c$var$__extends(LabeledTextInput2, _super);
    function LabeledTextInput2(label, variable) {
        if (variable === void 0) variable = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.Append(new $gkD0R.Span(label).Width(320).DisplayInlineBlock(), new $etGN3.TextInput(variable).Placeholder(label).Width(200));
        return _this;
    }
    return LabeledTextInput2;
}($joGvE.Div);
module.exports.LabeledTextInput2 = $cdabb7ce117dd32c$var$LabeledTextInput2;

});

parcelRegister("kUDwd", function(module, exports) {
"use strict";
var $f397b129d653e146$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledNumberInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $4ytZ3 = parcelRequire("4ytZ3");
var $f397b129d653e146$var$LabeledNumberInput = /** @class */ function(_super) {
    $f397b129d653e146$var$__extends(LabeledNumberInput, _super);
    function LabeledNumberInput(label, ref) {
        var _this = _super.call(this, "tf-form-labeled-number") || this;
        _this.label = label;
        _this.ref = ref;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.numberInput = new $4ytZ3.NumberInput(_this.ref).Class("input");
        _this.Append(_this.labelCmp, _this.numberInput);
        return _this;
    }
    LabeledNumberInput.prototype.Min = function(min) {
        this.numberInput.Min(min);
        return this;
    };
    LabeledNumberInput.prototype.Max = function(max) {
        this.numberInput.Max(max);
        return this;
    };
    LabeledNumberInput.prototype.Step = function(step) {
        this.numberInput.Step(step);
        return this;
    };
    LabeledNumberInput.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.numberInput);
        return this;
    };
    return LabeledNumberInput;
}($joGvE.Div);
module.exports.LabeledNumberInput = $f397b129d653e146$var$LabeledNumberInput;

});

parcelRegister("iBXy5", function(module, exports) {
"use strict";
var $d8c9dfd5cab4d14d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabeledSelect2 = module.exports.LabeledSelect = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $bGQX2 = parcelRequire("bGQX2");
var $d8c9dfd5cab4d14d$var$LabeledSelect = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect, _super);
    function LabeledSelect(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label");
        _this.input = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input");
        _this.Append(_this.labelCmp, _this.input);
        return _this;
    }
    LabeledSelect.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.input);
        return this;
    };
    return LabeledSelect;
}($joGvE.Div);
module.exports.LabeledSelect = $d8c9dfd5cab4d14d$var$LabeledSelect;
var $d8c9dfd5cab4d14d$var$LabeledSelect2 = /** @class */ function(_super) {
    $d8c9dfd5cab4d14d$var$__extends(LabeledSelect2, _super);
    function LabeledSelect2(label, ref, selectOptions) {
        if (selectOptions === void 0) selectOptions = [];
        var _this = _super.call(this, "tf-form-labeled-select") || this;
        _this.label = label;
        _this.ref = ref;
        _this.selectOptions = selectOptions;
        _this.labelCmp = new $gkD0R.Span(_this.label).Class("label").Width(320).DisplayInlineBlock();
        _this.Select = new $bGQX2.Select(_this.ref, _this.selectOptions).Class("input").Width(200);
        _this.Append(_this.labelCmp, _this.Select);
        return _this;
    }
    LabeledSelect2.prototype.Edit = function(hook) {
        hook(this.labelCmp, this.Select);
        return this;
    };
    return LabeledSelect2;
}($joGvE.Div);
module.exports.LabeledSelect2 = $d8c9dfd5cab4d14d$var$LabeledSelect2;

});

parcelRegister("6dx9g", function(module, exports) {
"use strict";
var $012b0f2770500f94$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultipleFilesInput = module.exports.FileInput = module.exports.FileInputV1 = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $8PO3e = parcelRequire("8PO3e");
var $012b0f2770500f94$var$FileInputV1 = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInputV1, _super);
    function FileInputV1() {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.element.addEventListener('change', function(e) {
            var _a;
            // console.log(this.element.files[0])
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInputV1.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInputV1.Name = "FileInput";
    FileInputV1.DefaultCssClasses = "";
    return FileInputV1;
}($aKtiT.ComponentBase);
module.exports.FileInputV1 = $012b0f2770500f94$var$FileInputV1;
var $012b0f2770500f94$var$FileInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(FileInput, _super);
    function FileInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file");
        _this.Class(FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener('change', function(e) {
            var _a;
            _this.onChange.Call((_a = _this.element.files) === null || _a === void 0 ? void 0 : _a[0], e);
        });
        return _this;
    }
    FileInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    FileInput.Name = "FileInput";
    FileInput.DefaultCssClasses = "";
    return FileInput;
}($aKtiT.ComponentBase);
module.exports.FileInput = $012b0f2770500f94$var$FileInput;
var $012b0f2770500f94$var$MultipleFilesInput = /** @class */ function(_super) {
    $012b0f2770500f94$var$__extends(MultipleFilesInput, _super);
    function MultipleFilesInput(onChange) {
        var _this = _super.call(this, "input") || this;
        _this.onChange = new $8PO3e.HandlersCollection();
        _this.Attribute("type", "file").Attribute("multiple");
        _this.Class($012b0f2770500f94$var$FileInput.DefaultCssClasses);
        _this.onChange.Add(onChange);
        _this.element.addEventListener('change', function(e) {
            _this.onChange.Call(_this.element.files, e);
        });
        return _this;
    }
    MultipleFilesInput.prototype.OnChange = function(handler) {
        this.onChange.Add(handler);
        return this;
    };
    MultipleFilesInput.Name = "MultipleFilesInput";
    MultipleFilesInput.DefaultCssClasses = "";
    return MultipleFilesInput;
}($aKtiT.ComponentBase);
module.exports.MultipleFilesInput = $012b0f2770500f94$var$MultipleFilesInput;

});

parcelRegister("bL1Ff", function(module, exports) {
"use strict";
var $88f55ffae983f4ad$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = module.exports.Menu = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $2S24U = parcelRequire("2S24U");
var $88f55ffae983f4ad$var$Menu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(Menu, _super);
    function Menu(menuItems, menuClasses, onClose) {
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "menu") || this;
        _this.onClose = onClose;
        // ☢️ UWAGA! TO MA BYĆ FUNKCJA (NIE METODA) JEŚLI ZROBIMY Z TEGO METODĘ TO NIE DZIAŁA document.removeEventListener. 
        // NIE WAŻNE CZY DO TEJ METODY PRZEKAŻEMY WSKAŹNIK NA METODE, WYWOŁANIE FUNKCJI STRZAŁKOWEJ CZY ZROBIMY .bind(this). 
        // KAŻDA TA OPCJA NIE DZIAŁA CO POTEM POWODUJE PROBLEMY Z RemoveSelf BO JEST TRACONY KONTEKST DO this. 
        // MOŻNA OD BIEDY WSPOMÓC SIĘ POMOCNICZĄ FLAGĄ ALE TAK KOD JEST CZYSTSZY CHOĆ WYGLĄDA KRETYŃSKO.
        _this.DocumentClick = function() {
            var _a;
            _this.RemoveSelf();
            (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
        };
        _this.Class(menuClasses);
        _this.Append.apply(_this, Object.entries(menuItems).map(function(_a) {
            var label = _a[0], action = _a[1];
            var span = new $gkD0R.Span(label).Class("menu-item").OnClick(function() {
                var _a;
                document.removeEventListener("click", _this.DocumentClick);
                _this.RemoveSelf();
                (_a = _this.onClose) === null || _a === void 0 || _a.call(_this);
                action();
            });
            return span;
        }));
        document.addEventListener("click", _this.DocumentClick, {
            once: true
        });
        return _this;
    }
    Menu.Name = "Menu";
    return Menu;
}($joGvE.Div);
module.exports.Menu = $88f55ffae983f4ad$var$Menu;
/*
    REMEMBER TO KEEP BUTTON IN A RELATIVE CONTAINER.
*/ var $88f55ffae983f4ad$var$PopupMenu = /** @class */ function(_super) {
    $88f55ffae983f4ad$var$__extends(PopupMenu, _super);
    function PopupMenu(menuItems, activator, menuClasses) {
        if (activator === void 0) activator = new $2S24U.Button("\u22EE").RemoveAllClasses();
        if (menuClasses === void 0) menuClasses = "";
        var _this = _super.call(this, "popup-menu") || this;
        var allowClick = true;
        _this.Append(activator.OnClick(function(_) {
            if (!allowClick) return;
            allowClick = false;
            _.Disabled();
            _this.Append(new $88f55ffae983f4ad$var$Menu(menuItems, menuClasses, function() {
                allowClick = true;
                _.Enabled();
            }));
        }));
        return _this;
    }
    PopupMenu.Name = "PopupMenu";
    return PopupMenu;
}($joGvE.Div);
module.exports.PopupMenu = $88f55ffae983f4ad$var$PopupMenu;

});

parcelRegister("5BSVz", function(module, exports) {
"use strict";
var $415b03e7f5c4206b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextCombo = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $joGvE = parcelRequire("joGvE");

var $gg7jy = parcelRequire("gg7jy");

var $azQFq = parcelRequire("azQFq");
// TODO?: pokazywanie wyników tylko jeśli jest focus na kontrolce
// ✅ TODO: możliwość odkliknięcia - lista wyników znika
// TODO: możliwość wybrania strzałkami z klawiatury
// ✅ TODO: ESC zamyka listę wyników
// TODO: po wybraniu/kliknięciu lista wyników zamyka się
var $415b03e7f5c4206b$var$TextCombo = /** @class */ function(_super) {
    $415b03e7f5c4206b$var$__extends(TextCombo, _super);
    function TextCombo(needle, stack) {
        if (needle === void 0) needle = new $6wI3m.Ref("");
        if (stack === void 0) stack = [];
        var _this = _super.call(this) || this;
        _this.needle = needle;
        _this.MaxResults = 5;
        _this.whenNoResultsText = "No results found";
        _this.SearchInput = new $azQFq.ClearableTextInput(_this.needle);
        _this.ResultsList = new $gg7jy.TextComboSearchResult(_this.MaxResults);
        needle.OnChange(function(v) {
            // TODO: move it all to TextComboSearchResult????
            var needleValue = v.trim().toLowerCase();
            var items = Array.isArray(stack) ? stack : stack.Items;
            var filteredItems = items.filter(function(x) {
                return x.SearchBy.toLowerCase().includes(needleValue);
            });
            // TODO: move to ResultsList?
            if (filteredItems.length == 0) _this.ResultsList.NoResults(_this.whenNoResultsText);
            else if (needleValue.length == 0) _this.ResultsList.Hide();
            else _this.ResultsList.LoadResults(filteredItems);
        });
        _this.SearchInput.TextInput.OnBlur(function() {
            // Timeout because Hide fires before item click
            setTimeout(function() {
                _this.ResultsList.Hide();
            }, 300);
        });
        _this.SearchInput.TextInput.OnFocus(function() {
            if (needle.value.length > 0) _this.ResultsList.Show();
        });
        _this.Append(_this.SearchInput, _this.ResultsList);
        return _this;
    }
    TextCombo.prototype.Placeholder = function(placeholder) {
        this.SearchInput.TextInput.Placeholder(placeholder);
        return this;
    };
    TextCombo.prototype.NoResultsText = function(text) {
        this.whenNoResultsText = text;
        return this;
    };
    TextCombo.Name = "TextCombo";
    TextCombo.DefaultCssClasses = "";
    return TextCombo;
}($joGvE.Div);
module.exports.TextCombo = $415b03e7f5c4206b$var$TextCombo;

});
parcelRegister("gg7jy", function(module, exports) {
"use strict";
var $bd63d07550015afb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResult = void 0;

var $joGvE = parcelRequire("joGvE");

var $8Lkmv = parcelRequire("8Lkmv");
var $bd63d07550015afb$var$TextComboSearchResult = /** @class */ function(_super) {
    $bd63d07550015afb$var$__extends(TextComboSearchResult, _super);
    function TextComboSearchResult(maxResults) {
        var _this = _super.call(this, "TextComboSearchResult") || this;
        _this.maxResults = maxResults;
        return _this;
    }
    TextComboSearchResult.prototype.NoResults = function(whenNoResultsText) {
        if (whenNoResultsText === void 0) whenNoResultsText = "No results found";
        this.Clear();
        this.Show();
        this.Append(new $joGvE.Div().Text(whenNoResultsText).Style("text-align: center;").Class("no-results"));
    };
    TextComboSearchResult.prototype.LoadResults = function(items) {
        this.Clear();
        this.Show();
        this.Append.apply(this, items.slice(0, this.maxResults).map(function(x) {
            return new $8Lkmv.TextComboSearchResultItem(x);
        }));
    };
    return TextComboSearchResult;
}($joGvE.Div);
module.exports.TextComboSearchResult = $bd63d07550015afb$var$TextComboSearchResult;

});
parcelRegister("8Lkmv", function(module, exports) {
"use strict";
var $661281f9fbfe1c03$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextComboSearchResultItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $661281f9fbfe1c03$var$TextComboSearchResultItem = /** @class */ function(_super) {
    $661281f9fbfe1c03$var$__extends(TextComboSearchResultItem, _super);
    function TextComboSearchResultItem(item) {
        var _this = _super.call(this, "TextComboSearchResultItem") || this;
        _this.Append(item.BindedTo());
        return _this;
    }
    return TextComboSearchResultItem;
}($joGvE.Div);
module.exports.TextComboSearchResultItem = $661281f9fbfe1c03$var$TextComboSearchResultItem;

});


parcelRegister("azQFq", function(module, exports) {
"use strict";
var $7b3606d93cf72d77$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClearableTextInput = void 0;

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");

var $etGN3 = parcelRequire("etGN3");
var $7b3606d93cf72d77$var$ClearableTextInput = /** @class */ function(_super) {
    $7b3606d93cf72d77$var$__extends(ClearableTextInput, _super);
    function ClearableTextInput(value, placeholder) {
        var _this = _super.call(this, "ClearableTextInput") || this;
        _this.value = value;
        _this.placeholder = placeholder;
        _this.PositionRelative();
        _this.TextInput = new $etGN3.TextInput(_this.value).Placeholder(_this.placeholder || "");
        _this.ClearButton = new $gkD0R.Span("\xd7").Class("x");
        _this.ClearButton.OnClick(function() {
            return _this.value.value = "";
        }).VisibleWhen(_this.value, function(v) {
            return v.length > 0;
        });
        _this.Append(_this.TextInput, _this.ClearButton);
        return _this;
    }
    ClearableTextInput.Name = "ClearableTextInput";
    return ClearableTextInput;
}($joGvE.Div);
module.exports.ClearableTextInput = $7b3606d93cf72d77$var$ClearableTextInput;

});


parcelRegister("7Kd03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchableItem = void 0;

var $joGvE = parcelRequire("joGvE");
var $5a36e9ce10fb7745$var$SearchableItem = /** @class */ function() {
    function SearchableItem(searchBy, bindedTo, onClick) {
        this.SearchBy = searchBy;
        this.BindedTo = function() {
            return new $joGvE.Div().Append(bindedTo()).OnClick(onClick);
        };
    }
    return SearchableItem;
}();
module.exports.SearchableItem = $5a36e9ce10fb7745$var$SearchableItem;

});

parcelRegister("bEnZu", function(module, exports) {
"use strict";
var $87b60a2f958f6b0a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalWindow = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $8PO3e = parcelRequire("8PO3e");

var $joGvE = parcelRequire("joGvE");

var $5PIlt = parcelRequire("5PIlt");

var $4wFdb = parcelRequire("4wFdb");

var $3B1VX = parcelRequire("3B1VX");
var $87b60a2f958f6b0a$var$ModalWindow = /** @class */ function(_super) {
    $87b60a2f958f6b0a$var$__extends(ModalWindow, _super);
    function ModalWindow(title, blurBackground, lockScroll, closeOnClickAway) {
        if (blurBackground === void 0) blurBackground = true;
        if (lockScroll === void 0) lockScroll = false;
        if (closeOnClickAway === void 0) closeOnClickAway = false;
        var _this = _super.call(this) || this;
        _this.blurBackground = blurBackground;
        _this.lockScroll = lockScroll;
        _this.closeOnClickAway = closeOnClickAway;
        _this.shutter = new $4wFdb.Shutter();
        _this.windowTitle = new $6wI3m.Ref("");
        _this.onBeforeCloseOrHideWindow = new $8PO3e.HandlersCollection();
        _this.onCloseOrHideWindow = new $8PO3e.HandlersCollection(); // close by pressing X or CloseWindow() call
        _this.onExitWindow = new $8PO3e.HandlersCollection(); // close by calling ExitWindow()
        _this.CloseButtonAction = function() {
            return _this.CloseWindow();
        };
        _this.CloseButton = new $5PIlt.Link("\xd7").NoDecorationOnHover().Class("tf-modal-window-close").OnClick(function() {
            return _this.CloseButtonAction();
        });
        _this.header = new $joGvE.Div().Class("tf-modal-window-header");
        _this.content = new $joGvE.Div().Class("tf-modal-window-content");
        _this.footer = new $joGvE.Div().Class("tf-modal-window-footer");
        _this.wasEverOpen = false;
        _this.Class(ModalWindow.DefaultCssClasses);
        _this.windowTitle.value = title instanceof $6wI3m.Ref ? title.value : title;
        return _this;
    }
    Object.defineProperty(ModalWindow.prototype, "Shutter", {
        get: function() {
            return this.shutter;
        },
        enumerable: false,
        configurable: true
    });
    ModalWindow.prototype.NoCloseButton = function() {
        this.CloseButton = null;
        return this;
    };
    ModalWindow.prototype.SetCloseButtonAction = function(handler) {
        this.CloseButtonAction = handler;
        return this;
    };
    ModalWindow.prototype.FullScreen = function() {
        return this.WidthPercent(100).HeightPercent(100);
    };
    ModalWindow.prototype.HideOnClose = function() {
        var _this = this;
        this.CloseButtonAction = function() {
            return _this.HideWindow();
        };
        return this;
    };
    ModalWindow.prototype.OpenWindow = function() {
        var _this = this;
        var _a, _b;
        this.Append(this.header.Append(new $joGvE.Div("tf-modal-window-header-title-section").Append(new $3B1VX.Text(this.windowTitle)), new $joGvE.Div("tf-modal-window-header-buttons-section").Append(this.CloseButton && this.CloseButton)), this.content, this.footer.HasAnyChildren && this.footer);
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.Append(this.Element);
        if (this.lockScroll) this.LockPageScroll();
        if (this.closeOnClickAway) this.Shutter.OnClick(function() {
            return _this.CloseButtonAction();
        });
        return this;
    };
    ModalWindow.prototype.Title = function(title) {
        this.windowTitle.value = title;
        return this;
    };
    ModalWindow.prototype.CloseWindow = function(onClosePayload) {
        if (this.onBeforeCloseOrHideWindow.AreAny) {
            var allowClose = this.onBeforeCloseOrHideWindow.CallAndGatherReturnValue();
            if (allowClose.some(function(x) {
                return x == false;
            })) return this;
        }
        this.RemoveWindow();
        this.onCloseOrHideWindow.Call(onClosePayload);
        return this;
    };
    ModalWindow.prototype.RemoveWindow = function() {
        var _a, _b;
        this.Clear();
        try {
            (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.Element);
            if (this.blurBackground) (_b = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _b === void 0 || _b.removeChild(this.shutter.Element);
        } catch (ex) {
            throw new Error("[truffle] You are trying to remove element (that window) that is not a child of ".concat(ModalWindow.Hook, ". Make sure Root.Hook and ModalWindow.Root are the same. Remember to not attach ModalWindow to any other element with .Append(). Exception:"), ex);
        }
        if (this.lockScroll) this.UnlockPageScroll();
    };
    ModalWindow.prototype.ExitWindow = function(onExitPayload) {
        this.RemoveWindow();
        this.onExitWindow.Call(onExitPayload);
        return this;
    };
    ModalWindow.prototype.ShowWindow = function() {
        var _a;
        if (this.wasEverOpen == false) {
            this.OpenWindow();
            this.wasEverOpen = true;
        }
        (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.Append(this.shutter.Element);
        this.Show().ZIndex(100);
        return this;
    };
    ModalWindow.prototype.HideWindow = function() {
        var _a;
        if (this.blurBackground) (_a = (0, $iqyiC.$)(ModalWindow.Hook)) === null || _a === void 0 || _a.removeChild(this.shutter.Element);
        this.Hide();
        this.onCloseOrHideWindow.Call();
        if (this.lockScroll) this.UnlockPageScroll();
        return this;
    };
    ModalWindow.prototype.AddToHeader = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.header).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddContent = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.content).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.AddToFooter = function() {
        var _a;
        var elements = [];
        for(var _i = 0; _i < arguments.length; _i++)elements[_i] = arguments[_i];
        (_a = this.footer).Append.apply(_a, elements);
        return this;
    };
    ModalWindow.prototype.OnCloseWindow = function(handler) {
        this.onCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnExitWindow = function(handler) {
        this.onExitWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.OnBeforeCloseWindow = function(handler) {
        this.onBeforeCloseOrHideWindow.Add(handler);
        return this;
    };
    ModalWindow.prototype.LockPageScroll = function() {
        document.body.classList.add("tf-stop-scrolling");
    };
    ModalWindow.prototype.UnlockPageScroll = function() {
        document.body.classList.remove("tf-stop-scrolling");
    };
    ModalWindow.Name = "ModalWindow";
    ModalWindow.DefaultCssClasses = "";
    ModalWindow.Hook = "body";
    return ModalWindow;
}($joGvE.Div);
module.exports.ModalWindow = $87b60a2f958f6b0a$var$ModalWindow;

});
parcelRegister("4wFdb", function(module, exports) {
"use strict";
var $34ba1e59762b223a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Shutter = void 0;

var $joGvE = parcelRequire("joGvE");
var $34ba1e59762b223a$var$Shutter = /** @class */ function(_super) {
    $34ba1e59762b223a$var$__extends(Shutter, _super);
    function Shutter() {
        return _super.call(this, "tf-shutter") || this;
    }
    return Shutter;
}($joGvE.Div);
module.exports.Shutter = $34ba1e59762b223a$var$Shutter;

});


parcelRegister("fMKT6", function(module, exports) {
"use strict";
var $b7dfb5a097b9983d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioSwitchesBuilder = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $b7dfb5a097b9983d$var$RadioSwitchesBuilder = /** @class */ function(_super) {
    $b7dfb5a097b9983d$var$__extends(RadioSwitchesBuilder, _super);
    function RadioSwitchesBuilder(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.switches = {};
        _this.classWhenActive = {};
        return _this;
    }
    RadioSwitchesBuilder.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            var classWhenActive = _this.classWhenActive[activator];
            if (_this.ref.value === activator) cmp.AddClass(classWhenActive);
            else cmp.RemoveClass(classWhenActive);
        });
    };
    RadioSwitchesBuilder.prototype.AddSwitch = function(activator, cmp, cssClassWhenActive) {
        var _this = this;
        this.switches[activator] = cmp;
        this.classWhenActive[activator] = cssClassWhenActive;
        cmp.OnClick(function() {
            return _this.ref.value = activator;
        });
        if (this.ref.value == activator) cmp.AddClass(cssClassWhenActive);
        if (this.ref.value == "") this.ref.value = activator;
        this.Append(cmp);
        return this;
    };
    return RadioSwitchesBuilder;
}($k6KGm.RefComponentBase);
module.exports.RadioSwitchesBuilder = $b7dfb5a097b9983d$var$RadioSwitchesBuilder;

});

parcelRegister("a9HcF", function(module, exports) {
"use strict";
var $764c41ee5cf11ca2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $764c41ee5cf11ca2$var$DestroyingContentSwitcher = /** @class */ function(_super) {
    $764c41ee5cf11ca2$var$__extends(DestroyingContentSwitcher, _super);
    function DestroyingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        return _this;
    }
    DestroyingContentSwitcher.prototype.AddContent = function(activator, cmp) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp;
        if (activator === this.ref.value) {
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent()) 
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.AddDefaultContent = function(cmp) {
        this.defaultContent = cmp;
        if (!this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "")) {
            // this.Append(cmp());
            var result = cmp();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
        return this;
    };
    DestroyingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var c = (_b = (_a = this.contents)[valueKey]) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.Clear();
        if (c) {
            // this.Append(c);
            // const result = c;
            if (Array.isArray(c)) this.Append.apply(this, c);
            else this.Append(c);
        } else if (this.defaultContent) {
            // this.Append(this.defaultContent())
            var result = this.defaultContent();
            if (Array.isArray(result)) this.Append.apply(this, result);
            else this.Append(result);
        }
    };
    DestroyingContentSwitcher.Name = "DestroyingContentSwitcher";
    return DestroyingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingContentSwitcher = $764c41ee5cf11ca2$var$DestroyingContentSwitcher;

});

parcelRegister("3slAG", function(module, exports) {
"use strict";
var $2844bc1766a7ae91$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DestroyingPatternContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");

var $3CTSE = parcelRequire("3CTSE");
var $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher = /** @class */ function(_super) {
    $2844bc1766a7ae91$var$__extends(DestroyingPatternContentSwitcher, _super);
    function DestroyingPatternContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {}; // TODO: to jest słabe, trzeba by to wynieść do jakiejś osobnej klasy
        return _this;
    }
    DestroyingPatternContentSwitcher.prototype.AddContent = function(pattern, cmp) {
        this.contents[pattern] = cmp;
        // const extractor = new PatternExtractor(pattern);
        // const params = extractor.Extract(this.ref.value);
        // if (params == null) // a co jak mamy pattern bez parametrów? zwraca pusty obiekt? TAK!
        // {
        //     return this;
        // }
        // this.Append(cmp(params));
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.AddDefaultContent = function(defaultCmp) {
        this.defaultContent = defaultCmp;
        if (!this.IsRefOneOfPatterns()) this.Append(defaultCmp());
        return this;
    };
    DestroyingPatternContentSwitcher.prototype.IsRefOneOfPatterns = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return true;
        }
        return false;
    };
    DestroyingPatternContentSwitcher.prototype.FindPatternAndParams = function() {
        for(var _i = 0, _a = this.contents.Keys(); _i < _a.length; _i++){
            var pattern = _a[_i];
            var extractor = new $3CTSE.PatternExtractor(pattern);
            var params = extractor.Extract(this.ref.value);
            if (params != null) return {
                found: true,
                pattern: pattern,
                params: params
            };
        }
        return {
            found: false,
            pattern: null,
            params: null
        };
    };
    DestroyingPatternContentSwitcher.prototype.Refresh = function() {
        this.Clear();
        var searchResult = this.FindPatternAndParams();
        if (searchResult.found) this.Append(this.contents[searchResult.pattern](searchResult.params));
        else if (this.defaultContent) this.Append(this.defaultContent());
        return this;
    };
    DestroyingPatternContentSwitcher.Name = "DestroyingPatternContentSwitcher";
    return DestroyingPatternContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.DestroyingPatternContentSwitcher = $2844bc1766a7ae91$var$DestroyingPatternContentSwitcher;

});

parcelRegister("4yfSX", function(module, exports) {
"use strict";
var $3506a8e7090cd5f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HidingContentSwitcher = void 0;

var $k6KGm = parcelRequire("k6KGm");
var $3506a8e7090cd5f2$var$HidingContentSwitcher = /** @class */ function(_super) {
    $3506a8e7090cd5f2$var$__extends(HidingContentSwitcher, _super);
    function HidingContentSwitcher(ref) {
        var _this = _super.call(this, "div", ref) || this;
        _this.contents = {};
        _this.showAses = {};
        _this.defaultContentShowAs = "";
        return _this;
    }
    HidingContentSwitcher.prototype.AddContent = function(activator, cmp, showAs) {
        var activatorKey = activator != null ? String(activator) : "";
        this.contents[activatorKey] = cmp();
        this.showAses[activatorKey] = showAs || "";
        if (activator === this.ref.value) this.Append(this.contents[activatorKey]);
        return this;
    };
    HidingContentSwitcher.prototype.AddDefaultContent = function(cmp, showAs) {
        this.defaultContent = cmp();
        this.defaultContentShowAs = showAs || "";
        if (!this.IsOneOfTheContents()) this.Append(this.defaultContent);
        return this;
    };
    HidingContentSwitcher.prototype.IsOneOfTheContents = function() {
        return this.contents.Keys().includes(this.ref.value != null ? String(this.ref.value) : "");
    };
    HidingContentSwitcher.prototype.Refresh = function() {
        var _a, _b;
        this.contents.Values().forEach(function(x) {
            return x.Hide();
        });
        var valueKey = this.ref.value != null ? String(this.ref.value) : "";
        var newContent = this.contents[valueKey];
        if (newContent) {
            (_a = this.defaultContent) === null || _a === void 0 || _a.Hide();
            if (!this.Exist(newContent)) this.Append(newContent);
            newContent.Show(this.showAses[valueKey]);
        } else {
            if (this.defaultContent && !this.Exist(this.defaultContent)) this.Append(this.defaultContent);
            (_b = this.defaultContent) === null || _b === void 0 || _b.Show(this.defaultContentShowAs);
        }
    };
    HidingContentSwitcher.Name = "HidingContentSwitcher";
    return HidingContentSwitcher;
}($k6KGm.RefComponentBase);
module.exports.HidingContentSwitcher = $3506a8e7090cd5f2$var$HidingContentSwitcher;

});

parcelRegister("3700g", function(module, exports) {
"use strict";
var $2442072dd1bbd50e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = module.exports.TabsSwitcher = module.exports.ButtonTabs = void 0;

var $6wI3m = parcelRequire("6wI3m");

var $k6KGm = parcelRequire("k6KGm");

var $joGvE = parcelRequire("joGvE");

var $2S24U = parcelRequire("2S24U");

var $5PIlt = parcelRequire("5PIlt");

var $2MZa4 = parcelRequire("2MZa4");

var $a9HcF = parcelRequire("a9HcF");

var $fMKT6 = parcelRequire("fMKT6");
var $2442072dd1bbd50e$var$ButtonTabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(ButtonTabs, _super);
    function ButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    ButtonTabs.prototype.Add = function(label, content) {
        this.switches.AddSwitch(label, new $2S24U.Button(label), "uk-button-danger");
        this.content.AddContent(label, content);
        return this;
    };
    return ButtonTabs;
}($joGvE.Div);
module.exports.ButtonTabs = $2442072dd1bbd50e$var$ButtonTabs;
var $2442072dd1bbd50e$var$TabsSwitcher = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(TabsSwitcher, _super);
    function TabsSwitcher(ref) {
        var _this = _super.call(this, "ul", ref) || this;
        _this.switches = {};
        _this.Attribute("uk-tab");
        _this.Class("uk-tab");
        return _this;
    }
    TabsSwitcher.prototype.Refresh = function() {
        var _this = this;
        this.switches.Keys().forEach(function(activator) {
            var cmp = _this.switches[activator];
            if (_this.ref.value === activator) cmp.AddClass("uk-active");
            else cmp.RemoveClass("uk-active");
        });
    };
    TabsSwitcher.prototype.Add = function(label) {
        var _this = this;
        var item = new $2MZa4.ListItem(new $5PIlt.Link(label, "#"));
        this.switches[label] = item;
        item.OnClick(function() {
            return _this.ref.value = label;
        });
        if (this.ref.value == label) item.AddClass("uk-active");
        if (this.ref.value == "") this.ref.value = label;
        this.Append(item);
        return this;
    };
    return TabsSwitcher;
}($k6KGm.RefComponentBase);
module.exports.TabsSwitcher = $2442072dd1bbd50e$var$TabsSwitcher;
var $2442072dd1bbd50e$var$Tabs = /** @class */ function(_super) {
    $2442072dd1bbd50e$var$__extends(Tabs, _super);
    function Tabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switches = new $2442072dd1bbd50e$var$TabsSwitcher(_this.ref);
        _this.content = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.Append(_this.switches, _this.content);
        return _this;
    }
    Tabs.prototype.Add = function(label, content) {
        this.switches.Add(label);
        this.content.AddContent(label, content);
        return this;
    };
    return Tabs;
}($joGvE.Div);
module.exports.Tabs = $2442072dd1bbd50e$var$Tabs;

});

parcelRegister("fhrT0", function(module, exports) {
"use strict";
var $b1fe132ae5518be4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VerticalButtonTabs = void 0;

var $2S24U = parcelRequire("2S24U");

var $1h8RE = parcelRequire("1h8RE");

var $a9HcF = parcelRequire("a9HcF");

var $6wI3m = parcelRequire("6wI3m");

var $fMKT6 = parcelRequire("fMKT6");
var $b1fe132ae5518be4$var$VerticalButtonTabs = /** @class */ function(_super) {
    $b1fe132ae5518be4$var$__extends(VerticalButtonTabs, _super);
    function VerticalButtonTabs(ref) {
        if (ref === void 0) ref = new $6wI3m.Ref("");
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.switcher = new $fMKT6.RadioSwitchesBuilder(_this.ref);
        _this.contentSwitcher = new $a9HcF.DestroyingContentSwitcher(_this.ref);
        _this.useActivator = function(label) {
            return new $2S24U.Button(label);
        };
        _this.LeftColumn.Append(_this.switcher);
        _this.RightColumn.Append(_this.contentSwitcher);
        return _this;
    }
    VerticalButtonTabs.prototype.Add = function(label, content) {
        this.switcher.AddSwitch(label, this.useActivator(label), "uk-button-danger");
        this.contentSwitcher.AddContent(label, content);
        return this;
    };
    VerticalButtonTabs.prototype.UseActivator = function(fn) {
        this.useActivator = fn;
        return this;
    };
    return VerticalButtonTabs;
}($1h8RE.AutoWidthTwoColumns);
module.exports.VerticalButtonTabs = $b1fe132ae5518be4$var$VerticalButtonTabs;

});

parcelRegister("4YE9f", function(module, exports) {
"use strict";
var $39fbe89ec484fc7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Led = module.exports.BlinkMode = void 0;

var $joGvE = parcelRequire("joGvE");
var $39fbe89ec484fc7d$var$BlinkMode;
(function(BlinkMode) {
    BlinkMode["Blink"] = "Blink";
    BlinkMode["LightUp"] = "Flash";
    BlinkMode["Both"] = "Both";
})($39fbe89ec484fc7d$var$BlinkMode || (module.exports.BlinkMode = $39fbe89ec484fc7d$var$BlinkMode = {}));
var $39fbe89ec484fc7d$var$Led = /** @class */ function(_super) {
    $39fbe89ec484fc7d$var$__extends(Led, _super);
    function Led(color) {
        if (color === void 0) color = Led.White;
        var _this = _super.call(this, "led") || this;
        _this.previousColor = Led.White;
        _this.currentColor = Led.White;
        _this.blinkTimer = null;
        _this.lightUpTimer = null;
        _this.SetColor(color);
        _this.NoShadow(color);
        return _this;
    }
    Led.prototype.LightUpShadow = function(color) {
        this.Style("box-shadow: 0 0 6px 2px ".concat(color));
    };
    Led.prototype.NoShadow = function(color) {
        this.Style("box-shadow: 0 0 2px 1px ".concat(color));
    };
    Led.prototype.SetColor = function(color) {
        this.previousColor = this.currentColor;
        this.currentColor = color;
        this.Background(color);
        if (color == Led.White) this.Style("border: 1px solid #d8d8d8");
        else this.Style("border: none");
        return this;
    };
    Led.prototype.PreviousColor = function() {
        this.SetColor(this.previousColor);
        return this;
    };
    Led.prototype.LightUp = function(color, duration) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (duration === void 0) duration = 0;
        this.SetColor(color);
        this.LightUpShadow(color);
        this.lightUpTimer && clearTimeout(this.lightUpTimer);
        if (duration > 0) this.lightUpTimer = setTimeout(function() {
            return _this.NoShadow(color);
        }, duration);
        return this;
    };
    Led.prototype.Blink = function(color, interval, mode) {
        var _this = this;
        if (color === void 0) color = this.currentColor;
        if (interval === void 0) interval = 1000;
        if (mode === void 0) mode = $39fbe89ec484fc7d$var$BlinkMode.Blink;
        this.SetColor(color);
        var counter = 0;
        this.blinkTimer && clearInterval(this.blinkTimer);
        if (interval > 0) this.blinkTimer = setInterval(function() {
            if (counter = 1 - counter) switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(color);
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.LightUpShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(color);
                    _this.LightUpShadow(color);
                    break;
            }
            else switch(mode){
                case $39fbe89ec484fc7d$var$BlinkMode.Blink:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.LightUp:
                    _this.NoShadow(color);
                    break;
                case $39fbe89ec484fc7d$var$BlinkMode.Both:
                    _this.SetColor(Led.White);
                    _this.NoShadow(Led.White);
                    break;
            }
        }, interval);
        return this;
    };
    Led.prototype.Destroy = function() {
        this.blinkTimer && clearInterval(this.blinkTimer);
        this.lightUpTimer && clearInterval(this.lightUpTimer);
    };
    Led.Name = "Led";
    Led.Green = "#00e100";
    Led.Yellow = "#ffc107";
    Led.Red = "#f44336";
    Led.White = "#fff";
    Led.Blue = "#007bff";
    Led.Gray = "#c8c8c8";
    Led.Black = "#000";
    Led.Brown = "#8b4513";
    Led.Purple = "#9c27b0";
    Led.Pink = "#e91e63";
    Led.Orange = "#ff9800";
    return Led;
}($joGvE.Div);
module.exports.Led = $39fbe89ec484fc7d$var$Led;

});

parcelRegister("1bL1j", function(module, exports) {
"use strict";
var $0ddb4aba3c249cfe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressBar = void 0;

var $joGvE = parcelRequire("joGvE");

var $k6KGm = parcelRequire("k6KGm");
var $0ddb4aba3c249cfe$var$ProgressBar = /** @class */ function(_super) {
    $0ddb4aba3c249cfe$var$__extends(ProgressBar, _super);
    function ProgressBar(value, color) {
        if (color === void 0) color = "#f0506e";
        var _this = _super.call(this, "div", value) || this;
        _this.bar = new $joGvE.Div().HeightPercent(100);
        _this.Style("width: 100%; height: 2px; background-color: transparent; border: none;");
        _this.bar.Background(color);
        _this.Append(_this.bar);
        _this.Refresh();
        return _this;
    }
    ProgressBar.prototype.Invert = function() {
        this.bar.FloatRight();
        return this;
    };
    ProgressBar.prototype.Refresh = function() {
        this.bar.WidthPercent(this.ref.value);
    };
    ProgressBar.Name = "ProgressBar";
    return ProgressBar;
}($k6KGm.RefComponentBase);
module.exports.ProgressBar = $0ddb4aba3c249cfe$var$ProgressBar;

});

parcelRegister("8BrJA", function(module, exports) {
"use strict";
var $64374ae64cd84fe1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBuilder = void 0;

var $2s69t = parcelRequire("2s69t");

var $8y6Fd = parcelRequire("8y6Fd");

var $1lIsG = parcelRequire("1lIsG");

var $pCapU = parcelRequire("pCapU");

var $cUBMo = parcelRequire("cUBMo");

var $1lG8E = parcelRequire("1lG8E");

var $7Fc9Q = parcelRequire("7Fc9Q");

var $3lnvs = parcelRequire("3lnvs");
var $64374ae64cd84fe1$var$TableBuilder = /** @class */ function(_super) {
    $64374ae64cd84fe1$var$__extends(TableBuilder, _super);
    function TableBuilder(data) {
        var _a;
        var _this = _super.call(this) || this;
        _this.columns = [];
        _this.body = new $1lIsG.TableBody();
        _this.whenEmpty = new $2s69t.Span("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");
        if (data && data instanceof Array) _this.dataView = new $8y6Fd.CollectionView(new $2s69t.Collection(data)).Refresh();
        else if (data && data instanceof $2s69t.Collection) _this.dataView = new $8y6Fd.CollectionView(data).Refresh();
        else if (data && data instanceof $8y6Fd.CollectionView) _this.dataView = data;
        _this.Class(TableBuilder.DefaultCssClasses);
        (_a = _this.dataView) === null || _a === void 0 || _a.AddSubscriber(_this);
        return _this;
    }
    TableBuilder.prototype.Reset = function() {
        this.columns = [];
        this.Clear();
        return this;
    };
    TableBuilder.prototype.WhenEmpty = function(component) {
        this.whenEmpty = component;
        return this;
    };
    TableBuilder.prototype.Refresh = function() {
        var _this = this;
        var _a, _b, _c, _d;
        this.body.Clear();
        if (((_b = (_a = this.dataView) === null || _a === void 0 ? void 0 : _a.Items) === null || _b === void 0 ? void 0 : _b.length) === 0) this.body.Append(new $cUBMo.TableRow().Append(new $pCapU.TableCell().Merge(this.columns.length).Append(this.whenEmpty)));
        else (_d = (_c = this === null || this === void 0 ? void 0 : this.dataView) === null || _c === void 0 ? void 0 : _c.Items) === null || _d === void 0 || _d.forEach(function(record) {
            var _a;
            var row = new $cUBMo.TableRow();
            (_a = _this.eachRowHandler) === null || _a === void 0 || _a.call(_this, row, record);
            _this.columns.forEach(function(c) {
                if (c.AddWhen && !c.AddWhen(record)) {
                    // Add empty cell
                    var cell_1 = new $pCapU.TableCell();
                    row.Append(cell_1);
                    return;
                }
                var cell = new $pCapU.TableCell();
                var elem = c.Mapping(record, row, cell, _this.body, _this);
                var m;
                if (!Array.isArray(elem)) m = [
                    elem
                ];
                else m = elem;
                m.forEach(function(e) {
                    cell.Append(e);
                });
                row.Append(cell);
            });
            _this.body.Append(row);
        });
    };
    TableBuilder.prototype.Build = function() {
        this.Append(new $3lnvs.TableHeaderV2(this.columns.map(function(x) {
            return x.Headers;
        })));
        this.Refresh();
        this.Append(this.body);
        return this;
    };
    TableBuilder.prototype.AddColumn = function(headers, mapping, addWhen) {
        if (!Array.isArray(headers)) headers = [
            headers
        ];
        this.columns.push(new $7Fc9Q.TableColumn(headers, mapping, addWhen));
        return this;
    };
    TableBuilder.prototype.ForEachRow = function(handler) {
        this.eachRowHandler = handler;
        return this;
    };
    TableBuilder.Name = "TableBuilder";
    TableBuilder.DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";
    return TableBuilder;
}($1lG8E.Table);
module.exports.TableBuilder = $64374ae64cd84fe1$var$TableBuilder;

});
parcelRegister("1lIsG", function(module, exports) {
"use strict";
var $0fba3dc739fa3f8a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableBody = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $0fba3dc739fa3f8a$var$TableBody = /** @class */ function(_super) {
    $0fba3dc739fa3f8a$var$__extends(TableBody, _super); // TODO: no type for tbody?
    function TableBody() {
        return _super.call(this, "tbody") || this;
    }
    return TableBody;
}($aKtiT.ComponentBase);
module.exports.TableBody = $0fba3dc739fa3f8a$var$TableBody;

});

parcelRegister("pCapU", function(module, exports) {
"use strict";
var $04cff1167b76a41a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $04cff1167b76a41a$var$TableCell = /** @class */ function(_super) {
    $04cff1167b76a41a$var$__extends(TableCell, _super);
    function TableCell(content) {
        var _this = _super.call(this, "td") || this;
        if (!content) return _this;
        if (typeof content == "string") _this.element.innerText = content;
        else _this.Append(content);
        return _this;
    }
    TableCell.prototype.Merge = function(cellsOnRightCount) {
        this.Attribute("colspan", cellsOnRightCount.toString());
        return this;
    };
    return TableCell;
}($aKtiT.ComponentBase);
module.exports.TableCell = $04cff1167b76a41a$var$TableCell;

});

parcelRegister("cUBMo", function(module, exports) {
"use strict";
var $9668053d81ade9f5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $pCapU = parcelRequire("pCapU");
var $9668053d81ade9f5$var$TableRow = /** @class */ function(_super) {
    $9668053d81ade9f5$var$__extends(TableRow, _super);
    function TableRow() {
        return _super.call(this, "tr") || this;
    }
    TableRow.prototype.AddCells = function() {
        var _this = this;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        cells.forEach(function(c) {
            return _this.Append(new $pCapU.TableCell(c));
        });
        return this;
    };
    return TableRow;
}($aKtiT.ComponentBase);
module.exports.TableRow = $9668053d81ade9f5$var$TableRow;

});

parcelRegister("1lG8E", function(module, exports) {
"use strict";
var $0fb87073a0d55a2d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = void 0;

var $2s69t = parcelRequire("2s69t");
var $0fb87073a0d55a2d$var$Table = /** @class */ function(_super) {
    $0fb87073a0d55a2d$var$__extends(Table, _super);
    function Table(headers, body) {
        var _this = _super.call(this, "table") || this;
        _this.Class(Table.DefaultCssClasses);
        if (headers) _this.AddHeaders.apply(_this, headers);
        if (body) body.forEach(function(row) {
            return _this.AddRow.apply(_this, row);
        });
        return _this;
    }
    Table.prototype.AddHeaders = function() {
        var headers = [];
        for(var _i = 0; _i < arguments.length; _i++)headers[_i] = arguments[_i];
        this.Append(new $2s69t.TableHeader(headers));
        return this;
    };
    Table.prototype.AddRow = function() {
        var _a;
        var cells = [];
        for(var _i = 0; _i < arguments.length; _i++)cells[_i] = arguments[_i];
        this.Append((_a = new $2s69t.TableRow()).AddCells.apply(_a, cells));
        return this;
    };
    Table.Name = "Table";
    Table.DefaultCssClasses = "";
    return Table;
}($2s69t.ComponentBase);
module.exports.Table = $0fb87073a0d55a2d$var$Table;

});

parcelRegister("7Fc9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableColumn = void 0;
var $5945cb0a69213503$var$TableColumn = /** @class */ function() {
    function TableColumn(Headers, Mapping, AddWhen) {
        this.Headers = Headers;
        this.Mapping = Mapping;
        this.AddWhen = AddWhen;
    }
    return TableColumn;
}();
module.exports.TableColumn = $5945cb0a69213503$var$TableColumn;

});

parcelRegister("3lnvs", function(module, exports) {
"use strict";
var $26f591266fc43a13$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderV2 = void 0;

var $2s69t = parcelRequire("2s69t");
var $26f591266fc43a13$var$TableHeaderV2 = /** @class */ function(_super) {
    $26f591266fc43a13$var$__extends(TableHeaderV2, _super);
    function TableHeaderV2(columnsHeaders) {
        var _this = _super.call(this, "thead") || this;
        var maxRows = Math.max.apply(Math, columnsHeaders.map(function(hs) {
            return hs.length;
        }));
        var _loop_1 = function(rowIndex) {
            var cells = columnsHeaders.map(function(x) {
                return x[rowIndex];
            });
            this_1.Append(new $2s69t.TableHeaderRow(cells));
        };
        var this_1 = this;
        for(var rowIndex = 0; rowIndex < maxRows; rowIndex++)_loop_1(rowIndex);
        return _this;
    }
    return TableHeaderV2;
}($2s69t.ComponentBase);
module.exports.TableHeaderV2 = $26f591266fc43a13$var$TableHeaderV2;

});


parcelRegister("bdjAM", function(module, exports) {
"use strict";
var $82a01b3c4a454fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeader = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $dLmKH = parcelRequire("dLmKH");
var $82a01b3c4a454fc0$var$TableHeader = /** @class */ function(_super) {
    $82a01b3c4a454fc0$var$__extends(TableHeader, _super);
    function TableHeader(headers) {
        var _this = _super.call(this, "thead") || this;
        if (headers) _this.Append(new $dLmKH.TableHeaderRow(headers));
        return _this;
    }
    return TableHeader;
}($aKtiT.ComponentBase);
module.exports.TableHeader = $82a01b3c4a454fc0$var$TableHeader;

});
parcelRegister("dLmKH", function(module, exports) {
"use strict";
var $a05150494376724d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderRow = void 0;

var $aKtiT = parcelRequire("aKtiT");

var $kWKxK = parcelRequire("kWKxK");
var $a05150494376724d$var$TableHeaderRow = /** @class */ function(_super) {
    $a05150494376724d$var$__extends(TableHeaderRow, _super);
    function TableHeaderRow(strings) {
        var _this = _super.call(this, "tr") || this;
        strings.forEach(function(str) {
            _this.Append(new $kWKxK.TableHeaderCell(str));
        });
        return _this;
    }
    return TableHeaderRow;
}($aKtiT.ComponentBase);
module.exports.TableHeaderRow = $a05150494376724d$var$TableHeaderRow;

});
parcelRegister("kWKxK", function(module, exports) {
"use strict";
var $f3fd53f403c219a2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableHeaderCell = void 0;

var $aKtiT = parcelRequire("aKtiT");
var $f3fd53f403c219a2$var$TableHeaderCell = /** @class */ function(_super) {
    $f3fd53f403c219a2$var$__extends(TableHeaderCell, _super);
    function TableHeaderCell(element) {
        var _this = _super.call(this, "th") || this;
        if (!element) return _this;
        if (typeof element == "string") _this.Text(element);
        else _this.Append(element);
        return _this;
    }
    return TableHeaderCell;
}($aKtiT.ComponentBase);
module.exports.TableHeaderCell = $f3fd53f403c219a2$var$TableHeaderCell;

});



parcelRegister("2ZZKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewerConfig = void 0;
var $22f12e1fe2753cc2$var$JsonViewerConfig = /** @class */ function() {
    function JsonViewerConfig() {
        this.foldAll = true;
        this.foldSymbol = "\u2795";
        this.unfoldSymbol = "\u2796";
        this.keyPrinter = function(key, objType) {
            return "\u25FE " + key + ":";
        };
        this.arrayKeyPrinter = function(index, objType) {
            return "#" + index;
        };
        this.keyStyle = "color: #222";
        this.nullStyle = "color: #ff7f96";
        this.stringStyle = "color: green";
        this.numberStyle = "color: blue";
        this.boolStyle = "color: violet";
        this.typePrinter = function(t) {
            return "(" + t + ")";
        };
        this.typeInfoStyle = "color: #aaa; font-style: italic;";
        this.maxStringLength = 100;
        this.indent = 22;
        this.showCopyIcon = true;
        this.copyValueIcon = "\uD83D\uDCCB";
        this.openLinkButton = "\uD83C\uDF10";
        this.markedColor = "yellow";
    }
    return JsonViewerConfig;
}();
module.exports.JsonViewerConfig = $22f12e1fe2753cc2$var$JsonViewerConfig;

});

parcelRegister("eBKPc", function(module, exports) {
"use strict";
var $aa28d7d45cf2f7d2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa28d7d45cf2f7d2$var$__assign = module.exports && module.exports.__assign || function() {
    $aa28d7d45cf2f7d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa28d7d45cf2f7d2$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonViewer = module.exports.RefJsonViewer = void 0;

var $hPtm1 = parcelRequire("hPtm1");

var $5PIlt = parcelRequire("5PIlt");

var $8UMl5 = parcelRequire("8UMl5");

var $joGvE = parcelRequire("joGvE");

var $2ZZKK = parcelRequire("2ZZKK");

var $gkD0R = parcelRequire("gkD0R");
var $aa28d7d45cf2f7d2$var$RefJsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(RefJsonViewer, _super);
    function RefJsonViewer(objAsString, config) {
        var _this = _super.call(this) || this;
        objAsString.OnChange(function(x) {
            var ob;
            try {
                ob = JSON.parse(x);
            } catch (ex) {
                return;
            }
            _this.Clear().Append(new $aa28d7d45cf2f7d2$var$JsonViewer(ob, undefined, config));
        }, true);
        return _this;
    }
    return RefJsonViewer;
}($joGvE.Div);
module.exports.RefJsonViewer = $aa28d7d45cf2f7d2$var$RefJsonViewer;
var $aa28d7d45cf2f7d2$var$ValuePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValuePrinter, _super);
    function ValuePrinter(value, style, config) {
        var _this = _super.call(this, value) || this;
        _this.config = config;
        _this.Margin(8).MarginLeft(0).Style(style).CursorPointer().OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValuePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValuePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$ValueTypePrinter = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(ValueTypePrinter, _super);
    function ValueTypePrinter(type, config) {
        var _this = _super.call(this, config.typePrinter(type)) || this;
        _this.config = config;
        _this.CursorPointer().Style(config.typeInfoStyle).OnClick(function(self) {
            return _this.Mark(self);
        });
        return _this;
    }
    ValueTypePrinter.prototype.Mark = function(element) {
        element.ToggleStyle("background-color", this.config.markedColor, "transparent");
    };
    return ValueTypePrinter;
}($gkD0R.Span);
var $aa28d7d45cf2f7d2$var$JsonViewer = /** @class */ function(_super) {
    $aa28d7d45cf2f7d2$var$__extends(JsonViewer, _super);
    function JsonViewer(obj, key, config) {
        if (key === void 0) key = "";
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.Config = new $2ZZKK.JsonViewerConfig();
        _this.Config = $aa28d7d45cf2f7d2$var$__assign($aa28d7d45cf2f7d2$var$__assign({}, _this.Config), _this.config);
        var tk = new $hPtm1.TwoFloatingColumns();
        var objType = typeof obj;
        if (key) tk.LeftColumn.Append(new $gkD0R.Span(_this.Config.keyPrinter(key, objType)).FloatLeft().MarginRight(6).Style(_this.Config.keyStyle).CursorPointer().OnClick(function(_) {
            return _.ToggleStyle("background-color", _this.Config.markedColor, "transparent");
        }));
        if (obj === null) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("null", _this.Config.nullStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("null", _this.Config));
        else if (objType === "string") {
            var str = void 0;
            if (obj.length > _this.Config.maxStringLength) str = "\"".concat(obj.slice(0, _this.Config.maxStringLength), ".....\"");
            else str = "\"".concat(obj, "\"");
            var isLink = obj.startsWith("http");
            var printer = new $aa28d7d45cf2f7d2$var$ValuePrinter(str, _this.Config.stringStyle, _this.Config);
            // if (isLink)
            // {
            //     printer.OnHover(_=>_.Style("text-decoration: underline"))
            //         .OnMouseOut(_=>_.Style("text-decoration: none"))
            // }
            tk.RightColumn.Append(printer);
            tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(obj.length, " char").concat(obj.length > 1 ? "s" : "", " string"), _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj, _this.Config.copyValueIcon), isLink && new $5PIlt.Link(_this.Config.openLinkButton, obj).MarginLeft(4).NoDecorationOnHover().OpenInNewCard());
        } else if (objType === "number") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj.toString(), _this.Config.numberStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter('number', _this.Config), _this.Config.showCopyIcon && new $8UMl5.CopyIcon(obj.toString(), _this.Config.copyValueIcon));
        else if (objType === "boolean") tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter(obj ? "true" : "false", _this.Config.boolStyle, _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter('boolean', _this.Config));
        else if (Array.isArray(obj)) {
            if (obj.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("[ ]", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty array", _this.Config));
            else {
                var foldButton_1 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                    foldButton_1.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                    tk.RightColumn.Toggle();
                });
                tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("array of ".concat(obj.length, " ").concat(_this.GetType(obj[0])).concat(obj.length > 1 ? "s" : ""), _this.Config), foldButton_1);
                if (_this.Config.foldAll) {
                    tk.RightColumn.Hide();
                    foldButton_1.Text(_this.Config.foldSymbol);
                } else {
                    tk.RightColumn.Show();
                    foldButton_1.Text(_this.Config.unfoldSymbol);
                }
                tk.LeftColumn.WidthPercent(100);
                tk.RightColumn.MarginLeft(_this.Config.indent);
                obj.forEach(function(e, i) {
                    return tk.RightColumn.Append(new JsonViewer(e, _this.Config.arrayKeyPrinter(i.toString(), typeof e), _this.config));
                });
            }
        } else if (objType === "object") {
            var keys = Object.keys(obj);
            if (keys.length === 0) tk.RightColumn.Append(new $aa28d7d45cf2f7d2$var$ValuePrinter("{ }", "", _this.Config), new $aa28d7d45cf2f7d2$var$ValueTypePrinter("empty object", _this.Config));
            else {
                if (key) {
                    var foldButton_2 = new $5PIlt.Link(_this.Config.foldSymbol).NoDecorationOnHover().MarginLeft(4).MarginRight(4).CursorPointer().OnClick(function() {
                        foldButton_2.Text(tk.RightColumn.IsVisible() ? _this.Config.foldSymbol : _this.Config.unfoldSymbol);
                        tk.RightColumn.Toggle();
                    });
                    tk.LeftColumn.Append(new $aa28d7d45cf2f7d2$var$ValueTypePrinter("".concat(keys.length, " field").concat(keys.length > 1 ? "s" : "", " object"), _this.Config), foldButton_2);
                    tk.LeftColumn.WidthPercent(100);
                    tk.RightColumn.MarginLeft(_this.Config.indent);
                    if (_this.Config.foldAll) {
                        tk.RightColumn.Hide();
                        foldButton_2.Text(_this.Config.foldSymbol);
                    } else {
                        tk.RightColumn.Show();
                        foldButton_2.Text(_this.Config.unfoldSymbol);
                    }
                }
                keys.forEach(function(k) {
                    var v = obj[k];
                    tk.RightColumn.Append(new JsonViewer(v, k, _this.config));
                });
            }
        }
        _this.Append(tk);
        _this.Append(new $joGvE.Div().ClearBoth());
        return _this;
    }
    JsonViewer.prototype.GetType = function(obj) {
        var objType = typeof obj;
        var isArray = Array.isArray(obj);
        if (isArray && obj.length > 0) return "array of ".concat(this.GetType(obj[0]), "s");
        else if (isArray) return "array";
        else return objType;
    };
    JsonViewer.Name = "JsonViewer";
    return JsonViewer;
}($joGvE.Div);
module.exports.JsonViewer = $aa28d7d45cf2f7d2$var$JsonViewer;

});

parcelRegister("e6E17", function(module, exports) {
"use strict";
var $a450aac81bb82448$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a450aac81bb82448$var$__assign = module.exports && module.exports.__assign || function() {
    $a450aac81bb82448$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a450aac81bb82448$var$__assign.apply(this, arguments);
};
var $a450aac81bb82448$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a450aac81bb82448$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Snack = module.exports.SnackPrinter = module.exports.SnackOptions = void 0;

var $iqyiC = parcelRequire("iqyiC");

var $6wI3m = parcelRequire("6wI3m");

var $1bL1j = parcelRequire("1bL1j");

var $joGvE = parcelRequire("joGvE");

var $gkD0R = parcelRequire("gkD0R");
var $a450aac81bb82448$var$SnackOptions = /** @class */ function() {
    function SnackOptions() {
        this.autoCloseTimeout = 4500;
        this.showCloseButton = true;
        this.clickAnywhereToClose = false;
        this.showTimeoutBar = true;
    }
    return SnackOptions;
}();
module.exports.SnackOptions = $a450aac81bb82448$var$SnackOptions;
var $a450aac81bb82448$var$SnackPrinter = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(SnackPrinter, _super);
    function SnackPrinter(header, content, options) {
        var _this = _super.call(this) || this;
        _this.CloseButton = new $gkD0R.Span("\xd7").Class("tf-snack-x");
        _this.timer = null;
        var opt = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, new $a450aac81bb82448$var$SnackOptions()), options);
        var p = new $6wI3m.Ref(100);
        if (opt.showTimeoutBar && opt.autoCloseTimeout && opt.autoCloseTimeout > 0) _this.timer = setInterval(function() {
            return p.value--;
        }, opt.autoCloseTimeout / 100);
        _this.Append(opt.showTimeoutBar && new $1bL1j.ProgressBar(p).Invert(), opt.showCloseButton && _this.CloseButton, new $joGvE.Div().Append(header).Class("tf-snack-label"), content && new $joGvE.Div().Append(content).Class("tf-snack-content"));
        return _this;
    }
    SnackPrinter.prototype.OnRemove = function() {
        return $a450aac81bb82448$var$__awaiter(this, void 0, void 0, function() {
            return $a450aac81bb82448$var$__generator(this, function(_a) {
                if (this.timer) clearInterval(this.timer);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return SnackPrinter;
}($joGvE.Div);
module.exports.SnackPrinter = $a450aac81bb82448$var$SnackPrinter;
var $a450aac81bb82448$var$Snack = /** @class */ function(_super) {
    $a450aac81bb82448$var$__extends(Snack, _super);
    function Snack(header, content, options) {
        var _a;
        var _b;
        var _this = _super.call(this) || this;
        _this.Config = new $a450aac81bb82448$var$SnackOptions();
        _this.Class(Snack.DefaultCssClasses);
        _this.Config = $a450aac81bb82448$var$__assign($a450aac81bb82448$var$__assign({}, _this.Config), options);
        var cont = Array.isArray(content) ? (_a = new $joGvE.Div()).Append.apply(_a, content) : content;
        var printer = new $a450aac81bb82448$var$SnackPrinter(header, cont, _this.Config);
        printer.CloseButton.OnClick(function() {
            return _this.Close();
        });
        _this.Append(printer);
        if (_this.Config.clickAnywhereToClose) _this.OnClick(function() {
            _this.Close();
        });
        (_b = (0, $iqyiC.$)("body")) === null || _b === void 0 || _b.Append(_this.Element);
        if (_this.Config.autoCloseTimeout && _this.Config.autoCloseTimeout > 0) setTimeout(function() {
            return _this.Close();
        }, _this.Config.autoCloseTimeout);
        return _this;
    }
    Snack.prototype.Close = function() {
        var _a;
        (_a = (0, $iqyiC.$)("body")) === null || _a === void 0 || _a.Remove(this.Element);
        return this;
    };
    Snack.Name = "Snack";
    Snack.DefaultCssClasses = "tf-snack";
    return Snack;
}($joGvE.Div);
module.exports.Snack = $a450aac81bb82448$var$Snack;

});

parcelRegister("50yqK", function(module, exports) {
"use strict";
var $3a57a8fc65d9b876$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicPaginator = void 0;

var $3B1VX = parcelRequire("3B1VX");

var $2s69t = parcelRequire("2s69t");

var $kanmU = parcelRequire("kanmU");
var $3a57a8fc65d9b876$var$BasicPaginator = /** @class */ function(_super) {
    $3a57a8fc65d9b876$var$__extends(BasicPaginator, _super);
    function BasicPaginator(start, count, total, filtered) {
        var _this = _super.call(this, "paginator") || this;
        _this.count = count;
        _this.goToFirstButton = new $2s69t.Button("\xab").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToFirst();
        });
        _this.gotoPreviousButton = new $2s69t.Button("\u2039").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToPreviousPage();
        });
        _this.gotoNextButton = new $2s69t.Button("\u203A").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToNextPage();
        });
        _this.gotoLastButton = new $2s69t.Button("\xbb").FontSize(18).Padding(0, 14).OnClick(function() {
            return _this.Brain.GoToLast();
        });
        _this.Brain = new $kanmU.PaginatorBrain(start, count, total, filtered);
        _this.display = new $3B1VX.Text(_this.Brain.display).Style("vertical-align: middle; margin: 0 16px");
        return _this;
    }
    BasicPaginator.prototype.AddGoToFirstButton = function() {
        this.Append(this.goToFirstButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToPreviousButton = function() {
        this.Append(this.gotoPreviousButton);
        return this;
    };
    BasicPaginator.prototype.AddDisplay = function() {
        this.Append(this.display);
        return this;
    };
    BasicPaginator.prototype.AddGoToNextButton = function() {
        this.Append(this.gotoNextButton);
        return this;
    };
    BasicPaginator.prototype.AddGoToLastButton = function() {
        this.Append(this.gotoLastButton);
        return this;
    };
    BasicPaginator.prototype.AddPagesCountSwitch = function(pageSizes) {
        var _this = this;
        if (pageSizes === void 0) pageSizes = [
            5,
            10,
            20
        ];
        var pageSizesOptions = pageSizes.map(function(x) {
            return new $2s69t.SelectOption("".concat(x, " ").concat(_this.Brain.options.PerPageTranslation), x);
        });
        var pagesCountSwitch = new $2s69t.Select(this.count, pageSizesOptions).ModifyAfterChange(function(v) {
            return +v;
        }).WidthAuto();
        this.Append(pagesCountSwitch);
        return this;
    };
    return BasicPaginator;
}($2s69t.Div);
module.exports.BasicPaginator = $3a57a8fc65d9b876$var$BasicPaginator;

});
parcelRegister("kanmU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginatorBrain = module.exports.PaginatorBrainOptions = void 0;

var $6wI3m = parcelRequire("6wI3m");
var $eae6de5785a00ef7$var$PaginatorBrainOptions = /** @class */ function() {
    function PaginatorBrainOptions() {
        this.FilteredTranslation = "filtered";
        this.InTotalTranslation = "in total";
        this.NoResultsTranslation = "No results";
        this.PerPageTranslation = "per page";
    }
    return PaginatorBrainOptions;
}();
module.exports.PaginatorBrainOptions = $eae6de5785a00ef7$var$PaginatorBrainOptions;
var $eae6de5785a00ef7$var$PaginatorBrain = /** @class */ function() {
    function PaginatorBrain(start, count, total, filtered, options) {
        if (options === void 0) options = new $eae6de5785a00ef7$var$PaginatorBrainOptions();
        var _this = this;
        this.start = start;
        this.count = count;
        this.total = total;
        this.filtered = filtered;
        this.options = options;
        this.display = new $6wI3m.Ref("");
        this.start.OnChange(function(_) {
            return _this.Refresh();
        });
        this.count.OnChange(function(_) {
            return _this.Refresh();
        });
        this.total.OnChange(function(_) {
            return _this.Refresh();
        });
        this.filtered.OnChange(function(_) {
            return _this.Refresh();
        });
        this.Refresh();
    }
    PaginatorBrain.prototype.Refresh = function() {
        var _a = this.Calc(), start = _a[0], end = _a[1];
        var total = this.total.value;
        var filtered = this.filtered.value;
        if (filtered > 0 && total > 0) {
            start += 1;
            if (start > end) start = end;
        }
        if (start < 0) start = 0;
        if (filtered != total) this.display.value = "".concat(start, " - ").concat(end, " / ").concat(filtered, " ").concat(this.options.FilteredTranslation, " / ").concat(total, " ").concat(this.options.InTotalTranslation);
        else if (start == end && start == 0) this.display.value = this.options.NoResultsTranslation;
        else if (start == end) this.display.value = "".concat(start, " / ").concat(total);
        else this.display.value = "".concat(start, " - ").concat(end, " / ").concat(total);
    };
    PaginatorBrain.prototype.Calc = function() {
        var start = this.start.value;
        var count = this.count.value;
        var last = this.filtered.value;
        var end = 0;
        if (start < 0) start = 0;
        if (start >= last) start = last;
        end = start + count;
        if (end >= last) end = last;
        if (start == end && start > 0) start -= 1;
        this.start.value = start;
        return [
            start,
            end
        ];
    };
    PaginatorBrain.prototype.GoToNextPage = function() {
        this.start.value += this.count.value;
    };
    PaginatorBrain.prototype.GoToPreviousPage = function() {
        this.start.value -= this.count.value;
    };
    PaginatorBrain.prototype.GoToFirst = function() {
        this.start.value = 0;
    };
    PaginatorBrain.prototype.GoToLast = function() {
        this.start.value = this.total.value - 1;
    };
    return PaginatorBrain;
}();
module.exports.PaginatorBrain = $eae6de5785a00ef7$var$PaginatorBrain;

});


parcelRegister("et3h1", function(module, exports) {
"use strict";
var $a886502ccd1e8fc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimplePaginator = void 0;

var $50yqK = parcelRequire("50yqK");
var $a886502ccd1e8fc0$var$SimplePaginator = /** @class */ function(_super) {
    $a886502ccd1e8fc0$var$__extends(SimplePaginator, _super);
    function SimplePaginator(start, count, total, filtered) {
        var _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch([
            5,
            10,
            30
        ]);
        return _this;
    }
    return SimplePaginator;
}($50yqK.BasicPaginator);
module.exports.SimplePaginator = $a886502ccd1e8fc0$var$SimplePaginator;

});

parcelRegister("5snGY", function(module, exports) {
"use strict";
var $3f91f20cf066699d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectionPaginator = module.exports.CollectionPaginatorOptions = void 0;

var $epBKP = parcelRequire("epBKP");

var $50yqK = parcelRequire("50yqK");
var $3f91f20cf066699d$var$CollectionPaginatorOptions = /** @class */ function() {
    function CollectionPaginatorOptions() {
        this.PerPage = [
            10,
            30,
            100
        ];
        this.PerPageStorageKey = "";
    }
    return CollectionPaginatorOptions;
}();
module.exports.CollectionPaginatorOptions = $3f91f20cf066699d$var$CollectionPaginatorOptions;
var $3f91f20cf066699d$var$CollectionPaginator = /** @class */ function(_super) {
    $3f91f20cf066699d$var$__extends(CollectionPaginator, _super);
    function CollectionPaginator(collectionView, options) {
        if (options === void 0) options = new $3f91f20cf066699d$var$CollectionPaginatorOptions();
        var _this = this;
        var start = new $epBKP.RefNumber(0);
        var count = new $epBKP.RefNumber(options.PerPage[0] || 10).Storable(options === null || options === void 0 ? void 0 : options.PerPageStorageKey);
        var total = collectionView.Collection.CountRef;
        var filtered = collectionView.FilteredCount;
        collectionView.See(start, count).Refresh();
        _this = _super.call(this, start, count, total, filtered) || this;
        _this.AddGoToFirstButton();
        _this.AddGoToPreviousButton();
        _this.AddDisplay();
        _this.AddGoToNextButton();
        _this.AddGoToLastButton();
        _this.AddPagesCountSwitch(options.PerPage);
        return _this;
    }
    return CollectionPaginator;
}($50yqK.BasicPaginator);
module.exports.CollectionPaginator = $3f91f20cf066699d$var$CollectionPaginator;

});

parcelRegister("bjWq6", function(module, exports) {
"use strict";
var $83dec913f80e5f62$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $2s69t = parcelRequire("2s69t");
var $83dec913f80e5f62$var$Spinner = /** @class */ function(_super) {
    $83dec913f80e5f62$var$__extends(Spinner, _super);
    function Spinner() {
        var _this = _super.call(this, "div") || this;
        _this.Attribute("uk-spinner").Style("margin-left", "8px");
        return _this;
    }
    return Spinner;
}($2s69t.ComponentBase);
module.exports.Spinner = $83dec913f80e5f62$var$Spinner;

});

parcelRegister("ckMZV", function(module, exports) {
"use strict";
var $8fad5c3bf2fab2a9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pie = void 0;

var $k6KGm = parcelRequire("k6KGm");
// https://www.freecodecamp.org/news/css-only-pie-chart/
var $8fad5c3bf2fab2a9$var$Pie = /** @class */ function(_super) {
    $8fad5c3bf2fab2a9$var$__extends(Pie, _super);
    function Pie(value) {
        var _this = _super.call(this, "div", value) || this;
        _this.Refresh();
        return _this;
    // this.Style(`--p: ${value}; --b: 22px; --c: #1e87f0;`)
    // this.Text(value.toString() + "%")
    }
    Pie.prototype.Refresh = function() {
        this.Html("<div class=\"pie\" style=\"--p:".concat(this.ref.value, ";--b:18px;--c:lightblue;\">").concat(this.ref.value, "%</div>"));
    };
    Pie.Name = "Pie";
    return Pie;
}($k6KGm.RefComponentBase);
module.exports.Pie = $8fad5c3bf2fab2a9$var$Pie;

});

parcelRegister("djLWA", function(module, exports) {
"use strict";
var $9b223d6054e3ab07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b223d6054e3ab07$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnlineStorage = void 0;

var $cOIL8 = parcelRequire("cOIL8");
// TODO: remove due to better OnlineStorage @ @tblabs/storage
var $9b223d6054e3ab07$var$OnlineStorage = /** @class */ function() {
    function OnlineStorage(url) {
        this.url = url;
    }
    OnlineStorage.prototype.Upload = function(file_1, newFileNameWithoutExtension_1) {
        return $9b223d6054e3ab07$var$__awaiter(this, arguments, void 0, function(file, newFileNameWithoutExtension, folder, override) {
            var fileExtension, formData, response, fileDir, ex_1;
            if (folder === void 0) folder = "";
            if (override === void 0) override = true;
            return $9b223d6054e3ab07$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!file || !(newFileNameWithoutExtension === null || newFileNameWithoutExtension === void 0 ? void 0 : newFileNameWithoutExtension.trim())) return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("No file or file name provided")
                        ];
                        fileExtension = file.name.split('.').pop();
                        formData = new FormData();
                        formData.append('file', file);
                        formData.append('folder', folder.trim());
                        formData.append('name', newFileNameWithoutExtension.trim() + "." + fileExtension);
                        formData.append('override', override ? "override-if-exist" : "throw-if-already-exist");
                        return [
                            4 /*yield*/ ,
                            fetch(this.url, {
                                method: 'POST',
                                body: formData
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        fileDir = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Success(fileDir)
                        ];
                    case 3:
                        ex_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $cOIL8.UploadResult.Failure("Can not upload: ".concat(ex_1.message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return OnlineStorage;
}();
module.exports.OnlineStorage = $9b223d6054e3ab07$var$OnlineStorage;

});
parcelRegister("cOIL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UploadResult = void 0;
var $954cdfd10ed9378c$var$UploadResult = /** @class */ function() {
    function UploadResult(IsSuccess, UploadedFileDir, ErrorMessage) {
        if (IsSuccess === void 0) IsSuccess = false;
        if (UploadedFileDir === void 0) UploadedFileDir = "";
        if (ErrorMessage === void 0) ErrorMessage = "";
        this.IsSuccess = IsSuccess;
        this.UploadedFileDir = UploadedFileDir;
        this.ErrorMessage = ErrorMessage;
    }
    UploadResult.Success = function(dir) {
        return new UploadResult(true, dir, "");
    };
    UploadResult.Failure = function(reason) {
        return new UploadResult(false, "", reason);
    };
    return UploadResult;
}();
module.exports.UploadResult = $954cdfd10ed9378c$var$UploadResult;

});


parcelRegister("aq9Em", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Switch = void 0;
var $7963d1637bb659f7$var$Switch = /** @class */ function() {
    function Switch(valueFromCtor) {
        this.valueFromCtor = valueFromCtor;
        this.cases = {};
    }
    Switch.prototype.Case = function(value, toDo) {
        this.cases[value] = toDo;
        return this;
    };
    Switch.prototype.Default = function(toDo) {
        this.default = toDo;
        return this;
    };
    Switch.prototype.Execute = function(variable) {
        var _a, _b, _c, _d, _e, _f;
        if (!variable) return ((_b = (_a = this.cases) === null || _a === void 0 ? void 0 : _a[this.valueFromCtor]) === null || _b === void 0 ? void 0 : _b.call(_a)) || ((_c = this.default) === null || _c === void 0 ? void 0 : _c.call(this)) || undefined;
        return ((_e = (_d = this.cases) === null || _d === void 0 ? void 0 : _d[variable]) === null || _e === void 0 ? void 0 : _e.call(_d)) || ((_f = this.default) === null || _f === void 0 ? void 0 : _f.call(this)) || undefined;
    };
    return Switch;
}();
module.exports.Switch = $7963d1637bb659f7$var$Switch;

});




parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});














var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");
var $3798e175c5551adb$exports = {};
//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})($3798e175c5551adb$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split('_'), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split('_'), monthsParse = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i
    ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch(key){
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : "minut\u0119";
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : "godzin\u0119";
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? "miesi\u0105ce" : "miesi\u0119cy");
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }
    var pl = moment.defineLocale('pl', {
        months: function(momentToFormat, format) {
            if (!momentToFormat) return monthsNominative;
            else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
            else return monthsNominative[momentToFormat.month()];
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split('_'),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split('_'),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Dzi\u015B o] LT",
            nextDay: '[Jutro o] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return '[We wtorek o] LT';
                    case 3:
                        return "[W \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: "1 dzie\u0144",
            dd: '%d dni',
            w: "tydzie\u0144",
            ww: translate,
            M: "miesi\u0105c",
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return pl;
});



var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");

class $029e32efb5f6474c$export$3117a0de16ab2854 {
    static IsHourSet(v) {
        if (v instanceof (0, $2s69t.Ref)) v = v.value;
        if (+v === 0) return false;
        if (v instanceof Date) return v.getHours() !== 0 || v.getMinutes() !== 0;
        return false;
    }
    static HowLongAgo(date, noDataText = "(brak daty)") {
        if (!date) return noDataText;
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        if (+date === 0) return noDataText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).from((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
    }
    static TimeTo(date, noDataText = "(brak daty)") {
        if (!date) return noDataText;
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        if (+date === 0) return noDataText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).from((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
    }
    static DaysTo(date, noDataText = "(brak daty)") {
        if (!date) return noDataText;
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        if (+date === 0) return noDataText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).diff((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now, "days").toString();
    }
    static DaysAgo(date) {
        return -+this.DaysTo(date);
    }
    static TimeLeftTo(date, noDataText = "(brak daty)", includeDayName = false) {
        if (!date) return noDataText;
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        if (+date === 0) return noDataText;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).isSame((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now, "date")) return "dzisiaj";
        if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).isSame((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().subtract(1, "day"), "date")) return "wczoraj";
        if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).isSame((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().add(1, "day"), "date")) return "jutro";
        const days = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).diff((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now, "days") + 1;
        if (days === -1) return "wczoraj";
        // if (days === 0)
        //     return "dzisiaj";
        if (days >= 7) return `za ${days} dni`;
        if (days > 0 && days < 7) {
            if (includeDayName) return `za ${days} dni, w ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("dddd")}`;
            else return `za ${days} dni`;
        }
        if (days < 0) return `${-days} dni temu`;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).from((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
    }
    static FormattedRange(From, To) {
        // Funkcja pomocnicza do sformatowania daty w formacie "d.m.rrrr"
        const formatDate = (date)=>{
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        };
        // Parsowanie dat
        const startDate = new Date(From.value);
        const endDate = new Date(To.value);
        // Formatowanie dat na "d.m.rrrr"
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        if (formattedStartDate === formattedEndDate) return formattedStartDate;
        // Sprawdzanie, czy daty są w tym samym roku
        if (startDate.getFullYear() === endDate.getFullYear()) {
            if (startDate.getMonth() === endDate.getMonth()) // Ten sam miesiąc i rok
            return `${startDate.getDate()}\u{2014}${endDate.getDate()}.${formattedStartDate.slice(3)}`;
            else // Inny miesiąc, ten sam rok
            return `${formattedStartDate} \u{2014} ${formattedEndDate}`;
        } else // Inny rok
        return `${formattedStartDate} \u{2014} ${formattedEndDate}`;
    }
    static FormatDuration(secondsLeft) {
        if (!secondsLeft) return "";
        let s = 0;
        if (secondsLeft instanceof (0, $2s69t.Ref)) s = secondsLeft.value;
        else s = secondsLeft;
        if (s < 0) s = -s;
        const days = Math.floor(s / 86400);
        const hours = Math.floor(s % 86400 / 3600);
        const minutes = Math.floor(s % 3600 / 60);
        const seconds = s % 60;
        return days > 0 ? `${days} dni, ${hours.toString()}h i ${minutes.toString()}m` : `${hours.toString()}h i ${minutes.toString()}m`;
    }
    static Since(date) {
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        const secondsAgo = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).diff((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now, "seconds");
        return this.FormatDuration(secondsAgo);
    }
    static FormattedDate(date) {
        if (date instanceof (0, $2s69t.Ref)) {
            if (!date.IsSet) return "(data nieustalona)";
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("DD.MM.YYYY");
        } else {
            if (+date === 0) return "(data nieustalona)";
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("DD.MM.YYYY");
        }
    }
    static FormattedDateTime(date) {
        if (!date) return "(brak daty)";
        if (date instanceof (0, $2s69t.Ref)) {
            if (!date.IsSet) return "(data nieustalona)";
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("DD.MM.YYYY HH:mm");
        } else {
            if (+date === 0) return "(data nieustalona)";
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("DD.MM.YYYY HH:mm");
        }
    }
    /*
      TUTAJ ZAKŁADAMY ŻE JEŚLI GODZINA TO 00:00 TO PORA DNIA NIE ZOSTAŁA USTALONA
  */ static FormattedDayHour(date) {
        if (!date) return "(brak daty)";
        if (date instanceof (0, $2s69t.Ref)) {
            if (!date.IsSet) return "(data nieustalona)";
            const day = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("DD.MM.YYYY");
            if (!this.IsTimeSet(date.value)) return day + ", godzina nie ustalona";
            else return `${day} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("HH:mm")}`;
        } else {
            if (+date === 0) return "(data nieustalona)";
            const day = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("dddd, DD.MM.YYYY");
            if (!this.IsTimeSet(date)) return day + ", godzina nie ustalona";
            else return `${day} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("HH:mm")}`;
        }
    }
    static IsTimeSet(date) {
        if (date instanceof (0, $2s69t.Ref)) date = date.value;
        const d = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date);
        return d.hour() !== 0 || d.minute() !== 0 || d.seconds() !== 0 || d.milliseconds() !== 0;
    }
}


class $b4452d9087ebde99$export$761b8f8bbc165703 {
    static UseFake(nowIs) {
        $b4452d9087ebde99$export$761b8f8bbc165703.UseFakeSwitch.value = true;
        $b4452d9087ebde99$export$761b8f8bbc165703._now.value = nowIs;
    }
    static get Now() {
        return $b4452d9087ebde99$export$761b8f8bbc165703.UseFakeSwitch.value ? $b4452d9087ebde99$export$761b8f8bbc165703._now.value : new Date();
    }
    static set Now(v) {
        this._now.value = v;
    }
    static get NowAsString() {
        return `${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($b4452d9087ebde99$export$761b8f8bbc165703.Now).format("dddd")}, ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime($b4452d9087ebde99$export$761b8f8bbc165703.Now)}`;
    }
}
$b4452d9087ebde99$export$761b8f8bbc165703.UseFakeSwitch = new (0, $2s69t.RefBool)(false);
$b4452d9087ebde99$export$761b8f8bbc165703._now = new (0, $2s69t.Ref)(new Date());


class $e13c3ababb4ac8b8$export$55185c17a0fcbe46 {
    GoToAgentsPage() {
        this.hash.value = `admin/agents`;
    }
    GoToExpenses() {
        this.hash.value = `admin/expanses`;
    }
    GoToOrderCreate(orderId) {
        this.hash.value = `order-creation${orderId ? `/${orderId}` : ""}`;
    }
    GoToAgentTasks(agentId) {
        this.hash.value = `agent/${agentId}/tasks`;
    }
    GoToOrderEdit(orderId) {
        this.hash.value = `admin/order/edit/${orderId}`;
    }
    GoToOrderRawEdit(orderId) {
        this.hash.value = `admin/order/raw/${orderId}`;
    }
    GoToLogin() {
        this.hash.value = `login`;
    }
    GoToCustomerView(orderId) {
        this.hash.value = `order/${orderId}`;
    }
    constructor(hash){
        this.hash = hash;
    }
    GoToOrdersList() {
        this.hash.value = `orders`;
    }
    GoToOrderView(orderId) {
        this.hash.value = `admin/order/view/${orderId}`;
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $92a7145927fcbc93$export$cfc95f342033cc43 {
    static NicePhoneNumber(input) {
        // Usuń wszystkie znaki poza cyframi i +
        const cleaned = input.replace(/[^\d+]/g, "");
        // Sprawdź, czy numer zaczyna się od "+"
        const hasPlus = cleaned.startsWith("+");
        // Usuń plusa, żeby łatwiej operować na cyfrach
        const digits = hasPlus ? cleaned.slice(1) : cleaned;
        if (digits.length === 9) // Format krajowy: 000-000-000
        return digits.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
        // else if (digits.length > 9)
        // {
        //     // Format z kierunkowym: +00 000-000-000
        //     const countryCode = digits.slice(0, digits.length - 9);
        //     const numberPart = digits.slice(-9);
        //     const formattedNumber = numberPart.replace(
        //         /(\d{3})(\d{3})(\d{3})/,
        //         "$1-$2-$3"
        //     );
        //     return `+${countryCode} ${formattedNumber}`;
        // }
        // Jeśli nie pasuje, zwróć w oryginalnej postaci
        return input;
    }
}


class $7491f76ebc0bf829$export$9818a1bf5e26633 {
    get AsString() {
        return `${this.ExperienceIcon} ${this.Name.value || "---"} (${this.Type.value || "---"})
\u{260E}\u{FE0F} ${(0, $92a7145927fcbc93$export$cfc95f342033cc43).NicePhoneNumber(this.Phone.value) || "---"}
\u{1F4CC} ${this.Address.value || "---"}
\u{1F4E7} ${this.Email.value || "---"}
\u{1F9ED} ${this.Origin.value || "---"}` + (this.Description.value.length ? `\n(${this.Description.value})` : "");
    }
    get AsShortString() {
        return `${this.ExperienceIcon} ${this.Name.value || "---"}`;
    }
    get ExperienceIcon() {
        const expIcon = {
            0: "\uD83D\uDC68\u200D\uD83D\uDCBC",
            1: "\uD83E\uDD54",
            2: "\uD83E\uDD49",
            3: "\uD83E\uDD48",
            4: "\uD83E\uDD47"
        };
        const exp = expIcon[this.Experience.value] || "\uD83D\uDC68\u200D\uD83D\uDCBC";
        return exp;
    }
    constructor(raw){
        this.Id = "";
        this.Type = new (0, $2s69t.RefString)("Klient");
        this.Name = new (0, $2s69t.RefString)();
        this.Address = new (0, $2s69t.RefString)();
        this.Email = new (0, $2s69t.RefString)();
        this.Phone = new (0, $2s69t.RefString)();
        this.Experience = new (0, $2s69t.RefNumber)(0);
        this.Description = new (0, $2s69t.RefString)();
        this.BankAccountNumber = new (0, $2s69t.RefString)();
        this.Origin = new (0, $2s69t.RefString)();
        this.Id = raw.Id || "";
        this.Type.value = raw.Type || "";
        this.Name.value = raw.Name || "";
        this.Phone.value = raw.Phone || "";
        this.Email.value = raw.Email || "";
        this.Address.value = raw.Address || "";
        this.Description.value = raw.Description || "";
        this.Experience.value = raw.Experience || 0;
        this.BankAccountNumber.value = raw.BankAccountNumber || "";
        if (this.BankAccountNumber.value == "(brak numeru konta)") this.BankAccountNumber.value = "";
        this.Origin.value = raw.Origin || "";
    }
    static get Default() {
        return new $7491f76ebc0bf829$export$9818a1bf5e26633({
            Type: "Klient",
            Experience: 0,
            Name: "---",
            Phone: "---",
            Address: "---",
            Email: "---",
            BankAccountNumber: "---",
            Origin: "---"
        });
    }
}



var $2s69t = parcelRequire("2s69t");
class $28a45f14bda821f3$export$60b649c371b56658 {
    get IsNew() {
        return +this.UpdatedAt == 0;
    }
    constructor(raw){
        this.Folder = "";
        this.CreatedAt = new Date(0);
        this.UpdatedAt = new Date(0);
        this.CreatedBy = "";
        this.UpdatedBy = "";
        this.ChangesHistory = [];
        this.Ticket = void 0;
        this.Folder = raw?.Folder || "";
        this.CreatedAt = new Date(raw?.CreatedAt || 0);
        this.UpdatedAt = new Date(raw?.UpdatedAt || 0);
        this.CreatedBy = raw?.CreatedBy || "";
        this.UpdatedBy = raw?.UpdatedBy || "";
        this.ChangesHistory = raw?.ChangesHistory || [];
        this.Ticket = raw?.Ticket || {};
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $0e0f6b9683ce33a7$export$fd55ce593607084a {
    constructor(Data){
        this.Data = Data;
        this.Type = void 0;
        this.Icon = void 0;
        this.TitleForCustomer = void 0;
        this.Title = void 0;
        this.InitialState = void 0;
        this.WellDoneStates = void 0;
        this.FailedDoneStates = void 0;
        this.STATES = void 0;
        this.IsVisibleForCustomer = true;
        this.Order = void 0;
        this.onStepStateChange = new (0, $2s69t.HandlersCollection)();
    }
    CallOnChange() {
        this.onStepStateChange.Call(this.Data);
    }
    GetFullTitle() {
        return this.Icon + " " + this.Title();
    }
    GetTitleForCustomer() {
        if (this.TitleForCustomer?.()) return this.Icon + " " + this.TitleForCustomer?.();
        else return this.GetFullTitle();
    }
    GetStateName() {
        return this.STATES[this.Data.State.value]?.StateName || "";
    }
    GetStateNameForAdmin() {
        return this.STATES[this.Data.State.value]?.Admin?.StateName || this.STATES[this.Data.State.value]?.StateName || "";
    }
    GetStateNameForCustomer() {
        return this.STATES[this.Data.State.value]?.Customer?.StateName || this.STATES[this.Data.State.value]?.StateName || "";
    }
    get AllStates() {
        return Object.keys(this.STATES);
    }
    OnStateChange(handler) {
        this.onStepStateChange.Add(handler);
    }
    get IsDone() {
        return this.IsWellDone || this.IsFailedDone;
    }
    get IsWellDone() {
        return this.WellDoneStates.includes(this.Data.State.value);
    }
    get IsFailedDone() {
        return this.FailedDoneStates?.includes(this.Data.State.value);
    }
    get IsInInitialState() {
        return this.Data.State.value == this.InitialState;
    }
    get IsInProgress() {
        // return (!this.IsInInitialState && !this.IsDone);
        return !this.IsDone;
    }
    GetAdminContent() {
        return this.STATES[this.Data.State.value]?.Admin?.Content() || [
            `Brak kontentu dla stanu ${this.Data.State.value || "(pusty string)"}`
        ];
    }
    GetCustomerContent() {
        return this.STATES[this.Data.State.value]?.Customer?.Content() || [];
    }
    GetActions() {
        return this.STATES[this.Data.State.value]?.Admin?.Actions || {};
    }
    GoTo(state) {
        this.Data.State.value = state;
        this.onStepStateChange.Call(this.Data);
    }
    get Timeout() {
        let timeout = this.STATES[this.Data.State.value]?.Timeout?.();
        if (timeout instanceof (0, $2s69t.Ref)) timeout = timeout.value;
        return timeout;
    }
    get HasTimeout() {
        return !!this.Timeout;
    }
    get HoursToTimeout() {
        if (!this.HasTimeout) return undefined;
        const timeToTimeout = +this.Timeout - +(0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        return timeToTimeout / 3600000;
    }
    get HoursAfterTimeout() {
        if (!this.HasTimeout) return undefined;
        return -this.HoursToTimeout;
    }
    ResetState() {
        this.Data.State.value = this.InitialState;
        this.onStepStateChange.Call(this.Data);
    }
}


class $4156b0a6006d5d4e$export$66b83811e15e705 {
    constructor(type, step, amount, description, when){
        this.Type = void 0;
        this.Step = void 0;
        this.Amount = void 0;
        this.Description = void 0;
        this.When = void 0;
        this.Type = type;
        this.Step = step;
        this.Amount = amount;
        this.Description = description;
        this.When = when;
    }
}


var $4f5bc0eca7827453$export$19ce097d7421ac9a = /*#__PURE__*/ function(StepEventType) {
    StepEventType["Invoice"] = "Invoice";
    StepEventType["PersonalPickup"] = "PersonalPickup";
    StepEventType["PackageToCustomer"] = "PackageToCustomer";
    StepEventType["Training"] = "Training";
    StepEventType["PersonalReturn"] = "PersonalReturn";
    StepEventType["PackageFromCustomer"] = "PackageFromCustomer";
    StepEventType["PaymentReturn"] = "PaymentReturn";
    StepEventType["ManaPostalDelivery"] = "ManaPostalDelivery";
    StepEventType["AddToBasket"] = "AddToBasket";
    StepEventType["Payment"] = "Payment";
    StepEventType["Event"] = "Event";
    return StepEventType;
}({});
class $4f5bc0eca7827453$export$8a8cb838e5d6584d {
    constructor(Type, OrderId, Icon, Label, Date, IsDone, IsVisibleForCustomer = true){
        this.Type = Type;
        this.OrderId = OrderId;
        this.Icon = Icon;
        this.Label = Label;
        this.Date = Date;
        this.IsDone = IsDone;
        this.IsVisibleForCustomer = IsVisibleForCustomer;
    }
}



var $45fvw = parcelRequire("45fvw");
var $8eef7e9c8ac4e085$export$e577eac1d0078c6f = /*#__PURE__*/ function(StepType) {
    StepType["AddToBasket"] = "AddToBasket";
    StepType["Payment"] = "Payment";
    StepType["PersonalPickup"] = "PersonalPickup";
    StepType["PackageToCustomer"] = "PackageToCustomer";
    StepType["Training"] = "Training";
    StepType["Usage"] = "Usage";
    StepType["PersonalReturn"] = "PersonalReturn";
    StepType["PackageFromCustomer"] = "PackageReturn";
    StepType["PaymentReturn"] = "PaymentReturn";
    StepType["ManaPostalDelivery"] = "ManaPostalDelivery";
    StepType["Invoice"] = "Invoice";
    StepType["Event"] = "Event";
    return StepType;
}({});
const $8eef7e9c8ac4e085$export$591e9e81bba96c12 = {
    ["AddToBasket"]: "\uD83D\uDED2 Zam\xf3wienie",
    ["Payment"]: "\uD83D\uDCB3 Wp\u0142ata",
    ["PersonalPickup"]: "\uD83D\uDC24 Odbi\xf3r osobisty",
    ["PackageToCustomer"]: "\uD83D\uDCE6 Wysy\u0142ka do klienta",
    ["Training"]: "\uD83C\uDF93 Szkolenie",
    ["Usage"]: "\uD83D\uDE80 U\u017Cycie",
    ["PersonalReturn"]: "\uD83D\uDC25 Zwrot osobisty",
    ["PackageReturn"]: "\uD83D\uDCEE Zwrot paczk\u0105",
    ["PaymentReturn"]: "\uD83D\uDCB8 Zwrot \u015Brodk\xf3w",
    ["ManaPostalDelivery"]: "\uD83D\uDCEF Przekaz pieni\u0119\u017Cny",
    ["Invoice"]: "\uD83D\uDDC3\uFE0F Faktura",
    ["Event"]: "\u26A1 Wydarzenie"
};



var $2s69t = parcelRequire("2s69t");
class $025f09358f3e6650$export$f8cd55916d491bc2 extends (0, $2s69t.Div) {
    constructor(...content){
        super();
        this.Background("lightyellow").PositionRelative().Padding(12).Border(2, "#ddd").BorderStyle("dashed").BorderRadius(4).MarginTop(16); //.Italic()//.Bold()
        this.Append(// new Span("⚡").FontSize(32).DisplayInlineBlock(), 
        new (0, $2s69t.Span)("\u26A1").FontSize(34).PositionAbsolute().Top(-22).Left(-22), new (0, $2s69t.Div)().MarginLeft(8) //.WidthPercent(80)
        .TextAlignLeft().Append(...content).DisplayInlineBlock());
    }
}


var $2a037d32327b8a8b$export$754efc3e3034943f = /*#__PURE__*/ function(AddToBasketStepState) {
    // Unset = "Unset",
    AddToBasketStepState["New"] = "New";
    AddToBasketStepState["Accepted"] = "Accepted";
    AddToBasketStepState["Rejecting"] = "Rejecting";
    AddToBasketStepState["Rejected"] = "Rejected";
    return AddToBasketStepState;
}({});



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
var $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    var uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


class $178f547cfe79a16c$export$94f2c38ab8f7f86f {
    constructor(raw){
        this.Type = void 0;
        this.Id = "";
        this.ProductSerialNumber = new (0, $2s69t.Ref)("");
        this.AccessData = new (0, $2s69t.Ref)("");
        this.ProductInfo = void 0;
        this.Option = void 0;
        this.Quantity = new (0, $2s69t.Ref)(1);
        this.TotalPrice = new (0, $2s69t.Ref)(0);
        this.Id = raw.Id || (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        this.ProductSerialNumber.value = raw.ProductSerialNumber || "";
        this.AccessData.value = raw.AccessData || "";
        this.ProductInfo = raw.ProductInfo || {};
        this.Option = raw.Option || {};
        this.Quantity.value = raw.Quantity || 1;
        this.TotalPrice.value = raw.TotalPrice || 0;
    }
    get AsRaw() {
        return {
            Id: this.Id,
            Type: this.Type,
            ProductSerialNumber: this.ProductSerialNumber.value,
            AccessData: this.AccessData.value,
            ProductInfo: this.ProductInfo,
            Option: this.Option,
            Quantity: this.Quantity.value,
            TotalPrice: this.TotalPrice.value
        };
    }
    Set(product, option) {
        this.ProductInfo.Id = product?.Id || "";
        this.ProductInfo.Origin = "website";
        this.ProductInfo.Name = product?.BasketName?.value || "";
        this.ProductInfo.Link = "https://specteam.pl/#produkt/" + (product?.Url?.value || "");
        this.ProductInfo.Category = product?.CategoryId?.value || "";
        this.ProductInfo.Picture = product?.Images?.Items?.[0]?.MiniUrl?.value || "";
        this.ProductInfo.Prices = product?.RentPrices?.Items?.map((x)=>`${x.Days?.value} dni: ${x.Value?.value} z\u{142}`)?.join("\n") || "";
        this.ProductInfo.Tutorial = product?.TutorialLink?.value || "";
        this.Option.Id = option?.Url?.value || "";
        this.Option.Name = option?.Label?.value || "";
    }
}


var $e97714b723cebee9$export$39b11636c68d48ec = /*#__PURE__*/ function(BasketItemType) {
    BasketItemType["Unset"] = "Unset";
    BasketItemType["Rent"] = "Rent";
    BasketItemType["Sale"] = "Sale";
    return BasketItemType;
}({});
const $e97714b723cebee9$export$92d49c510b1fb8c4 = {
    ["Unset"]: "Nieznany",
    ["Rent"]: "Wynajem",
    ["Sale"]: "Sprzeda\u017C"
};



class $b104fb107ffab6bd$export$865a56617b7eaf36 extends (0, $178f547cfe79a16c$export$94f2c38ab8f7f86f) {
    constructor(raw){
        super(raw);
        this.Type = (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent;
        this.From = new (0, $2s69t.Ref)(new Date(0));
        this.To = new (0, $2s69t.Ref)(new Date(0));
        this.Deposit = new (0, $2s69t.Ref)(0);
        this.From.value = new Date(raw.From || 0);
        this.To.value = new Date(raw.To || 0);
        this.Deposit.value = raw.Deposit || 0;
    }
    get AsString() {
        return `Wypo\u{17C}yczenie: ${this.ProductInfo.Name} (${this.Option.Name || "opcja domy\u015Blna"}) x${this.Quantity.value}, ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedRange(this.From, this.To)}`;
    }
    get AsRaw() {
        return {
            ...super.AsRaw,
            From: this.From.value,
            To: this.To.value,
            Deposit: this.Deposit.value
        };
    }
}




class $46c5a39bfbff30f5$export$ff28d6513ec20674 extends (0, $178f547cfe79a16c$export$94f2c38ab8f7f86f) {
    constructor(raw){
        super(raw);
        this.Type = (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale;
    }
    get AsString() {
        return `Sprzeda\u{17C}: ${this.ProductInfo.Name} (${this.Option.Name || "opcja domy\u015Blna"}) x${this.Quantity.value}`;
    }
    get AsRaw() {
        return {
            ...super.AsRaw
        };
    }
}


class $56cbe4be73d18176$export$a4fc62f641efeb55 extends (0, $2s69t.Div) {
    constructor(cartItem){
        super("basket-cart-item");
        this.Append(new (0, $2s69t.Image)(cartItem.ProductInfo.Picture, cartItem.ProductInfo.Name).Class("basket-cart-item-image"), new (0, $2s69t.Div)("basket-cart-item-details").Append(new (0, $2s69t.Link)(cartItem.ProductInfo.Name, cartItem.ProductInfo.Link), new (0, $2s69t.Span)(`\xd7${cartItem.Quantity.value}`).MarginLeft(8), new (0, $2s69t.Div)("basket-cart-item-dates").Text(`${cartItem.Option.Name || ""}`), cartItem instanceof (0, $b104fb107ffab6bd$export$865a56617b7eaf36) && new (0, $2s69t.Div)("basket-cart-item-dates").Text(`\u{1F4C6} Wynajem ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedRange(cartItem.From, cartItem.To)}`), cartItem instanceof (0, $46c5a39bfbff30f5$export$ff28d6513ec20674) && new (0, $2s69t.Div)("basket-cart-item-dates").Text(`\u{1F6D2} Zakup`)));
    }
}


class $b2ff25bd18e5cea3$export$69322168070db270 extends (0, $2s69t.Div) {
    constructor(items){
        super();
        this.Append(...items.Map((x)=>new (0, $56cbe4be73d18176$export$a4fc62f641efeb55)(x)));
    }
}



var $8a44b9b3a048a72c$export$1dc22a502a1e0e7 = /*#__PURE__*/ function(CashType) {
    CashType["BasketValue"] = "BasketValue";
    CashType["DesiredDeposit"] = "DesiredDeposit";
    CashType["ReceivedDeposit"] = "ReceivedDeposit";
    CashType["Expense"] = "Expense";
    CashType["ReceivedIncome"] = "ReceivedIncome";
    CashType["ReturnedDeposit"] = "ReturnedDeposit";
    return CashType;
}({});


class $ada1238ad66e65c1$export$56c7a80eb69f85c5 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).AddToBasket, this.Order.Id, "\uD83D\uDED2", "Utworzenie zam\xf3wienia", this.Data.CreatedAt, this.IsDone)
        ];
    }
    get Mana() {
        return [
            new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).BasketValue, this, this.Order.BasketValue, "Warto\u015B\u0107 koszyka", this.Data.CreatedAt),
            new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).DesiredDeposit, this, this.Order.DesiredDeposit, "Planowana kaucja", this.Data.CreatedAt)
        ];
    }
    get WhenPlanned() {
        return this.Data.CreatedAt;
    }
    get WhenDone() {
        return this.Data.AcceptedTime.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket;
        this.Icon = "\uD83D\uDED2";
        this.TitleForCustomer = ()=>`Zam\xf3wienie`;
        this.Title = ()=>this.Order?.ShortId ? `Zam\xf3wienie #${this.Order?.ShortId}` : `Uzupe\u{142}nienie koszyka`;
        this.InitialState = (0, $2a037d32327b8a8b$export$754efc3e3034943f).New;
        this.WellDoneStates = [
            (0, $2a037d32327b8a8b$export$754efc3e3034943f).Accepted
        ];
        this.FailedDoneStates = [
            (0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejected
        ];
        this.STATES = {
            [(0, $2a037d32327b8a8b$export$754efc3e3034943f).New]: {
                StateName: "Jeszcze nie zaakceptowane",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.CreatedAt).clone().add(1, "day").toDate(),
                Customer: {
                    Content: ()=>[
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems),
                            new (0, $2s69t.Line)(),
                            `\u{2611}\u{FE0F} Stan magazynowy wskazuje na dost\u{119}pno\u{15B}\u{107} produkt\xf3w, ale dla pewno\u{15B}ci potwierdzi to jeszcze kto\u{15B} z naszej obs\u{142}ugi`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems),
                            new (0, $2s69t.Line)(),
                            this.Order.PeopleAsString,
                            new (0, $2s69t.Line)(),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Potwierd\u{17A} lub odrzu\u{107} to zam\xf3wienie uwzgl\u{119}dnaj\u{105}c dost\u{119}pno\u{15B}\u{107} sprz\u{119}tu w danym terminie`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.AcceptedTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $2a037d32327b8a8b$export$754efc3e3034943f).Accepted);
                        },
                        "\u274C": ()=>this.GoTo((0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejecting)
                    }
                }
            },
            [(0, $2a037d32327b8a8b$export$754efc3e3034943f).Accepted]: {
                StateName: "Zaakceptowane",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Zam\xf3wienie zosta\u{142}o zaakceptowane`,
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Zam\xf3wienie zosta\u{142}o zaakceptowane`,
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems)
                        ]
                }
            },
            [(0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejecting]: {
                StateName: "Odrzucanie w toku",
                Customer: {
                    Content: ()=>[
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            "Pow\xf3d odrzucenia (widoczne dla klienta!):",
                            new (0, $2s69t.MultilineInput)(this.Data.RejectionReason).Rows(4)
                        ],
                    Actions: {
                        "\u2714\uFE0F": ()=>this.GoTo((0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejected),
                        "\u2716\uFE0F": ()=>this.GoTo((0, $2a037d32327b8a8b$export$754efc3e3034943f).New)
                    }
                }
            },
            [(0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejected]: {
                StateName: "Odrzucone",
                Customer: {
                    Content: ()=>[
                            new (0, $b2ff25bd18e5cea3$export$69322168070db270)(this.Data.BasketItems).Opacity(0.6),
                            `\u{274C} Niestety zam\xf3wienie zosta\u{142}o odrzucone z powodu: ${this.Data.RejectionReason.value || "(powodu nie podano)"}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Zam\xf3wienie zosta\u{142}o odrzucone z powodu: ${this.Data.RejectionReason.value || "(pow\xf3d nie zosta\u0142 wpisany)"}`
                        ]
                }
            }
        };
    }
    Init() {
        this.Data.SearchBy = this.Data.BasketItems.Items.map((x)=>x.ProductSerialNumber.value).join(" ");
    }
}





var $7e7a2993af6be382$export$f3cfc706d4531aed = /*#__PURE__*/ function(OrdersFolders) {
    OrdersFolders["Open"] = "OpenOrders";
    OrdersFolders["Closed"] = "ClosedOrders";
    return OrdersFolders;
}({});


class $8b90cdef4fa99aa6$export$7cd9ffa6089f1f3f {
    constructor(){
        this.Name = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Amount = new (0, $2s69t.RefNumber)();
        this.When = new (0, $2s69t.RefDate)();
    }
}
class $8b90cdef4fa99aa6$export$d6101cb40935bdea {
    get CurrentState() {
        return this.CurrentStep?.GetStateName() || "Zamkni\u0119te";
    }
    get CurrentStateForAdmin() {
        return this.CurrentStep?.GetStateNameForAdmin() || "Zamkni\u0119te";
    }
    get CurrentStateForCustomer() {
        return this.CurrentStep?.GetStateNameForCustomer() || "Zamkni\u0119te";
    }
    get FinishedAt() {
        const postalPaymentStep = this.Steps.Items.find((x)=>x.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).ManaPostalDelivery && x.IsDone);
        const personalReturnStep = this.Steps.Items.find((x)=>x.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn && x.IsDone);
        const packageReturnStep = this.Steps.Items.find((x)=>x.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer && x.IsDone);
        return new Date(+(postalPaymentStep?.WhenDone || 0) || +(personalReturnStep?.WhenDone || 0) || +(packageReturnStep?.WhenDone || 0) || +this.Meta.CreatedAt);
    }
    // public Costs = new Collection<Expense>();
    get AreAnyNotes() {
        return this.Notes.Customer.value.length > 0 || this.Notes.Public.value.length > 0 || this.Notes.Private.value.length > 0;
    }
    get Status() {
        if (this.Meta.IsNew) return "Nowe";
        if (this.IsClosed) return "Zamkni\u0119te";
        if (this.IsDone) return "Zako\u0144czone";
        if (this.IsFailed) return "Problematyczne";
        return "W trakcie realizacji";
    }
    get CurrentStep() {
        return this.Steps.Items.find((x)=>x.IsInProgress);
    }
    get IsClosed() {
        return this.Meta.Folder === (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed;
    }
    get IsFailed() {
        return this.Steps.Items.some((x)=>x.IsFailedDone);
    }
    get IsDone() {
        return this.Steps.Items.every((x)=>x.IsDone);
    }
    get IsOpen() {
        return this.Steps.Items.some((x)=>x.IsInProgress);
    }
    OnChange(handler) {
        this.onChange.Add(handler);
    }
    constructor(id){
        this.Id = "";
        this.Steps = new (0, $2s69t.Collection)();
        this.People = new (0, $2s69t.Collection)();
        this.Meta = new (0, $28a45f14bda821f3$export$60b649c371b56658)();
        this.Notes = {
            Customer: new (0, $2s69t.RefString)(""),
            Public: new (0, $2s69t.RefString)(""),
            Private: new (0, $2s69t.RefString)("")
        };
        this.onChange = new (0, $2s69t.HandlersCollection)();
        if (id) this.Id = id;
    }
    get PeopleAsString() {
        return this.People.Map((x)=>x.ExperienceIcon + " " + x.Name.value + ", tel. " + x.Phone.value).join(", ");
    }
    get BasketItems() {
        return this.Steps.Items.filter((x)=>x instanceof (0, $ada1238ad66e65c1$export$56c7a80eb69f85c5)).map((x)=>x.Data.BasketItems).flatMap((x)=>x.Items);
    }
    get BasketValue() {
        return this.BasketItems.reduce((acc, x)=>acc + x.TotalPrice.value, 0);
    }
    get DesiredDeposit() {
        return this.BasketItems.filter((x)=>x instanceof (0, $b104fb107ffab6bd$export$865a56617b7eaf36)).reduce((acc, x)=>acc + x.Deposit.value, 0);
    }
    Mana(filter) {
        let mana = this.Steps.Items.flatMap((x)=>x.Mana);
        mana = mana.filter((x)=>filter ? filter.includes(x.Type) : true);
        return mana;
    }
    get Expenses() {
        return this.Mana([
            (0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).Expense
        ]).reduce((acc, y)=>acc + y.Amount, 0);
    }
    get ReceivedIncome() {
        return this.Mana([
            (0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome
        ]).reduce((acc, y)=>acc + y.Amount, 0);
    }
    get ReceivedDeposit() {
        return this.Mana([
            (0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedDeposit
        ]).reduce((acc, y)=>acc + y.Amount, 0);
    }
    get ReturnedDeposit() {
        return this.Mana([
            (0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReturnedDeposit
        ]).reduce((acc, y)=>acc + y.Amount, 0);
    }
    get Profit() {
        return this.ReceivedIncome - this.Expenses + (this.ReceivedDeposit - this.ReturnedDeposit);
    }
    SelfSetup() {
        this.Steps.OnChange((step)=>{
            this.onChange.Call(step, undefined);
        }).ForEach((step)=>{
            step.Order = this;
            step.OnStateChange((data)=>{
                this.onChange.Call(step, data);
            });
            step.Init?.();
        });
    }
    get ShortId() {
        return this.Id.slice(-5).toUpperCase();
    }
    get AsEvents() {
        return this.Steps.Items.flatMap((x)=>x.AsEvents);
    }
    get SearchBy() {
        const orderSearchBy = this.ShortId;
        const searchInSteps = this.Steps.Items.map((x)=>x.Data.SearchBy).join(", ");
        const peopleSearchBy = this.People.Map((x)=>x.Name.value + " " + x.Phone.value).join(", ");
        const searchBy = orderSearchBy + " " + searchInSteps + " " + peopleSearchBy;
        return searchBy;
    }
}



var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");

var $58e7eb9318036e70$export$3c13f0bb485df434 = /*#__PURE__*/ function(PaymentCategory) {
    PaymentCategory["Unset"] = "Unset";
    PaymentCategory["DepositAndBasket"] = "DepositAndBasket";
    PaymentCategory["Deposit"] = "Deposit";
    // DepositReturn = "DepositReturn",
    PaymentCategory["Basket"] = "Basket";
    // Rzeczy do zapłaty (wynajmy, zakupy, usługi, wszystko co było w koszyku)
    PaymentCategory["Transport"] = "Transport"; // Np zwrot za jakieś nadmiarowe paczki
    return PaymentCategory;
}({});




var $45fvw = parcelRequire("45fvw");

class $c4f3860668cb2871$export$6116c50c11a0d9a0 {
    static Calc(deliverAt, threshold = 4) {
        let whenSend = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(deliverAt);
        while(threshold > 0){
            const dayOfWeek = whenSend.day();
            // Is weekend - Saturday or Sunday
            if ([
                6,
                0
            ].includes(dayOfWeek)) whenSend.subtract(1, 'day');
            whenSend.subtract(1, 'day');
            threshold -= 1;
        }
        return whenSend.hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
    }
    static GetDispatchTime(rentStart, threshold = 4) {
        let whenSend = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($c4f3860668cb2871$export$6116c50c11a0d9a0.Calc(rentStart, threshold));
        const today = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).hour(0).minutes(0).seconds(0).milliseconds(0);
        if (whenSend.isBefore(today)) whenSend = today;
        return whenSend.toDate();
    }
}


var $2c4684dc9ca51087$export$a8f34b9af2eae872 = /*#__PURE__*/ function(DeliveryForm) {
    DeliveryForm["Unset"] = "Unset";
    DeliveryForm["Personal"] = "Personal";
    DeliveryForm["Package"] = "Package";
    return DeliveryForm;
}({});


var $0928cc6340f2c462$export$3fda4618fcb351f4 = /*#__PURE__*/ function(PackageToCustomerStepState) {
    PackageToCustomerStepState["NotPlannedYet"] = "NotPlannedYet";
    PackageToCustomerStepState["Planned"] = "Planned";
    PackageToCustomerStepState["LabelReady"] = "LabelReady";
    PackageToCustomerStepState["ReadyToShipment"] = "ReadyToShipment";
    PackageToCustomerStepState["InTransit"] = "InTransit";
    PackageToCustomerStepState["Delivered"] = "Delivered";
    PackageToCustomerStepState["Problem"] = "Problem";
    PackageToCustomerStepState["NotDeliveredYet"] = "NotDeliveredYet";
    PackageToCustomerStepState["Cancelled"] = "Cancelled";
    PackageToCustomerStepState["RejectedByCustomer"] = "RejectedByCustomer";
    PackageToCustomerStepState["PackageLost"] = "PackageLost";
    PackageToCustomerStepState["AwaitingInPostOffice"] = "AwaitingInPostOffice";
    PackageToCustomerStepState["StillOnTheWay"] = "StillOnTheWay";
    PackageToCustomerStepState["PackageReturned"] = "PackageReturned";
    return PackageToCustomerStepState;
}({});


var $724aeb46db8dbe77$export$87efff06c03ae41e = /*#__PURE__*/ function(TrainingStepState) {
    TrainingStepState["NotPlannedYet"] = "NotPlannedYet";
    TrainingStepState["Planning"] = "Planning";
    TrainingStepState["Planned"] = "Planned";
    TrainingStepState["Done"] = "Done";
    TrainingStepState["Canceling"] = "Canceling";
    TrainingStepState["Cancelled"] = "Cancelled";
    TrainingStepState["Closed"] = "Closed";
    TrainingStepState["Undone"] = "Undone";
    TrainingStepState["Self"] = "Self";
    return TrainingStepState;
}({});


var $078d5da6e339265b$export$869046988cdc7485 = /*#__PURE__*/ function(PersonalPickupStepState) {
    PersonalPickupStepState["NotPlannedYet"] = "NotPlannedYet";
    PersonalPickupStepState["PrePlanned"] = "PrePlanned";
    PersonalPickupStepState["Planned"] = "Planned";
    PersonalPickupStepState["AfterMeeting"] = "AfterMeeting";
    PersonalPickupStepState["Canceled"] = "Canceled";
    PersonalPickupStepState["CanceledDespitePlanned"] = "CanceledDespitePlanned";
    PersonalPickupStepState["MeetingOk"] = "MeetingOk";
    PersonalPickupStepState["MeetingFailed"] = "MeetingFailed";
    return PersonalPickupStepState;
}({});


var $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef = /*#__PURE__*/ function(PackageFromCustomerStepState) {
    PackageFromCustomerStepState["ReturnInfo"] = "ReturnInfo";
    PackageFromCustomerStepState["TimeToSend"] = "TimeToSend";
    PackageFromCustomerStepState["CustomerDeclaredPackageSent"] = "CustomerDeclaredPackageSent";
    PackageFromCustomerStepState["OnTheWay"] = "OnTheWay";
    PackageFromCustomerStepState["NotDelivered"] = "NotDelivered";
    PackageFromCustomerStepState["PackageContentOk"] = "PackageContentOk";
    PackageFromCustomerStepState["PackageContentNotOk"] = "PackageContentNotOk";
    PackageFromCustomerStepState["Cancelled"] = "Cancelled";
    PackageFromCustomerStepState["Delivered"] = "Delivered";
    return PackageFromCustomerStepState;
}({});


var $eefd2630f536cfde$export$dbf30556f6a9efbf = /*#__PURE__*/ function(ReturnForm) {
    ReturnForm["Unset"] = "Unset";
    ReturnForm["Package"] = "Package";
    ReturnForm["Personal"] = "Personal";
    return ReturnForm;
}({});


var $9b29b937dcebdfc2$export$466cc72a1090db3f = /*#__PURE__*/ function(UsageStepState) {
    UsageStepState["BeforeStart"] = "BeforeStart";
    UsageStepState["InUse"] = "InUse";
    UsageStepState["AfterEnd"] = "AfterEnd";
    UsageStepState["Omitted"] = "Omitted";
    UsageStepState["StoppedBeforePlannedEnd"] = "StoppedBeforePlannedEnd";
    UsageStepState["Interrupted"] = "Interrupted";
    return UsageStepState;
}({});


var $d627bf357d1e8401$export$ea400e09cd29ee9b = /*#__PURE__*/ function(PersonalReturnStepState) {
    PersonalReturnStepState["NotPlannedYet"] = "NotPlannedYet";
    PersonalReturnStepState["Planned"] = "Planned";
    PersonalReturnStepState["Canceled"] = "Canceled";
    PersonalReturnStepState["CanceledDespitePlanned"] = "CanceledDespitePlanned";
    PersonalReturnStepState["MeetingOk"] = "MeetingOk";
    PersonalReturnStepState["Omitted"] = "Omitted";
    PersonalReturnStepState["TimeToMeet"] = "TimeToMeet";
    return PersonalReturnStepState;
}({});



var $59209e03fc7e50d4$export$7364ac5b612dd7f5 = /*#__PURE__*/ function(InvoiceStepState) {
    InvoiceStepState["Preparing"] = "Preparing";
    InvoiceStepState["Sent"] = "Sent";
    return InvoiceStepState;
}({});



var $b4315c565ef22fe2$export$b6ded7c5f3fd9245 = /*#__PURE__*/ function(PaymentForm) {
    PaymentForm["Unset"] = "Unset";
    PaymentForm["Cash"] = "Cash";
    PaymentForm["BankTransfer"] = "BankTransfer";
    PaymentForm["CashAtDelivery"] = "CashAtDelivery";
    PaymentForm["TransferAtDelivery"] = "TransferAtDelivery";
    // Przelew wykonany przez kuriera w momencie odbioru paczki
    PaymentForm["PostalTransfer"] = "PostalTransfer";
    // Kasa nadana na poczcie w formie przelewu
    PaymentForm["Crypto"] = "Crypto";
    PaymentForm["Blik"] = "Blik";
    return PaymentForm;
}({});
const $b4315c565ef22fe2$export$76326f79407286d6 = {
    ["Unset"]: "(forma nie okre\u015Blona)",
    ["Cash"]: "Got\xf3wka",
    ["BankTransfer"]: "Przelew bankowy",
    ["CashAtDelivery"]: "Got\xf3wka przy odbiorze",
    ["TransferAtDelivery"]: "Przelew przy odbiorze",
    ["PostalTransfer"]: "Przelew pocztowy",
    ["Crypto"]: "Kryptowaluta",
    ["Blik"]: "Blik"
};
const $b4315c565ef22fe2$export$2101405ba6a59df8 = {
    "(nie wybrano)": "Unset",
    "Got\xf3wka": "Cash",
    "Przelew bankowy": "BankTransfer",
    "Got\xf3wka przy odbiorze": "CashAtDelivery",
    "Przelew przy odbiorze": "TransferAtDelivery",
    "Przelew pocztowy": "PostalTransfer",
    "Kryptowaluta": "Crypto",
    "Blik": "Blik"
};


class $b9acad91e03b27f5$export$d3abacc731f387a {
    Log(...message) {
    // console.log(`[StepsPlanner]`, ...message);
    }
    constructor(_factory, btcValueInPln){
        this._factory = _factory;
        this.btcValueInPln = btcValueInPln;
        this.steps = new (0, $2s69t.Collection)();
    }
    Plan(ticket) {
        if (this.IsAnythingToRent(ticket)) this.WhenRent(ticket);
        else if (this.IsAnythingToSale(ticket)) this.WhenSale(ticket);
        else {
            // throw new Error("Ticket has no basket items");
            console.warn("[StepsPlanner] Ticket has no basket items");
            return [];
        }
        if (ticket.Invoice) this.AddInvoice({
            State: (0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Preparing,
            CompanyName: ticket.Invoice.CompanyName,
            CompanyAddress: ticket.Invoice.CompanyAddress,
            CompanyNIP: ticket.Invoice.CompanyNIP,
            DeliveryDeadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(14, 'day').toDate()
        });
        return this.steps.Items;
    }
    WhenSale(ticket) {
        this.Log("Sale");
        // 🛒 Koszyk
        this.AddAddToBasket({
            CreatedAt: ticket.Meta.CreatedAt,
            BasketItems: ticket.BasketList
        });
        // 💰 Płatność gotówką
        if ([
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash,
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery
        ].includes(ticket.BasketPaymentForm)) {
            // 🐤 Odbiór osobisty
            if (this.IsPersonalDelivery(ticket)) this.AddPersonalPickup({
                State: (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                MeetingPlace: ticket.PickupPlace,
                PlannedDispatchTime: this.CalcDispatchTime(ticket),
                BasketSum: this.BasketSum(ticket),
                DepositSum: this.DepositSum(ticket),
                Training: ticket.WithTraining,
                CustomerInfo: this.CustomerInfo(ticket)
            });
            else if (this.IsPackageDelivery(ticket)) {
                this.AddPackageToCustomer(ticket, {
                    PaymentAtDelivery: this.BasketSum(ticket)
                });
                // 🎓 Szkolenie
                this.AddTraining(ticket, {
                    State: (0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet
                });
                this.AddManaPostalDelivery({
                    DeliveryDeadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.CalcDispatchTime(ticket)).clone().add(14, 'day').toDate(),
                    Amount: this.BasketSum(ticket)
                });
            } else throw new Error(`Unknown delivery form "${ticket.Delivery}"`);
        } else if (this.IsTransferable(ticket.BasketPaymentForm)) {
            this.AddPayment(ticket, {
                Category: (0, $58e7eb9318036e70$export$3c13f0bb485df434).Basket,
                Title: this.TicketId(ticket),
                Amount: this.BasketSum(ticket),
                Form: ticket.BasketPaymentForm,
                Deadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().add(3, 'days').hour(12).minutes(0).seconds(0).milliseconds(0).toDate()
            });
            // 🐤 Odbiór osobisty
            if (this.IsPersonalDelivery(ticket)) this.AddPersonalPickup({
                State: (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                MeetingPlace: ticket.PickupPlace,
                PlannedDispatchTime: this.CalcDispatchTime(ticket),
                BasketSum: 0,
                DepositSum: 0,
                Training: ticket.WithTraining,
                CustomerInfo: this.CustomerInfo(ticket)
            });
            else if (this.IsPackageDelivery(ticket)) {
                this.AddPackageToCustomer(ticket, {
                    PaymentAtDelivery: 0
                });
                // 🎓 Szkolenie
                this.AddTraining(ticket, {
                    State: (0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet
                });
            } else throw new Error(`Unknown delivery form "${ticket.Delivery}"`);
        }
    }
    WhenRent(ticket) {
        this.Log("Rent");
        // 🛒 Koszyk
        this.AddAddToBasket({
            CreatedAt: ticket.Meta.CreatedAt,
            BasketItems: ticket.BasketList
        });
        // 💰 Kaucja gotówką
        if (this.IsDepositWithCash(ticket)) {
            this.Log("Deposit with Cash");
            // 💰 Koszyk gotówką
            if (this.IsBasketWithCash(ticket)) this.WhenDepositWithCashAndBasketWithCash(ticket);
            else if (this.IsTransferable(ticket.BasketPaymentForm)) throw new Error("You can't pay deposit with transfer when basket is paid with cash");
            else throw new Error(`Unknown basket payment form "${ticket.BasketPaymentForm}"`);
        } else if (this.IsDepositTransferable(ticket)) {
            // 💰 Koszyk gotówką
            if (this.IsBasketWithCash(ticket) || this.IsBasketWithCashAtDelivery(ticket)) this.WhenDepositWithTransferAndBasketWithCash(ticket);
            else if (this.IsTransferable(ticket.BasketPaymentForm)) this.WhenDepositWithTransferAndBasketWithTransfer(ticket);
            else throw new Error(`Unknown basket payment form "${ticket.BasketPaymentForm}"`);
        }
    }
    IsAnythingToSale(ticket) {
        return ticket.BasketList.some((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale);
    }
    IsBasketWithCashAtDelivery(ticket) {
        return ticket.BasketPaymentForm === (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery;
    }
    WhenDepositWithTransferAndBasketWithTransfer(ticket) {
        this.Log("Deposit with Transfer and Basket with Transfer");
        this.AddPayment(ticket, {
            Category: (0, $58e7eb9318036e70$export$3c13f0bb485df434).DepositAndBasket,
            Title: this.TicketId(ticket),
            Amount: this.DepositSum(ticket) + this.BasketSum(ticket),
            Form: ticket.DepositPaymentForm,
            Deadline: this.CalcPaymentDeadline(ticket)
        });
        if (this.IsPersonalDelivery(ticket)) {
            this.AddPersonalPickup({
                ItemsIds: ticket.BasketList.map((x)=>x.Id),
                State: (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                MeetingPlace: ticket.PickupPlace,
                PlannedDispatchTime: this.CalcDispatchTime(ticket),
                BasketSum: 0,
                DepositSum: 0,
                Training: ticket.WithTraining,
                CustomerInfo: this.CustomerInfo(ticket)
            });
            this.AddTraining(ticket, {
                State: (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self
            });
        } else if (this.IsPackageDelivery(ticket)) {
            this.AddPackageToCustomer(ticket, {
                PaymentAtDelivery: 0
            });
            this.AddTraining(ticket, {
                State: ticket.WithTraining ? (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planned : (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self,
                PlannedTime: this.TrainingTime(ticket)
            });
        } else throw new Error(`Unknown delivery form "${ticket.Delivery}"`);
        this.UsageAndReturnWhenDepositPaidWithTransfer(ticket);
    }
    WhenDepositWithTransferAndBasketWithCash(ticket) {
        this.Log("Deposit with Transfer and Basket with Cash");
        this.AddPayment(ticket, {
            Category: (0, $58e7eb9318036e70$export$3c13f0bb485df434).Deposit,
            Title: this.TicketId(ticket),
            Amount: this.DepositSum(ticket),
            Form: ticket.DepositPaymentForm,
            Deadline: this.CalcPaymentDeadline(ticket)
        });
        if (this.IsPersonalDelivery(ticket)) {
            this.AddPersonalPickup({
                ItemsIds: ticket.BasketList.map((x)=>x.Id),
                State: (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                MeetingPlace: ticket.PickupPlace,
                PlannedDispatchTime: this.CalcDispatchTime(ticket),
                BasketSum: this.BasketSum(ticket),
                DepositSum: 0,
                Training: ticket.WithTraining,
                CustomerInfo: this.CustomerInfo(ticket)
            });
            this.AddTraining(ticket, {
                State: (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self
            });
        } else if (this.IsPackageDelivery(ticket)) {
            this.AddPackageToCustomer(ticket, {
                PaymentAtDelivery: this.BasketSum(ticket)
            });
            this.AddTraining(ticket, {
                State: ticket.WithTraining ? (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planned : (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self,
                PlannedTime: this.TrainingTime(ticket)
            });
        }
        this.UsageAndReturnWhenDepositPaidWithTransfer(ticket);
        if (this.IsBasketWithCash(ticket) || this.IsBasketWithCashAtDelivery(ticket)) this.AddManaPostalDelivery({
            DeliveryDeadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.CalcDispatchTime(ticket)).clone().add(14, 'day').toDate(),
            Amount: this.BasketSum(ticket)
        });
    }
    UsageAndReturnWhenDepositPaidWithTransfer(ticket) {
        this.AddUsage(ticket);
        if (this.IsPersonalReturn(ticket)) this.AddPersonalReturn({
            State: (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Planned,
            MeetingPlace: ticket.PickupPlace,
            PlannedMeetingTime: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(1, 'day').hour(0).minute(0).second(0).millisecond(0).toDate(),
            CashToReturn: 0
        });
        else if (this.IsPackageReturn(ticket)) this.AddPackageFromCustomer({
            State: (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo,
            PlannedDispatchTime: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(1, 'day').hour(12).minute(0).second(0).millisecond(0).toDate()
        });
        this.AddPaymentReturn(ticket, {
            Category: (0, $58e7eb9318036e70$export$3c13f0bb485df434).Deposit,
            AccountNumber: ticket.Customer.BankAccountNumber,
            Form: this.DepositPaymentReturnForm(ticket),
            Amount: this.DepositSum(ticket),
            Title: `Zwrot ${this.TicketId(ticket)}`,
            Deadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(14, 'days').toDate()
        });
    }
    IsPackageDelivery(ticket) {
        return ticket.Delivery === (0, $2c4684dc9ca51087$export$a8f34b9af2eae872).Package;
    }
    IsBasketWithCash(ticket) {
        return ticket.BasketPaymentForm === (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash;
    }
    BasketItemsHaveTutorial(ticket) {
        return ticket.BasketList.some((x)=>x.ProductInfo.Tutorial.trim().length > 0);
    }
    WhenDepositWithCashAndBasketWithCash(ticket) {
        // 🐤 Odbiór osobisty
        if (this.IsPersonalDelivery(ticket)) {
            this.AddPersonalPickup({
                ItemsIds: ticket.BasketList.map((x)=>x.Id),
                State: (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                MeetingPlace: ticket.PickupPlace,
                PlannedDispatchTime: this.CalcDispatchTime(ticket),
                BasketSum: this.BasketSum(ticket),
                DepositSum: this.DepositSum(ticket),
                Training: ticket.WithTraining,
                CustomerInfo: this.CustomerInfo(ticket)
            });
            this.AddTraining(ticket, {
                State: (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self
            });
            // 🚀 Użytkowanie
            this.AddUsage(ticket);
            // 🐤 Zwrot osobisty
            if (this.IsPersonalReturn(ticket)) this.AddPersonalReturn({
                State: (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Planned,
                MeetingPlace: ticket.PickupPlace,
                PlannedMeetingTime: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(1, 'day').hour(0).minute(0).second(0).millisecond(0).toDate(),
                CashToReturn: this.DepositSum(ticket)
            });
            else if (this.IsPackageReturn(ticket)) {
                this.AddPackageFromCustomer({
                    State: (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo,
                    PlannedDispatchTime: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(1, 'day').hour(12).minute(0).second(0).millisecond(0).toDate()
                });
                this.AddPaymentReturn(ticket, {
                    Category: (0, $58e7eb9318036e70$export$3c13f0bb485df434).Deposit,
                    AccountNumber: ticket.Customer.BankAccountNumber,
                    Form: this.DepositPaymentReturnForm(ticket),
                    Amount: this.DepositSum(ticket),
                    Title: `Zwrot ${this.TicketId(ticket)}`,
                    Deadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.EndOfRent(ticket)).clone().add(14, 'days').toDate()
                });
                this.AddManaPostalDelivery({
                    DeliveryDeadline: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.CalcDispatchTime(ticket)).clone().add(14, 'day').toDate(),
                    Amount: this.BasketSum(ticket)
                });
            }
        } else throw new Error("You can't use delivery when deposit is paid with cash");
    }
    DepositPaymentReturnForm(ticket) {
        let depositReturnForm;
        switch(ticket.DepositPaymentForm){
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash:
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery:
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).TransferAtDelivery:
                depositReturnForm = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).PostalTransfer; // <-- this is important
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer:
                depositReturnForm = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer;
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik:
                depositReturnForm = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik;
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto:
                depositReturnForm = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto;
                break;
            default:
                throw new Error(`Can not determine deposit return form for "${ticket.DepositPaymentForm}" deposit payment form`);
        }
        return depositReturnForm;
    }
    CustomerInfo(ticket) {
        const expIcon = {
            0: "\uD83D\uDC24",
            1: "\uD83E\uDD54",
            2: "\uD83E\uDD49",
            3: "\uD83E\uDD48",
            4: "\uD83E\uDD47"
        };
        const exp = expIcon[ticket.Customer.Experience || 0];
        return `${exp} ${ticket.Customer.Name}, tel. ${(0, $92a7145927fcbc93$export$cfc95f342033cc43).NicePhoneNumber(ticket.Customer.Phone)}`;
    }
    IsPersonalReturn(ticket) {
        return ticket.Return == (0, $eefd2630f536cfde$export$dbf30556f6a9efbf).Personal;
    }
    IsPackageReturn(ticket) {
        return ticket.Return == (0, $eefd2630f536cfde$export$dbf30556f6a9efbf).Package;
    }
    IsDepositTransferable(ticket) {
        return this.IsTransferable(ticket.DepositPaymentForm);
    }
    IsDepositWithCash(ticket) {
        return ticket.DepositPaymentForm === (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash;
    }
    TicketId(ticket) {
        return ticket.Id.slice(-5).toUpperCase();
    }
    IsPersonalDelivery(ticket) {
        return ticket.Delivery === (0, $2c4684dc9ca51087$export$a8f34b9af2eae872).Personal;
    }
    DeliveryAddress(ticket) {
        const expIcon = {
            0: "\uD83D\uDC24",
            1: "\uD83E\uDD54",
            2: "\uD83E\uDD49",
            3: "\uD83E\uDD48",
            4: "\uD83E\uDD47"
        };
        const exp = expIcon[ticket.Customer.Experience || 0];
        return `${exp} ${ticket.Customer.Name}
\u{1F5FA}\u{FE0F} ${ticket.Customer.Address}
\u{260E}\u{FE0F} ${(0, $92a7145927fcbc93$export$cfc95f342033cc43).NicePhoneNumber(ticket.Customer.Phone)}`;
    }
    AddStep(step) {
        this.Log(`Adding step ${step.Type}`);
        this.steps.Add(step);
    }
    AddAddToBasket(basket) {
        this.steps.Add(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket, basket));
    }
    AddPersonalPickup(personal) {
        personal.PlannedDispatchTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(personal.PlannedDispatchTime).hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup, personal));
    }
    AddPackageToCustomer(ticket, transit) {
        transit.State = (0, $0928cc6340f2c462$export$3fda4618fcb351f4).Planned;
        transit.PackageContent = ticket.BasketList.map((x)=>x.Id);
        transit.PlannedDispatchTime = this.CalcDispatchTime(ticket);
        transit.AddressFullInfo = this.DeliveryAddress(ticket);
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer, transit));
    }
    AddTraining(ticket, training) {
        if (!this.BasketItemsHaveTutorial(ticket)) return;
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training, training));
    }
    AddPayment(ticket, payment) {
        if (payment.Amount && payment.Amount > 0) {
            payment.Currency = "PLN";
            payment.PaymentCurrency = ticket.DepositPaymentForm == (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto ? "BTC" : "PLN";
            payment.ExchangeRate = this.btcValueInPln;
            this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment, payment));
        } else this.Log(`Payment amount is 0. Omitting payment step`);
    }
    AddInvoice(invoice) {
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Invoice, invoice));
    }
    AddUsage(ticket) {
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Usage, {
            State: (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).BeforeStart,
            Start: this.StartOfRent(ticket),
            End: this.EndOfRent(ticket)
        }));
    }
    AddPersonalReturn(personal) {
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn, personal));
    }
    AddPackageFromCustomer(transit) {
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer, transit));
    }
    AddPaymentReturn(ticket, payment) {
        payment.Currency = "PLN";
        payment.PaymentCurrency = ticket.DepositPaymentForm == (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto ? "BTC" : "PLN";
        payment.ExchangeRate = this.btcValueInPln;
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn, payment));
    }
    AddManaPostalDelivery(payment) {
        payment.VisibleForCustomer = false;
        this.AddStep(this._factory.Create((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).ManaPostalDelivery, payment));
    }
    BasketSum(ticket) {
        return ticket.BasketList.reduce((sum, item)=>sum + item.TotalPrice, 0);
    }
    IsAnythingToRent(ticket) {
        return ticket.BasketList.some((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent);
    }
    StartOfRent(ticket) {
        const rent = ticket.BasketList.find((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent);
        if (!rent) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(rent.From).hour(0).minutes(1).seconds(0).milliseconds(0).toDate();
    }
    TrainingTime(ticket) {
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.StartOfRent(ticket));
        return start.hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
    }
    EndOfRent(ticket) {
        const rent = ticket.BasketList.find((x)=>x.Type == (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent);
        if (!rent) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(rent.To).hour(23).minutes(59).seconds(0).milliseconds(0).toDate();
    }
    DepositSum(ticket) {
        return ticket.BasketList.reduce((sum, item)=>sum + (item.Deposit || 0), 0);
    }
    CalcPaymentDeadline(ticket) {
        const dispatchTime = this.CalcDispatchTime(ticket);
        const prefered = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dispatchTime).subtract(1, 'day').hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
        const now = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        if (prefered < now) return now;
        return prefered;
    }
    CalcDispatchTime(ticket) {
        let plannedDispatch = new Date(0);
        const startOfRent = this.StartOfRent(ticket);
        if (startOfRent) // Is anything to rent
        {
            const threshold = this.IsPersonalDelivery(ticket) ? 1 : 4;
            plannedDispatch = (0, $c4f3860668cb2871$export$6116c50c11a0d9a0).GetDispatchTime(startOfRent, threshold);
        } else // Dispatch tomorrow
        plannedDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().add(1, 'day').hour(12).minutes(0).seconds(0).milliseconds(0).toDate();
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(plannedDispatch).hour(12).minutes(0).seconds(0).milliseconds(0).toDate();
    }
    IsTransferable(form) {
        return [
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer,
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto,
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik
        ].includes(form);
    }
}


class $32786e3a7ad3fec1$export$d73fce08fd84e72d {
    constructor(_factory){
        this._factory = _factory;
    }
    Convert(ticket, btcValueInPln) {
        try {
            const steps = new (0, $b9acad91e03b27f5$export$d3abacc731f387a)(this._factory, btcValueInPln).Plan(ticket);
            const order = new (0, $8b90cdef4fa99aa6$export$d6101cb40935bdea)();
            order.Id = ticket.Id.toUpperCase();
            order.People.Add(new (0, $7491f76ebc0bf829$export$9818a1bf5e26633)(ticket.Customer));
            order.Steps.Load(...steps);
            order.Meta.CreatedAt = ticket.Meta.CreatedAt;
            order.Meta.CreatedBy = ticket.Meta.CreatedBy;
            order.Meta.Ticket = ticket;
            order.Notes.Customer.value = ticket.Notes;
            return order;
        } catch (e) {
            console.error(`Ticket ${ticket.Id} to Order conversion failed:`, e);
            throw e;
        }
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $e8b1084b28a2a5a4$export$aff4fc93593c3bcf extends (0, $2s69t.Div) {
    constructor(title, content, theme = "#a87603"){
        super();
        this.Style(`display: block; margin: 32px 0; text-align: center;`);
        this.Append(new (0, $2s69t.Div)().Style(`display: inline-block; padding: 16px; color: #222; text-align: left; border-left: 12px solid ${theme}`).Append(new (0, $2s69t.Div)().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme), content));
    }
}



var $2s69t = parcelRequire("2s69t");
class $514335b6e811f7d2$export$ac16a6a04d9b7c84 extends (0, $2s69t.Button) {
    constructor(label, action){
        super(label, action);
        this.DisplayInlineBlock();
        this.Class("uk-button uk-button-primary");
        this.Style("white-space: nowrap");
    }
}


class $225750fe3a94dddc$export$6955bcca4cd3539f extends (0, $2s69t.Div) {
    constructor(pageTitle, cssClasses = ""){
        super(cssClasses), this.pageTitle = pageTitle;
        this.body = void 0;
        this.loader = new (0, $2s69t.Span)("\u0141adowanie strony...");
        this.onError = (ex)=>{
            return {
                header: "Error",
                body: ex.message
            };
        };
        this.SetTitle(this.pageTitle);
        this.body = new (0, $2s69t.Div)("");
        this.Append(new (0, $2s69t.Div)().WidthPercent(100).TextAlignCenter().Append(this.body));
    }
    SetTitle(title) {
        document.title = title instanceof (0, $2s69t.Ref) ? title.value : title || "specTeam.pl";
    }
    OnError(handler) {
        this.onError = handler;
    }
    async Content(content) {
        try {
            this.Append(this.loader);
            await content(this.body);
        } catch (ex) {
            console.error(ex);
            let problemHeader = "Error";
            let problemBody = ex.message;
            const msg = ex.message.toLowerCase();
            if (msg.includes("unauthorized")) {
                problemHeader = "Brak autoryzacji";
                problemBody = new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zaloguj", ()=>window.location.hash = "login");
            } else if (msg.includes("failed to fetch")) {
                problemHeader = "Problem z po\u0142\u0105czeniem";
                problemBody = "Sprawd\u017A swoje po\u0142\u0105czenie z internetem i od\u015Bwie\u017C stron\u0119";
            } else {
                const onErrorResult = this.onError(ex);
                problemHeader = onErrorResult.header;
                problemBody = onErrorResult.body;
            }
            this.body.Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)(problemHeader, problemBody));
        } finally{
            this.loader.RemoveSelf();
        }
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $dca4a10ada8bf906$export$e71c4d32a2263218 extends (0, $2s69t.Div) {
    constructor(...cmps){
        super("box");
        this.Append(...cmps);
    }
}



var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");

class $83a2f85696aa83bc$export$d24d2f8bbf3c93d4 extends (0, $2s69t.Div) {
    constructor(dateRef, now = ()=>new Date()){
        super("DateSlider");
        const display = new (0, $2s69t.Text)(dateRef, (v)=>this.FormatDate(v)).When(dateRef, (v)=>+v == 0, (_)=>_.Italic().Color("#aaa"), (_)=>_.Normal().Color("#666"));
        if (this.IsInvalidDate(dateRef.value)) display.Border(3, "#ff6565").BorderStyle("dashed").BorderRadius(16).PaddingLeft(8).PaddingRight(8);
        this.Append(display, new (0, $2s69t.Line)().Margin(4), new (0, $2s69t.Button)("d+").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(1, 'day').toDate()), new (0, $2s69t.Button)("d-").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(-1, 'day').toDate()), " : ", new (0, $2s69t.Button)("h+").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(1, 'hour').toDate()), new (0, $2s69t.Button)("h-").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(-1, 'hour').toDate()), " : ", new (0, $2s69t.Button)("m+").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(5, 'minute').toDate()), new (0, $2s69t.Button)("m-").OnClick(()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).add(-5, 'minute').toDate()), new (0, $2s69t.PopupMenu)({
            "Wczoraj": ()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().subtract(1, 'day').hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
            "Teraz": ()=>{
                const nowTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(now());
                const minutes = nowTime.minute();
                const roundedMinutes = Math.round(minutes / 15) * 15;
                dateRef.value = nowTime.minute(roundedMinutes).seconds(0).milliseconds(0).toDate();
            },
            "Dzisiaj": ()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
            "Jutro": ()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(1, 'day').hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
            "00:00": ()=>dateRef.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateRef.value).hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
            "null": ()=>dateRef.value = new Date(0)
        }, new (0, $2s69t.Button)("\u22EE").RemoveClass("uk-button").PaddingLeft(12).PaddingRight(12)).MarginLeft(16));
    }
    FormatDate(date) {
        if (!date) return "(brak daty)";
        if (date instanceof (0, $2s69t.Ref)) {
            if (!date.IsSet) return "- data nieustalona -";
            const day = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("DD.MM.YYYY");
            if (!(0, $029e32efb5f6474c$export$3117a0de16ab2854).IsTimeSet(date.value)) return day + "\ngodzina nie ustalona";
            else return `${day} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date.value).format("HH:mm")}`;
        } else {
            if (+date === 0) return "- data nieustalona -";
            const day = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("dddd, DD.MM.YYYY");
            if (!(0, $029e32efb5f6474c$export$3117a0de16ab2854).IsTimeSet(date)) return day + "\ngodzina nie ustalona";
            else return `${day} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("HH:mm")}`;
        }
    }
    IsInvalidDate(date) {
        try {
            return isNaN(date.getTime());
        } catch (e) {
            return true;
        }
    }
}


class $e713613ae4567f75$export$4f13f83fd8bb1dac {
}
$e713613ae4567f75$export$4f13f83fd8bb1dac.Basket = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart-icon lucide-shopping-cart"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Route = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-route-icon lucide-route"><circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/><circle cx="18" cy="5" r="3"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.User = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-icon lucide-user"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Save = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-save-icon lucide-save"><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/><path d="M7 3v4a1 1 0 0 0 1 1h7"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Lock = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock-icon lucide-lock"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.LockOpen = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock-open-icon lucide-lock-open"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Trash = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-icon lucide-trash"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Calendar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-icon lucide-calendar"><rect width="20" height="18" x="2" y="4" rx="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="2" x2="22" y1="10" y2="10"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Money = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign-icon lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Notes = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-notebook-pen-icon lucide-notebook-pen"><path d="M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4"/><path d="M2 6h4"/><path d="M2 10h4"/><path d="M2 14h4"/><path d="M2 18h4"/><path d="M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Plus = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus"><path d="M5 12h14"/><path d="M12 5v14"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Chat = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle-icon lucide-message-circle"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l3.5-9.5 2.3 2c.6 1.3 1.5 2.3 2.8 3.1l1.2 1.2a8.38 8.38 0 0 0 3.8.9 8.5 8.5 0 0 0 4.7-7.6 8.38 8.38 0 0 0-.9-3.8z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Bitcoin = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bitcoin-icon lucide-bitcoin"><path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Edit = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-edit-3-icon lucide-edit-3"><path d="M12 4h-1"/><path d="M17.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.Eye = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>`;
$e713613ae4567f75$export$4f13f83fd8bb1dac.List = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-icon lucide-list"><path d="M3 5h.01"/><path d="M3 12h.01"/><path d="M3 19h.01"/><path d="M8 5h13"/><path d="M8 12h13"/><path d="M8 19h13"/></svg>`;



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $aa6902a8d95be5a7$export$e17b9c1182212c96 extends (0, $2s69t.Div) {
    constructor(asText){
        super();
        this.DisplayInlineBlock();
        this.Html(asText);
    }
}


class $38988c1de85120c6$export$787a017fbb13560d extends (0, $2s69t.Button) {
    constructor(type, text, icon, onClick){
        super(text, onClick);
        this.Prepend(new (0, $aa6902a8d95be5a7$export$e17b9c1182212c96)(icon).Class("button__icon"));
        this.Class("xbutton xbutton--" + (type || "light"));
    }
}


class $ccab16682f88d5ed$export$8a19b280fefd0a15 extends (0, $38988c1de85120c6$export$787a017fbb13560d) {
    constructor(text, icon, onClick){
        super("primary", text, icon, onClick);
    }
}
class $ccab16682f88d5ed$export$174d0791895a902d extends (0, $38988c1de85120c6$export$787a017fbb13560d) {
    constructor(text, icon, onClick){
        super("dark", text, icon, onClick);
    }
}
class $ccab16682f88d5ed$export$8cc203231d44dc6a extends (0, $38988c1de85120c6$export$787a017fbb13560d) {
    constructor(text, icon, onClick){
        super("default", text, icon, onClick);
    }
}
class $ccab16682f88d5ed$export$b7c3a2f69225ecf extends (0, $2s69t.Button) {
    constructor(text, onClick){
        super(text, onClick);
        this.Class("uk-button uk-button-default");
        this.Style("white-space: nowrap");
    }
}





var $2s69t = parcelRequire("2s69t");
class $5a57c00e6e1c76a3$export$5f0fddd75cd8dcd7 {
    get AsRaw() {
        return {
            Name: this.Name.value,
            Code: this.Code.value,
            Value: this.Value.value,
            Description: this.Description.value,
            Target: this.Target.value,
            Type: this.Type.value,
            Limit: this.Limit.value,
            IsVisible: this.IsVisible.value
        };
    }
    constructor(raw){
        this.Type = new (0, $2s69t.RefString)();
        this.Target = new (0, $2s69t.RefString)();
        this.Code = new (0, $2s69t.RefString)();
        this.Value = new (0, $2s69t.RefNumber)();
        this.IsVisible = new (0, $2s69t.RefBool)();
        this.Name = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Limit = new (0, $2s69t.RefNumber)();
        this.Name.value = raw.Name || "";
        this.Code.value = raw.Code || "";
        this.Value.value = raw.Value || raw.Value || 0;
        this.Description.value = raw.Description || "";
        this.Target.value = raw.Target || "";
        this.Type.value = raw.Type || "";
        this.Limit.value = raw.Limit || 0;
        this.Value.value = raw.Value ?? raw.Percent ?? 0;
        this.IsVisible.value = raw.IsVisible ?? false;
    }
}



var $2s69t = parcelRequire("2s69t");
class $ca5ddfa4627c7851$export$ae1d92c6c071ba79 extends (0, $2s69t.Select) {
    constructor(exp){
        const experienceOptions = [
            new (0, $2s69t.SelectOption)("Nie wybrano", 0),
            new (0, $2s69t.SelectOption)("\uD83E\uDD54 Atechniczny", 1),
            new (0, $2s69t.SelectOption)("\uD83E\uDD49 Nigdy nie korzysta\u0142", 2),
            new (0, $2s69t.SelectOption)("\uD83E\uDD48 Korzysta\u0142 z podobnego", 3),
            new (0, $2s69t.SelectOption)("\uD83E\uDD47 U\u017Cywa\u0142 naszego", 4)
        ];
        super(exp, experienceOptions);
    }
}


// SYNC TO specTeam.Website!
var $c0d2121e22406ddb$export$ff0fe1ce2347cbc0 = /*#__PURE__*/ function(PaymentPresets) {
    PaymentPresets["Unset"] = "Unset";
    PaymentPresets["AllWithCash"] = "AllWithCash";
    // 💰+💰
    PaymentPresets["AllWithBankTransfer"] = "AllWithBankTransfer";
    // 💳+💳
    PaymentPresets["AllWithCrypto"] = "AllWithCrypto";
    // 🪙+🪙
    PaymentPresets["DepositWithBankTransfer_ServiceWithCash"] = "DepositPrepaidServicePostpaid";
    // 💳+💰
    PaymentPresets["DepositWithBlik_ServiceWithCash"] = "DepositPrepaidWithBlikServicePostpaid"; // ☎️+💰
    return PaymentPresets;
}({});



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $d3c6f9c591ce1668$export$4d0262465775ab3 {
    // For example 1.25 for 25% more expensive
    constructor(raw){
        this.Url = new (0, $2s69t.RefString)();
        // This is also an ID
        this.Label = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.PriceFactor = new (0, $2s69t.RefNumber)();
        this.Url.value = raw?.Url || "";
        this.Label.value = raw?.Label || "";
        this.Description.value = raw?.Description || "";
        this.PriceFactor.value = raw?.PriceFactor || 1;
    }
    static get Default() {
        return new $d3c6f9c591ce1668$export$4d0262465775ab3({
            Url: "opcja-domyslna",
            Label: "",
            Description: "Opcja domy\u015Blna",
            PriceFactor: 1
        });
    }
}


class $977d989a83a126db$export$2e2ab7553631f1f9 extends (0, $2s69t.Div) {
    constructor(products, basketItem){
        super(), this.products = products, this.basketItem = basketItem;
        this.productId = new (0, $2s69t.RefString)().OnChange(()=>this.Refresh());
        this.optionId = new (0, $2s69t.RefString)().OnChange(()=>this.Refresh());
        const productsNames = products.map((p)=>new (0, $2s69t.SelectOption)(p.Title.value, p.Id));
        this.productId.value = this.basketItem?.ProductInfo?.Id || "";
        this.optionId.value = this.basketItem?.Option?.Id || "";
        this.Append(new (0, $2s69t.Select)(this.productId, productsNames).WidthAuto(), new (0, $2s69t.Select)(this.optionId, ()=>this.OptionsOfSelectedProduct(products), this.productId).WidthAuto().AddDefaultOption("(wybierz opcj\u0119)").VisibleWhen(this.productId, ()=>this.OptionsOfSelectedProduct(products).length > 0));
    }
    OptionsOfSelectedProduct(productsInfo) {
        const product = productsInfo.find((x)=>x.Id == this.productId.value);
        const productOptions = product?.Options.List.Items.map((o)=>new (0, $2s69t.SelectOption)(o.Label.value, o.Url.value)) || [];
        return productOptions;
    }
    Refresh() {
        const product = this.products.find((x)=>x.Id == this.productId.value);
        if (!product) return;
        const option = product.Options.List.Find((o)=>o.Url.value == this.optionId.value) || (0, $d3c6f9c591ce1668$export$4d0262465775ab3).Default;
        this.basketItem.Set(product, option);
    }
}








var $2s69t = parcelRequire("2s69t");
class $81a14981abe2adb6$export$b534bc812df080fd extends (0, $2s69t.Div) {
    constructor(label, input){
        super("table-row");
        this.Append(new (0, $2s69t.Label)(label).Class("label-cell"), new (0, $2s69t.Div)().Append(input).Class("input-cell"));
    }
}



var $2s69t = parcelRequire("2s69t");
class $238219718d71b32e$export$78d5a44323dda815 extends (0, $2s69t.Div) {
    constructor(...rows){
        super("table-container");
        this.Append(...rows);
    }
}


class $1403eff4687fca1f$export$9f49d0559998a149 extends (0, $2s69t.ModalWindow) {
    constructor(shop, basketItems){
        super("Dodaj wynajem");
        const item = new (0, $b104fb107ffab6bd$export$865a56617b7eaf36)({});
        this.AddContent(new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Produkt", new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(shop.Products.Items, item)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Pocz\u0105tek", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(item.From)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Koniec", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(item.To)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Numer seryjny", new (0, $2s69t.TextInput)(item.ProductSerialNumber)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Dane dost\u0119powe", new (0, $2s69t.TextInput)(item.AccessData)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Ilo\u015B\u0107", new (0, $2s69t.NumberInput)(item.Quantity)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Cena", new (0, $2s69t.NumberInput)(item.TotalPrice)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Kaucja", new (0, $2s69t.NumberInput)(item.Deposit))));
        this.AddToFooter(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Dodaj", ()=>{
            basketItems.Add(item);
            this.CloseWindow();
        }), new (0, $ccab16682f88d5ed$export$b7c3a2f69225ecf)("Anuluj", ()=>this.CloseWindow()).MarginLeft(8));
        this.OpenWindow();
    }
}
class $1403eff4687fca1f$export$1b5b247269b99d50 extends (0, $2s69t.ModalWindow) {
    constructor(shop, basketItems){
        super("Dodaj sprzeda\u017C");
        const item = new (0, $46c5a39bfbff30f5$export$ff28d6513ec20674)({});
        this.AddContent(new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Produkt", new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(shop.Products.Items, item)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Numer seryjny", new (0, $2s69t.TextInput)(item.ProductSerialNumber)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Dane dost\u0119powe", new (0, $2s69t.TextInput)(item.AccessData)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Ilo\u015B\u0107", new (0, $2s69t.NumberInput)(item.Quantity)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Cena", new (0, $2s69t.NumberInput)(item.TotalPrice))));
        this.AddToFooter(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Dodaj", ()=>{
            basketItems.Add(item);
            this.CloseWindow();
        }), new (0, $ccab16682f88d5ed$export$b7c3a2f69225ecf)("Anuluj", ()=>this.CloseWindow()).MarginLeft(8));
        this.OpenWindow();
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $d5372390156ec6d7$export$1f54913ccc4368b1 extends (0, $2s69t.Div) {
    constructor(...components){
        super();
        this.DisplayBlock().TextAlignCenter().FullWidth().Append(...components);
    }
}


class $d43ea8c6f445c3d4$export$60938ba9f9a17048 extends (0, $2s69t.Div) {
    constructor(input){
        super("entry");
        this.warningBox = new (0, $2s69t.Div)("warning").BorderTop(1, "#aaa", "solid");
        this.Append(new (0, $2s69t.Div)().Append(...input.Content).FontSize(12), input.Warning && input.Warning.length > 0 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(this.warningBox.Append(...input.Warning)));
    }
}
class $d43ea8c6f445c3d4$export$440dddd12bf7bb92 extends (0, $2s69t.Div) {
    constructor(input){
        super("entry");
        this.infoBox = new (0, $2s69t.Div)("warning").BorderTop(1, "#ccc", "dashed").FontSize(11);
        this.Append(new (0, $2s69t.Div)().Append(...input.Content), input.ExtraInfo && input.ExtraInfo.length > 0 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(this.infoBox.Append(...input.ExtraInfo)));
    }
}




class $b18a2e4cac71d5d9$export$614b56d11b894a09 extends (0, $d43ea8c6f445c3d4$export$60938ba9f9a17048) {
    constructor(item){
        const dates = item instanceof (0, $b104fb107ffab6bd$export$865a56617b7eaf36) ? (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedRange(item.From, item.To) : "";
        super({
            Content: [
                new (0, $2s69t.Div)("basket-cart-item").Append(new (0, $2s69t.Image)(item.ProductInfo.Picture, item.ProductInfo.Name).Class("basket-cart-item-image"), new (0, $2s69t.Div)("basket-cart-item-details").Append(new (0, $2s69t.Link)(item.ProductInfo.Name, item.ProductInfo.Link), item.Quantity.value > 1 && new (0, $2s69t.Span)(`\xd7${item.Quantity.value}`).MarginLeft(8), new (0, $2s69t.Div)("basket-cart-item-dates").Text(`${item.Option.Name || ""}`), dates && new (0, $2s69t.Div)("basket-cart-item-dates").Text(`${dates}`), new (0, $2s69t.Span)(item.ProductSerialNumber.value || "(no product id)").WidthAuto().DisplayInline().Bold().Color("#666"), item.AccessData.value && new (0, $2s69t.Span)("\uD83E\uDDE9").CursorPointer().MarginLeft(4).OnClick(()=>new (0, $2s69t.ModalWindow)("Dane dost\u0119powe", true, true, true).AddContent(new (0, $2s69t.JsonViewer)(JSON.parse(item.AccessData.value))).OpenWindow())))
            ]
        });
    }
}
class $b18a2e4cac71d5d9$export$b4a5267eabb26439 extends (0, $2s69t.Div) {
    constructor(x){
        const dates = x instanceof (0, $b104fb107ffab6bd$export$865a56617b7eaf36) ? (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedRange(x.From, x.To) : "";
        super("product-item");
        this.Append(new (0, $2s69t.Div)("product-item__info").Append(new (0, $2s69t.Image)(x.ProductInfo.Picture, x.ProductInfo.Name).Class("product-item__image"), new (0, $2s69t.Div)("product-item__details").Append(new (0, $2s69t.Link)(x.ProductInfo.Name + " / " + (x.Option.Name || "(opcja domy\u015Blna)"), x.ProductInfo.Link), dates && new (0, $2s69t.Paragraph)("product-item__dates").Text(`Wypo\u{17C}yczenie ${dates}`), new (0, $2s69t.Text)(x.ProductSerialNumber).Bold())), new (0, $2s69t.Div)("product-item__pricing").Append(new (0, $2s69t.Paragraph)("product-item__quantity").Text(`Id: ${x.Id}`).FontSize(12).Color("#ddd"), // TODO: można to jakoś poprawić
        new (0, $2s69t.Paragraph)("product-item__price").Text(x.TotalPrice.value + " z\u0142"), new (0, $2s69t.Paragraph)("product-item__quantity").Text(`Ilo\u{15B}\u{107}: ${x.Quantity.value}`)));
    }
}


class $65d5c12a367cf456$export$69a444412c79c8e8 extends (0, $2s69t.Div) {
    constructor(shop, basketItems){
        super();
        this.Append(new (0, $2s69t.CollectionPrinter)(basketItems, (item)=>new (0, $b18a2e4cac71d5d9$export$614b56d11b894a09)(item)), new (0, $ccab16682f88d5ed$export$8cc203231d44dc6a)("Dodaj wynajem", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>new (0, $1403eff4687fca1f$export$9f49d0559998a149)(shop, basketItems)), new (0, $ccab16682f88d5ed$export$8cc203231d44dc6a)("Dodaj sprzeda\u017C", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>new (0, $1403eff4687fca1f$export$1b5b247269b99d50)(shop, basketItems)));
    }
}




class $c9e1890058e337ca$export$83861badb2062845 extends (0, $2s69t.Div) {
    constructor(shop, ticketData){
        super(), this.ticketData = ticketData;
        this.Append(new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Id", new (0, $2s69t.TextInput)(this.ticketData.orderId)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Data utworzenia:", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.ticketData.createdAt)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Produkty", new (0, $65d5c12a367cf456$export$69a444412c79c8e8)(shop, this.ticketData.basketItems)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Rabaty", new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.TableBuilder)(this.ticketData.discounts).AddColumn("Nazwa", (item)=>new (0, $2s69t.TextInput)(item.Name)).AddColumn("Kod", (item)=>new (0, $2s69t.TextInput)(item.Code)).AddColumn("Warto\u015B\u0107", (item)=>new (0, $2s69t.NumberInput)(item.Value)).AddColumn("Opcje", (item)=>new (0, $2s69t.Link)("\u2716\uFE0F").OnClick(()=>this.ticketData.discounts.Remove(item))).Build().VisibleWhen(this.ticketData.discounts.CountRef, (x)=>x > 0), new (0, $ccab16682f88d5ed$export$8cc203231d44dc6a)("Dodaj rabat", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>this.ticketData.discounts.Add(new (0, $5a57c00e6e1c76a3$export$5f0fddd75cd8dcd7)({}))))), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("P\u0142atno\u015B\u0107:", new (0, $2s69t.Radio)(this.ticketData.paymentPresets).Add((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCash, "Ca\u0142o\u015B\u0107 got\xf3wk\u0105 przy odbiorze").Add((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash, "Kaucja przelewem, reszta got\xf3wk\u0105").Add((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithBankTransfer, "Ca\u0142o\u015B\u0107 z g\xf3ry przelewem").Add((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCrypto, "Ca\u0142o\u015B\u0107 Bitcoinem z g\xf3ry").Add((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash, "Kaucja Blikem, reszta got\xf3wk\u0105")), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Dostawa:", new (0, $2s69t.Radio)(this.ticketData.deliveryForm).Add((0, $2c4684dc9ca51087$export$a8f34b9af2eae872).Personal, "Odbi\xf3r osobisty").Add((0, $2c4684dc9ca51087$export$a8f34b9af2eae872).Package, "Dostawa kurierem")), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Zwrot:", new (0, $2s69t.Radio)(this.ticketData.returnForm).Add((0, $eefd2630f536cfde$export$dbf30556f6a9efbf).Personal, "Zwrot osobisty").Add((0, $eefd2630f536cfde$export$dbf30556f6a9efbf).Package, "Zwrot paczkomatem")), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Trening:", new (0, $2s69t.Checkbox)(this.ticketData.withTraining)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Klient:", new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Imi\u0119", new (0, $2s69t.TextInput)(this.ticketData.customerName)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Email", new (0, $2s69t.TextInput)(this.ticketData.customerEmail)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Telefon", new (0, $2s69t.TextInput)(this.ticketData.customerPhone)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Adres", new (0, $2s69t.TextInput)(this.ticketData.customerAddress)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Do\u015Bwiadczenie", new (0, $ca5ddfa4627c7851$export$ae1d92c6c071ba79)(this.ticketData.customerExperience)))), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Faktura:", new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Wystawia\u0107 faktur\u0119?", new (0, $2s69t.Checkbox)(this.ticketData.withInvoice)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Nazwa firmy", new (0, $2s69t.TextInput)(this.ticketData.invoiceCompanyName)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Adres firmy", new (0, $2s69t.TextInput)(this.ticketData.invoiceCompanyAddress)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("NIP firmy", new (0, $2s69t.TextInput)(this.ticketData.invoiceCompanyNIP))))));
    }
}



var $2s69t = parcelRequire("2s69t");





var $4bebf6f7e0ab04af$export$39b11636c68d48ec = /*#__PURE__*/ function(BasketItemType) {
    BasketItemType["Unset"] = "Unset";
    BasketItemType["Rent"] = "Rent";
    BasketItemType["Sale"] = "Sale";
    BasketItemType["Service"] = "Service";
    BasketItemType["Help"] = "Help";
    return BasketItemType;
}({});





class $1195564a73869b7f$export$1fb22c6a31410181 {
    constructor(){
        this.orderId = new (0, $2s69t.RefString)((0, $3fa3ae484854b431$export$2e2bcd8739ae039)());
        //.Storable("ticket-builder:order-id");
        this.createdAt = new (0, $2s69t.RefDate)((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
        //.Storable("ticket-builder:created-at");
        this.withTraining = new (0, $2s69t.RefBool)(false);
        //.Storable("ticket-builder:with-training");
        this.withInvoice = new (0, $2s69t.RefBool)(false);
        //.Storable("ticket-builder:with-invoice");
        this.depositPaymentForm = new (0, $2s69t.Ref)((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash);
        //.Storable("ticket-builder:deposit-payment-form");
        this.basketPaymentForm = new (0, $2s69t.Ref)((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash);
        //.Storable("ticket-builder:basket-payment-form");
        this.paymentPresets = new (0, $2s69t.Ref)((0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).Unset);
        //.Storable("ticket-builder:payment-preset");
        this.deliveryForm = new (0, $2s69t.Ref)((0, $2c4684dc9ca51087$export$a8f34b9af2eae872).Unset);
        //.Storable("ticket-builder:delivery-form");
        this.returnForm = new (0, $2s69t.Ref)((0, $eefd2630f536cfde$export$dbf30556f6a9efbf).Unset);
        //.Storable("ticket-builder:return-form");
        this.basketItems = new (0, $2s69t.Collection)();
        this.discounts = new (0, $2s69t.Collection)();
        this.customerName = new (0, $2s69t.Ref)("").Storable("ticket-builder:customer-name");
        this.customerEmail = new (0, $2s69t.Ref)("").Storable("ticket-builder:customer-email");
        this.customerPhone = new (0, $2s69t.Ref)("").Storable("ticket-builder:customer-phone");
        this.customerAddress = new (0, $2s69t.Ref)("").Storable("ticket-builder:customer-address");
        this.customerExperience = new (0, $2s69t.Ref)(1).Storable("ticket-builder:customer-experience");
        this.invoiceCompanyName = new (0, $2s69t.Ref)("").Storable("ticket-builder:invoice-company-name");
        this.invoiceCompanyAddress = new (0, $2s69t.Ref)("").Storable("ticket-builder:invoice-company-address");
        this.invoiceCompanyNIP = new (0, $2s69t.Ref)("").Storable("ticket-builder:invoice-company-nip");
        this.paymentPresets.OnChange((preset)=>{
            switch(preset){
                case (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCash:
                    this.depositPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash;
                    this.basketPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash;
                    break;
                case (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithBankTransfer:
                    this.depositPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer;
                    this.basketPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer;
                    break;
                case (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCrypto:
                    this.depositPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto;
                    this.basketPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto;
                    break;
                case (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash:
                    this.depositPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer;
                    this.basketPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery;
                    break;
                case (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash:
                    this.depositPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik;
                    this.basketPaymentForm.value = (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery;
                    break;
            }
        }, true);
    }
    FromTicket(ticket) {
        this.orderId.value = ticket.Id;
        this.createdAt.value = ticket.Meta.CreatedAt;
        this.withTraining.value = ticket.WithTraining;
        this.withInvoice.value = ticket.Invoice !== undefined;
        this.invoiceCompanyName.value = ticket.Invoice?.CompanyName || "";
        this.invoiceCompanyAddress.value = ticket.Invoice?.CompanyAddress || "";
        this.invoiceCompanyNIP.value = ticket.Invoice?.CompanyNIP || "";
        this.basketItems.Load(...ticket.BasketList.map((item)=>new (0, $2s69t.Switch)(item.Type).Case((0, $4bebf6f7e0ab04af$export$39b11636c68d48ec).Rent, ()=>new (0, $b104fb107ffab6bd$export$865a56617b7eaf36)(item)).Case((0, $4bebf6f7e0ab04af$export$39b11636c68d48ec).Sale, ()=>new (0, $46c5a39bfbff30f5$export$ff28d6513ec20674)(item)).Execute()).filter((x)=>x !== undefined));
        this.deliveryForm.value = ticket.Delivery;
        this.returnForm.value = ticket.Return;
        this.customerName.value = ticket.Customer.Name;
        this.customerEmail.value = ticket.Customer.Email;
        this.customerPhone.value = ticket.Customer.Phone;
        this.customerAddress.value = ticket.Customer.Address;
        this.customerExperience.value = ticket.Customer.Experience || 0;
        this.depositPaymentForm.value = ticket.DepositPaymentForm;
        this.basketPaymentForm.value = ticket.BasketPaymentForm;
        if (this.depositPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash) && this.basketPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash)) this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCash;
        else if (this.depositPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer) && this.basketPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer)) this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithBankTransfer;
        else if (this.depositPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto) && this.basketPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto)) this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).AllWithCrypto;
        else if (this.depositPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer) && this.basketPaymentForm.IsIn([
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash,
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery
        ])) this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBankTransfer_ServiceWithCash;
        else if (this.depositPaymentForm.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik) && this.basketPaymentForm.IsIn([
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash,
            (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).CashAtDelivery
        ])) this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).DepositWithBlik_ServiceWithCash;
        else {
            console.log("Unknown payment preset: deposit=", this.depositPaymentForm.value, ", basket=", this.basketPaymentForm.value);
            this.paymentPresets.value = (0, $c0d2121e22406ddb$export$ff0fe1ce2347cbc0).Unset;
        }
    }
    ToTicket() {
        return {
            Id: this.orderId.value,
            Meta: {
                CreatedAt: new Date(this.createdAt.value),
                CreatedBy: "generator"
            },
            BasketList: this.basketItems.Items.map((item)=>item.AsRaw),
            BasketInfo: {
                PriceBeforeDiscount: this.basketItems.Items.reduce((acc, item)=>acc + item.TotalPrice.value, 0),
                PriceAfterDiscount: -1,
                Discounts: this.discounts.Items.map((item)=>item.AsRaw)
            },
            Customer: {
                Name: this.customerName.value,
                Email: this.customerEmail.value,
                Phone: this.customerPhone.value,
                Address: this.customerAddress.value,
                Id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                Type: "Zamawiaj\u0105cy",
                Experience: this.customerExperience.value,
                BankAccountNumber: "",
                Description: ""
            },
            Delivery: this.deliveryForm.value,
            Return: this.returnForm.value,
            DepositPaymentForm: this.depositPaymentForm.value,
            BasketPaymentForm: this.basketPaymentForm.value,
            WithTraining: this.withTraining.value,
            PickupPlace: "miejsce nieokre\u015Blone",
            Invoice: this.withInvoice.value ? {
                CompanyName: this.invoiceCompanyName.value,
                CompanyAddress: this.invoiceCompanyAddress.value,
                CompanyNIP: this.invoiceCompanyNIP.value
            } : undefined,
            Notes: ""
        };
    }
}





var $2s69t = parcelRequire("2s69t");
class $7aa14dd86653b561$export$f7e8c346445ef7be {
    constructor(){
        this.BtcValueInPln = new (0, $2s69t.RefNumber)(0).Storable("bitcoin-price");
        this.Status = new (0, $2s69t.RefString)();
    }
    async Update() {
        const urlAPI = "https://blockchain.info/ticker";
        try {
            this.Status.value = "\uD83D\uDE80";
            const response = await fetch(urlAPI);
            if (!response.ok) {
                this.Status.value = "\uD83D\uDC94";
                return;
            }
            const data = await response.json();
            if (data.PLN) {
                const btcInPln = data.PLN.last;
                this.BtcValueInPln.value = btcInPln;
                this.Status.value = "\u2705";
            } else {
                this.Status.value = "\uD83D\uDC94";
                console.error("Nie uda\u0142o si\u0119 uzyska\u0107 danych kursu BTC w PLN.");
            }
        } catch (error) {
            this.Status.value = "\uD83D\uDC94";
            console.error("B\u0142\u0105d podczas pobierania danych z API:", error);
        }
    }
    PLNtoBTC(amount) {
        return (amount / this.BtcValueInPln.value).toFixed(6);
    }
}


class $4c1dc4e94dbb2144$export$27ac7d0fb8609e64 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_manager, _stepsFactory, _shop, orderIdToRegenerate){
        super("Generator zam\xf3wie\u0144"), this._manager = _manager, this._stepsFactory = _stepsFactory, this._shop = _shop, this.orderIdToRegenerate = orderIdToRegenerate;
        this.Padding(16);
        this.Content(async (body)=>{
            const shop = await this._shop.GetOne("Shop");
            const ticketData = new (0, $1195564a73869b7f$export$1fb22c6a31410181)();
            if (this.orderIdToRegenerate) {
                const order = await this._manager.GetOne(this.orderIdToRegenerate);
                ticketData.FromTicket(order.Meta.Ticket);
            }
            this.Append(new (0, $c9e1890058e337ca$export$83861badb2062845)(shop, ticketData), new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Dodaj do zam\xf3wie\u0144", async (btn)=>{
                btn.Disabled();
                const ticket = ticketData.ToTicket();
                let btcValueInPln = -1;
                if (ticket.BasketPaymentForm == (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto) {
                    const _bitcoinPriceProvider = new (0, $7aa14dd86653b561$export$f7e8c346445ef7be)();
                    await _bitcoinPriceProvider.Update();
                    btcValueInPln = _bitcoinPriceProvider?.BtcValueInPln.value ?? -1;
                }
                const order = new (0, $32786e3a7ad3fec1$export$d73fce08fd84e72d)(this._stepsFactory).Convert(ticket, btcValueInPln);
                await this._manager.Add(order);
                new (0, $2s69t.Snack)("Wygenerowano nowe zam\xf3wienie #" + order.ShortId, orderIdToRegenerate ? `Na bazie zam\xf3wienia #${this.orderIdToRegenerate}` : "", {
                    autoCloseTimeout: 0
                });
            }).MarginTop(16));
        });
    }
}



class $17bd211ea4cc77a2$export$94affb487e701bf2 {
    constructor(){
        this.Items = [];
    }
    Clear() {
        this.Items = [];
    }
    Remove(item) {
        const itemIndex = this.Items.indexOf(item);
        if (itemIndex == -1) return;
        this.Items.splice(itemIndex, 1);
    }
    GetIndexById(id) {
        return this.Items.findIndex((x)=>x.Id == id);
    }
    UpdateOrAddSingle(item) {
        const index = this.GetIndexById(item.Id);
        if (index) this.Items[index] = item;
        else this.Items.push(item);
    }
    FindOne(id) {
        return this.Items.find((x)=>x.Id == id) || null;
    }
    UpdateOrAdd(...items) {
        items.forEach((x)=>this.UpdateOrAddSingle(x));
    }
}




var $45fvw = parcelRequire("45fvw");

class $79d1a039415ac35a$export$efff0f5979573c99 {
    static Throttle(lastCall, delay, now = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lastCall).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(now).subtract(delay, "seconds"));
    }
}





var $2s69t = parcelRequire("2s69t");
class $d6f9328a5971026b$export$5b067cc37f7a2e89 {
    constructor(){
        this.NotificationHasBeenSent = false;
    }
}
class $d6f9328a5971026b$export$78f811e9b2083add {
    Log(message) {
    // console.log(message);
    }
    get Orders() {
        return this.ordersCollection;
    }
    constructor(_orders, _tickets, _notifier){
        this._orders = _orders;
        this._tickets = _tickets;
        this._notifier = _notifier;
        this.cache = new (0, $17bd211ea4cc77a2$export$94affb487e701bf2)();
        this.ordersCollection = new (0, $2s69t.Collection)();
    }
    async OpenTicket(ticketId) {
        const order = await this._tickets.Open(ticketId);
        if (!order) return null;
        order.SelfSetup();
        await this.Add(order);
        await this._tickets.Close(ticketId);
        return order;
    }
    async Add(order) {
        await this._orders.Add((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open, order.Id, order);
        this.cache.UpdateOrAdd(order);
    }
    async GetOneFromRepo(orderId) {
        try {
            const order = await this._orders.GetOne((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open, orderId);
            order.Meta.Folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open;
            return order;
        } catch (error) {
            try {
                const order = await this._orders.GetOne((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed, orderId);
                order.Meta.Folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed;
                return order;
            } catch (error) {
                return null;
            }
        }
    }
    async GetOne(orderId) {
        // 1. Try from cache
        let orderFromCache = this.cache.FindOne(orderId);
        if (orderFromCache) {
            this.Log('Found in cache');
            return orderFromCache;
        }
        // 2. Try from remote repo
        const orderFromRepo = await this.GetOneFromRepo(orderId);
        if (orderFromRepo) {
            this.Log('Found in repo');
            this.cache.UpdateOrAdd(orderFromRepo);
            return orderFromRepo;
        }
        // 3. Check tickets
        const orderFromTicket = await this.OpenTicket(orderId);
        if (orderFromTicket) {
            this.Log('Found in tickets');
            this.cache.UpdateOrAdd(orderFromTicket);
            return orderFromTicket;
        }
        throw new Error("Order not found");
    }
    async FetchAll(folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open) {
        // 1. Get all orders from repo
        const orders = await this._orders.GetAll(folder);
        this.cache.UpdateOrAdd(...orders);
        // 2. Get all orders from tickets only if requesting current orders
        if (folder === (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open) {
            const ordersFromTickets = await this._tickets.OpenAll();
            this.cache.UpdateOrAdd(...ordersFromTickets);
            orders.push(...ordersFromTickets);
        }
        orders.forEach((x)=>x.Meta.Folder = folder);
        return orders;
    }
    async LoadAll(folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open) {
        const orders = await this.FetchAll(folder);
        orders.forEach((x)=>x.SelfSetup());
        orders.sort((a, b)=>+b.Meta.CreatedAt - +a.Meta.CreatedAt);
        this.ordersCollection.Load(...orders);
    }
    async Update(order) {
        const result = new $d6f9328a5971026b$export$5b067cc37f7a2e89();
        const canNotify = (0, $79d1a039415ac35a$export$efff0f5979573c99).Throttle(order.Meta.UpdatedAt, 600);
        order.Meta.UpdatedAt = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        order.Meta.UpdatedBy = this._orders.Database.User.Id || "(unknown user id)";
        await this._orders.Update(order.Meta.Folder, order.Id, order);
        this.cache.UpdateOrAdd(order);
        if (canNotify) {
            await this._notifier.NotifyOrderUpdate(order);
            result.NotificationHasBeenSent = true;
        }
        return result;
    }
    async Close(order) {
        order.Meta.Folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed;
        order.Meta.UpdatedAt = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        const currentFolder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open;
        await this._orders.Update(currentFolder, order.Id, order);
        await this._orders.Move(order.Id, currentFolder, (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed);
    }
    async Reopen(order) {
        order.Meta.Folder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open;
        order.Meta.UpdatedAt = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        const currentFolder = (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed;
        await this._orders.Update(currentFolder, order.Id, order);
        await this._orders.Move(order.Id, currentFolder, (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
    }
    async Delete(order) {
        try {
            this.Log(`Deleting order ${order.Id} in "${order.Meta.Folder}"...`);
            await this._orders.Delete(order.Meta.Folder, order.Id);
            this.cache.Remove(order);
        } catch (error) {
            try {
                this.Log(`Error deleting order ${order.Id}: ${error.message}. Trying in tickets...`);
                await this._tickets.Close(order.Id);
                this.cache.Remove(order);
            } catch (error) {
                // await this._orders.Delete(OrdersFolders.Closed, order.Id);
                this.Log(`Error deleting ticket ${order.Id}: ${error.message}`);
            }
        }
    }
    async Duplicate(order) {
        const newOrder = new (0, $8b90cdef4fa99aa6$export$d6101cb40935bdea)();
        newOrder.Id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)().toUpperCase();
        newOrder.Meta.CreatedAt = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        newOrder.Meta.CreatedBy = this._orders.Database.User?.Id || "(unknown user id)";
        const steps = [
            ...order.Steps.Items
        ];
        steps.forEach((x)=>x.ResetState());
        newOrder.Steps.Load(...steps);
        newOrder.People.Load(...order.People.Items);
        await this.Add(newOrder);
        return newOrder;
    // throw new Error("z dowolnego folderu do Open! + zmiana detali orderu");
    }
}



var $2s69t = parcelRequire("2s69t");



















// import { IStorageUserPrivileges } from "../../Models/IStorageUserPrivileges";




class $b216b0eb7439fe32$export$f69c19e57285b83a {
    Name;
    Body;
    constructor(Name, Body){
        this.Name = Name;
        this.Body = Body;
    }
}


class $5c97da8b615e66f9$export$44b688a57c0ea831 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("GetMetadata", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $45a158b08e11d32b$export$7ce83225b1a2ab35 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DropDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}


class $6afb9edbb9c148cf$export$a9076aff4a6d0070 {
    _db;
    dataset;
    constructor(_db, dataset){
        this._db = _db;
        this.dataset = dataset;
    }
    get Name() {
        return this.dataset;
    }
    get Database() {
        return this._db;
    }
    get DatasetPath() {
        return this._db.DatabaseDir + "/Datasets/" + this.dataset;
    }
    async GetMetadata() {
        const response = await this._db.Send(new (0, $5c97da8b615e66f9$export$44b688a57c0ea831)(this._db.DatabaseDir, this.dataset));
        if (!response.IsSuccess) throw new Error("Failed to get metadata: " + response.ErrorMessage);
        return response.Result;
    }
    CanUserDo(action) {
        if (!this._db.User.Privileges) return false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "object") return (this._db.User.Privileges[action].Datasets == "all" || this._db.User.Privileges[action].Datasets?.includes(this.dataset)) ?? false;
        if (this._db.User.Privileges?.[action] && typeof this._db.User.Privileges[action] === "boolean") return this._db.User.Privileges[action];
        return false;
    }
    Log(message) {
        this._db.Log(message);
    }
    async Drop() {
        this.Log(`Dropping "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $45a158b08e11d32b$export$7ce83225b1a2ab35)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to drop dataset: " + result.ErrorMessage);
        this.Log(`"${this.DatasetPath}" dropped successfully.`);
    }
}


var $d83b6b847cfe9f3e$export$69e133a2b31764a9;
(function(DatasetType) {
    DatasetType["Unknown"] = "Unknown";
    DatasetType["Object"] = "Object";
    DatasetType["Text"] = "Text";
    DatasetType["Picture"] = "Picture";
    DatasetType["File"] = "File";
})($d83b6b847cfe9f3e$export$69e133a2b31764a9 || ($d83b6b847cfe9f3e$export$69e133a2b31764a9 = {}));




class $e4e5ebdfac92419f$export$c8c5e7182924d536 {
    ToRaw(target) {
        try {
            return this.ConvertToRaw(target);
        } catch (ex) {
            console.error(`Conversion from object to raw problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nObject:`, target);
            throw ex;
        }
    }
    FromRaw(raw) {
        try {
            return this.ConvertFromRaw(raw);
        } catch (ex) {
            console.error(`Conversion from raw to object problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nRaw:`, raw);
            throw ex;
        }
    }
    GetArray(value, creator) {
        const items = value?.map((x)=>creator(x));
        return items || [];
    }
    GetString(value) {
        return value || "";
    }
    GetNumber(value) {
        return +value || 0;
    }
    GetBool(value) {
        return !!value || false;
    }
    GetDate(date) {
        return date ? new Date(date) : new Date(0);
    }
}



class $ce85a2da75640367$export$c12b8c1beca20106 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("AddObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $804cc7411a7d35d9$export$4df9e803b7373792 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjects", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $096817e3afb8207a$export$c63583173c519c11 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId, Content){
        super("UpdateObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId,
            Content: Content
        });
    }
}



class $c88a2226128c76ac$export$909394e50a5801cc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListObjectsIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}




class $e3183d94f6dbf053$export$1d3bda4c95d1bbeb {
    FromRaw(raw) {
        return raw;
    }
    ToRaw(item) {
        return item;
    }
}



class $cf2760f70c387ac3$export$7e9a3988c01bcb96 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("GetObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}



class $fab5932668ba36df$export$d60592d05571c4ef extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, ObjectId){
        super("DeleteObject", {
            Database: Database,
            Dataset: Dataset,
            ObjectId: ObjectId
        });
    }
}


class $75f1f7875a1df277$export$627789366574b89f extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    _converter;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Object;
    constructor(_db, dataset, _converter = new (0, $e3183d94f6dbf053$export$1d3bda4c95d1bbeb)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async GetOne(id) {
        this.Log(`Fetching "${id}"...`);
        const queryResult = await this._db.Send(new (0, $cf2760f70c387ac3$export$7e9a3988c01bcb96)(this._db.DatabaseDir, this.dataset, id));
        if (!queryResult.IsSuccess) throw new Error("Failed to get one object: " + queryResult.ErrorMessage);
        const rawItem = queryResult.Result;
        const item = this._converter.FromRaw(rawItem);
        this.Log(`Fetched "${id}" from "${this.DatasetPath}".`);
        return item;
    }
    async GetAll() {
        this.Log(`Fetching all from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $804cc7411a7d35d9$export$4df9e803b7373792)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items: " + queryResult.ErrorMessage);
        const rawItems = queryResult.Result;
        const items = rawItems.map((raw)=>this._converter.FromRaw(raw));
        this.Log(`Fetched ${items.length} items from "${this.DatasetPath}".`);
        return items;
    }
    async GetAllIds() {
        this.Log(`Fetching all objects IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all objects ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} objects in "${this.DatasetPath}".`);
        return ids;
    }
    async Add(id, item) {
        this.Log(`Adding "${id}" to "${this.DatasetPath}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $ce85a2da75640367$export$c12b8c1beca20106)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to add item: " + result.ErrorMessage);
        this.Log(`"${id}" added to "${this.DatasetPath}".`);
    }
    async Update(id, item) {
        this.Log(`Updating "${id}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $096817e3afb8207a$export$c63583173c519c11)(this._db.DatabaseDir, this.dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to update item: " + result.ErrorMessage);
        this.Log(`"${id}" updated in "${this.DatasetPath}".`);
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $fab5932668ba36df$export$d60592d05571c4ef)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete object: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}




class $85b2ca0db3fcf386$export$c68a8fe67ac55f0a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, ObjectId, Source, Target){
        super("MoveObject", {
            Database: Database,
            ObjectId: ObjectId,
            Source: Source,
            Target: Target
        });
    }
}









class $58876721d3f329ea$export$33b832977b7a4586 {
    _db;
    datasets;
    _converter;
    constructor(_db, datasets, _converter = new (0, $e3183d94f6dbf053$export$1d3bda4c95d1bbeb)()){
        this._db = _db;
        this.datasets = datasets;
        this._converter = _converter;
        if (datasets.length <= 1) throw new Error("Datasets must have at least 2 datasets. If one - use ObjectDataset<T> instead.");
    }
    get Names() {
        return this.datasets;
    }
    get Database() {
        return this._db;
    }
    // public CanUserDo(action: keyof IStorageUserPrivileges): boolean
    // {
    // 	if (!this._db.User.Privileges)
    // 	{
    // 		return false;
    // 	}
    // 	const privilege = this._db.User.Privileges[action];
    // 	if (!privilege)
    // 	{
    // 		return false;
    // 	}
    // 	// ex. AddFile: { Datasets: "all" } or AddFile: { Datasets: ["Public"] }
    // 	if (typeof privilege === "object")
    // 	{
    // 		const allowedDatasets = privilege.Datasets;
    // 		// ex. AddFile: { Datasets: "all" }
    // 		if (typeof allowedDatasets === "string")
    // 		{
    // 			if (allowedDatasets == "all")
    // 			{
    // 				return true;
    // 			}
    // 			else if (allowedDatasets == "none")
    // 			{
    // 				return false;
    // 			}
    // 			else
    // 			{
    // 				return false;
    // 			}
    // 		}
    // 		// ex. AddFile: { Datasets: ["Public"] }
    // 		else if (typeof allowedDatasets === "object")
    // 		{
    // 			if (Array.isArray(allowedDatasets))
    // 			{
    // 				for (const dataset of this.datasets)
    // 				{
    // 					if (allowedDatasets.includes(dataset))
    // 					{
    // 						return true;
    // 					}
    // 				}
    // 				return false;
    // 			}
    // 		}
    // 	}
    // 	// ex. CreateUser: true
    // 	else if (typeof privilege === "boolean")
    // 	{
    // 		return privilege;
    // 	}
    // 	return false;
    // }
    async GetOne(dataset, id) {
        this._db.Log(`Fetching "${id}" from "${dataset}"...`);
        const queryResult = await this._db.Send(new (0, $cf2760f70c387ac3$export$7e9a3988c01bcb96)(this._db.DatabaseDir, dataset, id));
        if (!queryResult.IsSuccess) throw new Error("Failed to get one object: " + queryResult.ErrorMessage);
        const rawItem = queryResult.Result;
        const item = this._converter.FromRaw(rawItem);
        this._db.Log(`Fetched "${id}" from "${dataset}".`);
        return item;
    }
    async GetAll(dataset) {
        this._db.Log(`Fetching all from "${dataset}"...`);
        const queryResult = await this._db.Send(new (0, $804cc7411a7d35d9$export$4df9e803b7373792)(this._db.DatabaseDir, dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all objects: " + queryResult.ErrorMessage);
        const rawItems = queryResult.Result;
        const items = rawItems.map((raw)=>this._converter.FromRaw(raw));
        this._db.Log(`Fetched ${items.length} items from "${dataset}".`);
        return items;
    }
    async GetAllIds(dataset) {
        this._db.Log(`Fetching all objects IDs from "${dataset}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all objects ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this._db.Log(`Found ${ids.length} objects in "${dataset}".`);
        return ids;
    }
    async Add(dataset, id, item) {
        this._db.Log(`Adding "${id}" to "${dataset}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $ce85a2da75640367$export$c12b8c1beca20106)(this._db.DatabaseDir, dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to add item: " + result.ErrorMessage);
        this._db.Log(`"${id}" added to "${dataset}".`);
    }
    async Update(dataset, id, item) {
        this._db.Log(`Updating "${id}"...`);
        const rawItem = this._converter.ToRaw(item);
        const result = await this._db.Send(new (0, $096817e3afb8207a$export$c63583173c519c11)(this._db.DatabaseDir, dataset, id, rawItem));
        if (!result.IsSuccess) throw new Error("Failed to update item: " + result.ErrorMessage);
        this._db.Log(`"${id}" updated in "${dataset}".`);
    }
    async Move(id, sourceDataset, targetDataset) {
        this._db.Log(`Moving "${id}" from "${sourceDataset}" to "${targetDataset}"...`);
        const result = await this._db.Send(new (0, $85b2ca0db3fcf386$export$c68a8fe67ac55f0a)(this._db.DatabaseDir, id, sourceDataset, targetDataset));
        if (!result.IsSuccess) throw new Error("Failed to move item: " + result.ErrorMessage);
        this._db.Log(`"${id}" moved from "${sourceDataset}" to "${targetDataset}".`);
    }
    async Delete(dataset, id) {
        this._db.Log(`Deleting "${id}" from "${dataset}"...`);
        const result = await this._db.Send(new (0, $fab5932668ba36df$export$d60592d05571c4ef)(this._db.DatabaseDir, dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete object: " + result.ErrorMessage);
        this._db.Log(`Deleted "${id}" from "${dataset}".`);
    }
    async Drop(datasets) {
        this._db.Log(`Dropping "${datasets ? datasets.join(", ") : "all"}" datasets...`);
        for (const dataset of datasets ?? this.datasets){
            const result = await this._db.Send(new (0, $45a158b08e11d32b$export$7ce83225b1a2ab35)(this._db.DatabaseDir, dataset));
            if (!result.IsSuccess) throw new Error("Failed to drop dataset: " + result.ErrorMessage);
            this._db.Log(`"${dataset}" dropped.`);
        }
    }
}





class $a13627770c0f1192$export$2be762ff71c7d52d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Content){
        super("AppendText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Content: Content
        });
    }
}



class $03370006e4ef8576$export$3ce67f7a974b3d12 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("Clear", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $8e38a36ab188b89f$export$7a284a805e14b0be extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("CreateFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $7d97c736d7152af0$export$2ba25239d87f5d44 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId){
        super("DeleteFile", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}




class $62e770cff444bee8$export$6eb5d27576a6f8ce extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, FileId, Offset = 0, Limit = 0){
        super("ReadText", {
            Database: Database,
            Dataset: Dataset,
            FileId: FileId,
            Offset: Offset,
            Limit: Limit
        });
    }
}



class $183ec87bb4e7b569$export$b76e0450f5b20591 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Text;
    constructor(_db, dataset){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
    }
    async Read(id, offset = 0, limit = 0) {
        this.Log(`Reading "${id}" from "${this.DatasetPath}"...`);
        if (limit < 0) throw new Error("Limit cannot be negative number. 0 = no limit.");
        const queryResult = await this._db.Send(new (0, $62e770cff444bee8$export$6eb5d27576a6f8ce)(this._db.DatabaseDir, this.dataset, id, offset, limit));
        if (!queryResult.IsSuccess) throw new Error("Failed to read: " + queryResult.ErrorMessage);
        const content = queryResult.Result;
        this.Log(`Read ${content.length} characters from "${id}" in "${this.DatasetPath}".`);
        return content;
    }
    async GetAllIds() {
        this.Log(`Fetching all files IDs from "${this.DatasetPath}"...`);
        const queryResult = await this._db.Send(new (0, $c88a2226128c76ac$export$909394e50a5801cc)(this._db.DatabaseDir, this.dataset));
        if (!queryResult.IsSuccess) throw new Error("Failed to fetch all items ids: " + queryResult.ErrorMessage);
        const ids = queryResult.Result;
        this.Log(`Found ${ids.length} files in "${this.DatasetPath}".`);
        return ids;
    }
    async Create(id) {
        this.Log(`Creating "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $8e38a36ab188b89f$export$7a284a805e14b0be)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to create item: " + result.ErrorMessage);
        this.Log(`"${id}" created in "${this.DatasetPath}".`);
    }
    async AppendText(id, text) {
        this.Log(`Appending ${text.length} characters to "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $a13627770c0f1192$export$2be762ff71c7d52d)(this._db.DatabaseDir, this.dataset, id, text));
        if (!result.IsSuccess) throw new Error("Failed to append: " + result.ErrorMessage);
        this.Log(`${text.length} characters appended to "${id}" in "${this.DatasetPath}".`);
    }
    async Clear(id) {
        this.Log(`Clearing "${id}" in "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $03370006e4ef8576$export$3ce67f7a974b3d12)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to clear text file: " + result.ErrorMessage);
        this.Log(`"${id}" cleared in "${this.DatasetPath}".`);
    }
    async ReplaceText(id, text) {
        this.Log(`Replacing text in "${id}" in "${this.DatasetPath}"...`);
        await this.Clear(id);
        await this.AppendText(id, text);
        this.Log(`"${id}" replaced in "${this.DatasetPath}".`);
    }
    async AppendLine(id, line) {
        await this.AppendText(id, line + "\n");
    }
    async Delete(id) {
        this.Log(`Deleting "${id}" from "${this.DatasetPath}"...`);
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, id));
        if (!result.IsSuccess) throw new Error("Failed to delete item: " + result.ErrorMessage);
        this.Log(`Deleted "${id}" from "${this.DatasetPath}".`);
    }
}


class $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd {
    ToLine(entry) {
        return JSON.stringify(entry);
    }
    ToEntry(line) {
        return JSON.parse(line);
    }
}



class $5a11653556197b99$export$b381a9c9206415ff extends (0, $183ec87bb4e7b569$export$b76e0450f5b20591) {
    _db;
    dataset;
    _converter;
    constructor(_db, dataset, _converter = new (0, $4d2da659f2458bd1$export$dc7fb1eb9fb3a3bd)()){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        this._converter = _converter;
    }
    async Load(id, offset = 0, limit = 0) {
        const lines = await super.Read(id, offset, limit);
        return lines.map((line)=>this._converter.ToEntry(line));
    }
    async Append(id, entry) {
        const line = this._converter.ToLine(entry);
        await super.AppendLine(id, line);
    }
}






class $a9292ba8af43c41c$export$9e95ed3bd9bab7b0 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset, PictureDir){
        super("DeletePicture", {
            Database: Database,
            Dataset: Dataset,
            PictureDir: PictureDir
        });
    }
}



class $be72006e758513b6$export$a5b3af442ea466b6 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListPictures", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $fac5005b6116fcf9$export$205686f7b10194b7 {
    KeepSource = true;
    Sizes = {};
}




class $42b5462dd7f06646$export$7afdc3bd517797d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListPicturesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $02741148466c919f$export$a6fb71614acfa923 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetPicture", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}


class $5640e2e8de6d5b79$export$47f3bf415b3a0f78 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).Picture;
    picsConfig = new (0, $fac5005b6116fcf9$export$205686f7b10194b7)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    SetConfig(config) {
        this.picsConfig = {
            ...this.picsConfig,
            ...config
        };
    }
    GetConfig() {
        return this.picsConfig;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $42b5462dd7f06646$export$7afdc3bd517797d)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list pictures ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(pictureDir) {
        const result = await this._db.Send(new (0, $02741148466c919f$export$a6fb71614acfa923)(this._db.Server, this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $be72006e758513b6$export$a5b3af442ea466b6)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list picture packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append('files[]', files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append('server', this._db.Server);
            formData.append('database', this._db.DatabaseDir);
            formData.append('dataset', this.dataset);
            formData.append('config', JSON.stringify(this.picsConfig));
            formData.append('userId', this._db.User.Id);
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/pictures-upload", {
                method: 'POST',
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload pictures: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload: ${ex.message}`);
        }
    }
    async Delete(pictureDir) {
        const result = await this._db.Send(new (0, $a9292ba8af43c41c$export$9e95ed3bd9bab7b0)(this._db.DatabaseDir, this.dataset, pictureDir));
        if (!result.IsSuccess) throw new Error("Failed to delete picture: " + result.ErrorMessage);
    }
}













class $5ef429f262eed9ae$export$9537075280f3c140 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset){
        super("ListFiles", {
            Server: Server,
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $ccf5f2a8c816a8d6$export$222972f50ef41123 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("ListFilesIds", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $407007f4e8a9cc47$export$47a715c3138de013 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Server, Database, Dataset, FileId){
        super("GetFile", {
            Server: Server,
            Database: Database,
            Dataset: Dataset,
            FileId: FileId
        });
    }
}



class $4b8a13f98b39bd48$export$3e5661d9f1dcca0e {
    MaxDatasetSize = 1073741824;
    SingleFileMaxSize = 104857600;
    AllowedExtensions = "any";
}


class $73db00c56adeadd0$export$30ac9230346b066 extends (0, $6afb9edbb9c148cf$export$a9076aff4a6d0070) {
    _db;
    dataset;
    Type = (0, $d83b6b847cfe9f3e$export$69e133a2b31764a9).File;
    config = new (0, $4b8a13f98b39bd48$export$3e5661d9f1dcca0e)();
    constructor(_db, dataset, config){
        super(_db, dataset);
        this._db = _db;
        this.dataset = dataset;
        if (config) this.config = {
            ...this.config,
            ...config
        };
    }
    SetConfig(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    GetConfig() {
        return this.config;
    }
    async GetAllIds() {
        const result = await this._db.Send(new (0, $ccf5f2a8c816a8d6$export$222972f50ef41123)(this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list files ids: " + result.ErrorMessage);
        return result.Result;
    }
    async GetOne(fileId) {
        const result = await this._db.Send(new (0, $407007f4e8a9cc47$export$47a715c3138de013)(this._db.Server, this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to get picture: " + result.ErrorMessage);
        return result.Result;
    }
    async GetAll() {
        const result = await this._db.Send(new (0, $5ef429f262eed9ae$export$9537075280f3c140)(this._db.Server, this._db.DatabaseDir, this.dataset));
        if (!result.IsSuccess) throw new Error("Failed to list file packs: " + result.ErrorMessage);
        return result.Result;
    }
    async Add(files) {
        try {
            if (!files) throw new Error("No files provided");
            const formData = new FormData();
            for(let i = 0; i < files.length; i++)formData.append('files[]', files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            formData.append('server', this._db.Server);
            formData.append('database', this._db.DatabaseDir);
            formData.append('dataset', this.dataset);
            formData.append('userId', this._db.User.Id);
            formData.append('config', JSON.stringify(this.config));
            let serverUrl = this._db.Server;
            if (serverUrl.endsWith("/")) serverUrl = serverUrl.slice(0, -1);
            const response = await fetch(serverUrl + "/files-upload", {
                method: 'POST',
                body: formData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const result = await response.json();
            if (!result.IsSuccess) throw new Error("Failed to upload files: " + result.ErrorMessage);
            return result.Result ?? [];
        } catch (ex) {
            throw new Error(`Can not upload file: ${ex.message}`);
        }
    }
    async Delete(fileId) {
        const result = await this._db.Send(new (0, $7d97c736d7152af0$export$2ba25239d87f5d44)(this._db.DatabaseDir, this.dataset, fileId));
        if (!result.IsSuccess) throw new Error("Failed to delete file: " + result.ErrorMessage);
    }
}







class $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d {
    IsSuccess = false;
    ErrorMessage = "";
    ErrorCode = -1;
    Result = undefined;
    static Success(result) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = true;
        response.Result = result;
        return response;
    }
    static Fault(errorCode, errorMessage) {
        const response = new $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d();
        response.IsSuccess = false;
        response.Result = undefined;
        response.ErrorCode = errorCode || -1;
        response.ErrorMessage = errorMessage;
        return response;
    }
}


class $0ebd3f586870c7e9$export$fe2589e86ee56365 {
    serverUrl;
    sender;
    constructor(serverUrl, sender){
        this.serverUrl = serverUrl;
        this.sender = sender;
    }
    get Sender() {
        return this.sender;
    }
    SetSender(sender) {
        this.sender = sender;
        return this;
    }
    SetServer(server) {
        this.serverUrl = server;
        return this;
    }
    async SendMessage(message) {
        let messagePackage = {
            Sender: this.sender || {
                Id: "Anonymous"
            },
            Message: message
        };
        return await this.SendMessagePackage(messagePackage);
    }
    async PostJSON(data) {
        let httpResponse = {
            status: 0,
            data: undefined
        };
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: dataAsString
        });
        httpResponse.status = response.status;
        const json = await response.json();
        httpResponse.data = json;
        return httpResponse;
    }
    async Ping() {
        try {
            const response = await fetch(this.serverUrl + "/ping", {
                method: "GET"
            });
            if (response.status != 200) return false;
            const body = await response.text();
            return body == "pong";
        } catch (ex) {
            return false;
        }
    }
    async SendMessagePackage(messagePackage) {
        try {
            const response = await this.PostJSON(messagePackage);
            if (response.status == 200 && response.data.IsSuccess == true) {
                const result = response.data;
                return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Success(result.Result);
            } else if (response.status == 200 && response.data.IsSuccess == false) return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, response.data.ErrorMessage);
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(response.status, "Non-200 status");
        } catch (ex) {
            return (0, $1d4431caad0a4ba2$export$8c36f96ba2ae5b0d).Fault(ex.response?.status, ex.message);
        }
    }
}



class $01c7686b748260ee$export$9ab52704d0773c02 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Type, Dataset){
        super("CreateDataset", {
            Database: Database,
            Type: Type,
            Dataset: Dataset
        });
    }
}



class $1e9c1748f4e80b89$export$3771dfdca41a73cb extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("DatasetExists", {
            Database: Database,
            Dataset: Dataset
        });
    }
}



class $c69a319b14a3f741$export$fbcbdb743352704d extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Dataset){
        super("RemoveDataset", {
            Database: Database,
            Dataset: Dataset
        });
    }
}





class $c7a20a66c26cd9cc$export$438b9770139752e8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Password, Login){
        super("LoginUser", {
            Database: Database,
            Password: Password,
            Login: Login
        });
    }
}



class $e6a3009419252341$export$e8eea69f349ac16b extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListUsers", {
            Database: Database
        });
    }
}



class $d1217b689949d4b5$export$2fcccd4a7b9ac845 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("UpdateUser", {
            Database: Database,
            User: User
        });
    }
}



class $d53b721476fd0e13$export$daebbca9d9338bc extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, User){
        super("AddUser", {
            Database: Database,
            User: User
        });
    }
}



class $49ebf2e3c9d0414c$export$16745b1b4cbcf131 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("DeleteUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $341fd7216a697b68$export$2c2cfb7ca1cbc644 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, UserId){
        super("GetUser", {
            Database: Database,
            UserId: UserId
        });
    }
}



class $017449eabfa9cc97$export$54e721faba08510a extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database, Id){
        super("GetLog", {
            Database: Database,
            Id: Id
        });
    }
}



class $0b12de66db7fc647$export$f4bc86deee9ad8c extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListLogsIds", {
            Database: Database
        });
    }
}



class $bfea829df9966a60$export$8306c05e5eceab13 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(){
        super("ListDatabases", {});
    }
}



class $8cd99d2756d53677$export$75790cd217c136b7 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("CreateDatabase", {
            Database: Database
        });
    }
}



class $9e5c29a9040d7100$export$532f827abef81411 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("ListDatasets", {
            Database: Database
        });
    }
}



class $1150d16d79392866$export$ae7689aec281aea8 extends (0, $b216b0eb7439fe32$export$f69c19e57285b83a) {
    constructor(Database){
        super("DeleteDatabase", {
            Database: Database
        });
    }
}







class $ae1a5cf54ffb33b6$export$5d991cdc62928edb {
    server;
    database;
    sender;
    ANONYMOUS_USER = {
        Id: "Anonymous"
    };
    user = this.ANONYMOUS_USER;
    logEnabled = false;
    _bus;
    onUserChange = [];
    USER_LOCAL_STORAGE_KEY_PREFIX = "OnlineStorage:User:";
    userLocalStorageKey = "";
    get Server() {
        return this.server;
    }
    get DatabaseDir() {
        return this.database;
    }
    get User() {
        return this.user;
    }
    constructor(server, database, sender = this.ANONYMOUS_USER, bus){
        this.server = server;
        this.database = database;
        this.sender = sender;
        this._bus = bus || new (0, $0ebd3f586870c7e9$export$fe2589e86ee56365)(server, sender);
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        if (this.LoadUserFromLocalStorage()) this.CallOnUserChanged(true);
    }
    SetServer(server) {
        this.server = server;
        this._bus.SetServer(server);
        return this;
    }
    SetDatabase(database) {
        this.database = database;
        this.userLocalStorageKey = this.USER_LOCAL_STORAGE_KEY_PREFIX + this.database;
        return this;
    }
    async ListDatasets() {
        const result = await this._bus.SendMessage(new (0, $9e5c29a9040d7100$export$532f827abef81411)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list datasets: ${result.ErrorMessage}`);
        return result.Result;
    }
    async ListUsers() {
        const result = await this._bus.SendMessage(new (0, $e6a3009419252341$export$e8eea69f349ac16b)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to list users: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetUser(userId) {
        const result = await this._bus.SendMessage(new (0, $341fd7216a697b68$export$2c2cfb7ca1cbc644)(this.DatabaseDir, userId));
        if (!result.IsSuccess) throw new Error(`Failed to get user: ${result.ErrorMessage}`);
        return result.Result;
    }
    async AddUser(user) {
        this.Log(`Adding user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d53b721476fd0e13$export$daebbca9d9338bc)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to add user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" added.`);
    }
    async UpdateUser(user) {
        this.Log(`Updating user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $d1217b689949d4b5$export$2fcccd4a7b9ac845)(this.DatabaseDir, user));
        if (!result.IsSuccess) throw new Error("Failed to update user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" updated.`);
    }
    async DeleteUser(user) {
        this.Log(`Deleting user "${user.Id}"...`);
        const result = await this._bus.SendMessage(new (0, $49ebf2e3c9d0414c$export$16745b1b4cbcf131)(this.DatabaseDir, user.Id));
        if (!result.IsSuccess) throw new Error("Failed to delete user: " + result.ErrorMessage);
        this.Log(`User "${user.Id}" deleted.`);
    }
    GetObjectDataset(datasetName, converter) {
        return new (0, $75f1f7875a1df277$export$627789366574b89f)(this, datasetName, converter);
    }
    GetObjectDatasets(datasestNames, converter) {
        return new (0, $58876721d3f329ea$export$33b832977b7a4586)(this, datasestNames, converter);
    }
    GetTextDataset(datasetName, converter) {
        return converter ? new (0, $5a11653556197b99$export$b381a9c9206415ff)(this, datasetName, converter) : new (0, $183ec87bb4e7b569$export$b76e0450f5b20591)(this, datasetName);
    }
    GetPictureDataset(datasetName, picsConfig) {
        return new (0, $5640e2e8de6d5b79$export$47f3bf415b3a0f78)(this, datasetName, picsConfig);
    }
    GetFileDataset(datasetName, config) {
        return new (0, $73db00c56adeadd0$export$30ac9230346b066)(this, datasetName, config);
    }
    IsBrowserEnvironment() {
        return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
    }
    LoadUserFromLocalStorage() {
        if (this.IsBrowserEnvironment()) {
            const user = window.localStorage.getItem(this.userLocalStorageKey);
            if (user) {
                this.user = JSON.parse(user);
                this.SetUser(this.user || this.ANONYMOUS_USER);
                return true;
            }
        }
        return false;
    }
    async Login(password, login) {
        const result = await this._bus.SendMessage(new (0, $c7a20a66c26cd9cc$export$438b9770139752e8)(this.DatabaseDir, password, login));
        if (!result.IsSuccess) throw new Error("Failed to login: " + result.ErrorMessage);
        this.user = result.Result || this.ANONYMOUS_USER;
        this.SetUser(this.user);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this.user;
    }
    SaveUserInLocalStorage() {
        if (this.IsBrowserEnvironment()) window.localStorage.setItem(this.userLocalStorageKey, JSON.stringify(this.user));
    }
    OnUserChange(handler) {
        this.onUserChange.push(handler);
        handler(this.user, this.IsAuthorized, true);
        return this;
    }
    //
    // UWAGA!!!!!!!!!! TAK NIE MOŻNA REJESTROWAĆ Privileges!!!!!! TO MUSI SIĘ ODBYWAĆ PRZEZ INNĄ METODE ALBO INNY MECHANIZM!!!!!!!
    // Użytkownik nie może sam sobie nadawać uprawnień xddd
    //
    //
    // public async Register(id: string, role: string, name: string,
    // 	login: string, password: string, email: string,
    // 	privileges: IStorageUserPrivileges,
    // 	icon?: string, tags?: string[]): Promise<IStorageUser>
    // {
    // 	const createdAt = new Date();
    // 	const result = await this._bus.SendMessage(new RegisterCommand(this.DatabaseDir, id, role, name, login, password, email, privileges, icon, tags, createdAt));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Could not register: ${result.ErrorMessage}`);
    // 	}
    // 	const user = result.Result as IStorageUser;
    // 	return user;
    // }
    Logout() {
        this.SetUser(this.ANONYMOUS_USER);
        this.SaveUserInLocalStorage();
        this.CallOnUserChanged(false);
        return this;
    }
    CallOnUserChanged(appStart) {
        this.onUserChange.forEach((handler)=>handler(this.user, this.IsAuthorized, appStart));
    }
    get IsAuthorized() {
        return this.user && this.user.Id !== this.ANONYMOUS_USER.Id;
    }
    get IsNotLoggedIn() {
        return !this.user || this.user.Id === this.ANONYMOUS_USER.Id;
    }
    SetUser(user) {
        this.user = user;
        this._bus.SetSender({
            Id: user.Id
        });
        return this;
    }
    EnableLog() {
        this.logEnabled = true;
        return this;
    }
    DisableLog() {
        this.logEnabled = false;
        return this;
    }
    Log(...message) {
        if (this.logEnabled) console.log('[OnlineStorage]', ...message);
    }
    async Ping() {
        return await this._bus.Ping();
    }
    async Send(message) {
        const result = await this._bus.SendMessage(message);
        if (!result.IsSuccess) throw new Error(`Message resulted with error: ${result.ErrorMessage}`);
        return result;
    }
    async CreateDataset(type, datasetName) {
        this.Log(`Creating dataset "${datasetName}" of ${type} type...`);
        const result = await this._bus.SendMessage(new (0, $01c7686b748260ee$export$9ab52704d0773c02)(this.DatabaseDir, type, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to add dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" created.`);
    }
    async DatasetExists(datasetName) {
        this.Log(`Checking if dataset "${datasetName}" exists...`);
        const result = await this._bus.SendMessage(new (0, $1e9c1748f4e80b89$export$3771dfdca41a73cb)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to check if dataset exists: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" ${result.Result ? "exists" : "does not exist"}.`);
        return result.Result;
    }
    async RemoveDataset(datasetName) {
        this.Log(`Removing dataset "${datasetName}"...`);
        const result = await this._bus.SendMessage(new (0, $c69a319b14a3f741$export$fbcbdb743352704d)(this.DatabaseDir, datasetName));
        if (!result.IsSuccess) throw new Error(`Failed to remove dataset: ${result.ErrorMessage}`);
        this.Log(`Dataset "${datasetName}" removed.`);
    }
    async Move(fileId, sourceDataset, targetDataset) {
        this.Log(`Moving "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}"...`);
        const result = await this._bus.SendMessage(new (0, $85b2ca0db3fcf386$export$c68a8fe67ac55f0a)(this.DatabaseDir, fileId, sourceDataset.Name, targetDataset.Name));
        if (!result.IsSuccess) throw new Error(`Failed to move "${fileId}" from "${sourceDataset.Name}" to "${targetDataset.Name}": ${result.ErrorMessage}`);
        this.Log(`"${fileId}" moved from "${sourceDataset.Name}" to "${targetDataset.Name}".`);
    }
    async GetLogsList() {
        const result = await this._bus.SendMessage(new (0, $0b12de66db7fc647$export$f4bc86deee9ad8c)(this.DatabaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to get logs list: ${result.ErrorMessage}`);
        return result.Result;
    }
    async GetLog(id) {
        const result = await this._bus.SendMessage(new (0, $017449eabfa9cc97$export$54e721faba08510a)(this.DatabaseDir, id));
        if (!result.IsSuccess) throw new Error(`Failed to get log '${id}': ${result.ErrorMessage}`);
        return result.Result;
    }
    /*
        Search() USAGE:

        datasetId = storage.Search(fileId)
        file = dataset.GetOne(fileId)

        ;/   to jest bardziej problematyczne niż myślałem.....
        bo gdzieś przecież trzeba konwersji typu dokonać a sam search odbywa się na całej bazie
    */ // public async Search<T extends object>(fileId: string): Promise<Dataset<T>>
    // {
    // 	this.Log(`Searching for "${fileId}" in entire database...`);
    // 	const result = await this._bus.SendMessage(new SearchQuery(this.DatabaseDir, fileId));
    // 	if (!result.IsSuccess)
    // 	{
    // 		throw new Error(`Failed to find "${fileId}": ${result.ErrorMessage}`);
    // 	}
    // 	const datasetName = result.Result.Dataset;
    // 	const dataset = this.GetDataset<T>(datasetName, converter); ?????????
    // 	this.Log(`"${fileId}" found in "${dataset} dataset".`);
    // 	return result.Result;
    // }
    async ListDatabases() {
        const result = await this._bus.SendMessage(new (0, $bfea829df9966a60$export$8306c05e5eceab13)());
        if (!result.IsSuccess) throw new Error(`Failed to list databases: ${result.ErrorMessage}`);
        return result.Result;
    }
    async CreateDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $8cd99d2756d53677$export$75790cd217c136b7)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to create database: ${result.ErrorMessage}`);
    }
    async DeleteDatabase(databaseDir) {
        const result = await this._bus.SendMessage(new (0, $1150d16d79392866$export$ae7689aec281aea8)(databaseDir));
        if (!result.IsSuccess) throw new Error(`Failed to delete database: ${result.ErrorMessage}`);
    }
    CanUser(action) {
        if (!this.User.Privileges) return false;
        if (typeof this.User.Privileges[action] === "boolean" && this.User.Privileges[action]) return !!this.User.Privileges[action];
        return false;
    }
}




class $94c672300ad3597b$export$ffc1669e9aabf849 extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    constructor(_stepFactory){
        super(), this._stepFactory = _stepFactory;
    }
    ConvertFromRaw(raw) {
        const order = new (0, $8b90cdef4fa99aa6$export$d6101cb40935bdea)();
        order.Id = this.GetString(raw.Id);
        order.Steps = this.GetCollection(raw.Steps, (x)=>this._stepFactory.Create(x.Type, x.Data));
        const people = this.GetCollection(raw.People, (x)=>new (0, $7491f76ebc0bf829$export$9818a1bf5e26633)(x));
        order.People.Load(...people.Items);
        order.Meta = new (0, $28a45f14bda821f3$export$60b649c371b56658)(raw.Meta);
        order.Notes.Customer.value = this.GetString(raw.Notes?.Customer);
        order.Notes.Public.value = this.GetString(raw.Notes?.Public);
        order.Notes.Private.value = this.GetString(raw.Notes?.Private);
        order.SelfSetup();
        return order;
    }
    ConvertToRaw(order) {
        return (0, $2s69t.RefSerializer).Flatenize({
            Id: order.Id.toUpperCase(),
            Steps: order.Steps.Items.map((x)=>({
                    Type: x.Type,
                    Data: x.Data
                })),
            People: order.People.Items,
            Meta: order.Meta,
            Notes: {
                Customer: order.Notes.Customer.value,
                Public: order.Notes.Public.value,
                Private: order.Notes.Private.value
            }
        });
    }
    GetCollection(value, creator) {
        const items = value?.map((x)=>creator(x));
        return new (0, $2s69t.Collection)(items);
    }
}




var $2s69t = parcelRequire("2s69t");

class $fcd2bbe34e7586a6$export$f05c48a4001d5356 {
    get AsString() {
        return this.Icon.value + " " + this.Name.value;
    }
    constructor(raw){
        this.Id = "";
        this.IsActive = new (0, $2s69t.RefBool)();
        this.Icon = new (0, $2s69t.RefString)();
        this.Name = new (0, $2s69t.RefString)();
        this.Phone = new (0, $2s69t.RefString)();
        this.Id = raw.Id;
        this.IsActive.value = raw.IsActive;
        this.Icon.value = raw.Icon;
        this.Name.value = raw.Name;
        this.Phone.value = raw.Phone;
    }
    ToRaw() {
        return {
            Id: this.Id,
            IsActive: this.IsActive.value,
            Icon: this.Icon.value,
            Name: this.Name.value,
            Phone: this.Phone.value
        };
    }
    static get Default() {
        return new $fcd2bbe34e7586a6$export$f05c48a4001d5356({
            Id: "tB",
            Icon: "\uD83D\uDC13",
            Name: "Tomasz",
            Phone: "507-293-714",
            IsActive: true
        });
    }
}
class $fcd2bbe34e7586a6$export$eb219aab84de4915 extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    ConvertToRaw(raw) {
        return raw.ToRaw();
    }
    ConvertFromRaw(raw) {
        return new $fcd2bbe34e7586a6$export$f05c48a4001d5356(raw);
    }
}
class $fcd2bbe34e7586a6$export$fff954b99dc26ba5 {
    constructor(_repo){
        this._repo = _repo;
        this.agents = new (0, $2s69t.Collection)([
            $fcd2bbe34e7586a6$export$f05c48a4001d5356.Default
        ]);
    }
    async Init() {
        try {
            const agents = await this._repo.GetAll();
            this.agents.Add(...agents);
        } catch (ex) {
            console.warn("Could not load agents: ", ex.message);
        }
    }
    get All() {
        return this.agents;
    }
    Get(id) {
        return this.agents.Find((x)=>x.Id === id);
    }
    async Add() {
        const id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        const agent = new $fcd2bbe34e7586a6$export$f05c48a4001d5356({
            Id: id,
            Icon: "\uD83D\uDE09",
            Name: "Nowy agent",
            Phone: "",
            IsActive: true
        });
        this.agents.Add(agent);
        await this._repo.Add(id, agent);
    }
    async Save(x) {
        await this._repo.Update(x.Id, x);
    }
}




var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $cadaa643bff02d98$export$7e24ee426ea2ba10 {
    // TODO:
    // public Notes = new RefString();
    // public MessageToCustomer = new RefString();
    constructor(raw){
        this.State = new (0, $2s69t.RefString)();
        this.CreatedAt = new Date(0);
        this.AssignedAgentId = new (0, $2s69t.RefString)();
        this.VisibleForCustomer = new (0, $2s69t.RefBool)(true);
        this.SearchBy = "";
        this.State.value = raw.State || "";
        this.CreatedAt = this.GetDate(raw.CreatedAt);
        this.AssignedAgentId.value = raw.AssignedAgentId || "";
        this.VisibleForCustomer.value = raw.VisibleForCustomer ?? true;
    }
    GetDate(rawDate) {
        return new Date(rawDate || 0);
    }
    GetString(rawString) {
        return rawString || "";
    }
    GetNumber(rawNumber) {
        return rawNumber || 0;
    }
}






class $994f84c2b62ba58d$export$4baa03b03d776143 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.BasketItems = new (0, $2s69t.Collection)();
        this.RejectionReason = new (0, $2s69t.Ref)("");
        this.AcceptedTime = new (0, $2s69t.Ref)(new Date(0));
        this.State.value ||= (0, $2a037d32327b8a8b$export$754efc3e3034943f).New;
        if (raw?.BasketItems) this.BasketItems.Load(...raw.BasketItems.map((x)=>{
            switch(x.Type){
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale:
                    return new (0, $46c5a39bfbff30f5$export$ff28d6513ec20674)(x);
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent:
                    return new (0, $b104fb107ffab6bd$export$865a56617b7eaf36)(x);
                default:
                    throw new Error(`Nieznany typ produktu: ${x.Type}`);
            }
        }) || []);
        this.RejectionReason.value = raw?.RejectionReason || "";
        this.AcceptedTime.value = new Date(raw?.AcceptedTime || 0);
    }
}



var $2s69t = parcelRequire("2s69t");


class $9ffad913acbd6c78$export$a01c43ce3cd4f57b extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.PlannedDispatchTime = new (0, $2s69t.RefDate)(new Date(0));
        this.PackageSendDeclared = new (0, $2s69t.RefDate)(new Date(0));
        this.Carrier = new (0, $2s69t.RefString)("Inpost");
        this.ManaInPackage = new (0, $2s69t.RefNumber)();
        this.DeliveryTime = new (0, $2s69t.RefDate)(new Date(0));
        this.PackageContentNotOkInfo = new (0, $2s69t.RefString)();
        this.PackageCost = new (0, $2s69t.RefNumber)();
        this.State.value ||= (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo;
        this.PackageSendDeclared.value = new Date(raw?.PackageSendDeclared || 0);
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.Carrier.value = raw?.Carrier || "Inpost";
        this.ManaInPackage.value = raw?.ManaInPackage || 0;
        this.DeliveryTime.value = new Date(raw?.DeliveryTime || 0);
        this.PackageContentNotOkInfo.value = raw?.PackageContentNotOkInfo || "";
        this.PackageCost.value = raw?.PackageCost || 0;
    }
}



var $45fvw = parcelRequire("45fvw");







var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");
class $5ad882dd69750787$export$2afca85a459950da extends (0, $2s69t.Div) {
    constructor(data){
        super();
        this.MarginTopBottom(8);
        const table = new (0, $1lG8E.Table)().Class("payment-info-table").AddRow("Paczkomat", "Inpost WAW02H").AddRow("Adres", "Cz\u0142uchowska 2A\n01-100 Warszawa").AddRow("Odbiorca", "specTeam").AddRow("Telefon", "507-293-714").AddRow("Email", "specteam@specteam.pl");
        if (data.ManaInPackage.value > 0) table.AddRow("Dop\u0142ata", data.ManaInPackage.value + " z\u0142, got\xf3wka w przesy\u0142ce");
        this.Append(table);
    }
}





var $2s69t = parcelRequire("2s69t");
class $a7cae6c3d344e899$export$ecc754f99843e759 {
    static ToTitleCase(str) {
        return str.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }
    static FormatName(name) {
        return this.ToTitleCase(name || "(brak nazwiska)").trim();
    }
    static FormatMoney(amount) {
        // Convert the amount to integer (remove decimals), then insert apostrophes as thousands separator
        const integerAmount = Math.round(amount);
        return integerAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + " z\u0142";
    }
}



var $2s69t = parcelRequire("2s69t");
class $30ca392835935f28$export$e0b1e205bcb4a7a5 extends (0, $2s69t.Div) {
    constructor(content){
        super();
        this.Style(`background-color: #fffa3b; padding: 12px; border-radius: 8px; margin-bottom: 12px; color: #222;`);
        this.Append(content);
    }
}



class $832fe0c89941a741$export$8be2db734204e7bc extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PackageFromCustomer, this.Order.Id, this.Icon, "Zwrot paczk\u0105", this.Data.PlannedDispatchTime.value, this.IsDone)
        ];
    }
    get Mana() {
        const cash = [];
        if ([
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Delivered,
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentOk,
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentNotOk
        ].includes(this.Data.State.value) && this.Data.ManaInPackage.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, this.Data.ManaInPackage.value, "Got\xf3wka w paczce", new Date(+this.Data.DeliveryTime.value || +this.Data.PlannedDispatchTime.value)));
        if (this.Data.PackageCost.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).Expense, this, this.Data.PackageCost.value, "Koszt zwrotu paczki", new Date(+this.Data.DeliveryTime.value || +this.Data.PlannedDispatchTime.value)));
        return cash;
    }
    get WhenPlanned() {
        return this.Data.PlannedDispatchTime.value;
    }
    get WhenDone() {
        return new Date(+this.Data.DeliveryTime.value || +this.Data.PlannedDispatchTime.value);
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer;
        this.Icon = "\uD83D\uDCEB";
        this.TitleForCustomer = ()=>`Zwrot paczk\u{105}`;
        this.Title = ()=>`Zwrot paczk\u{105} (${this.Data.Carrier.value || "(brak przewo\u017Anika)"})`;
        this.InitialState = (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo;
        this.WellDoneStates = [
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentOk
        ];
        this.FailedDoneStates = [
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered,
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentNotOk,
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Cancelled
        ];
        this.STATES = {
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo]: {
                StateName: "Informacje o zwrocie",
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            ...this.ReturnInfoByCarrier()
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Zwrot z u\u{17C}yciem ${this.Data.Carrier.value} (dost\u{119}pne opcje: inpost/uber/taxi).

Klient (${(0, $a7cae6c3d344e899$export$ecc754f99843e759).FormatName(this.Order.People.First()?.Name?.value)}) widzi informacje o zwrocie.`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Mo\u{17C}na wys\u{142}a\u{107} przypomnienie o zwrocie`)
                        ],
                    Actions: {
                        "\uD83C\uDFE0": ()=>{
                            this.Data.DeliveryTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Delivered);
                        },
                        "\u2705": ()=>this.PackageSendDeclared(),
                        "\u274C": ()=>this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered)
                    }
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).TimeToSend]: {
                StateName: "Pora na odes\u0142anie sprz\u0119tu " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime),
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PlannedDispatchTime.value).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now)) && new (0, $30ca392835935f28$export$e0b1e205bcb4a7a5)(`Czas na odes\u{142}anie sprz\u{119}tu min\u{105}\u{142} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime)}.
Je\u{15B}li paczka jeszcze nie zosta\u{142}a odes\u{142}ana - najwy\u{17C}sza pora to zrobi\u{107}!
Je\u{15B}li chcesz przed\u{142}u\u{17C}y\u{107} rezerwacj\u{119} - daj nam zna\u{107} telefonicznie`),
                            ...this.ReturnInfoByCarrier()
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Czas na odes\u{142}anie sprz\u{119}tu ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime)}.`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Upewnij si\u{119}, \u{17C}e klient odes\u{142}a\u{142} sprz\u{119}t`)
                        ],
                    Actions: {
                        "\uD83C\uDFE0": ()=>{
                            this.Data.DeliveryTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Delivered);
                        },
                        "\u2705": ()=>this.PackageSendDeclared(),
                        "\u274C": ()=>this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered)
                    }
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).CustomerDeclaredPackageSent]: {
                StateName: "Zadeklarowano nadanie paczki",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PackageSendDeclared.value).clone().add(3, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Zadeklarowano wys\u{142}anie paczki`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Klient zadeklarowa\u{142} nadanie paczki`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Sprawd\u{17A} status paczki w aplikacji przewo\u{17A}nika o ile takowy jest dost\u{119}pny`)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).OnTheWay),
                        "\u274C": ()=>this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered)
                    }
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).OnTheWay]: {
                StateName: "Paczka w drodze",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PackageSendDeclared.value).clone().add(4, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `\u{1F69A} Paczka w drodze

Damy zna\u{107} kiedy dotrze`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Paczka od ${(0, $a7cae6c3d344e899$export$ecc754f99843e759).FormatName(this.Order.People.First()?.Name?.value)} w drodze od ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PackageSendDeclared)}.
Status jest widoczny w aplikacji przewo\u{17A}nika.`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Czy paczka dotar\u{142}a? Je\u{15B}li mine\u{142}o wi\u{119}cej ni\u{17C} 5 dni kliknij \u{274C} i wyja\u{15B}nij spraw\u{119}`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DeliveryTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Delivered);
                        },
                        "\u274C": ()=>this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered)
                    }
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Delivered]: {
                StateName: "Dostarczona",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Paczka dostarczona`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Paczka odebrana`,
                            this.Data.ManaInPackage.value > 0 && `
W paczce powinno by\u{107} dodatkowo ${this.Data.ManaInPackage.value} z\u{142}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Czy zawarto\u{15B}\u{107} jest ok?`, new (0, $2s69t.MultilineInput)(this.Data.PackageContentNotOkInfo).Rows(4).Placeholder("Opis problemu lub brakuj\u0105cego sprz\u0119tu. Widoczny dla klienta!"))
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentOk);
                        },
                        "\u274C": ()=>{
                            this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentNotOk);
                        }
                    }
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentOk]: {
                StateName: "Zawarto\u015B\u0107 paczki jest ok",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Paczka dostarczona
\u{2705} Zawarto\u{15B}\u{107} jest w porz\u{105}dku`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Paczka odebrana. Zawarto\u{15B}\u{107} jest ok`
                        ]
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).NotDelivered]: {
                StateName: "Paczka nie dotar\u0142a",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Paczka nie dotar\u{142}a. Jako jej nadawca skontaktuj si\u{119} z przewo\u{17A}nikiem i z\u{142}\xf3\u{17C} reklamacj\u{119}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Paczka nie dotar\u{142}a`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)("Daj zna\u0107 klientowi, \u017Ce ma zadzwoni\u0107 do przewo\u017Anika i z\u0142o\u017Cy\u0107 reklamacje, bo tylko on ma uprawnienia do zarz\u0105dzania w\u0142asn\u0105 paczk\u0105")
                        ]
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).PackageContentNotOk]: {
                StateName: "Zawarto\u015B\u0107 paczki jest nieprawid\u0142owa",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Paczka dostarczona
\u{274C} Problem z zawarto\u{15B}ci\u{105}:
${this.Data.PackageContentNotOkInfo.value || "(brak notatki)"}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Paczka dostarczona, ale jest problem z jej zawarto\u{15B}ci\u{105}:
${this.Data.PackageContentNotOkInfo.value || "brak informacji"}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)("Zadzwo\u0144 do klienta i powiedz mu co jest nie tak. By\u0107 mo\u017Ce trzeba b\u0119dzie co\u015B dos\u0142a\u0107 (i warto doda\u0107 wtedy krok z kolejn\u0105 paczk\u0105) albo co\u015B zap\u0142aci\u0107 (i zaznaczy\u0107 to w zwrocie kaucji, \u017Ce suma jest mniejsza)")
                        ]
                }
            },
            [(0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).Cancelled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Zwrot zosta\u{142} odwo\u{142}any`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Zwrot zosta\u{142} odwo\u{142}any. Najpewniej dlatego, \u{17C}e paczka nie dotar\u{142}a do klienta b\u{105}d\u{17A} zosta\u{142}a zwr\xf3cona`
                        ]
                }
            }
        };
    }
    Init() {
        if (this.Data.State.IsIn([
            (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).ReturnInfo
        ])) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PlannedDispatchTime.value).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now))) this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).TimeToSend);
        }
    }
    PackageSendDeclared() {
        this.Data.PackageSendDeclared.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
        this.GoTo((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).CustomerDeclaredPackageSent);
    }
    ReturnInfoByCarrier() {
        const carrier = this.Data.Carrier.value.toLowerCase();
        if ([
            "inpost",
            "",
            "paczkomat"
        ].includes(carrier)) return [
            `Sprz\u{119}t nale\u{17C}y odes\u{142}a\u{107} Paczkomatem`,
            new (0, $5ad882dd69750787$export$2afca85a459950da)(this.Data),
            `Nadaj paczk\u{119} do dnia ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedDispatchTime)},\nmaksymalnie do godziny 12:00`,
            new (0, $2s69t.Line)(),
            new (0, $2s69t.Link)("Zobacz jak zapakowa\u0107 paczk\u0119", "https://tutorial.specteam.pl/#slide/jak-odeslac-paczke").OpenInNewCard()
        ];
        else if ([
            "uber",
            "bolt",
            "taxi"
        ].includes(carrier)) return [
            `Sprz\u{119}t nale\u{17C}y odes\u{142}a\u{107} taks\xf3wk\u{105} na adres ustalony przez telefon.

Zabezpiecz dobrze przesy\u{142}k\u{119} oraz nie zapomnij wys\u{142}a\u{107} informacji trakuj\u{105}cych do odbiorcy`
        ];
        return [
            "Forma zwrotu nie zosta\u0142a okre\u015Blona. Skontaktuj si\u0119 z nami aby naprawi\u0107 ten b\u0142\u0105d."
        ];
    }
}



var $2s69t = parcelRequire("2s69t");


class $ac3a730131a31431$export$8d038cf3aa43077e extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.PackageContent = new (0, $2s69t.Collection)();
        this.PlannedDispatchTime = new (0, $2s69t.RefDate)(new Date(0));
        this.DispatchTime = new (0, $2s69t.RefDate)(new Date(0));
        this.LastStatusCheckTime = new (0, $2s69t.RefDate)(new Date(0));
        this.AddressFullInfo = new (0, $2s69t.RefString)();
        this.PackageNumber = new (0, $2s69t.RefString)();
        this.Carrier = new (0, $2s69t.RefString)("Pocztex");
        this.PaymentAtDelivery = new (0, $2s69t.RefNumber)();
        this.PackageCost = new (0, $2s69t.RefNumber)();
        this.State.value ||= (0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotPlannedYet;
        this.PackageContent.Load(...raw?.PackageContent || []);
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.DispatchTime.value = new Date(raw?.DispatchTime || 0);
        this.LastStatusCheckTime.value = new Date(raw?.LastStatusCheckTime || 0);
        this.AddressFullInfo.value = raw?.AddressFullInfo || "";
        this.PackageNumber.value = raw?.PackageNumber || "";
        this.Carrier.value = raw?.Carrier || "Pocztex";
        this.PaymentAtDelivery.value = raw?.PaymentAtDelivery || 0;
        this.PackageCost.value = raw?.PackageCost || 0;
    }
}



var $2s69t = parcelRequire("2s69t");






var $45fvw = parcelRequire("45fvw");





var $2s69t = parcelRequire("2s69t");
class $9771b6f77df262ff$export$db0a28c1a3d147f3 extends (0, $2s69t.Div) {
    constructor(data){
        super();
        this.MarginTop(16);
        const carrier = data.Carrier.value.trim();
        switch(carrier.toLowerCase()){
            case "pocztex":
                this.Append(new (0, $2s69t.Link)("\uD83D\uDDFA\uFE0F \u015Aledzenie paczki", `https://www.pocztex.pl/sledzenie-przesylek/?numer=${data.PackageNumber.value}`).OpenInNewCard());
                break;
            case "dhl":
                this.Append(new (0, $2s69t.Link)("\uD83D\uDDFA\uFE0F \u015Aledzenie paczki", `https://www.dhl.com/pl/pl/home/tracking.html?trackingNumber=${data.PackageNumber.value}`).OpenInNewCard());
                break;
            default:
                this.Append(new (0, $2s69t.Span)("Brak danych na temat \u015Bledzenia paczki").Italic());
                break;
        }
        let paymentAtDelivery = "Bez pobrania";
        if (data.PaymentAtDelivery.value > 0) paymentAtDelivery = data.PaymentAtDelivery.value + " z\u0142";
        this.Append(// new Line(),
        // "Numer paczki: ", data.PackageNumber.value,
        // "\nPrzewoźnik: ", carrier,
        // "\nPobranie: ", paymentAtDelivery,
        new (0, $2s69t.Table)([], [
            [
                "Numer paczki",
                data.PackageNumber.value
            ],
            [
                "Przewo\u017Anik",
                carrier
            ],
            [
                "Pobranie",
                paymentAtDelivery
            ]
        ]).Class("payment-info-table"));
    }
}



var $2s69t = parcelRequire("2s69t");

class $da908d59f2450c72$export$d9cea58835133f4c extends (0, $2s69t.Div) {
    constructor(order, itemsIds){
        super();
        let items = itemsIds?.Items?.map((id)=>order.BasketItems.find((x)=>x.Id === id))?.filter((x)=>x != null) ?? order.BasketItems;
        this.Append(...items.map((item)=>new (0, $b18a2e4cac71d5d9$export$614b56d11b894a09)(item)));
    }
}



class $05a2f6c5fdd71a8d$export$84e947a9b1fcf723 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PackageToCustomer, this.Order.Id, "\uD83D\uDCE6", "Wysy\u0142ka", this.Data.PlannedDispatchTime.value, this.Data.State.Is((0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit))
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.PackageCost.value > 0 && (this.Data.State.Is((0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit) || this.IsDone)) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).Expense, this, this.Data.PackageCost.value, "Koszt paczki", this.Data.DispatchTime.value));
        return cash;
    }
    get WhenPlanned() {
        return this.Data.PlannedDispatchTime.value;
    }
    get WhenDone() {
        return this.Data.DispatchTime.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer;
        this.Icon = "\uD83D\uDCE6";
        this.TitleForCustomer = ()=>`Wysy\u{142}ka`;
        this.Title = ()=>`Wysy\u{142}ka (${this.Data.Carrier.value || "Pocztex"})`;
        this.InitialState = (0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotPlannedYet;
        this.WellDoneStates = [
            (0, $0928cc6340f2c462$export$3fda4618fcb351f4).Delivered
        ];
        this.FailedDoneStates = [
            (0, $0928cc6340f2c462$export$3fda4618fcb351f4).Cancelled,
            (0, $0928cc6340f2c462$export$3fda4618fcb351f4).RejectedByCustomer,
            (0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageLost
        ];
        this.STATES = {
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotPlannedYet]: {
                StateName: "Jeszcze nie zaplanowane",
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `Wysy\u{142}ka nie zosta\u{142}a jeszcze zaplanowana`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Czas wysy\u{142}ki nie zosta\u{142} jeszcze zaplanowany`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal czas wysy\u{142}ki`, new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedDispatchTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Planned),
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Cancelled)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).Planned]: {
                StateName: "Wysy\u0142ka " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime, "(nie okre\u015Blono)", false),
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `\u{2714}\u{FE0F} Wysy\u{142}ka zaplanowana na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedDispatchTime)}\n`,
                            this.Data.PaymentAtDelivery.value > 0 && `\nKwota pobrania: `,
                            this.Data.PaymentAtDelivery.value > 0 && new (0, $2s69t.Span)(this.Data.PaymentAtDelivery.value + " z\u0142").Attribute("data-testid", "package-payment-info-amount")
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2714}\u{FE0F} Wysy\u{142}ka ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime)} (${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedDispatchTime)}).`,
                            new (0, $da908d59f2450c72$export$d9cea58835133f4c)(this.Order, this.Data.PackageContent),
                            new (0, $2s69t.Div)("meeting-info-entry").Text(this.Data.AddressFullInfo.value || "(brak adresu)"),
                            `Pobranie: ${this.Data.PaymentAtDelivery.value + " z\u0142"} `,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Przygotuj etykiet\u{119} na podstawie powy\u{17C}szych danych.
Numer przesy\u{142}ki i numery seryjne urz\u{105}dze\u{144} b\u{119}d\u{105} do wpisania w nast\u{119}pnym kroku`)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).LabelReady),
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotPlannedYet)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).LabelReady]: {
                StateName: "Etykieta gotowa",
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Paczka w przygotowaniu...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Etykieta zosta\u{142}a wype\u{142}niona danymi klienta`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Wpisz numer paczki oraz numery seryjne wysy\u{142}anych urz\u{105}dze\u{144}

`, "Przewo\u017Anik", new (0, $2s69t.Select)(this.Data.Carrier, [
                                "Pocztex",
                                "Inpost",
                                "DHL",
                                "DPD",
                                "Uber"
                            ]), "\n\nNumer paczki", new (0, $2s69t.TextInput)(this.Data.PackageNumber), "\n\nKoszt paczki", new (0, $2s69t.NumberInput)(this.Data.PackageCost).Min(0).MarginLeftRight(8), "z\u0142", new (0, $2s69t.TableBuilder)(this.Order.BasketItems).AddColumn("Produkt", (x)=>x.ProductInfo.Name + " \xd7" + x.Quantity.value).AddColumn("Numer seryjny", (x)=>new (0, $2s69t.TextInput)(x.ProductSerialNumber)).AddColumn("Dane dost\u0119pu", (x)=>new (0, $2s69t.TextInput)(x.AccessData)).Build())
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).ReadyToShipment),
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Planned)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).ReadyToShipment]: {
                StateName: "Gotowa do wys\u0142ania",
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Twoja paczka jest ju\u{17C} gotowa do wys\u{142}ania. Nadamy j\u{105} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedDispatchTime)}`,
                            this.Data.PaymentAtDelivery.value && `, za pobraniem ${this.Data.PaymentAtDelivery.value} z\u{142}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Etykieta "${this.Data.PackageNumber.value || "(brak numeru paczki)"}" ("${this.Data.Carrier.value}") gotowa\n`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Wy\u{15B}lij paczk\u{119} najdalej do ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PlannedDispatchTime.value).format("DD.MM.YYYY")} do godziny 15:00`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DispatchTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit);
                        },
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotPlannedYet)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit]: {
                StateName: "W trasie",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.DispatchTime.value).clone().add(2, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `\u{1F69A} Paczka jest ju\u{17C} w drodze

Powinna dotrze\u{107} w ci\u{105}gu 24-48h

`,
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Paczka nadana ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.DispatchTime)} \u{2705}
Jest w trasie od ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).Since(this.Data.DispatchTime)}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Sprawd\u{17A} czy klient odebra\u{142} paczk\u{119}. Je\u{15B}li jest awizowana na poczcie wybierz \u{1F3E4}`),
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Delivered),
                        "\uD83C\uDFE4": ()=>{
                            this.Data.LastStatusCheckTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).AwaitingInPostOffice);
                        },
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotDeliveredYet)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).NotDeliveredYet]: {
                StateName: "Nie dostarczona",
                Customer: {
                    Content: ()=>[
                            `\u{1F69A} Paczka wci\u{105}\u{17C} jest w drodze

Wi\u{119}kszo\u{15B}\u{107} paczek dociera w ci\u{105}gu 1-2 dni roboczych. Kliknij w link poni\u{17C}ej, aby dowiedzie\u{107} si\u{119} wi\u{119}cej`,
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Min\u{119}\u{142}o ju\u{17C} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.DispatchTime.value).from((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now))} od nadania`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Warto sprawdzi\u{107} co si\u{119} dzieje z paczk\u{105}`, new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Delivered),
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Problem)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).Problem]: {
                StateName: "Problem z dostaw\u0105",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Jest jaki\u{15B} problem z dostaw\u{105}...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Problem z dostaw\u{105}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Okre\u{15B}l rodzaj problemu`)
                        ],
                    Actions: {
                        "\uD83C\uDFE4 Awizowana": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).AwaitingInPostOffice),
                        "\u274C Nie odebrana": ()=>{
                            this.Data.LastStatusCheckTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).RejectedByCustomer);
                        },
                        "\uD83C\uDF0A Zgubiona": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageLost),
                        "\uD83D\uDE9A Ci\u0105gle w drodze": ()=>{
                            this.Data.LastStatusCheckTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).StillOnTheWay);
                        },
                        "\uD83D\uDD19 Zwr\xf3cona": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageReturned)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).Delivered]: {
                StateName: "Dostarczona",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Paczka dostarczona`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Paczka dostarczona`,
                            new (0, $da908d59f2450c72$export$d9cea58835133f4c)(this.Order, this.Data.PackageContent),
                            new (0, $2s69t.Line)(),
                            `Number paczki: ${this.Data.PackageNumber.value} (${this.Data.Carrier.value})\nPobranie: ${this.Data.PaymentAtDelivery.value} z\u{142}`
                        ]
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).RejectedByCustomer]: {
                StateName: "Zrezygnowano z odebrania",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.LastStatusCheckTime.value).clone().add(7, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `\u{274C} Zrezygnowano z odebrania paczki`,
                            new (0, $2s69t.Line)(),
                            `Paczk\u{119} wci\u{105}\u{17C} mo\u{17C}na odebra\u{107} na poczcie w przeci\u{105}gu 7 dni od daty jej dostarczenia do urz\u{119}du. Po tym czasie zostanie zwr\xf3cona do nadawcy`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Klient \u{15B}wiadomie nie odebra\u{142} paczki`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Oczekuj zwrotu paczki. Anuluj zwrot kaucji.
Klient wci\u{105}\u{17C} mo\u{17C}e odebra\u{107} paczk\u{119} w urz\u{119}dzie przez 7 dni (i taki widzi komunikat)`),
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ]
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).StillOnTheWay]: {
                StateName: "Ci\u0105gle w drodze",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.LastStatusCheckTime.value).clone().add(1, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `Paczka jest w drodze d\u{142}u\u{17C}ej ni\u{17C} zak\u{142}adano...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Paczka wci\u{105}\u{17C} jest w drodze a powinna ju\u{17C} dotrze\u{107}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Skontaktuj si\u{119} z przewo\u{17A}nikiem i zapytaj o co chodzi`),
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ]
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageLost]: {
                StateName: "Zgubiona",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Paczka zosta\u{142}a zgubiona`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Paczka zosta\u{142}a najprawdopodobniej zgubiona`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Skontaktuj si\u{119} z przewo\u{17A}nikiem i z\u{142}\xf3\u{17C} reklamacj\u{119}`)
                        ]
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).AwaitingInPostOffice]: {
                StateName: "Awizowana",
                Timeout: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.LastStatusCheckTime.value).clone().add(7, "days").toDate(),
                Customer: {
                    Content: ()=>[
                            `\u{1F3E4} Paczka jest awizowana na poczcie. Zg\u{142}o\u{15B} si\u{119} po ni\u{105} do plac\xf3wki przydzielonej dla Twojego adresu zamieszkania w ci\u{105}gu 7 dni. Nie zapomnij zabra\u{107} ze sob\u{105} dowodu osobistego`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{1F3E4} Paczka awizowana`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Upewnij si\u{119}, \u{17C}e klient wie co to znaczy i co ma robi\u{107}. Status odebrania mo\u{17C}na sprawdzi\u{107} w trakerze`),
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Delivered),
                        "\u274C": ()=>this.GoTo((0, $0928cc6340f2c462$export$3fda4618fcb351f4).Problem)
                    }
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).Cancelled]: {
                StateName: "Odwo\u0142ana",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Wysy\u{142}ka zosta\u{142}a odwo\u{142}ana`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Wysy\u{142}ka zosta\u{142}a odwo\u{142}ana`
                        ]
                }
            },
            [(0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageReturned]: {
                StateName: "Zwr\xf3cona",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Przesy\u{142}ka zosta\u{142}a zwr\xf3cona`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Przesy\u{142}ka zosta\u{142}a zwr\xf3cona
`,
                            new (0, $9771b6f77df262ff$export$db0a28c1a3d147f3)(this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Warto ustali\u{107} dlaczego paczka si\u{119} odbi\u{142}a. Nale\u{17C}y anulowa\u{107} kolejne kroki i zastanowi\u{107} si\u{119} co zrobi\u{107} z kaucj\u{105} (zale\u{17C}y czy wina klienta czy nie)`)
                        ]
                }
            }
        };
    }
    Init() {
        this.Data.SearchBy = this.Data.PackageNumber.value + " " + this.Data.PackageContent.Items.join(" ");
    }
}



var $2s69t = parcelRequire("2s69t");



var $f2bf1286956e94e0$export$2429fab72cbe576d = /*#__PURE__*/ function(PaymentStepState) {
    PaymentStepState["Awaiting"] = "Awaiting";
    PaymentStepState["Paid"] = "Paid";
    PaymentStepState["Canceled"] = "Canceled";
    PaymentStepState["Omitted"] = "Omitted";
    PaymentStepState["Error"] = "Error";
    PaymentStepState["Returned"] = "Returned";
    PaymentStepState["UnableToExecute"] = "UnableToExecute";
    return PaymentStepState;
}({});
const $f2bf1286956e94e0$export$f8aa97792afa4663 = {
    "Czeka": "Awaiting",
    "Op\u0142acone": "Paid",
    "Odwo\u0142ane": "Canceled",
    "Pomini\u0119te": "Omitted",
    "B\u0142\u0105d": "Error",
    "Zwr\xf3cone": "Returned",
    "Nie mo\u017Cna wykona\u0107": "UnableToExecute"
};


class $a4751a13f69f4714$export$127c4655001e678f extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.Category = new (0, $2s69t.Ref)((0, $58e7eb9318036e70$export$3c13f0bb485df434).Unset);
        this.AccountNumber = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Amount = new (0, $2s69t.RefNumber)(0);
        this.Currency = new (0, $2s69t.RefString)("PLN");
        this.PaymentCurrency = new (0, $2s69t.RefString)("PLN");
        this.ExchangeRate = new (0, $2s69t.RefNumber)(0);
        this.Form = new (0, $2s69t.Ref)((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Unset);
        this.Deadline = new (0, $2s69t.RefDate)(0);
        this.WhenPaid = new (0, $2s69t.RefDate)(0);
        this.Comment = new (0, $2s69t.RefString)();
        this.CancellationReason = new (0, $2s69t.RefString)();
        this.State.value ||= (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting;
        this.Category.value = raw?.Category || (0, $58e7eb9318036e70$export$3c13f0bb485df434).Unset;
        this.AccountNumber.value = raw?.AccountNumber || "";
        if (this.AccountNumber.value == "(brak numeru konta)") this.AccountNumber.value = "";
        this.Title.value = raw?.Title || "";
        this.Amount.value = raw?.Amount || 0;
        this.Currency.value = raw?.Currency || "PLN";
        this.PaymentCurrency.value = raw?.PaymentCurrency || "PLN";
        this.ExchangeRate.value = raw?.ExchangeRate || 0;
        this.Form.value = raw?.Form || (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Unset;
        this.Deadline.value = new Date(raw?.Deadline || 0);
        this.WhenPaid.value = new Date(raw?.WhenPaid || 0);
        this.Comment.value = raw?.Comment || "";
        this.CancellationReason.value = raw?.CancellationReason || "";
    }
    get AmountAsString() {
        return this.Amount.value.toString() + " " + this.Currency.value;
    }
    get PaymentAsString() {
        if (this.Currency.value == this.PaymentCurrency.value) return `${this.Amount.value} ${this.Currency.value}, ${(0, $b4315c565ef22fe2$export$76326f79407286d6)[this.Form.value]}`;
        const amount = (this.Amount.value / this.ExchangeRate.value).toFixed(8);
        return `${amount} ${this.PaymentCurrency.value} = ${this.Amount.value} ${this.Currency.value}\n(${this.ExchangeRate.value} ${this.PaymentCurrency.value} za 1 ${this.Currency.value})`;
    }
}








var $1lG8E = parcelRequire("1lG8E");



class $fa748b403750f906$export$a3926c98aaf83a19 extends (0, $1lG8E.Table) {
    constructor(payment, customer){
        super();
        this.Class("payment-info-table");
        if (payment.Form.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Unset)) {
            this.AddRow("Forma", "\u26A0\uFE0F Forma zwrotu nie zosta\u0142a okre\u015Blona");
            return;
        }
        this.AddRow("Forma", (0, $b4315c565ef22fe2$export$76326f79407286d6)[payment.Form.value]).AddRow("Kwota", payment.AmountAsString).AddRow("Tytu\u0142em", payment.Title.value);
        let accountNumber = payment.AccountNumber.value || customer?.BankAccountNumber?.value;
        switch(payment.Form.value){
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash:
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik:
                this.AddRow("Na numer", this.HidePhoneNumber((0, $92a7145927fcbc93$export$cfc95f342033cc43).NicePhoneNumber(accountNumber || customer?.Phone?.value || "")) || "\u26A0\uFE0F brak numeru telefonu");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto:
                const toPay = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Warto\u015B\u0107", "Wyliczona z proporcji").AddRow("Z kwoty", payment.AmountAsString).AddRow("Do zwrotu", toPay + " " + payment.PaymentCurrency.value).AddRow("Kurs", `Z momentu wp\u{142}aty:
${payment.ExchangeRate.value} PLN za 1 BTC`).AddRow("Portfel", accountNumber ? this.HideCryptoNumber(accountNumber) : "\u26A0\uFE0F brak adresu portfela");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer:
                if (!accountNumber && payment.Form.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer)) this.AddRow("Konto", "Zwrot na to samo konto");
                else this.AddRow("Konto", accountNumber ? this.HideAccountNumber(accountNumber) : "\u26A0\uFE0F brak numeru konta");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).PostalTransfer:
                this.AddRow("Konto", accountNumber ? this.HideAccountNumber(accountNumber) : "\u26A0\uFE0F brak numeru konta");
                break;
            default:
                break;
        }
        this.AddRow("Termin", "do " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(payment.Deadline.value));
        if (payment.Comment.value) this.AddRow("Komentarz", payment.Comment.value);
    }
    HidePhoneNumber(number) {
        if (!number) return "";
        const first = number.slice(0, 1);
        const last = number.slice(-2);
        return first + "** *** *" + last;
    }
    HideCryptoNumber(number) {
        if (!number) return "";
        const first = number.slice(0, 6);
        const last = number.slice(-8);
        return first + "....." + last;
    }
    HideAccountNumber(number) {
        if (!number) return "";
        const first2 = number.slice(0, 2);
        const last4 = number.slice(-4);
        return first2 + " **** **** **** **** **** " + last4;
    }
}



var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");



class $c02880a8ea9b0004$export$25b67090f724a3b6 extends (0, $1lG8E.Table) {
    constructor(payment, customer){
        super();
        this.Class("payment-info-table");
        if (payment.Form.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Unset)) {
            this.AddRow("Forma", "\u26A0\uFE0F Nie zosta\u0142a okre\u015Blona");
            return;
        }
        let customerAccountNumber = payment.AccountNumber.value || customer?.BankAccountNumber?.value;
        if (payment.Form.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer)) customerAccountNumber = "To z kt\xf3rego przyszed\u0142 przelew";
        this.AddRow("Forma", (0, $b4315c565ef22fe2$export$76326f79407286d6)[payment.Form.value]).AddRow("Tytu\u0142em", payment.Title.value).AddRow("Kwota", payment.AmountAsString);
        switch(payment.Form.value){
            default:
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer:
                this.AddRow("Konto", new (0, $2s69t.MultilineInput)(customerAccountNumber || "\u26A0\uFE0F brak numeru konta").Readonly().Rows(3).Background("none").BorderNone().Padding(0).Margin(0).Color("#000")).AddRow("Odbiorca", (customer?.Name?.value || "---") + "\n" + (customer?.Address?.value || "---"));
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik:
                this.AddRow("Numer", customerAccountNumber || (0, $92a7145927fcbc93$export$cfc95f342033cc43).NicePhoneNumber(customer?.Phone?.value || "") || "\u26A0\uFE0F brak numeru telefonu").AddRow("Odbiorca", customer?.Name?.value || "---");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash:
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Do przelania", new (0, $2s69t.Span)(btcAmount + " " + payment.PaymentCurrency.value).Bold()).AddRow("Kurs BTC", payment.ExchangeRate.value + " PLN za 1 BTC").AddRow("Adres portfela", new (0, $2s69t.MultilineInput)(customerAccountNumber || "\u26A0\uFE0F brak adresu portfela").Readonly().Rows(3).Background("none").BorderNone().Padding(0).Margin(0).Color("#000"));
                break;
        }
        this.AddRow("Termin", "do " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(payment.Deadline.value));
    }
}





var $2s69t = parcelRequire("2s69t");



class $31813e7e41bded08$export$e8feeb28ee4fd095 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PaymentReturn, this.Order.Id, "\uD83D\uDCB0", "Zwrot \u015Brodk\xf3w", this.Data.Deadline.value, this.IsDone)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid)) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReturnedDeposit, this, this.Data.Amount.value, `Zwrot \u{15B}rodk\xf3w (${this.Data.Category.value})`, new Date(+this.Data.WhenPaid.value || +this.Data.Deadline.value)));
        return cash;
    }
    get WhenPlanned() {
        return this.Data.Deadline.value;
    }
    get WhenDone() {
        return new Date(+this.Data.WhenPaid.value || +this.Data.Deadline.value);
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn;
        this.Icon = "\uD83D\uDCB8";
        this.TitleForCustomer = ()=>`Zwrot \u{15B}rodk\xf3w`;
        this.Title = ()=>`Zwrot \u{15B}rodk\xf3w (${(0, $b4315c565ef22fe2$export$76326f79407286d6)[this.Data.Form.value]})`;
        this.InitialState = (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting;
        this.WellDoneStates = [
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid
        ];
        this.FailedDoneStates = [
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled,
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted
        ];
        this.STATES = {
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting]: {
                Timeout: ()=>this.Data.Deadline,
                Customer: {
                    StateName: `Oczekiwanie na zwrot \u{15B}rodk\xf3w`,
                    Content: ()=>this.AwaitingPaymentCustomerInfo()
                },
                Admin: {
                    StateName: `Oczekuje na zwrot (${(0, $b4315c565ef22fe2$export$76326f79407286d6)[this.Data.Form.value]}) ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).DaysAgo(this.Data.Deadline) > 0 ? `od ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).DaysAgo(this.Data.Deadline)} dni` : ""}`,
                    Content: ()=>[
                            `Do zwrotu:\n`,
                            new (0, $c02880a8ea9b0004$export$25b67090f724a3b6)(this.Data, this.Order.People.First()),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Wykonaj zwrot zale\u{17C}nie od formy planowanej p\u{142}atno\u{15B}ci`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.WhenPaid.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid);
                        },
                        "\u274C": ()=>this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled)
                    }
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid]: {
                StateName: "Zwr\xf3cone",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Zwrot wykonany ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.WhenPaid.value)}`,
                            new (0, $2s69t.Line)(),
                            new (0, $2s69t.Switch)(this.Data.Form.value).Case((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto, ()=>"Czas transferu wynosi od kilku minut do kilku godzin").Case((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer, ()=>"Czas transferu wynosi zwykle oko\u0142o 24 godzin").Case((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik, ()=>"Czas transferu to zwykle kilka minut").Case((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash, ()=>"Zwrot got\xf3wk\u0105").Case((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).PostalTransfer, ()=>"Czas transferu wynosi 1-3 dni robocze").Default(()=>"Forma zwrotu nie zosta\u0142a okre\u015Blona. Skontaktuj si\u0119 z nami aby naprawi\u0107 ten b\u0142\u0105d.").Execute()
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Zwrot wykonany`,
                            new (0, $c02880a8ea9b0004$export$25b67090f724a3b6)(this.Data, this.Order.People.First())
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Anulowano zwrot`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Przelew anulowany (${this.Data.AmountAsString})`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Je\u{15B}li tylko pomini\u{119}ty klinij X`, new (0, $2s69t.MultilineInput)(this.Data.CancellationReason).Placeholder("Pow\xf3d pomini\u0119cia zwrotu. Widoczne r\xf3wnie\u017C dla klienta!").Rows(3))
                        ],
                    Actions: {
                        "\u274C": ()=>this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted)
                    }
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted]: {
                StateName: "Zwrot \u015Brodk\xf3w zosta\u0142 pomini\u0119ty",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Zwrot zosta\u{142} pomini\u{119}ty z powodu: ${this.Data.CancellationReason.value || "nie podano"}.`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Zwrot pomini\u{119}ty (${this.Data.AmountAsString})`,
                            new (0, $2s69t.Line)(),
                            this.Data.CancellationReason.value
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Error]: {
                StateName: "B\u0142\u0105d p\u0142atno\u015Bci",
                Customer: {
                    Content: ()=>[
                            `B\u{142}\u{105}d podczas wykonywania operacji.`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Wyst\u{105}pi\u{142} b\u{142}\u{105}d podczas wykonywania operacji. Sytuacja wymaga wyja\u{15B}nienia!`
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Returned]: {
                StateName: "Zwr\xf3cone",
                Customer: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} zosta\u{142}a anulowana przez bank. Trwa wyja\u{15B}nianie sytuacji...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} zosta\u{142}a anulowana przez bank. Sytuacja wymaga wyja\u{15B}nienia!`
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).UnableToExecute]: {
                StateName: "Problem z wykonaniem zwrotu \u015Brodk\xf3w",
                Customer: {
                    Content: ()=>[
                            `Nie mo\u{17C}na wykona\u{107} zwrotu. Pow\xf3d: ${this.Data.CancellationReason.value || "nie podano"}.`,
                            new (0, $2s69t.Line)(),
                            "Skontaktuj si\u0119 z nami aby rozwi\u0105za\u0107 problem."
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Nie mo\u{17C}na wykona\u{107} zwrotu. Pow\xf3d: ${this.Data.CancellationReason.value || "nie podano"}.`
                        ]
                }
            }
        };
    }
    Init() {}
    AwaitingPaymentCustomerInfo() {
        if (this.Data.Form.Is((0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Unset)) return [
            `\u{26A0}\u{FE0F} Forma zwrotu nie zosta\u{142}a okre\u{15B}lona. Skontaktuj si\u{119} z nami aby naprawi\u{107} ten b\u{142}\u{105}d.`
        ];
        return [
            `Oczekuj zwrotu \u{15B}rodk\xf3w`,
            new (0, $fa748b403750f906$export$a3926c98aaf83a19)(this.Data, this.Order.People.First())
        ];
    }
}








var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");


class $42d00d593473dcd4$export$7304c592e4880356 extends (0, $1lG8E.Table) {
    constructor(payment){
        super();
        this.Class("payment-info-table");
        this.AddRow("Forma", (0, $b4315c565ef22fe2$export$76326f79407286d6)[payment.Form.value]);
        switch(payment.Form.value){
            default:
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer:
                this.AddRow("Numer konta", "88 1140 2004 0000 3102 7986 6622").AddRow("Adresat", "specTeam").AddRow("Tytu\u0142em", payment.Title.value).AddRow("Kwota", new (0, $2s69t.Span)(payment.AmountAsString).Attribute("data-testid", "payment-info-amount")).AddRow("Typ", "elixir (nie express!)");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik:
                this.AddRow("Na numer", "507-293-714").AddRow("Tytu\u0142em", payment.Title.value).AddRow("Kwota", new (0, $2s69t.Span)(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"));
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash:
                this.AddRow("Kwota", new (0, $2s69t.Span)(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"));
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Adres portfela", new (0, $2s69t.MultilineInput)("bc1qu72c9tuwjtgghmqtvgc0lhxt7n928hhn3ldyx8").Readonly().Rows(2).Background("none").BorderNone().Padding(0).Margin(0).Color("#000")).AddRow("Kwota", payment.AmountAsString).AddRow("Do przelania", new (0, $2s69t.Span)(btcAmount + " " + payment.PaymentCurrency.value).Bold()).AddRow("Kurs BTC", payment.ExchangeRate.value.toString() + " PLN za 1 BTC");
                break;
        }
        this.AddRow("Termin", "Do " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(payment.Deadline.value));
    }
}



var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");

class $427b74571c76dbe8$export$cda41c75dd25b2da extends (0, $1lG8E.Table) {
    constructor(payment, people){
        super();
        this.Class("payment-info-table");
        this.AddRow("Forma", (0, $b4315c565ef22fe2$export$76326f79407286d6)[payment.Form.value]).AddRow("Kwota", new (0, $2s69t.Span)(payment.AmountAsString).Attribute("data-testid", "payment-info-amount")).AddRow("Nadawca", people.Name.value || "\u26A0\uFE0F brak nazwy nadawcy").AddRow("Tytu\u0142em", payment.Title.value || "\u26A0\uFE0F brak tytu\u0142u");
        switch(payment.Form.value){
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).BankTransfer:
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Blik:
                this.AddRow("Z numeru", people.Phone.value || "\u26A0\uFE0F brak numeru telefonu");
                break;
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Do przelania", new (0, $2s69t.Span)(btcAmount + " " + payment.PaymentCurrency.value).Bold()).AddRow("Kurs BTC", payment.ExchangeRate.value.toString() + " PLN za 1 BTC");
                break;
            default:
            case (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Cash:
                break;
        }
    }
}




var $37QPp = parcelRequire("37QPp");

var $gwSD4 = parcelRequire("gwSD4");






var $2s69t = parcelRequire("2s69t");
class $a94d12eadcdd8dd0$export$20c36f2f8fe0d441 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).Payment, this.Order.Id, "\uD83D\uDCB0", "P\u0142atno\u015B\u0107", this.Data.Deadline.value, this.IsDone)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid)) {
            let income = this.Data.Amount.value - this.Order.DesiredDeposit;
            if (income < 0) income = 0;
            cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, income, "Wp\u0142acone \u015Brodki", new Date(+this.Data.WhenPaid.value || +this.Data.Deadline.value)));
            cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedDeposit, this, this.Order.DesiredDeposit, "Wp\u0142acona kaucja", new Date(+this.Data.WhenPaid.value || +this.Data.Deadline.value)));
        }
        return cash;
    }
    get WhenPlanned() {
        return this.Data.Deadline.value;
    }
    get WhenDone() {
        return this.Data.WhenPaid.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment;
        this.Icon = "\uD83D\uDCB3";
        this.TitleForCustomer = ()=>`P\u{142}atno\u{15B}\u{107}`;
        this.Title = ()=>`P\u{142}atno\u{15B}\u{107} (${(0, $b4315c565ef22fe2$export$76326f79407286d6)[this.Data.Form.value]}, ${this.Data.Amount.value} ${this.Data.Currency.value})`;
        this.InitialState = (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting;
        this.WellDoneStates = [
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid,
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted
        ];
        this.FailedDoneStates = [
            (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled
        ];
        this.STATES = {
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting]: {
                StateName: "Oczekuje na p\u0142atno\u015B\u0107",
                Timeout: ()=>this.Data.Deadline,
                Customer: {
                    Content: ()=>[
                            `Szczeg\xf3\u{142}y p\u{142}atno\u{15B}ci:
`,
                            new (0, $42d00d593473dcd4$export$7304c592e4880356)(this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Oczekiwanie na wp\u{142}at\u{119} do ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.Deadline.value)}`,
                            new (0, $427b74571c76dbe8$export$cda41c75dd25b2da)(this.Data, this.Order.People.First() || (0, $7491f76ebc0bf829$export$9818a1bf5e26633).Default),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Sprawd\u{17A} stan zaksi\u{119}gowana: czy wp\u{142}ata dotar\u{142}a na czas, z w\u{142}a\u{15B}ciwym kodem oraz czy kwota si\u{119} zgadza`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.WhenPaid.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid);
                        },
                        "\u274C": ()=>this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled)
                    }
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Paid]: {
                StateName: "Op\u0142acone",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Zam\xf3wienie zosta\u{142}o op\u{142}acone`,
                            new (0, $gwSD4.Line)(),
                            new (0, $2s69t.Span)(this.Data.PaymentAsString)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Zam\xf3wienie zosta\u{142}o op\u{142}acone`,
                            new (0, $427b74571c76dbe8$export$cda41c75dd25b2da)(this.Data, this.Order.People.First() || (0, $7491f76ebc0bf829$export$9818a1bf5e26633).Default)
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Canceled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Mo\u{17C}liwo\u{15B}\u{107} przyj\u{119}cia tej p\u{142}atno\u{15B}ci zosta\u{142}a anulowana`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} P\u{142}atno\u{15B}\u{107} anulowana`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Je\u{15B}li p\u{142}atno\u{15B}\u{107} zosta\u{142}a tylko pomini\u{119}ta (np. z tytu\u{142}u op\u{142}acenia w innym zam\xf3wieniu) to kliknij X poni\u{17C}ej`, new (0, $37QPp.MultilineInput)(this.Data.CancellationReason).Placeholder("Pow\xf3d pomini\u0119cia p\u0142atno\u015Bci. Widoczne r\xf3wnie\u017C dla klienta!").Rows(3))
                        ],
                    Actions: {
                        "\u2716\uFE0F": ()=>this.GoTo((0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted)
                    }
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Omitted]: {
                StateName: "Pomini\u0119te",
                Customer: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} nie jest konieczna`,
                            new (0, $gwSD4.Line)(),
                            this.Data.CancellationReason.value
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} zosta\u{142}a pomini\u{119}ta`,
                            new (0, $gwSD4.Line)(),
                            this.Data.CancellationReason.value
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Error]: {
                StateName: "B\u0142\u0105d p\u0142atno\u015Bci",
                Customer: {
                    Content: ()=>[
                            `B\u{142}\u{105}d podczas wykonywania operacji.`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Wyst\u{105}pi\u{142} b\u{142}\u{105}d podczas wykonywania operacji. Sytuacja wymaga wyja\u{15B}nienia!`
                        ]
                }
            },
            [(0, $f2bf1286956e94e0$export$2429fab72cbe576d).Returned]: {
                StateName: "Zwr\xf3cone",
                Customer: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} zosta\u{142}a anulowana przez bank. Trwa wyja\u{15B}nianie sytuacji...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `P\u{142}atno\u{15B}\u{107} zosta\u{142}a anulowana przez bank. Sytuacja wymaga wyja\u{15B}nienia!`
                        ]
                }
            }
        };
    }
    Init() {}
}



var $2s69t = parcelRequire("2s69t");


class $cac356047bc5bd7c$export$dc7fc268dd8974a9 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.ItemsIds = new (0, $2s69t.Collection)();
        this.MeetingPlace = new (0, $2s69t.RefString)();
        this.PlannedDispatchTime = new (0, $2s69t.RefDate)(new Date(0));
        this.DispatchTime = new (0, $2s69t.RefDate)(new Date(0));
        this.PaymentAtDelivery = new (0, $2s69t.RefNumber)();
        // [LEGACY]
        this.BasketSum = new (0, $2s69t.RefNumber)();
        this.DepositSum = new (0, $2s69t.RefNumber)();
        this.Training = new (0, $2s69t.RefBool)();
        this.MeetupNotes = new (0, $2s69t.RefString)();
        this.CustomerInfo = new (0, $2s69t.RefString)();
        this.State.value ||= (0, $078d5da6e339265b$export$869046988cdc7485).NotPlannedYet;
        this.ItemsIds.Load(...raw?.ItemsIds || []);
        this.MeetingPlace.value = raw?.MeetingPlace || "";
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.DispatchTime.value = new Date(raw?.DispatchTime || 0);
        this.PaymentAtDelivery.value = raw?.PaymentAtDelivery || 0;
        this.BasketSum.value = raw?.BasketSum || 0;
        this.DepositSum.value = raw?.DepositSum || 0;
        this.MeetupNotes.value = raw?.MeetupNotes || "";
        this.Training.value = raw?.Training || false;
        this.CustomerInfo.value = raw?.CustomerInfo || "";
    }
}



var $2s69t = parcelRequire("2s69t");









var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $20e1d75fe3540d0d$export$9ba739f4e3fc4d9 extends (0, $2s69t.Div) {
    constructor(rows){
        super();
        this.MarginTopBottom(8);
        this.Append(...rows.map((row)=>new (0, $2s69t.Div)("meeting-info-entry").Append(row)));
    }
}



class $bc9266c8a9fa279c$export$dcfd1673bca67f4b extends (0, $20e1d75fe3540d0d$export$9ba739f4e3fc4d9) {
    constructor(_agent, data){
        const agent = _agent.Get(data.AssignedAgentId.value);
        const sum = data.BasketSum.value + data.DepositSum.value || data.PaymentAtDelivery.value; // <--- PaymentAtDelivery is legacy
        const deposit = data.DepositSum.value;
        super([
            new (0, $2s69t.Span)(`\u{1F553} Pora spotkania: ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDayHour(data.PlannedDispatchTime)}`).When(data.PlannedDispatchTime, (v)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).IsHourSet(v), (_)=>_.Background("none"), (_)=>_.Background("#ffe5e5")),
            new (0, $2s69t.Span)(`\u{1F5FA}\u{FE0F} Miejsce odbioru: ${data.MeetingPlace.value || "jeszcze nie ustalone"}`),
            new (0, $2s69t.Span)(`\u{1F464} ${agent ? `Spotkanie z: ${agent.Name}, tel. ${agent.Phone}` : "Opiekun jeszcze nie przypisany"}`).When(data.AssignedAgentId, (v)=>!!v, (_)=>_.Background("none"), (_)=>_.Background("#ffe5e5")),
            new (0, $2s69t.Span)(sum > 0 ? `\u{1F4B0} P\u{142}atno\u{15B}\u{107} \u{142}\u{105}cznie: ${sum} z\u{142} (w tym ${deposit} z\u{142} zwrotnej kaucji), p\u{142}atne tylko got\xf3wk\u{105}` : `\u{1F4B0} Zam\xf3wienie jest ju\u{17C} op\u{142}acone`),
            new (0, $2s69t.Span)(data.Training.value ? `\u{1F393} Szkolenie odb\u{119}dzie si\u{119} na miejscu` : `\u{1F393} Bez szkolenia`)
        ]);
    }
}



var $2s69t = parcelRequire("2s69t");



class $48824674671ab1ef$export$d35482dba503c89f extends (0, $20e1d75fe3540d0d$export$9ba739f4e3fc4d9) {
    constructor(_agent, order, data){
        try {
            super([
                new (0, $da908d59f2450c72$export$d9cea58835133f4c)(order, data.ItemsIds),
                new (0, $2s69t.Span)(`\u{1F553} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDayHour(data.PlannedDispatchTime)}`).When(data.PlannedDispatchTime, (v)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).IsTimeSet(v), (_)=>_.Background("none"), (_)=>_.Background("#ffe5e5")),
                `\u{1F5FA}\u{FE0F} ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`,
                new (0, $2s69t.Span)(`\u{1F464} Agent: ${_agent.Get(data.AssignedAgentId.value)?.Name || "(jeszcze nie przypisany)"}`).When(data.AssignedAgentId, (v)=>!!v, (_)=>_.Background("none"), (_)=>_.Background("#ffe5e5")),
                `\u{1F6D2} ${data.BasketSum.value} z\u{142} + \u{1F4B0} ${data.DepositSum.value} z\u{142}`,
                `\u{1F393} ${data.Training.value ? "Ze szkoleniem" : "Bez szkolenia"}`,
                `${data.CustomerInfo.value}` // Icon included in CustomerInfo
            ]);
        } catch (ex) {
            console.error(`Error in MeetingInfoForAdmin: ${ex.message}\n\nStack trace: ${ex.stack}\n\nData:`, data);
            throw ex;
        }
    }
}






class $5a3e23156c8f8beb$export$a385700e164534ce extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PersonalPickup, this.Order.Id, "\uD83D\uDC24", "Spotkanie", this.Data.PlannedDispatchTime.value, this.IsDone)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $078d5da6e339265b$export$869046988cdc7485).MeetingOk)) {
            // LEGACY
            if (this.Data.PaymentAtDelivery.value > 0) {
                const extra = this.Data.PaymentAtDelivery.value - this.Order.DesiredDeposit;
                if (extra > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, extra, "Odbi\xf3r kasy podczas spotkania", new Date(+this.Data.DispatchTime.value || +this.Data.PlannedDispatchTime.value)));
                if (this.Order.DesiredDeposit > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedDeposit, this, this.Order.DesiredDeposit, "Odbi\xf3r kaucji podczas spotkania", new Date(+this.Data.DispatchTime.value || +this.Data.PlannedDispatchTime.value)));
            } else // CURRENT APPROACH
            {
                cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, this.Data.BasketSum.value, "Odbi\xf3r kasy podczas spotkania", new Date(+this.Data.DispatchTime.value || +this.Data.PlannedDispatchTime.value)));
                cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedDeposit, this, this.Data.DepositSum.value, "Odbi\xf3r kaucji podczas spotkania", new Date(+this.Data.DispatchTime.value || +this.Data.PlannedDispatchTime.value)));
            }
        }
        return cash;
    }
    get WhenPlanned() {
        return this.Data.PlannedDispatchTime.value;
    }
    get WhenDone() {
        return this.Data.DispatchTime.value;
    }
    constructor(_agent, Data){
        super(Data), this._agent = _agent, this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup;
        this.Icon = "\uD83D\uDC24";
        this.TitleForCustomer = ()=>`Odbi\xf3r osobisty`;
        this.Title = ()=>`Odbi\xf3r osobisty (${this.Data.MeetingPlace.value || "miejsce nieustalone"})`;
        this.InitialState = (0, $078d5da6e339265b$export$869046988cdc7485).NotPlannedYet;
        this.WellDoneStates = [
            (0, $078d5da6e339265b$export$869046988cdc7485).MeetingOk
        ];
        this.FailedDoneStates = [
            (0, $078d5da6e339265b$export$869046988cdc7485).MeetingFailed,
            (0, $078d5da6e339265b$export$869046988cdc7485).Canceled,
            (0, $078d5da6e339265b$export$869046988cdc7485).CanceledDespitePlanned
        ];
        this.STATES = {
            [(0, $078d5da6e339265b$export$869046988cdc7485).NotPlannedYet]: {
                StateName: "Jeszcze nie zaplanowane",
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `Spotkanie nie zosta\u{142}o jeszcze zaplanowane. Je\u{15B}li zbli\u{17C}a si\u{119} termin, mo\u{17C}esz do nas zadzwoni\u{107} i ustali\u{107} dogodny czas`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Czas spotkania nie zosta\u{142} jeszcze zaplanowany`,
                            new (0, $48824674671ab1ef$export$d35482dba503c89f)(this._agent, this.Order, this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Przypisz Agenta oraz ustal miejsce i czas spotkania\n`, new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedDispatchTime))
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.AssignedAgentId.value ||= (0, $fcd2bbe34e7586a6$export$f05c48a4001d5356).Default.Id;
                            this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned);
                        },
                        "\u274C": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).Canceled)
                    }
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned]: {
                StateName: `Spotkanie ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime, "(nie okre\u015Blono)", false)}`,
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Wci\u{105}\u{17C} ustalamy szczeg\xf3\u{142}y spotkania`,
                            new (0, $bc9266c8a9fa279c$export$dcfd1673bca67f4b)(this._agent, this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Szczeg\xf3\u{142}y spotkania jeszcze nie ustalone`,
                            new (0, $48824674671ab1ef$export$d35482dba503c89f)(this._agent, this.Order, this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal godzin\u{119} spotkania`, new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedDispatchTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).Planned),
                        "\u274C": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).Canceled)
                    }
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).Planned]: {
                StateName: "Spotkanie " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedDispatchTime, "(nie okre\u015Blono)", false),
                Timeout: ()=>this.Data.PlannedDispatchTime,
                Customer: {
                    Content: ()=>[
                            `Szczeg\xf3\u{142}y spotkania:`,
                            new (0, $bc9266c8a9fa279c$export$dcfd1673bca67f4b)(this._agent, this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Spotkanie zaplanowane`,
                            new (0, $48824674671ab1ef$export$d35482dba503c89f)(this._agent, this.Order, this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Czy spotkanie si\u{119} odby\u{142}o?`)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).AfterMeeting),
                        "\u274C": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).CanceledDespitePlanned)
                    }
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).AfterMeeting]: {
                StateName: "Po spotkaniu",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Ju\u{17C} po spotkaniu`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Spotkanie ju\u{17C} si\u{119} odby\u{142}o`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Wpisz numery seryjne\n`, new (0, $2s69t.TableBuilder)(this.Order.BasketItems).Class("small-table").AddColumn("Produkt", (x)=>x.ProductInfo.Name + " \xd7" + x.Quantity.value).AddColumn("Numer seryjny", (x)=>new (0, $2s69t.TextInput)(x.ProductSerialNumber)).AddColumn("Dane dost\u0119powe", (x)=>new (0, $2s69t.TextInput)(x.AccessData)).Build(), `\nKomentarz na temat spotkania:\n`, new (0, $2s69t.MultilineInput)(this.Data.MeetupNotes).Rows(4).Placeholder("Opis klienta i/lub spotkania"))
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DispatchTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).MeetingOk);
                        },
                        "\u274C": ()=>this.GoTo((0, $078d5da6e339265b$export$869046988cdc7485).MeetingFailed)
                    }
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).MeetingOk]: {
                StateName: "Spotkanie posz\u0142o dobrze",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Ju\u{17C} po spotkaniu`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Spotkanie posz\u{142}o dobrze`,
                            this.Data.MeetupNotes.value && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.Line)().MarginBottom(12), "Notatka ze spotkania:\n", new (0, $2s69t.Span)(this.Data.MeetupNotes.value).Italic()).DisplayBlock().MarginTop(16).TextAlignLeft(),
                            "\n\nPobrana got\xf3wka: " + this.Data.BasketSum.value + " z\u0142 + depozyt: " + this.Data.DepositSum.value + " z\u0142"
                        ]
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).MeetingFailed]: {
                StateName: "Spotkanie nieudane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Co\u{15B} posz\u{142}o nie tak`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Spotkanie nieudane: ${this.Data.MeetupNotes.value}`
                        ]
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).Canceled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o odwo\u{142}ane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Spotkanie zosta\u{142}o odwo\u{142}ane zanim si\u{119} odby\u{142}o`
                        ]
                }
            },
            [(0, $078d5da6e339265b$export$869046988cdc7485).CanceledDespitePlanned]: {
                StateName: "Odwo\u0142ane pomimo zaplanowania",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o odwo\u{142}ane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Spotkanie zosta\u{142}o odwo\u{142}ane pomimo zaplanowania na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.PlannedDispatchTime)}`
                        ]
                }
            }
        };
    }
    Init() {}
}



var $2s69t = parcelRequire("2s69t");


class $c85d36749eafeb9d$export$17d4face190d1b59 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.MeetingPlace = new (0, $2s69t.RefString)();
        this.PlannedMeetingTime = new (0, $2s69t.RefDate)(new Date(0));
        this.MeetingTime = new (0, $2s69t.RefDate)(new Date(0));
        this.CashToReturn = new (0, $2s69t.RefNumber)();
        this.ExtraCashToPay = new (0, $2s69t.RefNumber)();
        this.State.value ||= (0, $078d5da6e339265b$export$869046988cdc7485).NotPlannedYet;
        this.MeetingPlace.value = raw?.MeetingPlace || "";
        this.PlannedMeetingTime.value = new Date(raw?.PlannedMeetingTime || 0);
        this.MeetingTime.value = new Date(raw?.MeetingTime || 0);
        this.CashToReturn.value = raw?.CashToReturn || 0;
        this.ExtraCashToPay.value = raw?.ExtraCashToPay || 0;
    }
}










var $2s69t = parcelRequire("2s69t");

class $4ba431ee1818f704$export$a30acad4933f6971 extends (0, $2s69t.Div) {
    constructor(data){
        super();
        this.MarginTopBottom(8);
        this.Append(new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F553} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDayHour(data.PlannedMeetingTime)}`), new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F5FA}\u{FE0F} ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`), data.AssignedAgentId.value && new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F464} Agent: ${data.AssignedAgentId.value || "jeszcze nie przypisany"}`), data.CashToReturn.value > 0 && new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F4B0} ${data.CashToReturn.value} z\u{142} do zwrotu`), data.ExtraCashToPay.value > 0 && new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F4B0} ${data.ExtraCashToPay.value} z\u{142} do dop\u{142}aty`).Bold());
    }
}
class $4ba431ee1818f704$export$fe5d97bfeebb8bb8 extends (0, $2s69t.Div) {
    constructor(order, data){
        super();
        this.MarginTopBottom(8);
        this.Append(new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F553} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDayHour(data.PlannedMeetingTime)}`), new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F5FA}\u{FE0F} ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`), new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F424} ${order.People.Map((x)=>`${x.Name.value}, ${x.Phone.value}`).join("; ") || "\u26A0\uFE0F Brak danych klienta"}`), new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F464} Agent: ${data.AssignedAgentId.value || "jeszcze nie przypisany"}`), (data.CashToReturn.value > 0 || order.ReceivedDeposit > 0) && new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F4B0} ${data.CashToReturn.value} z\u{142} do zwrotu, wp\u{142}acone depozyty: ${order.ReceivedDeposit} z\u{142}`), data.ExtraCashToPay.value > 0 && new (0, $2s69t.Div)("meeting-info-entry").Text(`\u{1F4B0} ${data.ExtraCashToPay.value} z\u{142} do dop\u{142}aty`).Bold());
    }
}




var $2s69t = parcelRequire("2s69t");



var $45fvw = parcelRequire("45fvw");


class $b3e95d670de0f9ea$export$3e006b50ed27fa6 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PersonalReturn, this.Order.Id, "\uD83D\uDC25", "Zwrot", this.Data.PlannedMeetingTime.value, this.IsDone)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).MeetingOk)) {
            if (this.Data.CashToReturn.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReturnedDeposit, this, this.Data.CashToReturn.value, "Zwrot kasy podczas zwrotu sprz\u0119tu", this.Data.MeetingTime.value));
            if (this.Data.ExtraCashToPay.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, this.Data.ExtraCashToPay.value, "Dop\u0142ata podczas zwrotu sprz\u0119tu", this.Data.MeetingTime.value));
        }
        return cash;
    }
    get WhenPlanned() {
        return this.Data.PlannedMeetingTime.value;
    }
    get WhenDone() {
        return new Date(+this.Data.MeetingTime.value || +this.Data.PlannedMeetingTime.value);
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn;
        this.Icon = "\uD83D\uDC25";
        this.TitleForCustomer = ()=>`Zwrot osobisty`;
        this.Title = ()=>`Zwrot osobisty`;
        this.InitialState = (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).NotPlannedYet;
        this.WellDoneStates = [
            (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).MeetingOk,
            (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Omitted
        ];
        this.FailedDoneStates = [
            (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Canceled,
            (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).CanceledDespitePlanned
        ];
        this.STATES = {
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).NotPlannedYet]: {
                StateName: "Jeszcze nie zaplanowane",
                Timeout: ()=>this.Data.PlannedMeetingTime,
                Customer: {
                    Content: ()=>[
                            `Spotkanie nie zosta\u{142}o jeszcze zaplanowane.
Je\u{15B}li zbli\u{17C}a si\u{119} termin, mo\u{17C}esz do nas zadzwoni\u{107} i ustali\u{107} dogodny czas`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $da908d59f2450c72$export$d9cea58835133f4c)(this.Order),
                            "Zwrot od: ",
                            this.Order.PeopleAsString,
                            new (0, $2s69t.Line)(),
                            `Czas spotkania nie zosta\u{142} jeszcze zaplanowany`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal miejsce i czas spotkania razem z klientem`, new (0, $2s69t.TextInput)(this.Data.MeetingPlace).Placeholder("Miejsce spotkania").MarginBottom(4), new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedMeetingTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Planned),
                        "\u274C": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Canceled)
                    }
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Planned]: {
                StateName: "Zaplanowane",
                Timeout: ()=>this.Data.PlannedMeetingTime,
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Plan spotkania:`,
                            new (0, $4ba431ee1818f704$export$a30acad4933f6971)(this.Data)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $da908d59f2450c72$export$d9cea58835133f4c)(this.Order),
                            `\u{2611}\u{FE0F} Zaplanowane`,
                            new (0, $4ba431ee1818f704$export$fe5d97bfeebb8bb8)(this.Order, this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Czy spotkanie si\u{119} odby\u{142}o?`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.MeetingTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).MeetingOk);
                        },
                        "\uD83D\uDD51": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).NotPlannedYet),
                        "\u274C": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).CanceledDespitePlanned)
                    }
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).TimeToMeet]: {
                StateName: "Min\u0105\u0142 czas spotkania",
                Timeout: ()=>this.Data.PlannedMeetingTime,
                Customer: {
                    Content: ()=>[
                            new (0, $30ca392835935f28$export$e0b1e205bcb4a7a5)(`Czas na spotkanie min\u{105}\u{142} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.PlannedMeetingTime)}.
Um\xf3w nowe spotkanie by zwr\xf3ci\u{107} sprz\u{119}t, a je\u{15B}li chcesz przed\u{142}u\u{17C}y\u{107} rezerwacj\u{119} - daj nam zna\u{107} telefonicznie`)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $da908d59f2450c72$export$d9cea58835133f4c)(this.Order),
                            `Spotkanie nie odby\u{142}o si\u{119} cho\u{107} by\u{142}o zaplanowane na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.PlannedMeetingTime)}`,
                            new (0, $4ba431ee1818f704$export$fe5d97bfeebb8bb8)(this.Order, this.Data),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal nowy termin spotkania lub anuluj`)
                        ],
                    Actions: {
                        "\uD83D\uDD51": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).NotPlannedYet),
                        "\u274C": ()=>this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).CanceledDespitePlanned)
                    }
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).MeetingOk]: {
                StateName: "Po spotkaniu",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Ju\u{17C} po spotkaniu`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Spotkanie posz\u{142}o dobrze`,
                            new (0, $4ba431ee1818f704$export$fe5d97bfeebb8bb8)(this.Order, this.Data)
                        ]
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Canceled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o anulowane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o anulowane zanim si\u{119} odby\u{142}o`
                        ]
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).CanceledDespitePlanned]: {
                StateName: "Odwo\u0142ane pomimo zaplanowania",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o odwo\u{142}ane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Spotkanie zosta\u{142}o odwo\u{142}ane pomimo zaplanowania na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.PlannedMeetingTime)}`
                        ]
                }
            },
            [(0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Omitted]: {
                StateName: "Pomini\u0119te",
                Customer: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Spotkanie zosta\u{142}o pomini\u{119}te`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} Spotkanie zosta\u{142}o pomini\u{119}te`
                        ]
                }
            }
        };
        if (!this.IsDone) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.PlannedMeetingTime.value).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now))) this.GoTo((0, $d627bf357d1e8401$export$ea400e09cd29ee9b).TimeToMeet);
        }
    }
    Init() {}
}




var $2s69t = parcelRequire("2s69t");


class $784402037b37c56c$export$5e77184dea33ef45 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.PlannedTime = new (0, $2s69t.Ref)(new Date(0));
        this.DoneTime = new (0, $2s69t.Ref)(new Date(0));
        this.CancelationReason = new (0, $2s69t.Ref)("");
        this.State.value ||= (0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet;
        this.PlannedTime.value = this.GetDate(raw.PlannedTime);
        this.CancelationReason.value = this.GetString(raw.CancelationReason);
        this.DoneTime.value = this.GetDate(raw.DoneTime);
    }
}









var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");
function $a3d2c9cffc89f50c$export$2e6ef246283472d6(textToCopy) {
    try {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) // console.log("1111111111111");
        return new Promise((res, rej)=>{
            // navigator clipboard api method'
            try {
                navigator.clipboard.writeText(textToCopy);
                res("Success");
            } catch (error) {
                rej("Can not copy to clipboard: " + error.message);
            }
        });
        else {
            // console.log("2222222222222");
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej)=>{
                // here the magic happens
                document.execCommand('copy') ? res("Copy to clipboard succeeded") : rej("Copy to clipboard failed");
                textArea.remove();
            });
        }
    } catch (error) {
        console.error("Can not copy to clipboard: " + error.message);
        return Promise.reject("Can not copy to clipboard: " + error.message);
    // throw new Error("Can not copy to clipboard: " + error.message);
    }
}


class $9c53bb418f13342a$export$5d97bfcf36007427 extends (0, $2s69t.Span) {
    constructor(text){
        super(text + " \uD83D\uDCCB");
        this.CursorPointer();
        this.OnClick(()=>{
            (0, $a3d2c9cffc89f50c$export$2e6ef246283472d6)(text);
            new (0, $2s69t.Snack)("\uD83D\uDCCB Skopiowano do schowka", text, {
                autoCloseTimeout: 2000
            });
        });
    }
}


class $191da506753bff8b$export$5f307ceea46b293d extends (0, $2s69t.Div) {
    constructor(data){
        super();
        if (data.Version === "4.0.0") {
            this.Background("#fff3f3").Padding(12).BorderRadius(8).Border(1, "#eee", 8).MarginTop(8).TextAlignLeft();
            this.Append("Dost\u0119p do kamery ", new (0, $2s69t.Span)(data.DeviceId).Bold(), ":", new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Otw\xf3rz podgl\u0105d").Margin(8).OnClick(()=>{
                window.open(data.LaunchLink, "_blank");
            })), "lub wejd\u017A na stron\u0119:\n", new (0, $2s69t.Link)(data.LoginLink).OpenInNewCard(), "\ni wpisz: ", new (0, $9c53bb418f13342a$export$5d97bfcf36007427)(data.Password).Bold());
        }
    }
}



var $2s69t = parcelRequire("2s69t");
class $104b281a1e198271$export$b4faee6837e234d0 extends (0, $2s69t.UnorderedList) {
    constructor(order){
        super(Array.from(new Map(order.BasketItems.filter((x)=>x.ProductInfo.Tutorial).map((x)=>[
                x.ProductInfo.Tutorial,
                new (0, $2s69t.Link)(x.ProductInfo.Name, x.ProductInfo.Tutorial)
            ])).values()));
        this.TextAlignLeft().MarginTop(4);
    }
}



class $d64d9f50ce633061$export$fba5d011d7727ae6 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    // Undone is LEGACY
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).Training, this.Order.Id, "\uD83C\uDF93", "Szkolenie", this.Data.PlannedTime.value, this.IsDone)
        ];
    }
    get Mana() {
        return [];
    }
    get WhenPlanned() {
        return this.Data.PlannedTime.value;
    }
    get WhenDone() {
        return this.Data.PlannedTime.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training;
        this.Icon = "\uD83C\uDF93";
        this.TitleForCustomer = ()=>`Szkolenie`;
        this.Title = ()=>`Szkolenie`;
        this.InitialState = (0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet;
        this.WellDoneStates = [
            (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Done,
            (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self,
            (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Closed
        ];
        this.FailedDoneStates = [
            (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Cancelled,
            (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Undone
        ];
        this.STATES = {
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet]: {
                StateName: "Nie zaplanowane",
                Customer: {
                    Content: ()=>[
                            `Termin szkolenia nie zosta\u{142} jeszcze ustalony.
Je\u{15B}li zbli\u{17C}a si\u{119} termin, mo\u{17C}esz do nas zadzwoni\u{107} i ustali\u{107} dogodny czas`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Czas szkolenia nie zosta\u{142} jeszcze ustalony`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal termin szkolenia:\n\n`, new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planning),
                        "\u274C": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Canceling)
                    }
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planning]: {
                StateName: "Planowanie w toku",
                Customer: {
                    Content: ()=>[
                            `\u{1F553} Szkolenie jest w\u{142}a\u{15B}nie planowane...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Ustal termin szkolenia:\n\n`, new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planned),
                        "\u274C": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet)
                    }
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planned]: {
                StateName: "Zaplanowane",
                Timeout: ()=>this.Data.PlannedTime,
                Customer: {
                    Content: ()=>[
                            `Szkolenie wst\u{119}pnie zaplanowano na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedTime)}. Odb\u{119}dzie si\u{119} przez telefon i potrwa oko\u{142}o 10 minut`,
                            new (0, $2s69t.Line)(),
                            `Mo\u{17C}esz wst\u{119}pnie zapozna\u{107} si\u{119} z materia\u{142}ami szkoleniowymi:`,
                            new (0, $104b281a1e198271$export$b4faee6837e234d0)(this.Order),
                            new (0, $2s69t.Line)(),
                            `Je\u{15B}li masz ju\u{17C} sprz\u{119}t: zadzwo\u{144}. Im wcze\u{15B}niej go uruchomimy tym lepiej!`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Szkolenie zaplanowano na:\n${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.PlannedTime)}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Je\u{15B}li szkolenie si\u{119} odby\u{142}o - kliknij \u{2705}
Je\u{15B}li zosta\u{142}o odwo\u{142}ane - kliknij \u{274C} i podaj pow\xf3d odwo\u{142}ania`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DoneTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Done);
                        },
                        "\u274C": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Canceling)
                    }
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self]: {
                StateName: "Samoszkolenie",
                Timeout: ()=>this.Data.PlannedTime,
                Customer: {
                    Content: ()=>[
                            `Zapoznaj si\u{119} z materia\u{142}ami szkoleniowymi:`,
                            new (0, $104b281a1e198271$export$b4faee6837e234d0)(this.Order),
                            ...this.AccessInfo(this.Order)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Klient otrzyma\u{142} materia\u{142}y do samoszkolenia dla ${this.DevicesIds(this.Order).join(", ") || "(brak id urz\u0105dze\u0144)"}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Je\u{15B}li szkolenie si\u{119} odby\u{142}o - kliknij \u{2705}
Je\u{15B}li zosta\u{142}o odwo\u{142}ane - kliknij \u{274C} i podaj pow\xf3d odwo\u{142}ania`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DoneTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Done);
                        },
                        "\u274C": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Canceling)
                    }
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Done]: {
                StateName: "Wykonane",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Szkolenie zako\u{144}czone`,
                            new (0, $2s69t.Line)(),
                            `Materia\u{142}y szkoleniowe odnajdziesz tutaj:`,
                            new (0, $104b281a1e198271$export$b4faee6837e234d0)(this.Order),
                            ...this.AccessInfo(this.Order)
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Szkolenie zako\u{144}czone`
                        ]
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Canceling]: {
                StateName: "Odwo\u0142ywanie w toku",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Szkolenie jest w\u{142}a\u{15B}nie odwo\u{142}ywane...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Podaj pow\xf3d odwo\u{142}ania szkolenia (widoczny dla klienta!)`, new (0, $2s69t.MultilineInput)(this.Data.CancelationReason).Placeholder("Pow\xf3d odwo\u0142ania szkolenia").Rows(5), `
lub wr\xf3\u{107} do planowania szkolenia`)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Cancelled),
                        "\u2716\uFE0F": ()=>this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).NotPlannedYet)
                    }
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Undone]: {
                // [LEGACY]
                StateName: "Nie wykonane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Szkolenie zosta\u{142}o odwo\u{142}ane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Szkolenie zosta\u{142}o odwo\u{142}ane z powodu: ${this.Data.CancelationReason.value || "nie podano"}`
                        ]
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Cancelled]: {
                StateName: "Odwo\u0142ane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Szkolenie zosta\u{142}o odwo\u{142}ane z powodu: ${this.Data.CancelationReason.value || "nie podano"}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} Szkolenie zosta\u{142}o odwo\u{142}ane z powodu: ${this.Data.CancelationReason.value || "nie podano"}`
                        ]
                }
            },
            [(0, $724aeb46db8dbe77$export$87efff06c03ae41e).Closed]: {
                StateName: "Szkolenie zamkni\u0119te",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Szkolenie zosta\u{142}o zako\u{144}czone`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Szkolenie zosta\u{142}o zako\u{144}czone`
                        ]
                }
            }
        };
    }
    Init() {
        if (this.Order?.BasketItems?.some((x)=>x.AccessData.value)) this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Self);
        if (this.Order.IsDone) this.GoTo((0, $724aeb46db8dbe77$export$87efff06c03ae41e).Closed);
    }
    SingleAccessInfo(data) {
        return new (0, $2s69t.Switch)(data.Access).Case("TX-Watcher", ()=>new (0, $191da506753bff8b$export$5f307ceea46b293d)(data)).Default(()=>"").Execute();
    }
    AccessInfo(order) {
        return order.BasketItems.filter((x)=>x.AccessData.value).flatMap((x)=>{
            const data = JSON.parse(x.AccessData.value);
            if (Array.isArray(data)) return data.map((x)=>this.SingleAccessInfo(x));
            return this.SingleAccessInfo(data);
        });
    }
    DevicesIds(order) {
        return order.BasketItems.filter((x)=>x.AccessData.value).flatMap((x)=>{
            const data = JSON.parse(x.AccessData.value);
            return new (0, $2s69t.Switch)(data.Access).Case("TX-Watcher", ()=>data.DeviceId).Default(()=>"").Execute();
        }) ?? [];
    }
}



var $2s69t = parcelRequire("2s69t");

class $15f42115cb114856$export$f83f5981ac84d9d6 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.Start = new (0, $2s69t.RefDate)();
        this.End = new (0, $2s69t.RefDate)();
        this.StoppedBeforePlannedEnd = new (0, $2s69t.RefDate)();
        this.CancelationReason = new (0, $2s69t.RefString)();
        this.Start.value = new Date(raw.Start || 0);
        this.End.value = new Date(raw.End || 0);
        this.StoppedBeforePlannedEnd.value = new Date(raw.StoppedBeforePlannedEnd || 0);
        this.CancelationReason.value = raw.CancelationReason || "";
    }
}



var $45fvw = parcelRequire("45fvw");






var $2s69t = parcelRequire("2s69t");

class $ed50462c8ee7a718$export$cc212cd84b434059 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [];
    }
    get Mana() {
        return [];
    }
    get WhenPlanned() {
        return this.Data.Start.value;
    }
    get WhenDone() {
        return this.Data.End.value;
    }
    constructor(_agent, Data){
        super(Data), this._agent = _agent, this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Usage;
        this.Icon = "\uD83D\uDE80";
        this.TitleForCustomer = ()=>`U\u{17C}ytkowanie`;
        this.Title = ()=>`U\u{17C}ytkowanie`;
        this.InitialState = (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).BeforeStart;
        this.WellDoneStates = [
            (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).AfterEnd,
            (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).StoppedBeforePlannedEnd
        ];
        this.FailedDoneStates = [
            (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Interrupted,
            (0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Omitted
        ];
        this.STATES = {
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).BeforeStart]: {
                StateName: "Przed rozpocz\u0119ciem u\u017Cytkowania",
                Timeout: ()=>this.Data.Start,
                Customer: {
                    Content: ()=>[
                            `\u{2714}\u{FE0F} U\u{17C}ytkowanie rozpocznie si\u{119} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.Start)}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2714}\u{FE0F} Rozpocznie si\u{119} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.Start)}`,
                            new (0, $2s69t.Line)(),
                            `Okres u\u{17C}ytkowania:
`,
                            new (0, $2s69t.Text)(this.Data.Start, (v)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(v)),
                            " - ",
                            new (0, $2s69t.Text)(this.Data.End, (v)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(v)),
                            `\nTeraz jest ${(0, $b4452d9087ebde99$export$761b8f8bbc165703).NowAsString}`
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).AfterEnd),
                        "\u2716\uFE0F": ()=>this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Omitted),
                        "\u274C": ()=>this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Interrupted)
                    }
                }
            },
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).InUse]: {
                StateName: "W u\u017Cyciu",
                Timeout: ()=>this.Data.End,
                Customer: {
                    Content: ()=>[
                            `Okres u\u{17C}ytkowania trwa
od ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.Start.value).format("dddd, DD.MM.YYYY")}\ndo ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.End.value).format("dddd, DD.MM.YYYY")}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2611}\u{FE0F} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.Start)} - ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.End)}`,
                            new (0, $2s69t.Line)().Margin(8),
                            `Urz\u{105}dzenia w u\u{17C}yciu (do ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.End)}):`,
                            new (0, $2s69t.UnorderedList)(this.Order?.BasketItems?.map((x)=>x.ProductSerialNumber.value)).Margin(4),
                            new (0, $2s69t.Line)().Margin(8),
                            `U\u{17C}ytkownik: ${this.Order?.People?.First()?.AsShortString || "Nieznany u\u017Cytkownik"}`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Je\u{15B}li sprz\u{119}t zosta\u{142} zwr\xf3cony - kliknij \u{2705}
Je\u{15B}li dosz\u{142}o do awarii - kliknij \u{274C}
Je\u{15B}li zwr\xf3cony przed czasem - kliknij \u{1F6D1}`)
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).AfterEnd),
                        "\uD83D\uDED1": ()=>{
                            this.Data.StoppedBeforePlannedEnd.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).StoppedBeforePlannedEnd);
                        },
                        "\u274C": ()=>{
                            this.Data.CancelationReason.value = "Awaria";
                            this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Interrupted);
                        }
                    }
                }
            },
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).AfterEnd]: {
                StateName: "U\u017Cytkowanie zako\u0144czone",
                Customer: {
                    Content: ()=>[
                            `\u{2705} Okres u\u{17C}ytkowania zako\u{144}czy\u{142} si\u{119}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2705} Okres u\u{17C}ytkowania zako\u{144}czy\u{142} si\u{119} ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).TimeLeftTo(this.Data.End)}`,
                            new (0, $2s69t.Line)(),
                            `${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.Start)} - ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.End)}`
                        ]
                }
            },
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Omitted]: {
                StateName: "U\u017Cytkowanie pomini\u0119te",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Sprz\u{119}t nie by\u{142} u\u{17C}ywany`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Okres u\u{17C}ytkowania zosta\u{142} pomini\u{119}ty`
                        ]
                }
            },
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).StoppedBeforePlannedEnd]: {
                StateName: "U\u017Cytkowanie zako\u0144czone przed planowanym ko\u0144cem",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} U\u{17C}ytkowanie zosta\u{142}o przerwane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} U\u{17C}ytkowanie zosta\u{142}o przerwane przed planowanym zako\u{144}czeniem ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.StoppedBeforePlannedEnd.value)}`
                        ]
                }
            },
            [(0, $9b29b937dcebdfc2$export$466cc72a1090db3f).Interrupted]: {
                StateName: "U\u017Cytkowanie przerwane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} U\u{17C}ytkowanie zosta\u{142}o przerwane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `\u{274C} U\u{17C}ytkowanie zosta\u{142}o przerwane z powodu: ${this.Data.CancelationReason.value || "(nie podano)"}`
                        ]
                }
            }
        };
    }
    Init() {
        if (!this.IsDone) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.Start.value).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now))) this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).InUse);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.End.value).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now))) this.GoTo((0, $9b29b937dcebdfc2$export$466cc72a1090db3f).AfterEnd);
        }
    }
}




var $2s69t = parcelRequire("2s69t");

var $6f678fbb1497d9e5$export$feac61b26d50defd = /*#__PURE__*/ function(ManaPostalDeliveryStepState) {
    ManaPostalDeliveryStepState["Awaiting"] = "Awaiting";
    ManaPostalDeliveryStepState["Delivered"] = "Delivered";
    ManaPostalDeliveryStepState["Cancelled"] = "Cancelled";
    return ManaPostalDeliveryStepState;
}({});


class $11fa6a0db585d28b$export$305f81317becc751 extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.DeliveryDeadline = new (0, $2s69t.RefDate)(new Date(0));
        this.Amount = new (0, $2s69t.RefNumber)(0);
        this.DeliveryTime = new (0, $2s69t.RefDate)(new Date(0));
        this.State.value ||= (0, $6f678fbb1497d9e5$export$feac61b26d50defd).Awaiting;
        this.DeliveryDeadline.value = this.GetDate(raw?.DeliveryDeadline);
        this.Amount.value = this.GetNumber(raw?.Amount);
        this.DeliveryTime.value = this.GetDate(raw?.DeliveryTime);
    }
}










var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");


class $2371209a2ea270f8$export$9353f3e4f7727dad extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).ManaPostalDelivery, this.Order.Id, "\uD83D\uDCB0", "Przekaz pieni\u0119\u017Cny", this.Data.DeliveryDeadline.value, this.IsDone, false)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $6f678fbb1497d9e5$export$feac61b26d50defd).Delivered)) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, this.Data.Amount.value, "Przekaz pieni\u0119\u017Cny", new Date(+this.Data.DeliveryTime.value || +this.Data.DeliveryDeadline.value)));
        return cash;
    }
    get WhenPlanned() {
        return this.Data.DeliveryDeadline.value;
    }
    get WhenDone() {
        return new Date(+this.Data.DeliveryTime.value || +this.Data.DeliveryDeadline.value);
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).ManaPostalDelivery;
        this.Icon = "\uD83D\uDCB0";
        this.TitleForCustomer = ()=>``;
        this.Title = ()=>`Przekaz pieni\u{119}\u{17C}ny`;
        this.IsVisibleForCustomer = false;
        this.InitialState = (0, $6f678fbb1497d9e5$export$feac61b26d50defd).Awaiting;
        this.WellDoneStates = [
            (0, $6f678fbb1497d9e5$export$feac61b26d50defd).Delivered
        ];
        this.FailedDoneStates = [];
        this.STATES = {
            [(0, $6f678fbb1497d9e5$export$feac61b26d50defd).Awaiting]: {
                StateName: "Oczekuje",
                Timeout: ()=>this.Data.DeliveryDeadline,
                Admin: {
                    Content: ()=>[
                            `Pieni\u{105}dze (${this.Data.Amount.value} z\u{142}) powinny zosta\u{107} dostarczone przez listonosza pod adres nadania do mniej wi\u{119}cej ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(this.Data.DeliveryDeadline)} (o ile paczka zosta\u{142}a nadana i odebrana)`,
                            new (0, $2s69t.Line)(),
                            `Number paczki jest widoczny w kroku Wysy\u{142}ki`,
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Kliknij ptaszka je\u{15B}li pieni\u{105}dze dotar\u{142}y.
Je\u{15B}li nie - sprawd\u{17A} czy w skrzynce nie ma awiza.
Wci\u{15B}ni\u{119}cie X powoduje przesuni\u{119}cie daty kolejnego sprawdzenia o 7 dni`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.DeliveryTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $6f678fbb1497d9e5$export$feac61b26d50defd).Delivered);
                        },
                        "\u274C": ()=>{
                            this.Data.DeliveryDeadline.value = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.Data.DeliveryDeadline.value).clone().add(7, "day").toDate();
                            this.GoTo((0, $6f678fbb1497d9e5$export$feac61b26d50defd).Awaiting);
                        }
                    }
                }
            },
            [(0, $6f678fbb1497d9e5$export$feac61b26d50defd).Delivered]: {
                StateName: "Dostarczone",
                Admin: {
                    Content: ()=>[
                            `Pieni\u{105}dze dostarczone (${this.Data.Amount.value} z\u{142}) \u{2705}`
                        ]
                }
            },
            [(0, $6f678fbb1497d9e5$export$feac61b26d50defd).Cancelled]: {
                StateName: "Odwo\u0142ane",
                Admin: {
                    Content: ()=>[
                            `Anulowano dostarczenie (paczka zosta\u{142}a zwr\xf3cona b\u{105}d\u{17A} wyst\u{105}pi\u{142} inny problem)`
                        ]
                }
            }
        };
    }
    Init() {}
}



var $2s69t = parcelRequire("2s69t");


class $2866531eb55940df$export$85dcf78d20868c2c extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.InvoiceNumber = new (0, $2s69t.RefString)("");
        this.CompanyName = new (0, $2s69t.RefString)("");
        this.CompanyAddress = new (0, $2s69t.RefString)("");
        this.CompanyNIP = new (0, $2s69t.RefString)("");
        this.CompanyEmail = new (0, $2s69t.RefString)("");
        this.DeliveryDeadline = new (0, $2s69t.RefDate)(new Date(0));
        this.SentAt = new (0, $2s69t.RefDate)(new Date(0));
        this.State.value ||= (0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Preparing;
        this.InvoiceNumber.value = this.GetString(raw?.InvoiceNumber);
        this.CompanyName.value = this.GetString(raw?.CompanyName);
        this.CompanyAddress.value = this.GetString(raw?.CompanyAddress);
        this.CompanyNIP.value = this.GetString(raw?.CompanyNIP);
        this.CompanyEmail.value = this.GetString(raw?.CompanyEmail);
        this.DeliveryDeadline.value = this.GetDate(raw?.DeliveryDeadline);
        this.SentAt.value = this.GetDate(raw?.SentAt);
    }
}








var $1lG8E = parcelRequire("1lG8E");

class $a2d49a710d43b6f9$export$b25ec6a36edaebe5 extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).Invoice, this.Order.Id, "\uD83D\uDDC3\uFE0F", "Faktura", this.Data.DeliveryDeadline.value, this.IsDone)
        ];
    }
    get Mana() {
        return [];
    }
    get WhenPlanned() {
        return this.Data.DeliveryDeadline.value;
    }
    get WhenDone() {
        return this.Data.SentAt.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Invoice;
        this.Icon = "\uD83D\uDDC3\uFE0F";
        this.TitleForCustomer = ()=>`Faktura`;
        this.Title = ()=>`Faktura`;
        this.InitialState = (0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Preparing;
        this.WellDoneStates = [
            (0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Sent
        ];
        this.FailedDoneStates = [];
        this.STATES = {
            [(0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Preparing]: {
                StateName: "Przygotowywanie",
                Timeout: ()=>this.Data.DeliveryDeadline,
                Customer: {
                    Content: ()=>[
                            `Faktura jest w\u{142}a\u{15B}nie przygotowywana`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            `Faktura wymaga przygotowania`,
                            new (0, $1lG8E.Table)().Class("payment-info-table").AddRow("Nazwa firmy", this.Data.CompanyName.value).AddRow("Adres", this.Data.CompanyAddress.value).AddRow("NIP", this.Data.CompanyNIP.value).AddRow("Kwota", "").AddRow("Tytu\u0142em", ""),
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Przygotuj dokument i wy\u{15B}lij do klienta na adres ${this.Data.CompanyEmail.value}`)
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.SentAt.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Sent);
                        }
                    }
                }
            },
            [(0, $59209e03fc7e50d4$export$7364ac5b612dd7f5).Sent]: {
                StateName: "Wys\u0142ane",
                Admin: {
                    Content: ()=>[
                            `Faktura wys\u{142}ana \u{2705}`
                        ]
                }
            }
        };
        this.IsVisibleForCustomer = false;
    }
    Init() {}
}



var $2s69t = parcelRequire("2s69t");






var $ae0608f3ec47f242$export$e4ac77bdc8b18d0e = /*#__PURE__*/ function(EventStepState) {
    EventStepState["Preparing"] = "Preparing";
    EventStepState["Incoming"] = "Incoming";
    EventStepState["Executing"] = "Executing";
    EventStepState["Executed"] = "Executed";
    EventStepState["Canceled"] = "Canceled";
    EventStepState["Omitted"] = "Omitted";
    return EventStepState;
}({});





class $4935cec9c62bbacf$export$ef068860dc9a279e extends (0, $0e0f6b9683ce33a7$export$fd55ce593607084a) {
    get AsEvents() {
        return [
            new (0, $4f5bc0eca7827453$export$8a8cb838e5d6584d)((0, $4f5bc0eca7827453$export$19ce097d7421ac9a).Event, this.Order.Id, "\u26A1", this.Data.Title.value, this.Data.PlannedTime.value, this.IsDone, this.Data.VisibleForCustomer.value)
        ];
    }
    get Mana() {
        const cash = [];
        if (this.Data.State.Is((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executed)) {
            if (this.Data.Profit.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome, this, this.Data.Profit.value, "Profit", new Date(+this.Data.ExecutionTime.value)));
            if (this.Data.Cost.value > 0) cash.push(new (0, $4156b0a6006d5d4e$export$66b83811e15e705)((0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).Expense, this, this.Data.Cost.value, "Koszt", new Date(+this.Data.ExecutionTime.value)));
        }
        return cash;
    }
    get WhenPlanned() {
        return this.Data.PlannedTime.value;
    }
    get WhenDone() {
        return this.Data.ExecutionTime.value;
    }
    constructor(Data){
        super(Data), this.Data = Data;
        this.Type = (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Event;
        this.Icon = "\u26A1";
        this.TitleForCustomer = ()=>this.Data.Title.value;
        this.Title = ()=>this.Data.Title.value;
        this.InitialState = (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Preparing;
        this.WellDoneStates = [
            (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executed,
            (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Omitted
        ];
        this.FailedDoneStates = [
            (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Canceled
        ];
        this.STATES = {
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Preparing]: {
                StateName: "W przygotowaniu",
                Customer: {
                    Content: ()=>[
                            `W przygotowaniu...`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            new (0, $025f09358f3e6650$export$f8cd55916d491bc2)(`Dodaj informacje o zdarzeniu:\n\n`, new (0, $2s69t.Checkbox)(this.Data.VisibleForCustomer, "Widoczne dla klienta"), new (0, $2s69t.TextInput)(this.Data.Title).Placeholder("Tytu\u0142 zadania"), new (0, $2s69t.MultilineInput)(this.Data.Info).Rows(3).Placeholder("Informacja o zadaniu (widoczna r\xf3wnie\u017C dla klienta)"), "\nPlanowane na: ", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(this.Data.PlannedTime))
                        ],
                    Actions: {
                        "\u2705": ()=>this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Incoming),
                        "\u274C": ()=>this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Canceled)
                    }
                }
            },
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Incoming]: {
                StateName: "Zaplanowane",
                Timeout: ()=>this.Data.PlannedTime,
                Customer: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            +this.Data.PlannedTime.value > 0 && `\u{2611}\u{FE0F} Zaplanowane na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.PlannedTime)}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            `\u{2611}\u{FE0F} Zaplanowane na ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.PlannedTime)}`
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.ExecutionTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executed);
                        },
                        "\u274C": ()=>this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Canceled)
                    }
                }
            },
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executing]: {
                StateName: "W toku",
                Customer: {
                    Content: ()=>[
                            `Zadanie jest w\u{142}a\u{15B}nie realizowane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            this.Data.Info.value,
                            ` - jest w trakcie realizacji`
                        ],
                    Actions: {
                        "\u2705": ()=>{
                            this.Data.ExecutionTime.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now;
                            this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executed);
                        },
                        "\u274C": ()=>this.GoTo((0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Canceled)
                    }
                }
            },
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Executed]: {
                StateName: "Zrealizowane",
                Customer: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            `\u{2705} Zrealizowane ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.ExecutionTime)}`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            `\u{2705} Zrealizowane ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(this.Data.ExecutionTime)}`
                        ]
                }
            },
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Canceled]: {
                StateName: "Anulowane",
                Customer: {
                    Content: ()=>[
                            `\u{274C} Anulowane`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            `\u{274C} Anulowane`
                        ]
                }
            },
            [(0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Omitted]: {
                StateName: "Pomini\u0119te",
                Customer: {
                    Content: ()=>[
                            `\u{2716}\u{FE0F} Pomini\u{119}te`
                        ]
                },
                Admin: {
                    Content: ()=>[
                            this.Data.Info.value,
                            new (0, $2s69t.Line)(),
                            `\u{2716}\u{FE0F} Pomini\u{119}te`
                        ]
                }
            }
        };
    }
    Init() {}
}



var $2s69t = parcelRequire("2s69t");


class $85073184c1843252$export$7f63643d7461afa extends (0, $cadaa643bff02d98$export$7e24ee426ea2ba10) {
    constructor(raw){
        super(raw);
        this.Title = new (0, $2s69t.RefString)();
        this.Info = new (0, $2s69t.RefString)();
        this.VisibleForCustomer = new (0, $2s69t.RefBool)();
        this.PlannedTime = new (0, $2s69t.RefDate)();
        this.ExecutionTime = new (0, $2s69t.RefDate)();
        this.Cost = new (0, $2s69t.RefNumber)();
        this.Profit = new (0, $2s69t.RefNumber)();
        this.State.value ||= (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Preparing;
        this.Title.value = raw?.Title || "";
        this.Info.value = raw?.Info || "";
        this.VisibleForCustomer.value = raw?.VisibleForCustomer || false;
        this.PlannedTime.value = new Date(raw?.PlannedTime || 0);
        this.ExecutionTime.value = new Date(raw?.ExecutionTime || 0);
        this.Cost.value = raw?.Cost || 0;
        this.Profit.value = raw?.Profit || 0;
    }
}


class $f017c95ae7521c79$export$f77d2c4be60c7eb6 {
    constructor(_agents){
        this._agents = _agents;
        this.StepsLabels = {
            "\uD83D\uDED2 Zam\xf3wienie": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket,
            "\u26A1 Zdarzenie": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Event,
            "\uD83D\uDCB3 P\u0142atno\u015B\u0107": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment,
            "\uD83D\uDCE6 Wysy\u0142ka do klienta": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer,
            "\uD83D\uDC24 Odbi\xf3r osobisty": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup,
            "\uD83C\uDF93 Szkolenie": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training,
            "\uD83D\uDE80 U\u017Cytkowanie": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Usage,
            "\uD83D\uDCE6 Zwrot paczk\u0105": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer,
            "\uD83D\uDCB0 Przekaz pieni\u0119\u017Cny": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).ManaPostalDelivery,
            "\uD83D\uDC24 Zwrot osobisty": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn,
            "\uD83D\uDCB8 Zwrot kasy": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn,
            "\uD83D\uDCC3 Faktura": (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Invoice
        };
    }
    Create(type, data) {
        if (!data) data = {
            CreatedAt: (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now
        };
        switch(type){
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket:
                return new (0, $ada1238ad66e65c1$export$56c7a80eb69f85c5)(new (0, $994f84c2b62ba58d$export$4baa03b03d776143)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer:
                return new (0, $05a2f6c5fdd71a8d$export$84e947a9b1fcf723)(new (0, $ac3a730131a31431$export$8d038cf3aa43077e)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer:
                return new (0, $832fe0c89941a741$export$8be2db734204e7bc)(new (0, $9ffad913acbd6c78$export$a01c43ce3cd4f57b)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup:
                return new (0, $5a3e23156c8f8beb$export$a385700e164534ce)(this._agents, new (0, $cac356047bc5bd7c$export$dc7fc268dd8974a9)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn:
                return new (0, $b3e95d670de0f9ea$export$3e006b50ed27fa6)(new (0, $c85d36749eafeb9d$export$17d4face190d1b59)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training:
                return new (0, $d64d9f50ce633061$export$fba5d011d7727ae6)(new (0, $784402037b37c56c$export$5e77184dea33ef45)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment:
                return new (0, $a94d12eadcdd8dd0$export$20c36f2f8fe0d441)(new (0, $a4751a13f69f4714$export$127c4655001e678f)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn:
                return new (0, $31813e7e41bded08$export$e8feeb28ee4fd095)(new (0, $a4751a13f69f4714$export$127c4655001e678f)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Usage:
                return new (0, $ed50462c8ee7a718$export$cc212cd84b434059)(this._agents, new (0, $15f42115cb114856$export$f83f5981ac84d9d6)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).ManaPostalDelivery:
                return new (0, $2371209a2ea270f8$export$9353f3e4f7727dad)(new (0, $11fa6a0db585d28b$export$305f81317becc751)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Invoice:
                return new (0, $a2d49a710d43b6f9$export$b25ec6a36edaebe5)(new (0, $2866531eb55940df$export$85dcf78d20868c2c)(data));
            case (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Event:
                return new (0, $4935cec9c62bbacf$export$ef068860dc9a279e)(new (0, $85073184c1843252$export$7f63643d7461afa)(data));
            default:
                throw new Error(`Unknown Step type "${type}"`);
        }
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");


class $5d309aa59c698e61$export$8c7d9cff2b84c862 extends (0, $2s69t.Div) {
    constructor(order, showTotalPrice = true){
        super();
        const items = order.BasketItems;
        const totalPrice = order.BasketValue + "z\u0142";
        const totalDeposit = order.DesiredDeposit + "z\u0142";
        this.Append(...items.map((x)=>new (0, $b18a2e4cac71d5d9$export$614b56d11b894a09)(x)), order.Notes.Customer.value && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(order.Notes.Customer.value).Class("user-note-in-table-view").OnClick(()=>new (0, $2s69t.ModalWindow)(`Notatka klienta do zam\xf3wienia #${order.ShortId}`, false, false, true).AddContent(order.Notes.Customer.value).OpenWindow()), showTotalPrice && new (0, $2s69t.Div)().Text(totalPrice + " + " + totalDeposit + ", zni\u017Cki: " + (order.Meta?.Ticket?.BasketInfo?.Discounts?.length || "brak")).Style(`border-top: 1px dashed #ccc; color: #999; width: 82%; margin: 2px auto 0; text-align: center; font-size: 12px`));
    }
}
class $5d309aa59c698e61$export$b3b616c12869a148 extends (0, $2s69t.Div) {
    constructor(order, showTotalPrice = true){
        super();
        const items = order.BasketItems;
        const totalPrice = order.BasketValue + "z\u0142";
        const totalDeposit = order.DesiredDeposit + "z\u0142";
        this.Append(new (0, $2s69t.Div)("tab-content__title").Text("Produkty w koszyku"), new (0, $2s69t.Div)("tab-content__list").Append(...items.map((x)=>new (0, $b18a2e4cac71d5d9$export$b4a5267eabb26439)(x))), showTotalPrice && new (0, $2s69t.Div)().Text(totalPrice + " + " + totalDeposit).Style(`border-top: 1px dashed #ccc; color: #aaa; width: 82%; margin: 2px auto 0; text-align: center; font-size: 12px`));
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
class $64a0643c247794e6$export$d9b273488cd8ce6f extends (0, $2s69t.Div) {
    constructor(menuItems, onClose){
        super("menu-popup"), this.onClose = onClose;
        // ☢️ UWAGA! TO MA BYĆ FUNKCJA (NIE METODA) JEŚLI ZROBIMY Z TEGO METODĘ TO NIE DZIAŁA document.removeEventListener. 
        // NIE WAŻNE CZY DO TEJ METODY PRZEKAŻEMY WSKAŹNIK NA METODE, WYWOŁANIE FUNKCJI STRZAŁKOWEJ CZY ZROBIMY .bind(this). 
        // KAŻDA TA OPCJA NIE DZIAŁA CO POTEM POWODUJE PROBLEMY Z RemoveSelf BO JEST TRACONY KONTEKST DO this. 
        // MOŻNA OD BIEDY WSPOMÓC SIĘ POMOCNICZĄ FLAGĄ ALE TAK KOD JEST CZYSTSZY CHOĆ WYGLĄDA KRETYŃSKO.
        this.DocumentClick = ()=>{
            this.RemoveSelf();
            this.onClose?.();
        };
        this.Append(...Object.entries(menuItems).map(([label, action])=>{
            const span = new (0, $2s69t.Span)(label).Class("menu-item").OnClick(()=>{
                document.removeEventListener("click", this.DocumentClick);
                this.RemoveSelf();
                this.onClose?.();
                action();
            });
            return span;
        }));
        document.addEventListener("click", this.DocumentClick, {
            once: true
        });
    }
}
class $64a0643c247794e6$export$8dc6765e8be191c7 extends (0, $2s69t.Div) {
    constructor(menuItems, activator = new (0, $2s69t.Button)("\u22EE").RemoveClass("uk-button").Class("menu-button")){
        super();
        this.Append(activator.OnClick((_)=>{
            _.Disabled();
            this.Append(new $64a0643c247794e6$export$d9b273488cd8ce6f(menuItems, ()=>{
                _.Enabled();
            }));
        }));
    }
}



class $4ede64fc95701179$export$2568696a315cc05d extends (0, $2s69t.Div) {
    constructor(_router, _manager, orders, order){
        super();
        this.DisplayInlineBlock().Margin(8).MinWidth(180).PositionRelative();
        this.Append(new (0, $64a0643c247794e6$export$8dc6765e8be191c7)({
            "\uD83D\uDC41\uFE0F Zobacz": ()=>_router.GoToOrderView(order.Id),
            "\uD83D\uDCDD Edytuj": ()=>_router.GoToOrderEdit(order.Id),
            "\uD83C\uDF56 Raw": ()=>_router.GoToOrderRawEdit(order.Id),
            "\uD83D\uDC40 Widok klienta": ()=>_router.GoToCustomerView(order.Id),
            "\uD83D\uDC95 Duplikuj": async ()=>{
                const newOrder = await _manager.Duplicate(order);
                new (0, $2s69t.Snack)(`\u{2611}\u{FE0F} Zam\xf3wienie #${order.ShortId} zosta\u{142}o zduplikowane jako #${newOrder.ShortId}`, "Nowe zam\xf3wienie jest gotowe do edycji");
                _router.GoToOrderEdit(newOrder.Id);
            },
            "\uD83D\uDDD1\uFE0F Usu\u0144": async ()=>{
                if (confirm(`Czy na pewno chcesz usun\u{105}\u{107} to zam\xf3wienie ${order.ShortId}?`)) {
                    await _manager.Delete(order);
                    orders.Collection.Remove(order); // TODO: gdyby kolekcja siedziała w menadżerze to nie trzeba by tej linijki...
                }
            },
            "\uD83D\uDD04 Regeneruj": ()=>_router.GoToOrderCreate(order.Id),
            "\uD83D\uDCC2 Archiwizuj": async ()=>{
                if (confirm("Czy na pewno chcesz archiwizowa\u0107 to zam\xf3wienie?")) {
                    await _manager.Close(order);
                    new (0, $2s69t.Snack)(`\u{2611}\u{FE0F} Zam\xf3wienie #${order.ShortId} zosta\u{142}o zarchiwizowane`);
                    orders.Collection.Remove(order);
                }
            }
        }).DisplayInlineBlock(), new (0, $2s69t.Span)("#" + order.ShortId).MarginLeft(8).CursorPointer().Style(order.IsClosed ? "text-decoration: line-through;" : "").OnClick(()=>_router.GoToOrderView(order.Id)), new (0, $2s69t.Div)().Append("\uD83D\uDC49 " + order.CurrentState).FontSize(12).Color("#444"), new (0, $2s69t.Div)().Text(`\u{1F423} Utworzone ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).HowLongAgo(order.Meta.CreatedAt)}
\u{26A1} Aktualizowane ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).HowLongAgo(order.Meta.UpdatedAt, "jeszcze nie aktualizowany")}`).FontSize(12).Color("#666").MarginTop(4).PaddingTop(4), order.Notes.Private.value && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.Span)("PRYWATNA NOTATKA").Bold(), new (0, $2s69t.Line)().Margin(4), order.Notes.Private.value).Class("private-note-in-table-view").OnClick(()=>new (0, $2s69t.ModalWindow)(`Notatka prywatna do zam\xf3wienia #${order.ShortId}`, false, false, true).AddContent(order.Notes.Private.value).OpenWindow()), order.Notes.Public.value && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.Span)("NOTATKA PUBLICZNA").Bold(), new (0, $2s69t.Line)().Margin(4), order.Notes.Public.value).Class("public-note-in-table-view").OnClick(()=>new (0, $2s69t.ModalWindow)(`Notatka publiczna do zam\xf3wienia #${order.ShortId}`, false, false, true).AddContent(order.Notes.Public.value).OpenWindow()));
    }
}



var $2s69t = parcelRequire("2s69t");

class $58b77af9dd8fd18e$export$19190b657a342936 extends (0, $2s69t.Div) {
    constructor(order){
        super();
        this.Append(...order.People.Items.map((x)=>new (0, $d43ea8c6f445c3d4$export$60938ba9f9a17048)({
                Content: [
                    x.AsString
                ]
            })));
    }
}



var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");
var $c177bbc21544856e$export$81262d6ca0162a3 = /*#__PURE__*/ function(StepState) {
    StepState["Unknown"] = "Unknown";
    StepState["Initial"] = "Initial";
    StepState["InProgress"] = "InProgress";
    StepState["WellDone"] = "WellDone";
    StepState["Failed"] = "Failed";
    return StepState;
}({});




class $8c41aca7699fc583$export$5e7c26e7042271fe {
    get IsBeforeCurrent() {
        return !this.IsUnDone && !this.IsCurrent;
    }
    get IsAfterCurrent() {
        return this.IsUnDone && !this.IsCurrent;
    }
    get IsDone() {
        return this.Step.IsWellDone || this.Step.IsFailedDone;
    }
    get IsUnDone() {
        return !this.Step.IsWellDone && !this.Step.IsFailedDone;
    }
    constructor(Step){
        this.Step = Step;
        this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).Unknown;
        this.IsCurrent = false;
        if (Step.IsInInitialState) this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).Initial;
        else if (Step.IsInProgress) this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).InProgress;
        else if (Step.IsWellDone) this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).WellDone;
        else if (Step.IsFailedDone) this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).Failed;
        else this.State = (0, $c177bbc21544856e$export$81262d6ca0162a3).Unknown;
    }
    get StateAsIcon() {
        switch(this.State){
            case (0, $c177bbc21544856e$export$81262d6ca0162a3).Failed:
                return "\u274C";
            case (0, $c177bbc21544856e$export$81262d6ca0162a3).WellDone:
                return "\u2705";
            case (0, $c177bbc21544856e$export$81262d6ca0162a3).InProgress:
                return "\u2714\uFE0F";
            // ☑️ 
            case (0, $c177bbc21544856e$export$81262d6ca0162a3).Initial:
                return "\uD83D\uDD5C";
            default:
                return "\u2753";
        }
    }
}


class $2b9446962095951e$export$c036ee88a093a80c {
    static Mark(steps) {
        const marked = [];
        let allowSetCurrent = true;
        let index = 1;
        for (const step of steps){
            const wrapped = new (0, $8c41aca7699fc583$export$5e7c26e7042271fe)(step);
            // wrapped.CurrentIndex = index;
            // wrapped.StepsCount = steps.length;
            if (wrapped.State == (0, $c177bbc21544856e$export$81262d6ca0162a3).Failed) {
                marked.forEach((x)=>x.IsCurrent = false); // Remove current so far
                wrapped.IsCurrent = true;
                allowSetCurrent = false;
            }
            // else
            if (wrapped.IsUnDone && allowSetCurrent) {
                wrapped.IsCurrent = true;
                allowSetCurrent = false;
            }
            marked.push(wrapped);
            index++;
        }
        return marked;
    }
}






class $7a7a9a2fbff2720e$export$c104cc1d0386efa extends (0, $2s69t.Div) {
    constructor(steps){
        super(), this.steps = steps;
        this.FontSize(12);
        const markedSteps = (0, $2b9446962095951e$export$c036ee88a093a80c).Mark(this.steps.Items);
        for (const step of markedSteps){
            const label = new (0, $2s69t.Span)(`${step.Step.GetTitleForCustomer()} ${step.StateAsIcon} ${step.Step.GetStateName()}`).Style("white-space: nowrap;");
            const secondsLeft = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(step.Step.Timeout).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now), 'seconds');
            const warning = secondsLeft > 0 ? "Wygasa za " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormatDuration(secondsLeft) : "\uD83D\uDFE0 Wygas\u0142o " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormatDuration(-secondsLeft) + " temu";
            const entryInfo = {
                Content: [
                    label
                ],
                ExtraInfo: []
            };
            if (warning && step.IsCurrent && secondsLeft != 0) entryInfo.ExtraInfo.push(warning);
            const entry = new (0, $d43ea8c6f445c3d4$export$440dddd12bf7bb92)(entryInfo);
            if (step.IsCurrent) entry.Style("background-color: #def7ff;");
            if (step.State == (0, $c177bbc21544856e$export$81262d6ca0162a3).Failed) entry.Style("background-color: #ffe6e8;");
            if (step.IsAfterCurrent) entry.Style("opacity: 0.6;");
            if (step.Step.Type != (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training) {
                if (secondsLeft < -259200) entry.Style("border: 3px solid #f6f10c");
            }
            this.Append(entry);
        }
    }
}



var $2s69t = parcelRequire("2s69t");

var $1lG8E = parcelRequire("1lG8E");
class $0ac1beb9675d6626$export$386e296787a6cbf1 extends (0, $1lG8E.Table) {
    constructor(order){
        super([], [
            [
                "Warto\u015B\u0107 koszyka",
                order.BasketValue + " z\u0142"
            ],
            [
                "Rzeczywiste wp\u0142aty",
                order.ReceivedIncome + " z\u0142"
            ],
            [
                "Docelowa kaucja",
                order.DesiredDeposit + " z\u0142"
            ],
            [
                "Wp\u0142acona kaucja",
                order.ReceivedDeposit + " z\u0142"
            ],
            [
                "Zwr\xf3cona kaucja",
                order.ReturnedDeposit + " z\u0142"
            ],
            [
                "Koszty",
                order.Expenses + " z\u0142"
            ],
            [
                "Profit",
                new (0, $2s69t.Span)(order.Profit + " z\u0142").Bold()
            ]
        ]);
    }
} // export class MoneyListSummaryForCustomer extends Table
 // {
 //     constructor(order: Order)
 //     {
 //         super([], [
 //             ["Wartość koszyka", order.BasketValue + " zł"],
 //             ["Rzeczywiste wpłaty", order.ReceivedIncome + " zł"],
 //             ["Docelowa kaucja", order.DesiredDeposit + " zł"],
 //             ["Wpłacona kaucja", order.ReceivedDeposit + " zł"],
 //             ["Zwrócona kaucja", order.ReturnedDeposit + " zł"],
 //         ])
 //     }
 // }


class $fa6c33cfa4cce153$export$b3c27e869d856b7 extends (0, $2s69t.Div) {
    constructor(_router, _manager, orders){
        super(), this._router = _router, this._manager = _manager;
        this.TextAlignLeft();
        const profitSum = new (0, $2s69t.RefNumber)();
        orders.OnChange(()=>profitSum.value = orders.Items.reduce((acc, order)=>acc + order.Profit, 0), true);
        this.Append(new (0, $2s69t.TableBuilder)(orders).MarginTop(16).AddColumn(new (0, $2s69t.Text)(orders.FilteredCount, (v)=>v + " \u0142\u0105cznie"), (order)=>new (0, $4ede64fc95701179$export$2568696a315cc05d)(this._router, this._manager, orders, order)).AddColumn("\uD83D\uDED2 Zam\xf3wienie", (order)=>new (0, $5d309aa59c698e61$export$8c7d9cff2b84c862)(order)).AddColumn("\uD83D\uDC3E Kroki", (order)=>new (0, $7a7a9a2fbff2720e$export$c104cc1d0386efa)(order.Steps)).AddColumn("\uD83D\uDC65 Ludzie", (order)=>new (0, $58b77af9dd8fd18e$export$19190b657a342936)(order)).AddColumn(new (0, $2s69t.Text)(profitSum, (v)=>`\u{1F4B0} Kasa (${v} z\u{142})`), (order)=>new (0, $0ac1beb9675d6626$export$386e296787a6cbf1)(order).Class("tight-table").FontSize(12)).ForEachRow((row, order)=>this.SetColorRow(row, order)).Build());
    }
    SetColorRow(row, order) {
        if (order.Meta.IsNew) row.Background("#ffffdb");
        else if (order.IsDone) row.Background("#e9ffe9");
        else row.Background("");
    }
}



var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");




class $59680bdde9a14d77$export$9570723381ca8f3b {
    constructor(Name, Title){
        this.Name = Name;
        this.Title = Title;
        this.Items = [];
    }
    get Size() {
        return this.Items.length;
    }
    Add(item) {
        this.Items.push(item);
    }
}



var $435e5a76b8cbc27c$export$70972b93d6090c4 = /*#__PURE__*/ function(BagName) {
    BagName["Today"] = "now";
    BagName["Past"] = "past";
    BagName["Future"] = "future";
    BagName["Inprogress"] = "inprogress";
    BagName["Other"] = "other";
    BagName["Rejected"] = "rejected";
    BagName["Insignificant"] = "insignificant";
    BagName["Tomorrow"] = "Tomorrow";
    return BagName;
}({});
class $435e5a76b8cbc27c$export$f98e131e69dbe944 {
    constructor(){
        this.Bags = [
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("now", "Na dzisiaj"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("past", "Zaleg\u0142e"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("Tomorrow", "Na jutro"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("future", "Na p\xf3\u017Aniej"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("inprogress", "W toku"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("rejected", "Odrzucone"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("insignificant", "Ma\u0142o istotne"),
            new (0, $59680bdde9a14d77$export$9570723381ca8f3b)("other", "Inne")
        ];
    }
    get BagsNames() {
        return this.Bags.map((bag)=>bag.Name);
    }
    PutTo(bagName, item) {
        const bag = this.Bags.find((bag)=>bag.Name === bagName);
        if (bag) bag.Add(item);
    }
    PutToBag(step) {
        const timeout = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(step.Step.Timeout);
        if (!step.Step.HasTimeout) {
            this.PutTo("other", step);
            return;
        }
        const tillTimeout = step.Step.HoursToTimeout;
        const afterTimeout = step.Step.HoursAfterTimeout;
        if (step.Step.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Usage || step.Step.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer && step.Step.Data.State.Is((0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit) || step.Step.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer && step.Step.Data.State.Is((0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).OnTheWay)) this.PutTo("inprogress", step);
        else if (timeout.isSame((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now, "date")) this.PutTo("now", step);
        else if (timeout.isSame((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().add(1, "day"), "date")) this.PutTo("Tomorrow", step);
        else if (afterTimeout && afterTimeout > 168) this.PutTo("past", step);
        else if (step.Step.Data.State.Is((0, $2a037d32327b8a8b$export$754efc3e3034943f).Rejected)) this.PutTo("rejected", step);
        else if (step.Step.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket) this.PutTo("now", step);
        else if (tillTimeout === undefined) this.PutTo("insignificant", step);
        else if (tillTimeout < 0) this.PutTo("past", step);
        else if (timeout.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now).clone().add(1, "day"), "date")) this.PutTo("future", step);
        else this.PutTo("other", step);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");


class $0d301638d645fc71$export$cca3a30a97b7f3e6 {
    get HasTimeout() {
        const t = this.timeout instanceof (0, $2s69t.Ref) ? this.timeout.value : this.timeout;
        return !!t && +t > 0;
    }
    Dispose() {
        clearInterval(this.timer);
    }
    constructor(timeout){
        this.timeout = timeout;
        this.timer = void 0;
        this.printer = new (0, $2s69t.Ref)("");
        if (!this.timeout) return;
        const t = this.timeout instanceof (0, $2s69t.Ref) ? this.timeout.value : this.timeout;
        const SecondsLeft = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(t).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now), 'seconds');
        const Label = ()=>{
            const secondsLeft = SecondsLeft();
            return secondsLeft > 0 ? `Wygasa za ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormatDuration(secondsLeft)}` : `\u{1F7E0} Wygas\u{142}o ${(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormatDuration(secondsLeft)} temu`;
        };
        this.timer = setInterval(()=>{
            this.printer.value = Label();
        }, 1000);
        this.printer.value = Label();
    }
    get ExpiresIn() {
        return this.printer;
    }
}



var $2s69t = parcelRequire("2s69t");
class $21424b9765c1f064$export$b7aabc9c05052a5f extends (0, $2s69t.Div) {
    constructor(step, afterExecute){
        super();
        this.MarginBottom(12);
        const actions = step.GetActions();
        if (actions) this.Append(...Object.entries(actions).map(([label, action])=>new (0, $2s69t.Button)(label, async ()=>{
                await action();
                afterExecute();
            }).Class("uk-button uk-button-default").MarginLeft(4)));
    }
}



class $40bb09c767c260dc$export$358ebd1afec01362 extends (0, $64a0643c247794e6$export$8dc6765e8be191c7) {
    constructor(_router, _agents, step, openInlineEditor, refresh){
        super({
            "\uD83D\uDC41\uFE0F Poka\u017C zam\xf3wienie": ()=>{
                _router.GoToOrderView(step.Order.Id);
            },
            "\uD83D\uDCDD Edytuj zam\xf3wienie": ()=>{
                _router.GoToOrderEdit(step.Order.Id);
            },
            "\uD83D\uDC53 Widok klienta": ()=>{
                _router.GoToCustomerView(step.Order.Id);
            },
            "\u2622\uFE0F Resetuj krok": ()=>{
                step.ResetState();
                refresh?.();
            },
            "\uD83C\uDF9B\uFE0F Edycja kroku": ()=>{
                openInlineEditor.Toggle();
            },
            "\uD83D\uDD75\uFE0F Przypisz agenta": ()=>{
                this.Append(new (0, $64a0643c247794e6$export$d9b273488cd8ce6f)(this.AgentsList(_agents, step, refresh)));
            }
        });
        this.PositionAbsolute().Top(24).Right(8);
    }
    AgentsList(_agents, step, refresh) {
        const agentsToAssignMenu = _agents.All.reduce((acc, x)=>({
                ...acc,
                [x.Icon + " " + x.Name]: ()=>{
                    step.Data.AssignedAgentId.value = x.Id;
                    step.CallOnChange();
                    refresh?.();
                }
            }), {});
        if (step.Data.AssignedAgentId.value) agentsToAssignMenu["(nie przypisany)"] = ()=>{
            step.Data.AssignedAgentId.value = "";
            step.CallOnChange();
            refresh?.();
        };
        return agentsToAssignMenu;
    }
}



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");
class $a6f9ac4860e2927f$export$4d82ce4c37371892 extends (0, $2s69t.Div) {
    constructor(text){
        super();
        this.Style(`font-size: 16px; 
            color: #1e87f0; 
            text-align:left; 
            padding: 8px; 
            margin-top: 16px; 
            padding: 4px 16px;
            border-top: 2px dashed #1e87f044;`);
        this.Text(text);
    }
}
class $a6f9ac4860e2927f$export$7f82016a969fb9d2 extends (0, $2s69t.Div) {
    constructor(text, cmps){
        super();
        this.Style(`font-size: 22px; 
            color: #1e87f0; 
            background: #effbff;
            text-align:left; 
            padding: 8px; 
            margin-top: 32px;
            padding: 4px 16px;
            border-top: 4px solid #1e87f0;`);
        this.Append(text, cmps && new (0, $2s69t.Div)().Append(...cmps));
    }
}





const $d8b90477cbcae015$export$a98ac09e56a5ecee = (name)=>name;
class $d8b90477cbcae015$export$8e9df03dc5899c9f extends (0, $2s69t.Div) {
    constructor(step, showSaveButton = true){
        super(), this.step = step;
        this.Append(...Object.entries(step.Data).map(([key, value])=>{
            const label = new (0, $a6f9ac4860e2927f$export$4d82ce4c37371892)(key).Padding(4).Margin(4).MarginBottom(0).BorderNone();
            let input = undefined;
            if (key === $d8b90477cbcae015$export$a98ac09e56a5ecee("State")) input = new (0, $2s69t.Select)(step.Data.State, step.AllStates);
            else if (value instanceof (0, $2s69t.Ref)) {
                if (value.value instanceof Date) input = new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(value);
                else switch(typeof value.value){
                    case "string":
                        input = new (0, $2s69t.MultilineInput)(value).Rows(1);
                        break;
                    case "number":
                        input = new (0, $2s69t.NumberInput)(value);
                        break;
                    case "boolean":
                        input = new (0, $2s69t.Checkbox)(value);
                        break;
                    default:
                        input = new (0, $2s69t.Span)(value.value);
                        break;
                }
            } else if (value instanceof Date) input = new (0, $2s69t.Span)((0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(value));
            else if (Array.isArray(value)) input = new (0, $2s69t.JsonViewer)((0, $2s69t.RefSerializer).Flatenize(value));
            else if (value instanceof (0, $2s69t.Collection)) input = new (0, $2s69t.JsonViewer)((0, $2s69t.RefSerializer).Flatenize(value.Items));
            if (input) input.Background("#fff").Margin(8); //.WidthPercent(95).MarginTop(0)
            return new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(label, input).WidthPercent(100).TextAlignLeft();
        }), showSaveButton && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $514335b6e811f7d2$export$ac16a6a04d9b7c84)("Zapisz").OnClick(()=>{
            this.step.CallOnChange();
        })).Margin(8));
    }
}



var $2s69t = parcelRequire("2s69t");

class $c78fe1cdd6ea5710$export$de59616a9ae7b44 extends (0, $2s69t.Div) {
    constructor(_agents, _router, step, refresh){
        super("agent-box");
        const agentLabel = new (0, $2s69t.Text)(step.Data.AssignedAgentId, (v)=>{
            const agent = _agents.Get(v);
            return agent ? agent.AsString : "Agent nie przypisany";
        });
        agentLabel.OnClick(()=>{
            const agentsToAssignMenu = this.BuildAgentsList(_agents, step, refresh);
            this.Append(new (0, $64a0643c247794e6$export$d9b273488cd8ce6f)(agentsToAssignMenu));
        });
        agentLabel.On("dblclick", ()=>{
            _router.GoToAgentTasks(step.Data.AssignedAgentId.value);
        });
        this.Append(agentLabel);
    }
    BuildAgentsList(_agents, step, refresh) {
        const agentsToAssignMenu = _agents.All.Items.reduce((acc, x)=>({
                ...acc,
                [x.AsString]: ()=>{
                    step.Data.AssignedAgentId.value = x.Id;
                    step.CallOnChange();
                    refresh();
                }
            }), {});
        if (step.Data.AssignedAgentId.value) agentsToAssignMenu["(nie przypisany)"] = ()=>{
            step.Data.AssignedAgentId.value = "";
            step.CallOnChange();
            refresh();
        };
        return agentsToAssignMenu;
    }
}



class $a146cad85d56a538$export$81d6b4cdbf702e82 extends (0, $2s69t.Div) {
    constructor(_router, _agents, step){
        super("step-box admin-view"), this._router = _router, this._agents = _agents, this.step = step;
        this.timer = new (0, $0d301638d645fc71$export$cca3a30a97b7f3e6)(this.step.Step.Timeout);
        this.showEdit = new (0, $2s69t.RefBool)(false);
        this.Refresh();
        if (!step.Step.IsVisibleForCustomer) this.BorderStyle("dashed");
        if (step.Step.HoursAfterTimeout && step.Step.HoursAfterTimeout > 168) this.Background("lightyellow").BorderColor("darkyellow");
    }
    async OnRemove() {
        this.timer?.Dispose();
    }
    Refresh() {
        const step = this.step.Step;
        const agentBox = new (0, $c78fe1cdd6ea5710$export$de59616a9ae7b44)(this._agents, this._router, step, ()=>this.Refresh());
        this.Clear().Append(new (0, $40bb09c767c260dc$export$358ebd1afec01362)(this._router, this._agents, step, this.showEdit, ()=>this.Refresh()), new (0, $2s69t.Div)("step-content").Append(// new Span("#" + step.Order.Id.slice(-5) + " | " + step.Data.State.value + " till " + TimeUtils.FormattedDateTime(step.Timeout)).FontSize(12).Italic().PositionAbsolute().Top(0).Left(8),
        // new Span("#" + step.Order.ShortId + " | " + step.GetStateName() + " do " + TimeUtils.FormattedDateTime(step.Timeout)).FontSize(12).Italic().PositionAbsolute().Top(0).Left(8).Color("#ccc"),
        new (0, $2s69t.Div)().TextAlignLeft().Append(new (0, $2s69t.Span)(step.GetFullTitle()).Class("step-title")), // !this._agents.IsItMe(step.Data.AssignedAgentId.value) &&
        agentBox, new (0, $2s69t.Div)("step-description").Append(...step.GetAdminContent()), new (0, $d8b90477cbcae015$export$8e9df03dc5899c9f)(this.step.Step).Visible(this.showEdit)), new (0, $2s69t.Div)("step-footer").Append(new (0, $21424b9765c1f064$export$b7aabc9c05052a5f)(step, ()=>this.Refresh()), this.timer?.HasTimeout && new (0, $2s69t.Text)(this.timer.ExpiresIn).Class("step-footer-text"), !this.timer?.HasTimeout && step.WhenDone && new (0, $2s69t.Span)("Zako\u0144czono " + (0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDateTime(step.WhenDone)).Class("step-footer-text")));
    }
}
class $a146cad85d56a538$export$411b928d8bd6d9b6 extends (0, $2s69t.Div) {
    constructor(_router, _agents, step){
        super("step-box-v2"), this._router = _router, this._agents = _agents, this.step = step;
        // super("");
        // this.TextAlignCenter()
        this.timer = new (0, $0d301638d645fc71$export$cca3a30a97b7f3e6)(this.step.Step.Timeout);
        this.showEdit = new (0, $2s69t.RefBool)(false);
        this.Refresh();
        if (!step.Step.IsVisibleForCustomer) this.BorderStyle("dashed");
        if (step.Step.HoursAfterTimeout && step.Step.HoursAfterTimeout > 168) this.Background("lightyellow").BorderColor("darkyellow");
    }
    async OnRemove() {
        this.timer?.Dispose();
    }
    StatusIcon(step) {
        if (step.IsDone) return "\uD83D\uDFE2";
        if (step.IsCurrent) return "\uD83D\uDD35";
        return "\u26AA\uFE0F";
    }
    Refresh() {
        const step = this.step.Step;
        const agentBox = new (0, $c78fe1cdd6ea5710$export$de59616a9ae7b44)(this._agents, this._router, step, ()=>this.Refresh());
        const folded = new (0, $2s69t.RefBool)(false);
        this.Clear().Append(// new AdminStepPrinterMenu(this._router, this._agents, step, this.showEdit, () => this.Refresh()),
        new (0, $2s69t.Div)("step-content vertical").Append(new (0, $2s69t.Span)(this.StatusIcon(this.step) + " " + step.Title()).Class("step-title").OnClick((_)=>folded.Toggle()), // !this._agents.IsItMe(step.Data.AssignedAgentId.value) && agentBox,
        new (0, $2s69t.Div)("step-description").Append(...step.GetAdminContent()).Visible(folded)), new (0, $2s69t.Div)("step-footer").Append(new (0, $21424b9765c1f064$export$b7aabc9c05052a5f)(step, ()=>this.Refresh()), this.timer?.HasTimeout && new (0, $2s69t.Text)(this.timer.ExpiresIn).Class("step-timeout")).Visible(folded));
    }
}




class $6bc63868dca0f0ab$export$29191413860a7fcb extends (0, $2s69t.Div) {
    constructor(bag, _router, _agents){
        super();
        this.Append(new (0, $2s69t.Div)("bag-header").Text(bag.Title).Append(new (0, $2s69t.Span)(bag.Size.toString()).Class("items-in-bag-count")), new (0, $2s69t.Div)("blocks-container").Append(...bag.Items.map((step)=>new (0, $a146cad85d56a538$export$81d6b4cdbf702e82)(_router, _agents, step))), bag.Size == 0 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(`Brak zada\u{144}`).Italic().Color("#ccc"));
    }
}
class $6bc63868dca0f0ab$export$8013acab62007000 extends (0, $2s69t.Div) {
    constructor(_router, _manager, _agents, orders){
        super("TodoView");
        const stepsOrganizer = new (0, $435e5a76b8cbc27c$export$f98e131e69dbe944)();
        orders.Items.forEach((order)=>{
            order.OnChange(async ()=>{
                await _manager.Update(order);
                new (0, $2s69t.Snack)(`Zam\xf3wienie #${order.ShortId} zaktualizowane`);
            });
            const steps = order.Steps.Items;
            const markedSteps = (0, $2b9446962095951e$export$c036ee88a093a80c).Mark(steps);
            const currentStep = markedSteps.find((x)=>x.IsCurrent);
            if (currentStep) stepsOrganizer.PutToBag(currentStep);
        });
        // stepsOrganizer.BagsNames.map(bag =>
        //     this.Append(
        //         new Div("bag-header").Text(stepsOrganizer.BagsTitles[bag])
        //             .Append(new Span(stepsOrganizer.bags[bag].length.toString()).Class("items-in-bag-count")),
        //         new Div("blocks-container").Append(
        //             ...stepsOrganizer.bags[bag].map(step => new AdminStepPrinter(_router, _agents, step))
        //         ),
        //         stepsOrganizer.bags[bag].length == 0 && new Center(`Brak zadań ${stepsOrganizer.BagsTitles[bag].toLowerCase()}`).Italic().Color("#aaa")
        //     )
        // );
        this.Append(...stepsOrganizer.Bags.map((bag)=>new $6bc63868dca0f0ab$export$29191413860a7fcb(bag, _router, _agents)));
    }
}



var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

var $45fvw = parcelRequire("45fvw");


class $8ff0ea4b1a8cd723$export$5b98606decb8931e extends (0, $2s69t.Div) {
    get AsDate() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().year(this.year.value).month(this.month.value).date(1);
    }
    OnChange(handler) {
        this.onChange.Add(handler);
    }
    constructor(startAt){
        super("MonthSwitcher"), this.startAt = startAt;
        this.month = new (0, $2s69t.Ref)(this.startAt?.getMonth() || 0).Storable("month");
        this.year = new (0, $2s69t.Ref)(this.startAt?.getFullYear() || new Date().getFullYear()).Storable("year");
        this.MonthsNames = [
            "Stycze\u0144",
            "Luty",
            "Marzec",
            "Kwiecie\u0144",
            "Maj",
            "Czerwiec",
            "Lipiec",
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            "Listopad",
            "Grudzie\u0144"
        ];
        this.onChange = new (0, $2s69t.HandlersCollection)();
        this.month.OnChange((v)=>this.onChange.Call(v, this.year.value));
        this.year.OnChange((v)=>this.onChange.Call(this.month.value, v));
        this.Append(new (0, $aa6902a8d95be5a7$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left-icon lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg>`).OnClick(()=>{
            if (this.month.value <= 0) {
                this.year.value--;
                this.month.value = 11;
                return;
            }
            this.month.value--;
        }).FloatLeft() //.Margin(4)
        , new (0, $2s69t.Text)(this.month, (v)=>this.MonthsNames[+v]).FontSize(16).OnClick(()=>{
            this.month.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now.getMonth();
            this.onChange.Call(this.month.value, this.year.value);
        }), new (0, $2s69t.Text)(this.year).Margin(12).FontSize(16).OnClick(()=>{
            this.year.value = (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now.getFullYear();
            this.onChange.Call(this.month.value, this.year.value);
        }), new (0, $aa6902a8d95be5a7$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>`).OnClick(()=>{
            if (this.month.value >= 11) {
                this.year.value++;
                this.month.value = 0;
                return;
            }
            this.month.value++;
        }).FloatRight() //.Margin(4)
        );
    }
}


class $0fccb80f67f714eb$export$e1aef45b828286de extends (0, $2s69t.Div) {
    get Switcher() {
        return this.monthSwitcher;
    }
    OnDayClick(handler) {
        this.onDayClick.Add(handler);
        return this;
    }
    constructor(entries){
        super("calendar"), this.entries = entries;
        this.grid = new (0, $2s69t.Div)("calendar-grid");
        this.monthSwitcher = new (0, $8ff0ea4b1a8cd723$export$5b98606decb8931e)(this.entries[0]?.Date);
        this.onDayClick = new (0, $2s69t.HandlersCollection)();
        this.monthSwitcher.OnChange((v)=>this.Refresh());
        const header = new (0, $2s69t.Div)("calendar-header").Append(this.monthSwitcher);
        const daysHeader = new (0, $2s69t.Div)("calendar-days").Append(...[
            "Pn",
            "Wt",
            "\u015Ar",
            "Cz",
            "Pt",
            "So",
            "Nd"
        ].map((day)=>new (0, $2s69t.Div)("day-name").Text(day)));
        this.Append(header, daysHeader, this.grid);
        this.Refresh();
    }
    Refresh() {
        this.grid.Clear();
        // Previous month days
        const firstDayOfMonth = this.monthSwitcher.AsDate.date(1);
        for(let i = firstDayOfMonth.weekday(); i > 0; i--){
            this.monthSwitcher.AsDate.subtract(1, "month").daysInMonth() //+ firstDayOfMonth.weekday() 
            ;
            this.monthSwitcher.AsDate.subtract(1, "month").format("MMM");
            const dayDiv = new (0, $2s69t.Div)("calendar-day inactive");
            /////////////    .Text(d.toString() + " " + mn);    
            this.grid.Append(dayDiv);
        }
        // Current month days
        for(let i = 1; i <= this.DaysInSelectedMonth; i++){
            const dayDiv = new (0, $2s69t.Div)("calendar-day").Append(new (0, $2s69t.Div)("day").Text(i.toString())).OnClick(()=>this.onDayClick.Call((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.monthSwitcher.AsDate).date(i).toDate()));
            const ddd = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.monthSwitcher.AsDate).date(i);
            if (ddd.isSame((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now), 'day')) dayDiv.Class("today");
            if (ddd.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now), 'day')) dayDiv.Class("inactive");
            const thisDayEntries = this.entries.filter((event)=>ddd.isSame((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(event.Date), 'date'));
            if (thisDayEntries.length > 0) dayDiv.Append(new (0, $2s69t.Div)().Append(...thisDayEntries.flatMap((x)=>x.Content?.())));
            this.grid.Append(dayDiv);
        }
        // Next month days
        const lastDayInThisMonth = this.DaysInSelectedMonth;
        const lastWeekdayInThisMonth = this.monthSwitcher.AsDate.date(lastDayInThisMonth).weekday();
        let dayIndex = 1;
        for(let i = lastWeekdayInThisMonth + 1; i < 7; i++){
            this.monthSwitcher.AsDate.add(1, "month").format("MMM");
            this.grid.Append(new (0, $2s69t.Div)("calendar-day inactive"));
            dayIndex++;
        }
    }
    get DaysInSelectedMonth() {
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][this.monthSwitcher.month.value];
    }
}


class $647f7db927945362$export$ef69cdfc3b05ef04 {
    constructor(Date, Content){
        this.Date = Date;
        this.Content = Content;
    }
}



var $2s69t = parcelRequire("2s69t");

class $628dffcca82552a6$export$9efdbbf545e98d8c extends (0, $dca4a10ada8bf906$export$e71c4d32a2263218) {
    constructor(_router, event){
        super(event.Icon), this._router = _router, this.event = event;
        this.PositionRelative().Margin(4);
        this.OnClick(()=>this._router.GoToOrderView(this.event.OrderId));
        this.Append(new (0, $2s69t.Span)(this.event.IsDone ? "\u2705" : "").FontSize(10).PositionAbsolute().Top(-4).Right(-4));
    }
}



class $a6400e9f03245c9c$export$b573856c46cc9357 extends (0, $2s69t.Div) {
    constructor(_router, orders){
        super(), this._router = _router, this.orders = orders;
        this.TextAlignCenter();
        // const filter = new RefString().Storable("calendar-filter");
        const allOrdersEvents = this.orders.Items.flatMap((order)=>order.AsEvents).filter((x)=>[
                (0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PackageToCustomer,
                (0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PersonalPickup,
                (0, $4f5bc0eca7827453$export$19ce097d7421ac9a).PersonalReturn
            ].includes(x.Type));
        const calendarEntries = allOrdersEvents.map((event)=>new (0, $647f7db927945362$export$ef69cdfc3b05ef04)(event.Date, ()=>[
                    new (0, $628dffcca82552a6$export$9efdbbf545e98d8c)(this._router, event)
                ]));
        this.Append(// new Select(filter, { "Wszystkie": "all", "Ważne": "important" }),
        new (0, $0fccb80f67f714eb$export$e1aef45b828286de)(calendarEntries));
    }
}



var $2s69t = parcelRequire("2s69t");





var $45fvw = parcelRequire("45fvw");


class $d2f9d688d82c8ed8$export$ac31bf1fefce2165 extends (0, $2s69t.Div) {
    constructor(orders){
        super(), this.orders = orders;
        this.TextAlignCenter();
        const incomes = this.orders.Items.flatMap((order)=>order.Mana([
                (0, $8a44b9b3a048a72c$export$1dc22a502a1e0e7).ReceivedIncome
            ]));
        // const total = incomes.reduce((acc, income) => acc + income.Amount, 0);
        const total = this.orders.Items.reduce((acc, order)=>acc + order.Profit, 0);
        const incomesByDay = incomes.reduce((acc, income)=>{
            const dateKey = income.When.toDateString();
            if (!acc[dateKey]) acc[dateKey] = [];
            acc[dateKey].push(income);
            return acc;
        }, {});
        const calendarEntries = Object.entries(incomesByDay).map(([date, incomes])=>new (0, $647f7db927945362$export$ef69cdfc3b05ef04)(new Date(date), ()=>{
                let content = [];
                const dayTotal = incomes.reduce((acc, income)=>acc + income.Amount, 0);
                if (dayTotal > 0) content.push(new (0, $2s69t.Span)("+" + dayTotal + " z\u0142").Class("uk-badge").FontSize(15));
                return content;
            }));
        const calendar = new (0, $0fccb80f67f714eb$export$e1aef45b828286de)(calendarEntries);
        this.Append("Uwaga! To \u017Ale liczy! Do poprawki!", calendar, new (0, $2s69t.Span)(total + " z\u0142").Class("uk-badge").FontSize(20));
    }
}
class $d2f9d688d82c8ed8$export$acf1acf464ab52d8 extends (0, $2s69t.Div) {
    constructor(_manager){
        super(), this._manager = _manager;
        this.TextAlignCenter();
    }
    async OnAppend() {
        const open = await this._manager.FetchAll((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
        const closed = await this._manager.FetchAll((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed);
        const orders = new (0, $2s69t.Collection)(open.concat(closed).sort((a, b)=>+b.Meta.CreatedAt - +a.Meta.CreatedAt));
        const assumedProfit = orders.Items.reduce((acc, order)=>acc + order.BasketValue, 0);
        const totalProfit = orders.Items.reduce((acc, order)=>acc + order.Profit, 0);
        const profitByDay = [];
        orders.Items.filter((x)=>x.FinishedAt).forEach((order)=>{
            const dateKey = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.FinishedAt);
            const day = profitByDay.find((x)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(x.Day).isSame(dateKey, "day"));
            if (day) day.Orders.push(order);
            else profitByDay.push({
                Day: dateKey.toDate(),
                Orders: [
                    order
                ]
            });
        });
        const calendarEntries = profitByDay.map((x)=>new (0, $647f7db927945362$export$ef69cdfc3b05ef04)(x.Day, ()=>[
                    new (0, $2s69t.Span)(x.Orders.filter((x)=>x.FinishedAt).reduce((acc, order)=>acc + order.Profit, 0) + " z\u0142" + " (" + x.Orders.length + ")").Class("uk-badge").FontSize(15)
                ]));
        const profitByMonth = [];
        orders.Items.filter((x)=>x.FinishedAt).forEach((order)=>{
            const m = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.FinishedAt).format("YYYY-MM");
            const month = profitByMonth.find((x)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(x.Month).format("YYYY-MM") === m);
            if (month) month.Orders.push(order);
            else profitByMonth.push({
                Month: m,
                Orders: [
                    order
                ]
            });
        });
        this.Append(new (0, $2s69t.TableBuilder)(profitByMonth).TextAlignRight().AddColumn("Miesi\u0105c", (x)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(x.Month).format("MM.YYYY"))// .AddColumn("Orders", x => x.Orders.length + `: ${x.Orders.map(o => (o.IsDone ? "✅" : "🕐") + o.ShortId).join(", ")}`)
        .AddColumn("Orders", (x)=>x.Orders.length).AddColumn("Profit", (x)=>{
            const sum = x.Orders.reduce((acc, order)=>acc + order.Profit, 0);
            return (0, $a7cae6c3d344e899$export$ecc754f99843e759).FormatMoney(sum);
        }).Build().Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(), new (0, $0fccb80f67f714eb$export$e1aef45b828286de)(calendarEntries), new (0, $2s69t.TableBuilder)(profitByDay.sort((a, b)=>+b.Day - +a.Day)).TextAlignLeft().AddColumn("Data", (x)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(x.Day)).AddColumn("Orders", (x)=>x.Orders.length + `: ${x.Orders.map((o)=>(o.IsDone ? "\u2705" : "\uD83D\uDD50") + o.ShortId).join(", ")}`).AddColumn("Profit", (x)=>{
            const profit = x.Orders.reduce((acc, order)=>acc + order.Profit, 0);
            const basketValue = x.Orders.reduce((acc, order)=>acc + order.BasketValue, 0);
            return profit + " z\u0142 / " + basketValue + " z\u0142";
        }).Build().Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(), new (0, $2s69t.TableBuilder)(orders).AddColumn("Zam\xf3wienie", (x)=>new (0, $2s69t.Link)(x.ShortId, `#admin/order/view/${x.Id}`)).AddColumn("Status", (record, row)=>{
            row.Background(record.IsDone ? "#e6ffe6" : "#e6f0fa");
            return record.Status;
        }).AddColumn("Szacowany profit", (x)=>x.BasketValue + " z\u0142").AddColumn("Profit", (x)=>x.Profit + " z\u0142").AddColumn("Kiedy", (x)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(x.Meta.CreatedAt)).Build().Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(), "\n\n", new (0, $2s69t.Span)(totalProfit + " z\u0142").Class("uk-badge").FontSize(20), " z ", new (0, $2s69t.Span)(assumedProfit + " z\u0142").FontSize(20), "\n\n\n");
    }
}



var $45fvw = parcelRequire("45fvw");

var $2s69t = parcelRequire("2s69t");










class $5e8029f20eba1d84$export$77bc526bfccc9372 {
    constructor(StepType, Orders){
        this.StepType = StepType;
        this.Orders = Orders;
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $9f73b3c5c75cffcc$export$a0d381ba5db17436 extends (0, $2s69t.Link) {
    constructor(order){
        super("#" + order.ShortId, "#admin/order/view/" + order.Id);
    }
}


class $0ce55df113330941$export$6d1a1bdc239bbd62 extends (0, $2s69t.Div) {
    constructor(order){
        super();
        this.Append(new (0, $9f73b3c5c75cffcc$export$a0d381ba5db17436)(order), " - ", order.CurrentStateForAdmin);
        this.Margin(6).Background("#fff").DisplayInlineBlock().BorderRadius(16).Padding(4, 12).MarginLeft(12);
    }
}



class $96d495c1b2c64f86$export$601a9d23acaa58d1 extends (0, $2s69t.Div) {
    constructor(title, tasks){
        super();
        this.Width(360).BorderRadius(16).Background("#fff").Padding(16);
        this.Append(new (0, $a6f9ac4860e2927f$export$7f82016a969fb9d2)(title).MarginBottom(4).MarginTop(0).Bold().BorderNone().Background("none"));
        tasks.filter((t)=>t.Orders.length > 0).forEach((task)=>{
            // const stepName = task.Orders[0].CurrentStep?.GetTitleForCustomer() || "---";
            const stepName = (0, $8eef7e9c8ac4e085$export$591e9e81bba96c12)[task.StepType] ?? "---";
            this.Append(new (0, $a6f9ac4860e2927f$export$4d82ce4c37371892)(stepName).MarginBottom(4).Bold(), ...task.Orders.map((order)=>new (0, $0ce55df113330941$export$6d1a1bdc239bbd62)(order)));
        });
    }
}


class $8009c7b67425bcdb$export$689b82a1511cd27b extends (0, $2s69t.Div) {
    GroupAndFilter(orders, filterAndOrder) {
        const allowedSteps = Object.keys(filterAndOrder);
        const tasks = [
            ...allowedSteps.map((stepType)=>new (0, $5e8029f20eba1d84$export$77bc526bfccc9372)(stepType, []))
        ];
        orders.forEach((order)=>{
            const step = order.CurrentStep;
            if (!step) return;
            if (!allowedSteps.includes(step.Type)) return;
            const allowedStates = filterAndOrder[step.Type];
            if (!allowedStates?.includes(step.Data.State.value)) return;
            const task = tasks.find((t)=>t.StepType === step.Type);
            task?.Orders?.push(order);
        });
        return tasks;
    }
    constructor(orders){
        super(), this.orders = orders;
        const openOrders = this.orders.Filter((x)=>x.IsOpen && !x.IsFailed);
        const bags = {
            today: [],
            tomorrow: [],
            future: [],
            earlier: []
        };
        openOrders.forEach((order)=>{
            const step = order.CurrentStep;
            if (!step) return;
            const timeout = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(step?.Timeout);
            const now = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))((0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
            const tomorrow = now.clone().add(1, "day");
            if (timeout.isSame(now, "date")) bags.today.push(order);
            else if (timeout.isSame(tomorrow, "date")) bags.tomorrow.push(order);
            else if (timeout.isAfter(tomorrow, "date")) bags.future.push(order);
            else bags.earlier.push(order);
        });
        const filterAndOrder = {
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket]: [
                (0, $2a037d32327b8a8b$export$754efc3e3034943f).New
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer]: [
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).Planned,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).LabelReady,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).ReadyToShipment,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).AwaitingInPostOffice,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).PackageLost,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).InTransit,
                (0, $0928cc6340f2c462$export$3fda4618fcb351f4).StillOnTheWay
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup]: [
                (0, $078d5da6e339265b$export$869046988cdc7485).PrePlanned,
                (0, $078d5da6e339265b$export$869046988cdc7485).Planned
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalReturn]: [
                (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).Planned,
                (0, $d627bf357d1e8401$export$ea400e09cd29ee9b).TimeToMeet
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Training]: [
                (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planned,
                (0, $724aeb46db8dbe77$export$87efff06c03ae41e).Planning
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment]: [
                (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn]: [
                (0, $f2bf1286956e94e0$export$2429fab72cbe576d).Awaiting
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Event]: [
                (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Incoming,
                (0, $ae0608f3ec47f242$export$e4ac77bdc8b18d0e).Preparing
            ],
            [(0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageFromCustomer]: [
                (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).TimeToSend,
                (0, $f3df16e20c2ea059$export$5d0a8a6aa6ce8cef).OnTheWay
            ]
        };
        const groupedForToday = this.GroupAndFilter(bags.today, filterAndOrder);
        const groupedForTomorrow = this.GroupAndFilter(bags.tomorrow, filterAndOrder);
        const groupedForFuture = this.GroupAndFilter(bags.future, filterAndOrder);
        const groupedForEarlier = this.GroupAndFilter(bags.earlier, filterAndOrder);
        this.Style(`display: flex; flex-direction: row; flex-wrap: wrap; gap: 32px; padding: 16px`).Append(new (0, $96d495c1b2c64f86$export$601a9d23acaa58d1)("Zaleg\u0142e", groupedForEarlier), new (0, $96d495c1b2c64f86$export$601a9d23acaa58d1)("Na dzisiaj", groupedForToday).Background("#e3f8ff"), new (0, $96d495c1b2c64f86$export$601a9d23acaa58d1)("Na jutro", groupedForTomorrow), new (0, $96d495c1b2c64f86$export$601a9d23acaa58d1)("Na p\xf3\u017Aniej", groupedForFuture));
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
var $b1bf926166be94d7$export$c20edc3521983dfc = /*#__PURE__*/ function(DiscountType) {
    DiscountType["Percent"] = "percent";
    DiscountType["LimitedPercent"] = "limited-percent";
    DiscountType["FixedPrice"] = "fixed-price";
    return DiscountType;
}({});
class $b1bf926166be94d7$export$b6e0323406a427eb extends (0, $2s69t.Div) {
    constructor(order){
        super("");
        const discounts = order.Meta?.Ticket?.BasketInfo?.Discounts;
        if (discounts?.length === 0) {
            this.Append("Brak zni\u017Cek");
            return;
        }
        this.Append(`Ilo\u{15B}\u{107} zni\u{17C}ek: ${discounts?.length || 0}`, new (0, $2s69t.UnorderedList)(discounts?.map((x)=>this.DiscountToString(x))).MarginTop(8));
    }
    DiscountToString(discount) {
        if (discount.Type === "percent") return `${discount.Code}: ${discount.Name}: -${discount.Value}%`;
        else if (discount.Type === "limited-percent") return `${discount.Code}: ${discount.Name}: -${discount.Value}% (limit: ${discount.Limit} z\u{142})`;
        else if (discount.Type === "fixed-price") return `${discount.Code}: ${discount.Name}: -${discount.Value} z\u{142}`;
        return `discount type not supported: ${discount.Type} (code: ${discount.Code}, name: ${discount.Name}, value:${discount.Value}, limit: ${discount.Limit})`;
    }
}




class $f0841b8ce43f7a14$export$928836a6e1d219f8 extends (0, $2s69t.Div) {
    constructor(orders){
        super(), this.orders = orders;
        const originsCount = {};
        this.orders.Items.forEach((order)=>{
            const origin = order.People.First()?.Origin?.value?.trim() || "(brak \u017Ar\xf3d\u0142a)";
            originsCount[origin] = (originsCount[origin] || 0) + 1;
        });
        const origins = Object.entries(originsCount).map(([origin, count])=>({
                origin: origin,
                count: count
            }));
        this.Append(new (0, $2s69t.TableBuilder)(origins).AddColumn("\u0179r\xf3d\u0142o", (x)=>x.origin).AddColumn("Ilo\u015B\u0107", (x)=>x.count).AddColumn("Procent", (x)=>(x.count / this.orders.Items.length * 100).toFixed(0) + "%").Build().Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(), new (0, $2s69t.Line)(), new (0, $2s69t.TableBuilder)(this.orders).AddColumn("Zam\xf3wienie", (x)=>new (0, $2s69t.Link)(x.ShortId, `#admin/order/view/${x.Id}`)).AddColumn("Utworzone", (x)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(x.Meta.CreatedAt)).AddColumn("Status", (x)=>x.Status).AddColumn("Zni\u017Cki", (x)=>new (0, $b1bf926166be94d7$export$b6e0323406a427eb)(x)).AddColumn("\u0179r\xf3d\u0142o", (x)=>x.People.First()?.Origin?.value || "").AddColumn("Profit", (x)=>x.Profit + " z\u0142").Build().WidthAuto().MarginAuto());
    }
}
class $f0841b8ce43f7a14$export$cd074e5fdcaf262b extends (0, $2s69t.Div) {
    constructor(_manager){
        super(), this._manager = _manager;
    }
    async OnAppend() {
        const originsCount = {};
        const open = await this._manager.FetchAll((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
        const closed = await this._manager.FetchAll((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed);
        const orders = new (0, $2s69t.Collection)(open.concat(closed));
        orders.Load(...orders.Filter((x)=>x.IsDone).sort((a, b)=>+b.Meta.CreatedAt - +a.Meta.CreatedAt).filter((x)=>{
            const origin = x.People.First()?.Origin?.value || "";
            const isSocialMedia = [
                "Facebook",
                "Instagram",
                "TikTok"
            ].includes(origin);
            const usedDiscounts = x.Meta?.Ticket?.BasketInfo?.Discounts?.map((d)=>d.Code) || [];
            const hasDiscount = usedDiscounts.some((d)=>d.startsWith("WK"));
            const force = [
                "88428",
                "C7B09"
            ];
            return isSocialMedia || hasDiscount || force.includes(x.ShortId);
        }));
        orders.Items.forEach((order)=>{
            const origin = order.People.First()?.Origin?.value?.trim() || "(brak \u017Ar\xf3d\u0142a)";
            originsCount[origin] = (originsCount[origin] || 0) + 1;
        });
        const origins = Object.entries(originsCount).map(([origin, count])=>({
                origin: origin,
                count: count
            }));
        const total = orders.Items.reduce((acc, order)=>acc + order.Profit, 0);
        this.Append("\n\nWszystie uko\u0144czone zam\xf3wienia (otwarte i zamkni\u0119te)", new (0, $2s69t.TableBuilder)(origins).AddColumn("\u0179r\xf3d\u0142o", (x)=>x.origin).AddColumn("Ilo\u015B\u0107", (x)=>x.count).AddColumn("Procent", (x)=>(x.count / orders.Items.length * 100).toFixed(0) + "%").Build().Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(), new (0, $2s69t.Line)(), new (0, $2s69t.TableBuilder)(orders).AddColumn("Zam\xf3wienie", (x)=>new (0, $2s69t.Link)(x.ShortId, `#admin/order/view/${x.Id}`)).AddColumn("Utworzone", (x)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(x.Meta.CreatedAt))// .AddColumn("Status", x => x.Status)
        .AddColumn("U\u017Cyte kody", (x)=>x.Meta?.Ticket?.BasketInfo?.Discounts?.map((d)=>d.Code).join(", ") || "").AddColumn("\u0179r\xf3d\u0142o", (x, row)=>{
            row.Background([
                "Facebook",
                "Instagram",
                "TikTok"
            ].includes(x.People.First()?.Origin?.value || "") ? "#e6f0fa" : "none");
            return x.People.First()?.Origin?.value || "";
        }).AddColumn("Profit", (x)=>x.Profit + " z\u0142").Build().WidthAuto().MarginAuto(), "\n\n", new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.Span)(total + " z\u0142").Class("uk-badge").FontSize(20), ", 5% = ", new (0, $2s69t.Span)(total * 0.05 + " z\u0142").Class("uk-badge").FontSize(20)), "\n\n");
    }
}



class $ad2cf527d68e2da3$export$a0a410c8a79d52b9 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_manager, _router, _agents){
        super("Zam\xf3wienia"), this._manager = _manager, this._router = _router, this._agents = _agents;
        this.Content(async (body)=>{
            const ordersSet = new (0, $2s69t.Ref)((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open).Storable("orders-set");
            await this._manager.LoadAll(ordersSet.value);
            const view = new (0, $2s69t.RefString)("steps").Storable("orders-view");
            const filter = new (0, $2s69t.RefString)().Storable("orders-filter");
            filter.OnChange(()=>view.value = "table");
            const ordersView = new (0, $2s69t.CollectionView)(this._manager.Orders).Filter(filter, (order)=>(0, $2s69t.Filters).TextContains(filter, [
                    order.SearchBy
                ])).Refresh();
            const content = new (0, $2s69t.DestroyingContentSwitcher)(view).AddContent("table", ()=>new (0, $fa6c33cfa4cce153$export$b3c27e869d856b7)(this._router, this._manager, ordersView)).AddContent("calendar", ()=>new (0, $a6400e9f03245c9c$export$b573856c46cc9357)(this._router, ordersView)).AddContent("todo", ()=>new (0, $6bc63868dca0f0ab$export$8013acab62007000)(this._router, this._manager, this._agents, ordersView)).AddContent("profit", ()=>new (0, $d2f9d688d82c8ed8$export$ac31bf1fefce2165)(ordersView)).AddContent("profit-2", ()=>new (0, $d2f9d688d82c8ed8$export$acf1acf464ab52d8)(_manager)).AddContent("tasks", ()=>new (0, $8009c7b67425bcdb$export$689b82a1511cd27b)(this._manager.Orders)).AddContent("origins", ()=>new (0, $f0841b8ce43f7a14$export$928836a6e1d219f8)(ordersView)).AddContent("origins-2", ()=>new (0, $f0841b8ce43f7a14$export$cd074e5fdcaf262b)(_manager));
            ordersSet.OnChange(async (set)=>{
                const info = new (0, $2s69t.Snack)("\u0141adowanie zam\xf3wie\u0144...");
                await this._manager.LoadAll(set);
                info.Close();
                content.Refresh();
            });
            body.TextAlignLeft().Append(new (0, $2s69t.Select)(ordersSet, {
                "\uD83D\uDFE2 Aktualne": (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open,
                "\uD83D\uDFE4 Zamkni\u0119te": (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Closed
            }).WidthAuto().Margin(8), new (0, $2s69t.ClearableTextInput)(filter, "Szukaj...").DisplayInlineBlock().WidthAuto(), new (0, $2s69t.Select)(view, {
                "\uD83C\uDF54 Tabela": "table",
                "\uD83C\uDF42 Zadania": "todo",
                "\uD83D\uDE80 Akcje": "tasks",
                "\uD83D\uDCC5 Kalendarz": "calendar",
                "\uD83D\uDCB0 Profit": "profit",
                "\uD83D\uDCB0 ProfitV2": "profit-2",
                "\uD83E\uDDED \u0179r\xf3d\u0142a": "origins",
                "\uD83E\uDDED \u0179r\xf3d\u0142aV2": "origins-2"
            }).WidthAuto().Margin(8).FloatRight().PaddingRight(32), new (0, $2s69t.Div)().ClearBoth(), content);
        });
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $39dcd471b3dfb34e$export$986b72e8ab2b5953 extends (0, $2s69t.Div) {
    constructor(){
        super("invisible-on-mobile");
        this.Append(new (0, $2s69t.Div)().Class("connecting-line"));
    }
}




class $dd4a61e510380454$export$d64d2cfb0965aa13 {
    Style(markedStep, stepBox) {
        if (markedStep.IsCurrent) stepBox.AddClass("active");
        if (markedStep.State == (0, $c177bbc21544856e$export$81262d6ca0162a3).Failed) stepBox.BorderColor("#ffa2a2").BorderWidth(4);
        if (markedStep.IsBeforeCurrent) {
            if (markedStep.Step.IsWellDone) stepBox.BorderColor("#16cf74").BorderWidth(2);
        }
        if (markedStep.IsAfterCurrent) stepBox.Opacity(0.5);
    }
}



var $2s69t = parcelRequire("2s69t");
class $8ae9f30cfafdfe04$export$8df6c96968d58fdc extends (0, $2s69t.Div) {
    // private timer = new ExpirationTimer(this.step.Step.Timeout);
    constructor(step){
        super("step-box customer-view"), this.step = step;
        this.Refresh();
    }
    // public async OnRemove()
    // {
    //     this.timer.Dispose();
    // }
    Refresh() {
        const step = this.step.Step;
        this.Clear().Append(new (0, $2s69t.Div)("step-content").TextAlignCenter().Append(new (0, $2s69t.Div)("step-title").Append(new (0, $2s69t.Span)(step.GetTitleForCustomer()).Attribute("data-test-class", "step-title-text")), new (0, $2s69t.Div)("step-description").Append(...step.GetCustomerContent())));
    }
}


class $c9c881b38b5ba8ac$export$35883b0615f0b6cf extends (0, $2s69t.Div) {
    constructor(steps, perspective, printer, autoScrollToCurrent = true){
        super("StepsPrinter"), this.steps = steps, this.perspective = perspective, this.printer = printer, this.autoScrollToCurrent = autoScrollToCurrent;
        this.stepsBox = new (0, $2s69t.Div)("blocks-container");
        this.dotButtonsBox = new (0, $2s69t.Div)("buttons invisible-on-mobile");
        this.Append(this.stepsBox, this.dotButtonsBox);
        this.Refresh();
    }
    Refresh() {
        this.stepsBox.Clear();
        this.dotButtonsBox.Clear();
        let i = 0;
        let c;
        let lastClickedButton;
        const stylist = new (0, $dd4a61e510380454$export$d64d2cfb0965aa13)();
        const markedSteps = (0, $2b9446962095951e$export$c036ee88a093a80c).Mark(this.steps);
        for (const markedStep of markedSteps){
            if (this.perspective == "customer" && !markedStep.Step.Data.VisibleForCustomer.value) continue;
            if (this.perspective == "customer" && !markedStep.Step.IsVisibleForCustomer) continue;
            if (i > 0) this.stepsBox.Append(new (0, $39dcd471b3dfb34e$export$986b72e8ab2b5953)());
            i++;
            const stepBox = this.printer(markedStep);
            const dotButton = new (0, $2s69t.Span)("\u25CF").Class("switch-btn").OnClick((_)=>{
                lastClickedButton?.Style(`text-shadow: none`);
                lastClickedButton = _;
                _.Style(`text-shadow: #3b82f6 1px 0 10px;`);
                stepBox.Element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
            });
            if (markedStep.IsCurrent) {
                c = stepBox;
                dotButton.Color("#3b82f6");
                stepBox.Append(new (0, $2s69t.Span)("Aktualny krok").Class("uk-badge").Style("position: absolute; top: 8px; right: 8px; padding: 0.5rem; background-color: #3b82f6; color: white; border-radius: 1rem; font-size: 0.8rem; font-weight: 400;"));
            }
            stylist.Style(markedStep, stepBox);
            this.stepsBox.Append(stepBox);
            this.dotButtonsBox.Append(dotButton);
            // TO POWODUJE ROZPIERDOL, leci milion refreshy i nie wiem dlaczego
            // markedStep.Step.Data.State
            //     .ClearHandlers()
            //     .OnChange(() =>
            //     {
            //         this.Refresh();
            //     });
            if (!c && i == this.steps.length - 1) c = stepBox;
        }
        // NIE ZA BARDZO ROZUMIEM DLACZEGO DZIAŁA Z TIMEOUTEM DOPIERO, PRZECIEŻ WSZYSTKIE TE ELEMENTY SA JUŻ DAWNO APPENDOWANE
        if (this.autoScrollToCurrent) setTimeout(()=>{
            c?.Element?.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center'
            });
        }, 1);
        return this;
    }
}
class $c9c881b38b5ba8ac$export$f9440b7acff9bc1b extends $c9c881b38b5ba8ac$export$35883b0615f0b6cf {
    constructor(order){
        super(order.Steps.Items, "customer", (step)=>new (0, $8ae9f30cfafdfe04$export$8df6c96968d58fdc)(step), true);
    }
}




var $2s69t = parcelRequire("2s69t");
class $b1d3913a190def89$export$e1d10c5c2a8aa62f extends (0, $0fccb80f67f714eb$export$e1aef45b828286de) {
    constructor(order){
        const calendarEntries = order.AsEvents.filter((x)=>x.IsVisibleForCustomer).map((x)=>({
                Date: x.Date,
                Content: ()=>[
                        new (0, $2s69t.Div)("calendar-event-entry").Text(x.Icon + " " + x.Label + (x.IsDone ? "\u2705" : ""))
                    ]
            }));
        super(calendarEntries);
    }
}




var $2s69t = parcelRequire("2s69t");
class $954c63c9dc3f7b9b$export$aff4fc93593c3bcf extends (0, $2s69t.Div) {
    constructor(title, content, theme = "#3b82f6"){
        super();
        this.Style(`display: block; margin: 32px 0; text-align: center;`);
        this.Append(new (0, $2s69t.Div)().Style(`display: inline-block; padding: 16px; text-align: left; border-left: 12px solid ${theme}`).Append(new (0, $2s69t.Div)().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme), new (0, $2s69t.Text)(content).Color("#444")));
    }
}


class $07c5f95939e760d3$export$d294212a2467781a extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_manager, orderId){
        super("Zam\xf3wienie #" + orderId), this._manager = _manager, this.orderId = orderId;
        this.order = null;
        this.OnError((ex)=>{
            console.error(ex);
            if (!this.order) {
                const shortId = this.orderId.slice(-5).toUpperCase();
                return {
                    header: "Nie znaleziono zam\xf3wienia",
                    body: `Skontaktuj si\u{119} z obs\u{142}ug\u{105} sklepu podaj\u{105}c ten numer: ${shortId}`
                };
            }
            return {
                header: "Error",
                body: ex.message
            };
        });
        this.Content(async (body)=>{
            const order = await this._manager.GetOne(this.orderId);
            if (order.IsClosed) {
                body.Append(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)("Zam\xf3wienie jest ju\u017C zamkni\u0119te. Je\u015Bli chcesz je przywr\xf3ci\u0107, skontaktuj si\u0119 z obs\u0142ug\u0105 sklepu.").MarginTop(32));
                return;
            }
            const view = new (0, $2s69t.RefString)("\uD83D\uDC3E Przebieg zam\xf3wienia").Storable("customer-order-view");
            const tabs = new (0, $2s69t.Tabs)(view); //.Style(`overflow-x: auto; flex-wrap: nowrap;`);
            tabs.Add("\uD83D\uDC3E Przebieg zam\xf3wienia", ()=>new (0, $c9c881b38b5ba8ac$export$f9440b7acff9bc1b)(order)).Add("\uD83D\uDCC5 Kalendarz", ()=>new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $b1d3913a190def89$export$e1d10c5c2a8aa62f)(order)).MarginTopBottom(32));
            if (order.Notes.Public.value) tabs.Add("\uD83D\uDCDD Notatka", ()=>new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $2s69t.MultilineInput)(order.Notes.Public).Readonly().Rows(20).MarginTop(16).Padding(12).BorderRadius(8)));
            // if (this.CHAT_VISIBLE)
            // {
            //     const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
            //     const chat = new Chat(_connector, new ChatUser({ Name: `Klient #${order.ShortId}` }));
            //     await _connector.Load();
            //     tabs.Add(`💬 Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat));
            // }
            body.Append(new (0, $2s69t.Div)().TextAlignLeft().MarginBottom(16).Padding(16).Append(new (0, $2s69t.Span)("Zam\xf3wienie #" + order.ShortId).FontSize(24).Bold().Color("#1e87f0").Margin(0).MarginTop(0).MarginBottom(16), "\n", new (0, $2s69t.Span)(order.CurrentStateForCustomer).FontSize(16).Color("#888").Margin(0).MarginTop(0).MarginBottom(16)), tabs, // new Line().Margin(16),
            new (0, $954c63c9dc3f7b9b$export$aff4fc93593c3bcf)("Chcesz co\u015B zmieni\u0107 w zam\xf3wieniu?", "Zadzwo\u0144 lub napisz: \u260E\uFE0F +48 507 293 714"));
        });
    }
}



var $2s69t = parcelRequire("2s69t");





var $2s69t = parcelRequire("2s69t");
class $3aa75da3d1297622$export$1fcac1e545e67677 extends (0, $2s69t.Div) {
    constructor(people){
        super();
        this.Append(...people.Map((x)=>new (0, $2s69t.Div)().Text(`${x.Type.value}\n${x.ExperienceIcon} ${x.Name.value}
\u{260E}\u{FE0F} ${x.Phone.value}
\u{1F4E7} ${x.Email.value}
\u{1F4CC} ${x.Address.value}
\u{1F5D2}\u{FE0F} ${x.Description.value || "(brak notatki)"}
\u{1F3E6} ${x.BankAccountNumber.value || "(brak numeru konta)"}
\u{1F9ED} ${x.Origin.value || "(brak \u017Ar\xf3d\u0142a)"}`).Style(`display: inline-block; font-size: 1rem; text-align: left; padding: 1rem; margin: 1rem; border-bottom: 1px solid #f3f4f6; background-color: #f9fafb; border-radius: 0.75rem;`)));
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $e43273b2c5641098$export$324340805fe381d8 extends (0, $2s69t.RefComponentBase) {
    constructor(ref){
        super("div", ref);
        this.switches = {};
        this.classWhenActive = {};
    }
    Refresh() {
        this.switches.Keys().forEach((activator)=>{
            const cmp = this.switches[activator];
            const classWhenActive = this.classWhenActive[activator];
            if (this.ref.value === activator) cmp.AddClass(classWhenActive);
            else cmp.RemoveClass(classWhenActive);
        });
    }
    AddSwitch(activator, cmp, cssClassWhenActive) {
        this.switches[activator] = cmp;
        this.classWhenActive[activator] = cssClassWhenActive;
        cmp.OnClick(()=>this.ref.value = activator);
        if (this.ref.value == activator) cmp.AddClass(cssClassWhenActive);
        if (this.ref.value == "") this.ref.value = activator;
        this.Append(cmp);
        return this;
    }
}



class $44c69e36ff118069$export$b2539bed5023c21c extends (0, $2s69t.Div) {
    constructor(ref = new (0, $2s69t.Ref)("")){
        super(), this.ref = ref;
        this.switches = new (0, $e43273b2c5641098$export$324340805fe381d8)(this.ref).Class("tabs-nav");
        this.content = new (0, $2s69t.DestroyingContentSwitcher)(this.ref);
        this.Append(this.switches, this.content);
    }
    Add(label, content) {
        // this.switches.AddSwitch(label, new Button(label).Class("tab-button"), "uk-button-danger");
        this.switches.AddSwitch(label, new (0, $2s69t.Button)(label).Class("tab-button"), "tab-button-active");
        this.content.AddContent(label, content);
        return this;
    }
}
class $44c69e36ff118069$export$c3edd0c947539ceb extends (0, $2s69t.Div) {
    constructor(ref = new (0, $2s69t.Ref)("")){
        super("card"), this.ref = ref;
        this.switches = new (0, $e43273b2c5641098$export$324340805fe381d8)(this.ref).Class("tabs__list");
        this.content = new (0, $2s69t.DestroyingContentSwitcher)(this.ref).Class("tabs__content");
        this.Append(new (0, $2s69t.Div)("tabs__nav").Append(this.switches), this.content);
    }
    Add(svgIcon, label, content) {
        this.switches.AddSwitch(label, new (0, $2s69t.Button)(label).Class("tabs__button").Prepend(new (0, $aa6902a8d95be5a7$export$e17b9c1182212c96)(svgIcon).Class("tabs__button-icon")), "tabs__button--active");
        this.content.AddContent(label, content);
        return this;
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $8421f066f4df449c$export$df2440bcd6ef2a5c extends (0, $d5372390156ec6d7$export$1f54913ccc4368b1) {
    constructor(title, content){
        super(new (0, $2s69t.Div)("info-frame").Append(new (0, $2s69t.Div)("info-frame-title").Text(title), new (0, $2s69t.Div)("info-frame-content").Text(content)));
    }
}




class $e8c4066a3cccbcf7$export$34a71c7aba5768a7 extends (0, $38988c1de85120c6$export$787a017fbb13560d) {
    constructor(text, icon, onClick){
        super("warning", text, icon, onClick);
    }
}




class $f05a08c096cd19ca$export$2568696a315cc05d extends (0, $2s69t.Div) {
    constructor(_router, _manager, order){
        super("card"), this._router = _router, this._manager = _manager, this.order = order;
        this.Append(order.IsClosed && new (0, $8421f066f4df449c$export$df2440bcd6ef2a5c)("To zam\xf3wienie jest zamkni\u0119te", "Mo\u017Cna je przywr\xf3ci\u0107 z poziomu edycji"), new (0, $2s69t.Div)("card__content").Append(new (0, $2s69t.Div)("order-header__content").Append(new (0, $2s69t.Div)("order-header__info").Append(new (0, $2s69t.Div)("order-header__title").Text(`Zam\xf3wienie #${order.ShortId} - ${order.CurrentStateForAdmin}`), new (0, $2s69t.Div)("order-header__details").Append(new (0, $2s69t.Div)("order-header__detail").Append(new (0, $2s69t.Div)("order-header__detail-label").Text("Data utworzenia"), new (0, $2s69t.Div)("order-header__detail-value").Text(order.Meta.CreatedAt.toLocaleString())), new (0, $2s69t.Div)("order-header__detail").Append(new (0, $2s69t.Div)("order-header__detail-label").Text("Ostatnia edycja"), new (0, $2s69t.Div)("order-header__detail-value").Text((0, $029e32efb5f6474c$export$3117a0de16ab2854).HowLongAgo(order.Meta.UpdatedAt, "jeszcze nigdy"))), new (0, $2s69t.Div)("order-header__detail").Append(new (0, $2s69t.Div)("order-header__detail-label").Text("Status"), new (0, $2s69t.Div)("order-header__detail-value").Text(order.Status)))), new (0, $2s69t.Div)("order-header__actions").Append(new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Edytuj", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Edit, ()=>_router.GoToOrderEdit(order.Id)), !order.IsClosed && new (0, $e8c4066a3cccbcf7$export$34a71c7aba5768a7)("Archiwizuj", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Lock, async (btn)=>await this.ArchiveOrder()), order.IsClosed && new (0, $e8c4066a3cccbcf7$export$34a71c7aba5768a7)("Przywr\xf3\u0107", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).LockOpen, async (btn)=>await this.UnarchiveOrder()), new (0, $ccab16682f88d5ed$export$174d0791895a902d)("Widok klienta", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Eye, ()=>_router.GoToCustomerView(order.Id))))));
    }
    async ArchiveOrder() {
        try {
            if (confirm("Czy na pewno chcesz zamkn\u0105\u0107 zam\xf3wienie? Sprawd\u017A czy wszystkie kroki zosta\u0142y wykonane i czy wszystko jest rozliczone (kasa, sprz\u0119t etc).")) {
                await this._manager.Close(this.order);
                new (0, $2s69t.Snack)("\u2611\uFE0F Zam\xf3wienie zosta\u0142o zamkni\u0119te");
                this._router.GoToOrdersList();
            }
        } catch (ex) {
            new (0, $2s69t.Snack)(`\u{274C} Nie uda\u{142}o si\u{119} zamkn\u{105}\u{107} zam\xf3wienia: ${ex.message}`);
        }
    }
    async UnarchiveOrder() {
        try {
            if (confirm("Czy na pewno chcesz przenie\u015B\u0107 zamkni\u0119te zam\xf3wienie do otwartych?")) {
                await this._manager.Reopen(this.order);
                new (0, $2s69t.Snack)("\u2611\uFE0F Zam\xf3wienie zosta\u0142o ponownie otwarte");
                this._router.GoToOrdersList();
            }
        } catch (ex) {
            new (0, $2s69t.Snack)(`\u{274C} Nie uda\u{142}o si\u{119} ponownie otworzy\u{107} zam\xf3wienia: ${ex.message}`);
        }
    }
}




var $2s69t = parcelRequire("2s69t");


class $cdebf840ca3fcadf$export$c1b1cc231a26aa34 extends (0, $2s69t.Div) {
    constructor(order){
        super();
        const mana = order.Steps.Items.flatMap((x)=>x.Mana).filter((x)=>x.Amount > 0);
        this.Append(new (0, $2s69t.Div)("tab-content__title").Text("Podsumowanie"), new (0, $0ac1beb9675d6626$export$386e296787a6cbf1)(order).Class("uk-table uk-table-small uk-table-divider uk-table-middle"), new (0, $2s69t.Line)(), new (0, $2s69t.Div)("tab-content__title").Text("Zdarzenia"), new (0, $2s69t.TableBuilder)(mana).AddColumn("Opis", (x)=>x.Description).AddColumn("Kwota", (x)=>x.Amount + " z\u0142").AddColumn("Krok", (x)=>x.Step.GetFullTitle()).AddColumn("Data", (x)=>(0, $029e32efb5f6474c$export$3117a0de16ab2854).FormattedDate(x.When)).Build());
    }
}



var $2s69t = parcelRequire("2s69t");
class $1e6ebd3f6de6e587$export$bb7812f02ac4d31f extends (0, $2s69t.Div) {
    constructor(order){
        super();
        this.Append(new (0, $2s69t.Div)("tab-content__title").Text("Notatka klienta"), new (0, $2s69t.MultilineInput)(order.Notes.Customer).Rows(6).Readonly(), new (0, $2s69t.Div)("tab-content__title").Text("Notatka prywatna").MarginTop(16), new (0, $2s69t.MultilineInput)(order.Notes.Private).Rows(6).Readonly(), new (0, $2s69t.Div)("tab-content__title").Text("Notatka publiczna").MarginTop(16), new (0, $2s69t.MultilineInput)(order.Notes.Public).Rows(6).Readonly());
    }
}



var $2s69t = parcelRequire("2s69t");


class $19316e7504889b0f$export$3dcb9297c00a957f extends (0, $2s69t.Div) {
    constructor(order){
        super();
        this.Append(new (0, $5d309aa59c698e61$export$b3b616c12869a148)(order, false).Margin(16), new (0, $2s69t.Line)(), new (0, $2s69t.Span)("\u0141\u0105cznie: " + order.BasketValue + "z\u0142 + " + order.DesiredDeposit + "z\u0142 kaucji").Margin(16), new (0, $2s69t.Line)(), new (0, $b1bf926166be94d7$export$b6e0323406a427eb)(order).Margin(16));
    }
}




class $6dbe8d516d0a5f1c$export$f0cfa2e7816d5089 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    // private CHAT_ENABLED = false;
    constructor(_manager, _router, _agents, orderId){
        super(`Zam\xf3wienie #${orderId}`), this._manager = _manager, this._router = _router, this._agents = _agents, this.orderId = orderId;
        this.Content(async (body)=>{
            const order = await this._manager.GetOne(this.orderId);
            if (!order) {
                body.Append(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $954c63c9dc3f7b9b$export$aff4fc93593c3bcf)("B\u0142\u0105d", `Nie znaleziono zam\xf3wienia. Jego adres jest niepoprawny lub zosta\u{142}o zamkni\u{119}te albo usuni\u{119}te.`)));
                return;
            }
            order.OnChange(async ()=>{
                const result = await this._manager.Update(order);
                new (0, $2s69t.Snack)("\u2705 Zmiany zapisane", result.NotificationHasBeenSent ? "\u2709\uFE0F Powiadomienie wys\u0142ane" : "Bez powiadomienia");
            });
            const view = new (0, $2s69t.RefString)("Przebieg").Storable("admin-order-view");
            const tabs = new (0, $44c69e36ff118069$export$c3edd0c947539ceb)(view).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Basket, "Koszyk", ()=>new (0, $19316e7504889b0f$export$3dcb9297c00a957f)(order)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Route, "Przebieg", ()=>new (0, $c9c881b38b5ba8ac$export$35883b0615f0b6cf)(order.Steps.Items, "admin", (step)=>new (0, $a146cad85d56a538$export$81d6b4cdbf702e82)(this._router, this._agents, step), true)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Calendar, "Kalendarz", ()=>new (0, $b1d3913a190def89$export$e1d10c5c2a8aa62f)(order).MarginTop(32)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).User, "Ludzie", ()=>new (0, $3aa75da3d1297622$export$1fcac1e545e67677)(order.People)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Money, "Rozliczenie", ()=>new (0, $cdebf840ca3fcadf$export$c1b1cc231a26aa34)(order)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Notes, "Notatki" + (order.AreAnyNotes ? "\uD83D\uDD34" : ""), ()=>new (0, $1e6ebd3f6de6e587$export$bb7812f02ac4d31f)(order));
            /*
               if (this.CHAT_ENABLED)
              {
                  const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
                  const chat = new Chat(_connector, new ChatUser({ Name: this._auth.UserInfo?.User?.ChatName || "Admin" }));
      
                  await _connector.Load();
      
                  tabs.Add(Icons.Chat, `Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat))
              }
      */ body.Append(new (0, $f05a08c096cd19ca$export$2568696a315cc05d)(this._router, this._manager, order).MarginTop(16).MarginBottom(16), tabs);
        });
    }
}




var $2s69t = parcelRequire("2s69t");



class $d3bd4eaa5763c9cf$export$b7eeec5db3309796 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_manager, orderId){
        super("Raw order view"), this._manager = _manager, this.orderId = orderId;
        this.view = new (0, $2s69t.RefString)("view").Storable("order-raw-view");
        this.Content(async (body)=>{
            const order = await this._manager.GetOne(this.orderId);
            if (!order) {
                this.Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("B\u0142\u0105d", `Nie znaleziono zam\xf3wienia`));
                return;
            }
            const steps = (0, $2s69t.RefSerializer).Flatenize(order.Steps.Items.map((x)=>x.Data));
            const raw = new (0, $2s69t.RefString)(JSON.stringify(steps, null, 2));
            body.Append(new (0, $a6f9ac4860e2927f$export$4d82ce4c37371892)(`Kroki #${order.Id}`), new (0, $2s69t.Select)(this.view, [
                "edit",
                "view"
            ]).WidthAuto(), // new HidingContentSwitcher(this.view)
            //     // .AddContent("edit", () => new MultilineInput(raw).Rows(32))
            //     .AddContent("view", () => new JsonViewer(flat)),
            // new Center(
            //     new DangerButton("Zapisz").OnClick(() => this._manager.Update(order))
            //         .VisibleWhen(this.view, v => v === "edit")
            // ).Margin(16)
            "Steps:", new (0, $2s69t.JsonViewer)(steps), "Meta:", new (0, $2s69t.JsonViewer)(order.Meta));
        });
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
class $6fc67b0c57e6c65f$export$3b0d6d7590275603 extends (0, $2s69t.Div) {
    constructor(text = "\u0141adowanie..."){
        super();
        this.Append(new (0, $2s69t.Spinner)().MarginRight(8), text);
    }
}


class $c4eaf041ea99f0bb$export$ed845e874be57a49 extends (0, $d5372390156ec6d7$export$1f54913ccc4368b1) {
    constructor(text = "\u0141adowanie..."){
        super();
        this.Margin(32);
        this.Append(new (0, $6fc67b0c57e6c65f$export$3b0d6d7590275603)(text));
    }
}




var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $1ee906eee47d349b$export$a0d46203173587a1 extends (0, $2s69t.Div) {
    constructor(label, input){
        super("control-group");
        this.Append(new (0, $2s69t.Label)(label, label), input.Attribute("id", label));
    }
}



var $2s69t = parcelRequire("2s69t");
class $7a45c5e512647a1b$export$2ddb90ad54e5f587 extends (0, $2s69t.Div) {
    constructor(){
        super();
        this.titleGroup = new (0, $2s69t.Div)().Class("panel-title-group");
        this.controls = new (0, $2s69t.Div)().Class("panel-controls");
        this.Content = new (0, $2s69t.Div)().Class("panel-content");
        this.Class("panel");
        const header = new (0, $2s69t.Div)().Class("panel-header").Append(this.titleGroup, this.controls);
        this.Append(header, this.Content);
    }
    SetTitle(title, subtitle) {
        this.titleGroup.Clear().Append(new (0, $2s69t.Div)().Class("panel-title").Text(title));
        if (subtitle) this.titleGroup.Append(new (0, $2s69t.Div)().Class("panel-subtitle").Text(subtitle));
        return this;
    }
    AddControl(icon, onClick) {
        this.controls.Append(new (0, $2s69t.Div)().Class("control-button").Text(icon).OnClick(onClick));
        return this;
    }
    AddContent(...content) {
        this.Content.Append(...content);
        return this;
    }
}


class $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59 extends (0, $7a45c5e512647a1b$export$2ddb90ad54e5f587) {
    AddInfo(label, value) {
        this.AddContent(new (0, $2s69t.Div)("control-group").Append(new (0, $2s69t.Span)(label), new (0, $2s69t.Div)().Text(value)));
        return this;
    }
    AddInput(label, input) {
        this.AddContent(new (0, $1ee906eee47d349b$export$a0d46203173587a1)(label, input));
        return this;
    }
    AddField(label, field) {
        this.AddContent(new (0, $2s69t.Div)("control-group").Append(new (0, $2s69t.Span)(label).FontSize(14).Color("#111827"), field));
        return this;
    }
    constructor(item, collection, content, showControls = true){
        super();
        if (showControls) {
            if (collection.CanSwapUp(item)) this.AddControl("\u25B4", ()=>collection.SwapUp(item));
            if (collection.CanSwapDown(item)) this.AddControl("\u25BE", ()=>collection.SwapDown(item));
            this.AddControl("\xd7", ()=>collection.Remove(item));
            const expand = new (0, $2s69t.RefBool)(false);
            const expandLabel = new (0, $2s69t.RefString)("\u25BC");
            this.Content.Append(...content).Visible(expand, "block");
            this.AddControl(expandLabel, ()=>{
                expand.Toggle();
                expandLabel.value = expand.value ? "\u25B2" : "\u25BC";
            });
        }
    }
}


class $886795f30f175397$export$34e93ecd6228713a extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(human, people){
        super(human, people, []);
        this.SetTitle("Cz\u0142owiek").AddInput("Typ", new (0, $2s69t.TextInput)(human.Type)).AddInput("Imi\u0119 i nazwisko", new (0, $2s69t.TextInput)(human.Name)).AddInput("Telefon", new (0, $2s69t.TextInput)(human.Phone)).AddInput("Email", new (0, $2s69t.TextInput)(human.Email)).AddInput("Adres", new (0, $2s69t.TextInput)(human.Address)).AddInput("Numer konta", new (0, $2s69t.TextInput)(human.BankAccountNumber)).AddInput("Do\u015Bwiadczenie", new (0, $ca5ddfa4627c7851$export$ae1d92c6c071ba79)(human.Experience)).AddInput("\u0179r\xf3d\u0142o", new (0, $2s69t.TextInput)(human.Origin)).AddInput("Opis", new (0, $2s69t.MultilineInput)(human.Description).Rows(2));
    }
}



var $2s69t = parcelRequire("2s69t");
class $2b7196407ac174fc$export$31d20f485ed55995 extends (0, $2s69t.Div) {
    constructor(menu){
        super();
        this.TextAlignCenter().MarginTop(16);
        this.Append(...Object.entries(menu).map(([label, action])=>new (0, $2s69t.Link)(label).MarginLeft(16).Style("white-space: nowrap").OnClick(action)));
    }
}


class $089f9e02589009dd$export$d9ce5327b4d3732c extends (0, $2s69t.Div) {
    constructor(people){
        super();
        this.Append(new (0, $2s69t.CollectionPrinter)(people, (x)=>new (0, $886795f30f175397$export$34e93ecd6228713a)(x, people)).Class("panels-container"), new (0, $2b7196407ac174fc$export$31d20f485ed55995)({
            "\u2795 Osoba": ()=>people.Add(new (0, $7491f76ebc0bf829$export$9818a1bf5e26633)({}))
        }));
    }
}



var $2s69t = parcelRequire("2s69t");




class $1122c33783008036$export$427cdf186a37746c extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(step, steps){
        super(step, steps, [
            new (0, $d8b90477cbcae015$export$8e9df03dc5899c9f)(step, false)
        ]);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
    }
}



var $2s69t = parcelRequire("2s69t");









var $1lG8E = parcelRequire("1lG8E");
class $489d1f5e7aafbf72$export$b4b28119584ffd04 extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(step, steps, _shop){
        super(step, steps, []), this.step = step, this.steps = steps, this._shop = _shop;
        this.AddInput("Stan", new (0, $2s69t.Select)(step.Data.State, step.AllStates));
        this.AddInput("Pow\xf3d odrzucenia", new (0, $2s69t.MultilineInput)(step.Data.RejectionReason).Rows(4).Placeholder("Pow\xf3d odrzucenia"));
        this.Content.Append(// new TableViewer(step.Data.BasketItems).FontSize(14)
        //     .AddColumn("Typ", x => new Span(BasketItemTypeLabels[x.Type]).WidthAuto())
        //     .AddColumn("Produkt", x => new ProductSelector(_shop.Products.Items, x))
        //     .AddColumn("Ilość", x => new NumberInput(x.Quantity))
        //     .AddColumn("Koszt", x => new NumberInput(x.TotalPrice))
        //     .AddColumn("Identyfikator", x => new TextInput(x.ProductSerialNumber))
        //     .AddColumn("Dostępne dane", x => new TextInput(x.AccessData))
        //     .AddColumn("Depozyt łącznie (w PLN)", x => new NumberInput((x as RentBasketItem).Deposit), x => x.Type === BasketItemType.Rent)
        //     .AddColumn("Początek użytkowania", x => new DateInput((x as RentBasketItem).From), x => x.Type === BasketItemType.Rent)
        //     .AddColumn("Koniec użytkowania", x => new DateInput((x as RentBasketItem).To), x => x.Type === BasketItemType.Rent)
        //     .AddColumn("Opcje", item => new Link("❌ Usuń").OnClick(() => step.Data.BasketItems.Remove(item)))
        //     .Build(),
        new (0, $2s69t.CollectionPrinter)(step.Data.BasketItems, (x)=>{
            switch(x.Type){
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent:
                    const rentItem = x;
                    return new (0, $1lG8E.Table)([], [
                        [
                            `Wypo\u{17C}yczenie`,
                            ""
                        ],
                        [
                            "Produkt",
                            new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(_shop.Products.Items, rentItem)
                        ],
                        [
                            "Unikalny numer",
                            new (0, $2s69t.TextInput)(rentItem.ProductSerialNumber).Bold()
                        ],
                        [
                            "Dane dost\u0119powe",
                            new (0, $2s69t.TextInput)(rentItem.AccessData)
                        ],
                        [
                            "",
                            new (0, $2s69t.RefJsonViewer)(rentItem.AccessData)
                        ],
                        [
                            "Ilo\u015B\u0107",
                            new (0, $2s69t.NumberInput)(rentItem.Quantity)
                        ],
                        [
                            "Koszt",
                            new (0, $2s69t.NumberInput)(rentItem.TotalPrice)
                        ],
                        [
                            "Depozyt",
                            new (0, $2s69t.NumberInput)(rentItem.Deposit)
                        ],
                        [
                            "Pocz\u0105tek u\u017Cytkowania",
                            new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(rentItem.From)
                        ],
                        [
                            "Koniec u\u017Cytkowania",
                            new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(rentItem.To)
                        ],
                        [
                            "Opcje",
                            new (0, $2s69t.Button)("Usu\u0144", ()=>step.Data.BasketItems.Remove(rentItem))
                        ]
                    ]).Background("#e8f4f7").Padding(16).BorderRadius(8);
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale:
                    const saleItem = x;
                    return new (0, $1lG8E.Table)([], [
                        [
                            `Sprzeda\u{17C}`,
                            ""
                        ],
                        [
                            "Produkt",
                            new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(_shop.Products.Items, saleItem)
                        ],
                        [
                            "Unikalny numer",
                            new (0, $2s69t.TextInput)(saleItem.ProductSerialNumber).Bold()
                        ],
                        [
                            "Dane dost\u0119powe",
                            new (0, $2s69t.TextInput)(saleItem.AccessData)
                        ],
                        [
                            "",
                            new (0, $2s69t.RefJsonViewer)(saleItem.AccessData)
                        ],
                        [
                            "Ilo\u015B\u0107",
                            new (0, $2s69t.NumberInput)(saleItem.Quantity)
                        ],
                        [
                            "Koszt",
                            new (0, $2s69t.NumberInput)(saleItem.TotalPrice)
                        ],
                        [
                            "Opcje",
                            new (0, $2s69t.Button)("Usu\u0144", ()=>step.Data.BasketItems.Remove(saleItem))
                        ]
                    ]).Background("#e8f4f7").Padding(16).BorderRadius(8);
                default:
                    return `No edit form for ${x.Type}`;
            }
        }).Class("panels-container"), new (0, $38988c1de85120c6$export$787a017fbb13560d)("light", "wynajem", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>this.AddRentItem()), new (0, $38988c1de85120c6$export$787a017fbb13560d)("light", "sprzeda\u017C", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>this.AddSaleItem()));
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
    }
    AddRentItem() {
        this.step.Data.BasketItems.Add(new (0, $b104fb107ffab6bd$export$865a56617b7eaf36)({
            Type: (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent,
            Quantity: 1,
            TotalPrice: 0,
            ProductSerialNumber: "",
            From: new Date(),
            To: new Date(),
            Deposit: 300
        }));
    }
    AddSaleItem() {
        this.step.Data.BasketItems.Add(new (0, $46c5a39bfbff30f5$export$ff28d6513ec20674)({
            Type: (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent,
            Quantity: 1,
            TotalPrice: 0,
            ProductSerialNumber: ""
        }));
    }
}



var $2s69t = parcelRequire("2s69t");









class $5e13a7315560a483$export$740d904642a012c0 extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(step, steps){
        super(step, steps, []);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
        this.AddInput("Stan", new (0, $2s69t.Select)(step.Data.State, (0, $f2bf1286956e94e0$export$f8aa97792afa4663)));
        this.AddInput("Forma p\u0142atno\u015Bci", new (0, $2s69t.Select)(step.Data.Form, (0, $b4315c565ef22fe2$export$2101405ba6a59df8)));
        this.AddInput("Numer konta", new (0, $2s69t.TextInput)(step.Data.AccountNumber));
        this.Content.Append(new (0, $2s69t.Tabs)().Add("Dane do przelewu", ()=>new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Tytu\u0142em", new (0, $2s69t.TextInput)(step.Data.Title)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Kwota", new (0, $2s69t.NumberInput)(step.Data.Amount).Step(10).Min(0)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Waluta", new (0, $2s69t.TextInput)(step.Data.Currency)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("P\u0142atne do", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.Deadline)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Data wp\u0142aty", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.WhenPaid)))).Add("Kryptowaluta", ()=>new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Kurs BTC", new (0, $2s69t.NumberInput)(step.Data.ExchangeRate).Step(0.000001).Min(0)), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("", new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Pobierz kurs BTC", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, async ()=>{
                const bitcoinPriceProvider = new (0, $7aa14dd86653b561$export$f7e8c346445ef7be)();
                await bitcoinPriceProvider.Update();
                step.Data.ExchangeRate.value = bitcoinPriceProvider.BtcValueInPln.value;
            })))).Add("Szczeg\xf3\u0142y", ()=>new (0, $238219718d71b32e$export$78d5a44323dda815)(new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Pow\xf3d anulowania", new (0, $2s69t.MultilineInput)(step.Data.CancellationReason).Rows(4).Placeholder("Pow\xf3d")), new (0, $81a14981abe2adb6$export$b534bc812df080fd)("Komentarz", new (0, $2s69t.MultilineInput)(step.Data.Comment).Rows(4).Placeholder("Komentarz")))));
    }
}



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");

class $4f5f2b42e9ed13e9$export$ce93eecaafe6f013 extends (0, $2s69t.Div) {
    constructor(basketItems, selectedItems){
        super();
        const items = [
            ...basketItems.map((x)=>({
                    Item: x,
                    Selected: new (0, $2s69t.Ref)(selectedItems.Contains(x.Id))
                }))
        ];
        this.Append(new (0, $2s69t.TableBuilder)(items).AddColumn("", (item)=>new (0, $2s69t.Checkbox)(item.Selected).OnChange(()=>selectedItems.Contains(item.Item.Id) ? selectedItems.Remove(item.Item.Id) : selectedItems.Add(item.Item.Id))).AddColumn("", (item)=>new (0, $b18a2e4cac71d5d9$export$614b56d11b894a09)(item.Item)).Build());
    }
}


class $cd5c5a1d6c9b1cf6$export$374be2f750eb5146 extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(step, steps){
        super(step, steps, []);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
        this.AddField("Przedmioty", new (0, $4f5f2b42e9ed13e9$export$ce93eecaafe6f013)(step.Order.BasketItems, step.Data.PackageContent));
        this.AddInput("Stan", new (0, $2s69t.Select)(step.Data.State, step.AllStates));
        this.AddField("Planowany czas nadania", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.PlannedDispatchTime));
        this.AddField("Realny czas nadania", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.DispatchTime));
        this.AddInput("Adres", new (0, $2s69t.MultilineInput)(step.Data.AddressFullInfo).Rows(5));
        this.AddInput("P\u0142atno\u015B\u0107 przy odbiorze", new (0, $2s69t.NumberInput)(step.Data.PaymentAtDelivery));
        this.AddInput("Numer paczki", new (0, $2s69t.TextInput)(step.Data.PackageNumber));
        this.AddInput("Przewo\u017Anik", new (0, $2s69t.Select)(step.Data.Carrier, [
            "Pocztex",
            "Inpost",
            "Uber"
        ]));
        this.AddInput("Koszt paczki", new (0, $2s69t.NumberInput)(step.Data.PackageCost));
    }
}


class $866af8d277a11f52$export$b5d5cf8927ab7262 {
    constructor(){
        this.cases = {};
        this.default = void 0;
    }
    Case(value, toDo) {
        this.cases[value] = toDo;
        return this;
    }
    Default(toDo) {
        this.default = toDo;
        return this;
    }
    Execute(variable) {
        return this.cases?.[variable]?.() || this.default?.();
    }
}





var $2s69t = parcelRequire("2s69t");



class $78a1a318083fcb4a$export$8747ef78aa5978d6 extends (0, $7f85c7ddcb0ccd3c$export$3bb977b3ba9d3b59) {
    constructor(step, steps){
        super(step, steps, []);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
        this.AddField("Przedmioty", new (0, $4f5f2b42e9ed13e9$export$ce93eecaafe6f013)(step.Order.BasketItems, step.Data.ItemsIds));
        this.AddInput("Stan", new (0, $2s69t.Select)(step.Data.State, step.AllStates));
        this.AddField("Planowany czas spotkania", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.PlannedDispatchTime));
        this.AddField("Realny czas spotkania", new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(step.Data.DispatchTime));
        this.AddInput("Miejsce spotkania", new (0, $2s69t.TextInput)(step.Data.MeetingPlace));
        this.AddInput("Pobrana got\xf3wka", new (0, $2s69t.NumberInput)(step.Data.BasketSum));
        this.AddInput("Depozyt", new (0, $2s69t.NumberInput)(step.Data.DepositSum));
        this.AddInput("Trening", new (0, $2s69t.Checkbox)(step.Data.Training));
        this.AddInput("Informacje o kliencie", new (0, $2s69t.MultilineInput)(step.Data.CustomerInfo).Rows(5));
        this.AddInput("Informacje o spotkaniu", new (0, $2s69t.MultilineInput)(step.Data.MeetupNotes).Rows(5));
    }
}


class $43dce7c075ea8b74$export$7e28910e6c64e11c extends (0, $2s69t.Div) {
    constructor(_factory, _shop, order){
        super(), this._factory = _factory, this._shop = _shop, this.order = order;
        const addStepSelect = new (0, $2s69t.Select)(undefined, _factory.StepsLabels).WidthAuto().MarginLeft(8).AddDefaultOption("Wybierz (krok...").OnChange((v, i, k)=>{
            this.AddStep(v);
            addStepSelect.RemoveSelf();
        });
        this.Append(new (0, $2s69t.CollectionPrinter)(this.order.Steps, (x)=>this.GetEditor(x)).Class("panels-container"), new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Dodaj krok", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus).OnClick(()=>this.Append(addStepSelect)).MarginTop(16));
    }
    GetEditor(x) {
        const steps = this.order.Steps;
        return new (0, $866af8d277a11f52$export$b5d5cf8927ab7262)().Case((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket, ()=>new (0, $489d1f5e7aafbf72$export$b4b28119584ffd04)(x, steps, this._shop)).Case((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PackageToCustomer, ()=>new (0, $cd5c5a1d6c9b1cf6$export$374be2f750eb5146)(x, steps)).Case((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PersonalPickup, ()=>new (0, $78a1a318083fcb4a$export$8747ef78aa5978d6)(x, steps)).Case((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).Payment, ()=>new (0, $5e13a7315560a483$export$740d904642a012c0)(x, steps)).Case((0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).PaymentReturn, ()=>new (0, $5e13a7315560a483$export$740d904642a012c0)(x, steps)).Default(()=>new (0, $1122c33783008036$export$427cdf186a37746c)(x, steps)).Execute(x.Type);
    }
    AddStep(step) {
        const stepInstance = this._factory.Create(step, {
            CreatedAt: (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now
        });
        stepInstance.Order = this.order;
        this.order.Steps.Add(stepInstance);
    }
}




var $2s69t = parcelRequire("2s69t");





class $021196022e3a891f$export$8ad0f430ed2c70e8 extends (0, $2s69t.Div) {
    constructor(_shop, basket, customerNote){
        super();
        this.Append(new (0, $954c63c9dc3f7b9b$export$aff4fc93593c3bcf)("Uwaga!", `Dodawanie i usuwanie produkt\xf3w odbywa si\u{119} w krokach AddToBasket. Tutaj mo\u{17C}na tylko edytowa\u{107} szczeg\xf3\u{142}y istniej\u{105}cych produkt\xf3w we wszystkich tych krokach.`), customerNote && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)("Notatka klienta: " + customerNote).Class("user-note-in-table-view").FontSize(16), new (0, $2s69t.CollectionPrinter)(basket, (x)=>{
            switch(x.Type){
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Rent:
                    const rentItem = x;
                    return new (0, $2s69t.Table)([], [
                        [
                            `Wypo\u{17C}yczenie`,
                            ""
                        ],
                        [
                            "Produkt",
                            new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(_shop.Products.Items, rentItem)
                        ],
                        [
                            "Unikalny numer",
                            new (0, $2s69t.TextInput)(rentItem.ProductSerialNumber).Bold()
                        ],
                        [
                            "Dane dost\u0119powe",
                            new (0, $2s69t.TextInput)(rentItem.AccessData)
                        ],
                        [
                            "",
                            new (0, $2s69t.RefJsonViewer)(rentItem.AccessData)
                        ],
                        [
                            "Ilo\u015B\u0107",
                            new (0, $2s69t.NumberInput)(rentItem.Quantity)
                        ],
                        [
                            "Koszt",
                            new (0, $2s69t.NumberInput)(rentItem.TotalPrice)
                        ],
                        [
                            "Depozyt",
                            new (0, $2s69t.NumberInput)(rentItem.Deposit)
                        ],
                        [
                            "Pocz\u0105tek u\u017Cytkowania",
                            new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(rentItem.From)
                        ],
                        [
                            "Koniec u\u017Cytkowania",
                            new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(rentItem.To)
                        ]
                    ]).Background("#e8f4f7").Padding(16).BorderRadius(8);
                case (0, $e97714b723cebee9$export$39b11636c68d48ec).Sale:
                    const saleItem = x;
                    return new (0, $2s69t.Table)([], [
                        [
                            `Sprzeda\u{17C}`,
                            ""
                        ],
                        [
                            "Produkt",
                            new (0, $977d989a83a126db$export$2e2ab7553631f1f9)(_shop.Products.Items, saleItem)
                        ],
                        [
                            "Unikalny numer",
                            new (0, $2s69t.TextInput)(saleItem.ProductSerialNumber).Bold()
                        ],
                        [
                            "Dane dost\u0119powe",
                            new (0, $2s69t.TextInput)(saleItem.AccessData)
                        ],
                        [
                            "",
                            new (0, $2s69t.RefJsonViewer)(saleItem.AccessData)
                        ],
                        [
                            "Ilo\u015B\u0107",
                            new (0, $2s69t.NumberInput)(saleItem.Quantity)
                        ],
                        [
                            "Koszt",
                            new (0, $2s69t.NumberInput)(saleItem.TotalPrice)
                        ]
                    ]).Background("#e8f4f7").Padding(16).BorderRadius(8);
                default:
                    return `No edit form for ${x.Type}`;
            }
        }).Class("panels-container"));
    }
}






var $2s69t = parcelRequire("2s69t");





class $b3cc17f319cfd1f4$export$e4913c9cda223d46 extends (0, $2s69t.Div) {
    async SaveChanges() {
        const result = await this._manager.Update(this.order);
        new (0, $2s69t.Snack)("\u2705 Zmiany zapisane", result.NotificationHasBeenSent ? "\u2709\uFE0F Powiadomienie wys\u0142ane" : "Bez powiadomienia");
        this._router.GoToOrderView(this.order.Id);
    }
    constructor(_router, _manager, order){
        super("card"), this._router = _router, this._manager = _manager, this.order = order;
        this.Append(order.IsClosed && new (0, $8421f066f4df449c$export$df2440bcd6ef2a5c)("To zam\xf3wienie jest zamkni\u0119te", "Mo\u017Cna je przywr\xf3ci\u0107 z poziomu edycji"), new (0, $2s69t.Div)("card__content").Append(new (0, $2s69t.Div)("order-header__content").Append(new (0, $2s69t.Div)("order-header__info").Append(new (0, $2s69t.Div)("order-header__title").Text(`Zam\xf3wienie #${order.ShortId}`), new (0, $2s69t.Div)("order-header__details").Append(new (0, $2s69t.Div)("order-header__detail").Append(new (0, $2s69t.Div)("order-header__detail-label").Text("Data utworzenia"), new (0, $2s69t.Div)("order-header__detail-value").Text(order.Meta.CreatedAt.toLocaleString())), new (0, $2s69t.Div)("order-header__detail").Append(new (0, $2s69t.Div)("order-header__detail-label").Text("Ostatnia edycja"), new (0, $2s69t.Div)("order-header__detail-value").Text((0, $029e32efb5f6474c$export$3117a0de16ab2854).HowLongAgo(order.Meta.UpdatedAt, "jeszcze nigdy"))))), new (0, $2s69t.Div)("order-header__actions").Append(new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Zapisz zmiany", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Save, async ()=>await this.SaveChanges()), !order.IsClosed && new (0, $e8c4066a3cccbcf7$export$34a71c7aba5768a7)("Archiwizuj", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Lock, async (btn)=>{
            try {
                if (confirm("Czy na pewno chcesz zamkn\u0105\u0107 zam\xf3wienie? Sprawd\u017A czy wszystkie kroki zosta\u0142y wykonane i czy wszystko jest rozliczone (kasa, sprz\u0119t etc).")) {
                    btn.Disabled();
                    await _manager.Close(order);
                    new (0, $2s69t.Snack)("\u2611\uFE0F Zam\xf3wienie zosta\u0142o zamkni\u0119te");
                    _router.GoToOrdersList();
                }
            } catch (ex) {
                new (0, $2s69t.Snack)(`\u{274C} Nie uda\u{142}o si\u{119} zamkn\u{105}\u{107} zam\xf3wienia: ${ex.message}`);
            }
        }), order.IsClosed && new (0, $e8c4066a3cccbcf7$export$34a71c7aba5768a7)("Przywr\xf3\u0107", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).LockOpen, async (btn)=>{
            try {
                btn.Disabled();
                await _manager.Reopen(order);
                new (0, $2s69t.Snack)("\u2611\uFE0F Zam\xf3wienie zosta\u0142o przywr\xf3cone");
                _router.GoToOrdersList();
            } catch (ex) {
                new (0, $2s69t.Snack)(`\u{274C} Nie uda\u{142}o si\u{119} przywr\xf3ci\u{107} zam\xf3wienia: ${ex.message}`);
            }
        }), new (0, $2s69t.PopupMenu)({
            "\uD83D\uDC95 Duplikuj": async ()=>{
                const newOrder = await _manager.Duplicate(order);
                _router.GoToOrderEdit(newOrder.Id);
            },
            "\uD83E\uDD69 Edytor JSON": ()=>_router.GoToOrderRawEdit(order.Id),
            "\uD83D\uDDD1\uFE0F Usu\u0144": async ()=>{
                if (confirm("Czy na pewno chcesz usun\u0105\u0107 zam\xf3wienie? Sprawd\u017A czy wszystkie kroki zosta\u0142y wykonane i czy wszystko jest rozliczone (kasa, sprz\u0119t etc).")) {
                    await _manager.Delete(order);
                    new (0, $2s69t.Snack)("\u2611\uFE0F Zam\xf3wienie zosta\u0142o usuni\u0119te");
                    _router.GoToOrdersList();
                }
            }
        }, new (0, $2s69t.Button)("\u22EE").RemoveClass("uk-button").Class("menu-button"))))));
    }
}



var $2s69t = parcelRequire("2s69t");
class $7fb8fc45a70409da$export$e13c437cbdd0526a extends (0, $2s69t.Div) {
    constructor(order){
        super();
        this.Append(new (0, $2s69t.Div)("tab-content__title").Text("Notatka klienta"), new (0, $2s69t.MultilineInput)(order.Notes.Customer).Rows(6).Placeholder("Ten tekst nie b\u0119dzie widoczny dla klienta cho\u0107 zosta\u0142 przez niego napisany"), new (0, $2s69t.Div)("tab-content__title").Text("Notatka prywatna"), new (0, $2s69t.MultilineInput)(order.Notes.Private).Rows(6).Placeholder("Ten tekst nie b\u0119dzie widoczny dla klienta"), new (0, $2s69t.Div)("tab-content__title").Text("Notatka publiczna").MarginTop(16), new (0, $2s69t.MultilineInput)(order.Notes.Public).Rows(6).Placeholder("Ten tekst b\u0119dzie widoczny dla klienta!"));
    }
}


class $493d0ece97f0f37a$export$4b847dcea99313e extends (0, $2s69t.Div) {
    constructor(_manager, _router, _factory, _shop, orderId){
        super(), this._manager = _manager, this._router = _router, this._factory = _factory, this._shop = _shop, this.orderId = orderId;
        this.loader = new (0, $c4eaf041ea99f0bb$export$ed845e874be57a49)("Pobieranie zam\xf3wienia... Prosz\u0119 czeka\u0107");
        this.Append(this.loader);
    }
    async OnAppend() {
        try {
            const order = await this._manager.GetOne(this.orderId);
            this.loader.RemoveSelf();
            if (!order) {
                this.Append(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(`\u{1F625} Nie znaleziono zam\xf3wienia #${this.orderId?.toUpperCase()}
Jego adres jest niepoprawny albo zosta\u{142}o zamkni\u{119}te lub usuni\u{119}te.`).MarginTop(32));
                return;
            }
            const basketItems = order.Steps.Filter((x)=>x.Type === (0, $8eef7e9c8ac4e085$export$e577eac1d0078c6f).AddToBasket);
            const basket = new (0, $2s69t.Collection)(basketItems.map((x)=>x.Data.BasketItems.Items).flat());
            const shop = await this._shop.GetOne("Shop");
            if (!shop) {
                this.Append(new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(`\u{1F625} Nie znaleziono danych sklepu`));
                return;
            }
            const view = new (0, $2s69t.RefString)("Koszyk").Storable("admin-order-edit-tab");
            const tabs = new (0, $44c69e36ff118069$export$c3edd0c947539ceb)(view).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Basket, "Koszyk", ()=>new (0, $021196022e3a891f$export$8ad0f430ed2c70e8)(shop, basket, order.Notes.Customer.value)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Route, "Przebieg", ()=>new (0, $43dce7c075ea8b74$export$7e28910e6c64e11c)(this._factory, shop, order)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).User, "Ludzie", ()=>new (0, $089f9e02589009dd$export$d9ce5327b4d3732c)(order.People)).Add((0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Notes, "Notatki", ()=>new (0, $7fb8fc45a70409da$export$e13c437cbdd0526a)(order));
            this.Append(new (0, $b3cc17f319cfd1f4$export$e4913c9cda223d46)(this._router, this._manager, order), tabs);
        } catch (ex) {
            console.error(ex);
            new (0, $2s69t.Snack)(`\u{274C} Problem: ${ex.message}`);
            this.Append(new (0, $8421f066f4df449c$export$df2440bcd6ef2a5c)(`Problem`, `${ex.message}`));
        }
    }
}



var $2s69t = parcelRequire("2s69t");


class $a29e0accec041044$export$f14c0e3f98d164c0 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_formLogic){
        super("Logowanie", "admin-page"), this._formLogic = _formLogic;
        this.body.Style(`margin-top: 64px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;`);
    }
    async OnAppend() {
        if (this._formLogic.IsAuthorized) {
            this.body.Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("Jeste\u015B ju\u017C zalogowany", `Jako ${this._formLogic.User.Name}`), new (0, $2s69t.Button)("Wyloguj").WidthAuto().OnClick(()=>this._formLogic.Logout()));
            return;
        }
        const loginInput = new (0, $2s69t.TextInput)(this._formLogic.LoginInput).Color("#444").WidthAuto().BorderRadius(4).Placeholder("Login").OnEnterKeyPressed(async ()=>await this._formLogic.TryLogin());
        const passwordInput = new (0, $2s69t.PasswordInput)(this._formLogic.PasswordInput).Color("#444").StyleInput(`border-radius: 4px;`).TogglePasswordView().Placeholder("Has\u0142o").OnEnterKeyPressed(async ()=>await this._formLogic.TryLogin());
        const loginButton = new (0, $2s69t.Button)("Zaloguj").WidthAuto().Padding(8, 24).FontNormal().BorderRadius(4).FontSize(16).Disable(this._formLogic.LoginInProgress).OnClick(async ()=>await this._formLogic.TryLogin());
        this.body.Append(loginInput, passwordInput, loginButton, new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("B\u0142\u0105d", new (0, $2s69t.Text)(this._formLogic.ErrorMessage)).Visible(this._formLogic.ErrorMessageVisible));
    }
}


class $cf738602a5ebbb7f$export$1d94dfe0d9d1f1e7 {
    constructor(){
        this.status = void 0;
        this.data = void 0;
    }
}


class $ddd3270a0c5ca78c$export$9b9bb80223f42bd1 {
    constructor(){
        this.serverUrl = "https://email.specteam.pl";
    }
    async SendEmail(targetEmail, subject, message) {
        try {
            if (!targetEmail?.trim()) throw new Error(`No email address provided`);
            const postPackage = {
                Target: targetEmail.trim(),
                Subject: subject,
                Message: message
            };
            const result = await this.PostJSON(postPackage);
            return result.data == "SENT";
        } catch (ex) {
            return false;
        }
    }
    async PostJSON(data) {
        const httpResponse = new (0, $cf738602a5ebbb7f$export$1d94dfe0d9d1f1e7)();
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: dataAsString
        });
        httpResponse.status = response.status;
        const json = await response.text();
        httpResponse.data = json;
        return httpResponse;
    }
}


// WARNING! THOSE NAMES ARE CRITICAL FOR STORAGE. THEY ARE FOLDERS NAMES!
var $0c1fa2ba96dd2b8b$export$6c0517834721cef7 = /*#__PURE__*/ function(Env) {
    Env["Local"] = "Local";
    Env["Stage"] = "Stage";
    Env["Prod"] = "Prod";
    return Env;
}({});


class $f5b7e39314fbd69b$export$c962982833242e24 {
    constructor(_emailSender, _env){
        this._emailSender = _emailSender;
        this._env = _env;
    }
    async Notify(email, title, message) {
        await this._emailSender.SendEmail(email, title, message);
    }
    async NotifyOrderUpdate(order) {
        const customerEmail = order.People.Items.find((x)=>x.Email.value != "")?.Email.value;
        if (customerEmail) {
            let origin = "";
            let title = `specTeam.pl: Zmiana w zam\xf3wieniu #${order.ShortId}`;
            switch(this._env.Env){
                case (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Local:
                case (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Stage:
                    // origin = window.location.origin;
                    // break;
                    console.log("[Notifier] Notifications are disabled in test environment");
                    return;
                // origin = "https://stage.shop.specteam.pl";
                // break;
                case (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Prod:
                    origin = "https://shop.specteam.pl";
                    break;
            }
            await this.Notify(customerEmail, title, `Stan Twojego zam\xf3wienia #${order.ShortId} w\u{142}a\u{15B}nie si\u{119} zmieni\u{142} - <a href="${origin}#order/${order.Id}" target="_blank">Sprawd\u{17A} co si\u{119} zmieni\u{142}o</a>`);
        }
    }
}




class $e213f992906f9c3a$export$7bc334c5772eb68c {
    get Env() {
        // return Env.Prod;
        return this.env;
    }
    DetectEnv() {
        if (window.location.origin.includes("localhost")) return (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Local;
        else if (window.location.origin.includes("stage")) return (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Stage;
        else return (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Prod;
    }
    constructor(){
        this.env = void 0;
        this.env = this.DetectEnv();
    // console.log(`Assuming environment is ${this.Env}`);
    }
}



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");

class $38a08d9564c2e1fa$export$c43bfb5198aa7b21 extends (0, $2s69t.Button) {
    constructor(){
        super("");
        this.OnClick(()=>window.location.hash = "login");
        this.Append(new (0, $aa6902a8d95be5a7$export$e17b9c1182212c96)(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart navbar__icon"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="10" r="3"/><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/></svg>`));
    }
}



var $2s69t = parcelRequire("2s69t");
class $9dba8c14948f8920$export$eb464d4b5edff412 extends (0, $2s69t.Div) {
    constructor(_storage){
        super("user-section");
        const icon = new (0, $2s69t.RefString)(_storage.User.Icon || "\u26AA");
        const name = new (0, $2s69t.RefString)(_storage.User.Name || "Unknown");
        const role = new (0, $2s69t.RefString)(_storage.User.Role || "Unknown");
        _storage.OnUserChange((u)=>{
            icon.value = u.Icon;
            name.value = u.Name;
            role.value = u.Role;
        });
        this.Append(new (0, $2s69t.Text)(icon).Class("user-section__avatar"), new (0, $2s69t.Div)("user-section__info").Append(new (0, $2s69t.Text)(name).Class("user-section__name"), new (0, $2s69t.Text)(role).Class("user-section__role")));
    }
}


class $7ea7bb78ca77e218$export$a4cc7f57a60f8c44 extends (0, $2s69t.Div) {
    constructor(_storage, _router){
        super();
        const isUserAuthorized = new (0, $2s69t.RefBool)(false);
        _storage.OnUserChange((u, isAuthorized)=>{
            isUserAuthorized.value = isAuthorized;
        });
        const menu = {
            "\uD83D\uDD12 Wyloguj": ()=>{
                _storage.Logout();
                _router.GoToLogin();
            },
            "\uD83D\uDCB0 Wydatki": ()=>_router.GoToExpenses(),
            "\uD83D\uDC14 Agenci": ()=>_router.GoToAgentsPage()
        };
        const openMenuButton = new (0, $9dba8c14948f8920$export$eb464d4b5edff412)(_storage).VisibleWhen(isUserAuthorized, (v)=>v == true, "flex");
        this.Append(new (0, $38a08d9564c2e1fa$export$c43bfb5198aa7b21)().VisibleWhen(isUserAuthorized, (v)=>v == false), new (0, $2s69t.PopupMenu)(menu, openMenuButton));
    }
}


class $5116e3bbc73ef3a9$export$42d18e13b35290c3 extends (0, $2s69t.Div) {
    constructor(_storage, _router){
        super("header");
        this.Append(new (0, $2s69t.Div)("header__container").Append(new (0, $2s69t.Div)("header__content").Append(new (0, $2s69t.Div)("header__buttons").Append(new (0, $ccab16682f88d5ed$export$174d0791895a902d)("Zam\xf3wienia", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).List).OnClick(()=>_router.GoToOrdersList()), new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Dodaj", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus).OnClick(()=>_router.GoToOrderCreate())), new (0, $7ea7bb78ca77e218$export$a4cc7f57a60f8c44)(_storage, _router))));
    }
}





var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $cbe27bbe04e01a2b$export$66f77c162e6515a8 {
    constructor(raw){
        this.Category = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Amount = new (0, $2s69t.RefNumber)();
        this.When = new (0, $2s69t.RefDate)();
        this.Category.value = raw.Category || "";
        this.Description.value = raw.Description || "";
        this.Amount.value = raw.Amount || 0;
        this.When.value = new Date(raw.When || 0);
    }
    ToRaw() {
        return {
            Category: this.Category.value,
            Description: this.Description.value,
            Amount: this.Amount.value,
            When: this.When.value
        };
    }
}



class $f3bc05979579d1ac$export$cf2fd8b4b0fd611d extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    ConvertToRaw(expanses) {
        return (0, $2s69t.RefSerializer).Flatenize(expanses);
    }
    ConvertFromRaw(raw) {
        return raw.map((x)=>new (0, $cbe27bbe04e01a2b$export$66f77c162e6515a8)(x));
    }
}



var $2s69t = parcelRequire("2s69t");



class $9146b141d9987256$export$8636d79c975d2ba7 extends (0, $38988c1de85120c6$export$787a017fbb13560d) {
    constructor(text, icon, onClick){
        super("danger", text, icon, onClick);
    }
}






var $2s69t = parcelRequire("2s69t");
class $313fe1ee10fb406d$export$c72a9f92241b4b0 {
    constructor(Header, Mapping, AddWhen){
        this.Header = Header;
        this.Mapping = Mapping;
        this.AddWhen = AddWhen;
    }
}


class $810988d99afd3570$export$a7de6293698509b0 extends (0, $2s69t.Div) {
    constructor(data){
        super("better-table");
        this.dataView = void 0;
        this.columns = [];
        this.body = new (0, $2s69t.Div)("");
        this.whenEmpty = new (0, $2s69t.Span)("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");
        if (data && data instanceof Array) this.dataView = new (0, $2s69t.CollectionView)(new (0, $2s69t.Collection)(data)).Refresh();
        else if (data && data instanceof (0, $2s69t.Collection)) this.dataView = new (0, $2s69t.CollectionView)(data).Refresh();
        else if (data && data instanceof (0, $2s69t.CollectionView)) this.dataView = data;
        this.dataView?.AddSubscriber(this);
    }
    Reset() {
        this.columns = [];
        this.Clear();
        return this;
    }
    WhenEmpty(component) {
        this.whenEmpty = component;
        return this;
    }
    Refresh() {
        this.body.Clear();
        if (this.dataView?.Items?.length === 0) this.body.Append(this.whenEmpty);
        else this?.dataView?.Items?.forEach((record)=>{
            const row = new (0, $2s69t.Div)("row");
            this.columns.forEach((c)=>{
                if (c.AddWhen && !c.AddWhen(record)) {
                    // Add empty cell
                    const cell = new (0, $2s69t.Div)("cell");
                    // cell.Append(new Label(c.Header));
                    row.Append(cell);
                    return;
                }
                const cell = new (0, $2s69t.Div)("cell");
                const elem = c.Mapping(record, cell, row, this);
                let m;
                if (!Array.isArray(elem)) m = [
                    elem
                ];
                else m = elem;
                m.forEach((e)=>{
                    cell.Append(new (0, $2s69t.Label)(c.Header), e);
                });
                row.Append(cell);
            });
            this.body.Append(row);
        });
    }
    Build() {
        this.Append(new (0, $2s69t.Div)("row header").Append(...this.columns.map((x)=>new (0, $2s69t.Div)("cell").Append(...x.Header))));
        this.Refresh();
        this.Append(this.body);
        return this;
    }
    AddColumn(header, mapping, addWhen) {
        if (!Array.isArray(header)) header = [
            header
        ];
        this.columns.push(new (0, $313fe1ee10fb406d$export$c72a9f92241b4b0)(header, mapping, addWhen));
        return this;
    }
}
$810988d99afd3570$export$a7de6293698509b0.Name = "TableViewer";
$810988d99afd3570$export$a7de6293698509b0.DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";


class $f93878e18231845e$export$71cbf15472d22cc7 extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_exp){
        super("Wydatki"), this._exp = _exp;
        this.Content(async (body)=>{
            const expanses = await this._exp.GetAll();
            body.Append(new (0, $810988d99afd3570$export$a7de6293698509b0)(expanses).AddColumn("Kategoria", (x)=>new (0, $2s69t.Select)(x.Category, [
                    "Cz\u0119\u015Bci",
                    "Reklama",
                    "Prowizja Agent\xf3w",
                    "Narz\u0119dzia",
                    "Transport",
                    "Inne"
                ])).AddColumn("Wydatek", (x)=>new (0, $2s69t.TextInput)(x.Description)).AddColumn("Kwota", (x)=>new (0, $2s69t.NumberInput)(x.Amount)).AddColumn("Data", (x)=>new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)(x.When)).AddColumn("", (x)=>new (0, $9146b141d9987256$export$8636d79c975d2ba7)("Usu\u0144", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Trash, ()=>this._exp.Remove(x))).Build(), new (0, $2s69t.Div)().Append("Suma: ", new (0, $2s69t.Text)(this._exp.Sum)).Style("text-align: left; font-size: 1.5rem; font-weight: bold;"), new (0, $2s69t.Line)(), new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Dodaj wydatek", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, ()=>_exp.Add(new (0, $cbe27bbe04e01a2b$export$66f77c162e6515a8)({
                    Description: "",
                    Amount: 0,
                    When: new Date()
                }))), new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Zapisz zmiany", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Save, async ()=>{
                await this._exp.Save();
                new (0, $2s69t.Snack)("Zmiany zapisane");
            }));
        });
    }
}



var $2s69t = parcelRequire("2s69t");
class $f73ed3e19ec6eaba$export$5e8b634e523af342 {
    get Items() {
        return this.items;
    }
    get Sum() {
        return this.sum;
    }
    constructor(_expansesRepo){
        this._expansesRepo = _expansesRepo;
        this.items = new (0, $2s69t.Collection)();
        this.sum = new (0, $2s69t.RefNumber)();
    }
    RecalcSum() {
        // this.items.Items.forEach(e =>
        // e.Amount.OnChange((_) =>
        this.sum.value = this.items.Items.reduce((acc, x)=>acc + x.Amount.value, 0);
    // , true));
    }
    async GetAll() {
        const expanses = await this._expansesRepo.GetOne("Expanses");
        this.items.Load(...expanses);
        this.RecalcSum();
        return this.items;
    }
    async Add(expanse) {
        this.items.Add(expanse);
        this.RecalcSum();
        await this.Save();
    }
    async Remove(expanse) {
        this.items.Remove(expanse);
        this.RecalcSum();
        await this.Save();
    }
    async Save() {
        await this._expansesRepo.Update("Expanses", this.items.Items);
    }
}







var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $fabcfa43de44120c$export$2ecad7aad28ac73b {
    constructor(){
        this.GeneralPriceFactor = new (0, $2s69t.RefNumber)(1);
        this.DeliveryCostForPriceAbove300 = new (0, $2s69t.RefNumber)(25);
        this.DeliveryCostForPriceBelow300 = new (0, $2s69t.RefNumber)(1);
        this.Discounts = new (0, $2s69t.Collection)([]);
    }
}


class $7e3317d51d9165a4$export$9dd8876539768efc {
    constructor(){
        this.Id = "Shop";
        this.Logo = new (0, $2s69t.RefString)();
        this.AboutUsText = new (0, $2s69t.RefString)();
        this.AboutUsFaq = new (0, $2s69t.Collection)();
        this.ProductCategories = new (0, $2s69t.Collection)();
        this.Products = new (0, $2s69t.Collection)();
        this.BasketOptions = new (0, $fabcfa43de44120c$export$2ecad7aad28ac73b)();
        this.ContactTabs = new (0, $2s69t.Collection)();
        this.Contact = new (0, $2s69t.Collection)();
        this.RentalPageContentTabs = new (0, $2s69t.Collection)();
        this.RentalPageContent = new (0, $2s69t.Collection)();
    }
    get AvailableProducts() {
        return this.Products.Items.filter((x)=>x.Visible.value);
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $763cabb77827ba1d$export$7562e752e5ef1fad {
    constructor(raw){
        this.Question = new (0, $2s69t.RefString)();
        this.Answer = new (0, $2s69t.RefString)();
        this.Question.value = raw.Question;
        this.Answer.value = raw.Answer;
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");
class $9e91357c1c903dca$export$48e30329ded2268e {
    constructor(raw){
        this.OriginalUrl = new (0, $2s69t.RefString)();
        this.NormalizedUrl = new (0, $2s69t.RefString)();
        this.ThumbnailUrl = new (0, $2s69t.RefString)();
        this.MiniUrl = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.XOffset = new (0, $2s69t.RefNumber)();
        this.YOffset = new (0, $2s69t.RefNumber)();
        this.OriginalUrl.value = raw.OriginalUrl || "";
        this.NormalizedUrl.value = raw.NormalizedUrl || "";
        this.ThumbnailUrl.value = raw.ThumbnailUrl || "";
        this.MiniUrl.value = raw.MiniUrl || "";
        this.Description.value = raw.Description || "";
        this.XOffset.value = raw.XOffset || 0;
        this.YOffset.value = raw.YOffset || 0;
    }
}



var $2s69t = parcelRequire("2s69t");
class $30f733f1cb886bc6$export$9ad530ff9b116248 {
    constructor(raw){
        this.Rate = new (0, $2s69t.RefNumber)();
        this.Advantages = new (0, $2s69t.RefString)();
        this.Disadvantages = new (0, $2s69t.RefString)();
        this.Comment = new (0, $2s69t.RefString)();
        this.Author = new (0, $2s69t.RefString)();
        this.Rate.value = raw.Rate || -1;
        this.Advantages.value = raw.Advantages || "";
        this.Disadvantages.value = raw.Disadvantages || "";
        this.Comment.value = raw.Comment || "";
        this.Author.value = raw.Author || "";
    }
}



var $2s69t = parcelRequire("2s69t");
var $719d30ed0d363273$export$5c538aa0d3be3a90 = /*#__PURE__*/ function(PriceFactorMode) {
    PriceFactorMode["Multiply"] = "multiply";
    PriceFactorMode["Constant"] = "constant";
    return PriceFactorMode;
}({});


class $7ff3cf9f37b5637f$export$60e1d7099065e3ef {
    constructor(raw){
        this.Start = new (0, $2s69t.RefDate)();
        this.End = new (0, $2s69t.RefDate)();
        this.Mode = new (0, $2s69t.Ref)((0, $719d30ed0d363273$export$5c538aa0d3be3a90).Multiply);
        this.Value = new (0, $2s69t.RefNumber)(1);
        this.Info = new (0, $2s69t.RefString)("");
        this.Start.value = new Date(raw?.Start ?? 0);
        this.End.value = new Date(raw?.End ?? 0);
        this.Mode.value = raw?.Mode || (0, $719d30ed0d363273$export$5c538aa0d3be3a90).Multiply;
        this.Value.value = raw?.Value || 1;
        this.Info.value = raw?.Info || "";
    }
}



var $2s69t = parcelRequire("2s69t");
class $1dcdfb263c857902$export$81fb35662c98d436 {
    constructor(raw){
        this.Id = new (0, $2s69t.RefString)();
        this.Url = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Subtitle = new (0, $2s69t.RefString)();
        this.Image = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Visible = new (0, $2s69t.RefBool)(true);
        this.RelatedArticles = new (0, $2s69t.Collection)();
        this.Id.value = raw.Id || "";
        this.Url.value = raw.Url || "";
        this.Title.value = raw.Title || "";
        this.Subtitle.value = raw.Subtitle || "";
        this.Image.value = raw.Image || "";
        this.Description.value = raw.Description || "";
        this.Visible.value = raw.Visible ?? true;
        this.RelatedArticles.Load(...raw.RelatedArticles || []);
    }
    static NotFound() {
        return new $1dcdfb263c857902$export$81fb35662c98d436({
            Id: "",
            Title: "(brak kategorii)"
        });
    }
}




var $2s69t = parcelRequire("2s69t");
class $e2c991428fd8fb40$export$93c4b472b8e61039 {
    constructor(){
        this.List = new (0, $2s69t.Collection)();
    }
}



var $2s69t = parcelRequire("2s69t");
class $f362c075167967e1$export$702c536c4b65a073 {
    constructor(raw){
        this.Quantity = new (0, $2s69t.RefNumber)();
        this.Percent = new (0, $2s69t.RefNumber)();
        this.Quantity.value = raw.Quantity || 0;
        this.Percent.value = raw.Percent || 0;
    }
}



var $2s69t = parcelRequire("2s69t");
class $73f49f6d75efd7f9$export$b972827e986d3b65 {
    constructor(raw){
        this.Value = new (0, $2s69t.RefNumber)();
        this.Days = new (0, $2s69t.RefNumber)();
        this.Visible = new (0, $2s69t.RefBool)();
        this.Value.value = raw.Value || 0;
        this.Days.value = raw.Days || 0;
        this.Visible.value = raw.Visible || false;
    }
}



var $2s69t = parcelRequire("2s69t");
class $944977d1425b133b$export$3e41faf802a29e71 {
    constructor(raw){
        this.Id = new (0, $2s69t.RefString)();
        this.Icon = new (0, $2s69t.RefString)();
        this.Label = new (0, $2s69t.RefString)();
        this.IsVisible = new (0, $2s69t.RefBool)(true);
        this.Id.value = raw?.Id || "";
        this.Icon.value = raw?.Icon || "";
        this.Label.value = raw?.Label || "default";
        this.IsVisible.value = raw?.IsVisible || false;
    }
}



var $2s69t = parcelRequire("2s69t");


var $2s69t = parcelRequire("2s69t");
class $89624624a841cf3b$export$a455218a85c89869 {
    constructor(raw){
        this.Type = void 0;
        this.Visible = new (0, $2s69t.RefBool)(true);
        this.Tab = new (0, $2s69t.RefString)();
        this.Icon = new (0, $2s69t.RefString)();
        this.Header = new (0, $2s69t.RefString)();
        this.Style = new (0, $2s69t.RefString)();
        this.VisibleHeader = new (0, $2s69t.RefBool)(true);
        this.Visible.value = raw.Visible ?? true;
        this.Tab.value = raw.Tab || "default";
        this.Icon.value = raw.Icon || "";
        this.Header.value = raw.Header || "";
        this.VisibleHeader.value = raw.VisibleHeader ?? true;
        this.Style.value = raw.Style || "";
    }
}


var $86e23d096cc13e2d$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["Markdown"] = "Markdown";
    FieldType["Text"] = "Text";
    FieldType["Faq"] = "Faq";
    FieldType["Table"] = "Table";
    FieldType["Gallery"] = "Gallery";
    FieldType["Opinion"] = "Opinion";
    FieldType["TextWithPicture"] = "TextWithPicture";
    return FieldType;
}({});


class $8460b9aabd9ade95$export$a5b263448200bf07 extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Faq;
        this.Questions = new (0, $2s69t.Collection)();
        this.Questions.Load(...raw.Questions?.map((x)=>new (0, $763cabb77827ba1d$export$7562e752e5ef1fad)(x)) || []);
    }
}




var $2s69t = parcelRequire("2s69t");



class $7b35042f1ce111a0$export$f2577b57255d41 extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Gallery;
        this.Images = new (0, $2s69t.Collection)();
        this.Images.Load(...raw.Images?.map((x)=>new (0, $9e91357c1c903dca$export$48e30329ded2268e)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");


class $2bbce96e507a3305$export$5af8b454cf0a55a9 extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Markdown;
        this.Markdown = new (0, $2s69t.RefString)();
        this.Markdown.value = raw.Markdown || "";
    }
}



var $2s69t = parcelRequire("2s69t");



class $519736bad7d5daae$export$c5ef935f3c05dffb extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Opinion;
        this.Opinions = new (0, $2s69t.Collection)();
        this.Opinions.Load(...raw.Opinions?.map((x)=>new (0, $30f733f1cb886bc6$export$9ad530ff9b116248)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");



var $2s69t = parcelRequire("2s69t");
class $da53be8bf8a76f1a$export$8b0036ef4f4ccb34 {
    constructor(raw){
        this.Left = new (0, $2s69t.RefString)();
        this.Right = new (0, $2s69t.RefString)();
        this.Left.value = raw.Left || "";
        this.Right.value = raw.Right || "";
    }
}


class $354d07d30d85463f$export$5cefce85eae032bb extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Table;
        this.Rows = new (0, $2s69t.Collection)();
        this.Rows.Load(...raw.Rows?.map((x)=>new (0, $da53be8bf8a76f1a$export$8b0036ef4f4ccb34)(x)) || []);
    }
}



var $2s69t = parcelRequire("2s69t");


class $34d495643da4a718$export$2c73285ae9390cec extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).Text;
        this.Text = new (0, $2s69t.RefString)();
        this.Text.value = raw.Text || "";
    }
}



var $2s69t = parcelRequire("2s69t");


class $e7a9e27e3db296af$export$227a61a47ffe47e1 extends (0, $89624624a841cf3b$export$a455218a85c89869) {
    constructor(raw){
        super(raw);
        this.Type = (0, $86e23d096cc13e2d$export$ed12481c953b8653).TextWithPicture;
        this.Text = new (0, $2s69t.RefString)();
        this.PictureUrl = new (0, $2s69t.RefString)();
        this.PicturePosition = new (0, $2s69t.Ref)("left");
        this.Text.value = raw.Text || "";
        this.PictureUrl.value = raw.PictureUrl || "";
        this.PicturePosition.value = raw.PicturePosition || "left";
    }
}


class $26a2d0626f3035de$export$f6d490d3b7c1d484 {
    static ToClass(raw) {
        switch(raw.Type){
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Markdown:
                return new (0, $2bbce96e507a3305$export$5af8b454cf0a55a9)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Faq:
                return new (0, $8460b9aabd9ade95$export$a5b263448200bf07)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Gallery:
                return new (0, $7b35042f1ce111a0$export$f2577b57255d41)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Table:
                return new (0, $354d07d30d85463f$export$5cefce85eae032bb)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Text:
                return new (0, $34d495643da4a718$export$2c73285ae9390cec)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).TextWithPicture:
                return new (0, $e7a9e27e3db296af$export$227a61a47ffe47e1)(raw);
            case (0, $86e23d096cc13e2d$export$ed12481c953b8653).Opinion:
                return new (0, $519736bad7d5daae$export$c5ef935f3c05dffb)(raw);
            default:
                throw new Error(`[DescriptionFieldConverter] Unknown "${raw.Type}" description field type`);
        }
    }
}



class $8f6ae46eb2d6bf73$export$264ad599d7cef668 {
    constructor(raw){
        this.Id = "";
        this.Visible = new (0, $2s69t.RefBool)();
        this.Rentable = new (0, $2s69t.RefBool)();
        this.Saleable = new (0, $2s69t.RefBool)();
        this.Basketable = new (0, $2s69t.RefBool)();
        this.Options = new (0, $e2c991428fd8fb40$export$93c4b472b8e61039)();
        this.AddToBasketAs = new (0, $2s69t.Ref)((0, $4bebf6f7e0ab04af$export$39b11636c68d48ec).Unset);
        this.CategoryId = new (0, $2s69t.RefString)();
        this.Url = new (0, $2s69t.RefString)();
        this.Title = new (0, $2s69t.RefString)();
        this.Subtitle = new (0, $2s69t.RefString)();
        this.BasketName = new (0, $2s69t.RefString)();
        this.Tags = new (0, $2s69t.RefString)();
        this.RentPrices = new (0, $2s69t.Collection)();
        this.PriceFactor = new (0, $2s69t.Collection)();
        this.Discounts = new (0, $2s69t.Collection)();
        this.SalePrice = new (0, $2s69t.RefNumber)();
        this.Deposit = new (0, $2s69t.RefNumber)();
        this.Features = new (0, $2s69t.RefString)();
        this.Tabs = new (0, $2s69t.Collection)([
            new (0, $944977d1425b133b$export$3e41faf802a29e71)({
                Label: "Opis",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-presentation-icon lucide-presentation"><path d="M2 3h20"/><path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"/><path d="m7 21 5-5 5 5"/></svg>`
            }),
            new (0, $944977d1425b133b$export$3e41faf802a29e71)({
                Label: "Szczeg\u0142y",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-icon lucide-package"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/></svg>`
            }),
            new (0, $944977d1425b133b$export$3e41faf802a29e71)({
                Label: "FAQ i Opinie",
                Icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-microchip-icon lucide-microchip"><path d="M18 12h2"/><path d="M18 16h2"/><path d="M18 20h2"/><path d="M18 4h2"/><path d="M18 8h2"/><path d="M4 12h2"/><path d="M4 16h2"/><path d="M4 20h2"/><path d="M4 4h2"/><path d="M4 8h2"/><path d="M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z"/></svg>`
            })
        ]);
        this.Description = new (0, $2s69t.Collection)();
        this.Images = new (0, $2s69t.Collection)();
        this.Opinions = new (0, $2s69t.Collection)();
        this.Extras = new (0, $2s69t.Collection)();
        // TODO:
        this.TutorialLink = new (0, $2s69t.RefString)();
        this.Category = (0, $1dcdfb263c857902$export$81fb35662c98d436).NotFound();
        this.IsAvailable = new (0, $2s69t.RefBool)(true);
        this.StatusLabel = new (0, $2s69t.RefString)("\uD83D\uDFE2 Produkt dost\u0119pny");
        this.StatusColor = new (0, $2s69t.RefString)("#4ade80");
        this.ShowDiscounts = new (0, $2s69t.RefBool)(true);
        this.ShowExtraInfo = new (0, $2s69t.RefBool)(true);
        this.Rating = new (0, $2s69t.RefNumber)(5);
        this.Id = raw?.Id || "";
        this.Visible.value = raw?.Visible ?? true;
        this.Rentable.value = raw?.Rentable ?? false;
        this.Saleable.value = raw?.Saleable ?? false;
        this.Basketable.value = raw?.Basketable ?? false;
        this.AddToBasketAs.value = raw?.AddToBasketAs || (0, $4bebf6f7e0ab04af$export$39b11636c68d48ec).Unset;
        this.Options.List.Load(...raw?.Options?.List?.map((x)=>new (0, $d3c6f9c591ce1668$export$4d0262465775ab3)(x)) || []);
        this.CategoryId.value = raw?.CategoryId || "";
        this.Url.value = raw?.Url || "";
        this.Title.value = raw?.Title || "";
        this.Subtitle.value = raw?.Subtitle || "";
        this.BasketName.value = raw?.BasketName || "";
        this.Tags.value = raw?.Tags || "";
        if (raw?.RentPrices) this.RentPrices.Load(...raw.RentPrices.map((x)=>new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)(x)));
        else this.RentPrices.Load(new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)({
            Days: 3,
            Visible: true
        }), new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)({
            Days: 7,
            Visible: true
        }), new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)({
            Days: 14,
            Visible: true
        }), new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)({
            Days: 30
        }), new (0, $73f49f6d75efd7f9$export$b972827e986d3b65)({
            Days: 90
        }));
        if (raw?.PriceFactor) this.PriceFactor.Load(...raw.PriceFactor.map((x)=>new (0, $7ff3cf9f37b5637f$export$60e1d7099065e3ef)(x)));
        this.SalePrice.value = raw?.SalePrice || 0;
        this.Discounts.Load(...raw?.Discounts?.map((x)=>new (0, $f362c075167967e1$export$702c536c4b65a073)(x)) || []);
        this.Deposit.value = raw?.Deposit || 0;
        this.Features.value = raw?.Features || "";
        this.Tabs.Load(...raw?.Tabs?.map((x)=>new (0, $944977d1425b133b$export$3e41faf802a29e71)(x)) || []);
        this.Description.Load(...raw?.Description?.map((x)=>(0, $26a2d0626f3035de$export$f6d490d3b7c1d484).ToClass(x)) || []);
        this.Images.Load(...raw?.Images?.map((x)=>new (0, $9e91357c1c903dca$export$48e30329ded2268e)(x)) || []);
        this.Opinions.Load(...raw?.Opinions?.map((x)=>new (0, $30f733f1cb886bc6$export$9ad530ff9b116248)(x)) || []);
        this.TutorialLink.value = raw?.TutorialLink || "";
        this.StatusLabel.value = raw?.StatusLabel || "\uD83D\uDFE2 Produkt dost\u0119pny";
        this.StatusColor.value = raw?.StatusColor ?? $8f6ae46eb2d6bf73$export$264ad599d7cef668.StatusColors["Zielony"];
        this.ShowDiscounts.value = raw?.ShowDiscounts ?? true;
        this.ShowExtraInfo.value = raw?.ShowExtraInfo ?? true;
        this.Rating.value = raw?.Rating || 5;
    }
}
// per 5
$8f6ae46eb2d6bf73$export$264ad599d7cef668.StatusColors = {
    "Zielony": "#4ade80",
    "Czerwony": "#ef4444",
    "\u017B\xf3\u0142ty": "#eab308",
    "Niebieski": "#3b82f6",
    "Pomara\u0144czowy": "#fb923c",
    "Szary": "#6b7280",
    "Bia\u0142y": "#f3f4f6",
    "Czarny": "#000000"
};






var $2s69t = parcelRequire("2s69t");
var $93f3764e15503ef3$export$cf5ae448a4c90036 = /*#__PURE__*/ function(DiscountTarget) {
    DiscountTarget["WholeBasket"] = "whole-basket";
    DiscountTarget["RentalItems"] = "rental-items";
    DiscountTarget["SaleItems"] = "sale-items";
    DiscountTarget["SpecificItem"] = "specific-item";
    return DiscountTarget;
}({});


var $97289cb5476b2127$export$c20edc3521983dfc = /*#__PURE__*/ function(DiscountType) {
    DiscountType["Percent"] = "percent";
    DiscountType["LimitedPercent"] = "limited-percent";
    DiscountType["FixedPrice"] = "fixed-price";
    return DiscountType;
}({});


class $f7569d46621b8f16$export$5ee97a12e4b944d9 {
    // Max value in PLN when DiscountType.LimitedPercent is used
    constructor(raw){
        this.Type = new (0, $2s69t.Ref)((0, $97289cb5476b2127$export$c20edc3521983dfc).Percent);
        this.Target = new (0, $2s69t.Ref)((0, $93f3764e15503ef3$export$cf5ae448a4c90036).WholeBasket);
        this.Code = new (0, $2s69t.RefString)();
        this.Value = new (0, $2s69t.RefNumber)(0);
        // Percent or fixed price
        this.IsOn = new (0, $2s69t.RefBool)(false);
        this.IsVisible = new (0, $2s69t.RefBool)(true);
        this.Name = new (0, $2s69t.RefString)();
        this.Description = new (0, $2s69t.RefString)();
        this.Limit = new (0, $2s69t.RefNumber)(0);
        this.Type.value = raw?.Type || (0, $97289cb5476b2127$export$c20edc3521983dfc).Percent;
        this.Target.value = raw?.Target || (0, $93f3764e15503ef3$export$cf5ae448a4c90036).WholeBasket;
        this.Name.value = raw?.Name || "";
        this.Code.value = raw?.Code || "";
        this.Value.value = raw?.Value || 0;
        this.IsVisible.value = raw?.IsVisible || false;
        this.Description.value = raw?.Description || "";
        this.Limit.value = raw?.Limit || 0;
    }
    get AsRaw() {
        return {
            Name: this.Name.value,
            Code: this.Code.value,
            Value: this.Value.value,
            Type: this.Type.value,
            Target: this.Target.value,
            IsVisible: this.IsVisible.value,
            Description: this.Description.value,
            Limit: this.Limit.value
        };
    }
}



class $e1b313533b58ec13$export$5f0fddd75cd8dcd7 extends (0, $f7569d46621b8f16$export$5ee97a12e4b944d9) {
    constructor(raw){
        super(raw);
    }
    CalcValue(price) {
        switch(this.Type.value){
            case (0, $97289cb5476b2127$export$c20edc3521983dfc).Percent:
                return Math.round(price * (this.Value.value / 100));
            case (0, $97289cb5476b2127$export$c20edc3521983dfc).LimitedPercent:
                const percentValue = Math.round(price * (this.Value.value / 100));
                if (percentValue > this.Limit.value) return this.Limit.value;
                return percentValue;
            case (0, $97289cb5476b2127$export$c20edc3521983dfc).FixedPrice:
                return this.Value.value;
        }
    }
    AsString(price) {
        if (price == 0) return `${this.Value.value}% zni\u{17C}ki za ${this.Name.value}`;
        const discount = this.CalcValue(price).toFixed(0);
        return `${discount}z\u{142} zni\u{17C}ki za ${this.Name.value}`;
    }
}


class $22bf4abf66953369$export$29701ae0a05ea4be extends (0, $e4e5ebdfac92419f$export$c8c5e7182924d536) {
    ConvertToRaw(content) {
        return (0, $2s69t.RefSerializer).Flatenize(content);
    }
    ConvertFromRaw(raw) {
        const content = new (0, $7e3317d51d9165a4$export$9dd8876539768efc)();
        content.AboutUsText.value = this.GetString(raw.AboutUsText);
        content.AboutUsFaq.Load(...this.GetArray(raw.AboutUsFaq, (x)=>new (0, $763cabb77827ba1d$export$7562e752e5ef1fad)(x)));
        content.ProductCategories.Load(...this.GetArray(raw.ProductCategories, (x)=>new (0, $1dcdfb263c857902$export$81fb35662c98d436)(x)));
        content.Products.Load(...this.GetArray(raw.Products, (x)=>new (0, $8f6ae46eb2d6bf73$export$264ad599d7cef668)(x)));
        content.ContactTabs.Load(...this.GetArray(raw.ContactTabs, (raw)=>new (0, $944977d1425b133b$export$3e41faf802a29e71)(raw)));
        content.Contact.Load(...this.GetArray(raw.Contact, (raw)=>(0, $26a2d0626f3035de$export$f6d490d3b7c1d484).ToClass(raw)));
        content.RentalPageContentTabs.Load(...this.GetArray(raw.RentalPageContentTabs, (raw)=>new (0, $944977d1425b133b$export$3e41faf802a29e71)(raw)));
        content.RentalPageContent.Load(...this.GetArray(raw.RentalPageContent, (raw)=>(0, $26a2d0626f3035de$export$f6d490d3b7c1d484).ToClass(raw)));
        content.BasketOptions.GeneralPriceFactor.value = this.GetNumber(raw?.BasketOptions?.GeneralPriceFactor);
        content.BasketOptions.DeliveryCostForPriceAbove300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceAbove300);
        content.BasketOptions.DeliveryCostForPriceBelow300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceBelow300);
        content.BasketOptions.Discounts.Load(...this.GetArray(raw.BasketOptions?.Discounts, (raw)=>new (0, $e1b313533b58ec13$export$5f0fddd75cd8dcd7)(raw)));
        content.Logo.value = this.GetString(raw?.Logo);
        return content;
    }
}



class $17415602f8a6b568$export$30f3b99c5ac85dd8 {
    constructor(_tickets, _ticketToOrderConverter, _bitcoinPriceProvider){
        this._tickets = _tickets;
        this._ticketToOrderConverter = _ticketToOrderConverter;
        this._bitcoinPriceProvider = _bitcoinPriceProvider;
    }
    async Open(ticketId) {
        const ticket = await this._tickets.GetOne(ticketId);
        if (!ticket) return null;
        if (ticket.BasketPaymentForm == (0, $b4315c565ef22fe2$export$b6ded7c5f3fd9245).Crypto) await this._bitcoinPriceProvider.Update();
        const btcValueInPln = this._bitcoinPriceProvider.BtcValueInPln.value ?? -1;
        const order = this._ticketToOrderConverter.Convert(ticket, btcValueInPln);
        return order;
    }
    async OpenAll() {
        const tickets = await this._tickets.GetAll();
        return tickets.map((ticket)=>this._ticketToOrderConverter.Convert(ticket, this._bitcoinPriceProvider.BtcValueInPln.value ?? -1));
    }
    async Close(ticketId) {
        await this._tickets.Delete(ticketId);
    }
}



var $2s69t = parcelRequire("2s69t");
class $3055e7e52e29e391$export$ef5f0cf0168d8c43 {
    constructor(_storage){
        this._storage = _storage;
        this.onLogin = new (0, $2s69t.HandlersCollection)();
        this.onLogout = new (0, $2s69t.HandlersCollection)();
        this.LoginInput = new (0, $2s69t.RefString)().Storable("auth-form:login-input");
        this.PasswordInput = new (0, $2s69t.RefString)().Storable("auth-form:password-input");
        this.ErrorMessageVisible = new (0, $2s69t.RefBool)();
        this.LoginInProgress = new (0, $2s69t.RefBool)();
        this.ErrorMessage = new (0, $2s69t.RefString)();
        this.autologinSnack = void 0;
        this.autologinFailedSnack = void 0;
        this.PasswordInput.OnChange(()=>{
            this.ErrorMessageVisible.False();
        });
        this._storage.OnUserChange((user, isAuthorized)=>{
            if (!isAuthorized) this.onLogout.Call();
        });
    }
    get User() {
        return this._storage.User;
    }
    get IsAuthorized() {
        return this._storage.IsAuthorized;
    }
    ClearForm() {
        this.LoginInput.value = "";
        this.PasswordInput.value = "";
        this.ErrorMessageVisible.False();
        this.LoginInProgress.False();
        this.ErrorMessage.value = "";
    }
    ClearLoginInfo() {
        this.LoginInput.value = "";
        this.PasswordInput.value = "";
    }
    OnLogin(handler) {
        this.onLogin.Add(handler);
        return this;
    }
    OnLogout(handler) {
        this.onLogout.Add(handler);
        return this;
    }
    CleanUp() {
        this.autologinFailedSnack?.Close();
        this.autologinFailedSnack = undefined;
        this.autologinSnack?.Close();
        this.autologinSnack = undefined;
    }
    Logout() {
        this._storage.Logout();
    }
    async TryAutoLogin() {
        // this.autologinSnack = new Snack("⌛ Autologin in progress", "Checking for credentials...", { autoCloseTimeout: 10000, clickAnywhereToClose: true });
        // console.log("TryAutoLogin", this._storage.IsNotLoggedIn ? "Not logged in" : "Logged in");
        try {
            if (this._storage.IsNotLoggedIn) await this._storage.Login(this.PasswordInput.value, this.LoginInput.value);
            this.onLogin.Call(this._storage.User, true);
        } catch (ex) {
            const msg = ex.message.toLowerCase();
            let message;
            if (msg.includes("unauthorized")) message = "Unauthorized";
            else if (msg.includes("failed to fetch")) message = "Connection problem";
            else message = ex.message;
            this.autologinFailedSnack = new (0, $2s69t.Snack)("\u274C Autologin failed", message, {
                autoCloseTimeout: 0,
                clickAnywhereToClose: true
            });
        } finally{
            this.autologinSnack?.Close();
            this.autologinSnack = undefined;
        }
    }
    async TryLogin() {
        if (this.LoginInProgress.value) return false;
        if (!this.PasswordInput.value) {
            this.ShowErrorMessage("No password provided");
            return false;
        }
        this.ErrorMessageVisible.False();
        this.LoginInProgress.True();
        try {
            await this._storage.Login(this.PasswordInput.value, this.LoginInput.value);
            this.LoginInProgress.False();
            this.CleanUp();
            this.onLogin.Call(this._storage.User, false);
            return true;
        } catch (ex) {
            this.LoginInProgress.False();
            this.ShowErrorMessage("Failed to login");
            return false;
        }
    }
    ShowErrorMessage(message) {
        this.ErrorMessage.value = message;
        this.ErrorMessageVisible.True();
    }
}




var $2s69t = parcelRequire("2s69t");




class $b09be2e3368c4a30$export$344c3bc1fc12c3dd extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_router, _agents){
        super("Agenci"), this._router = _router, this._agents = _agents;
        this.Content(async (body)=>{
            body.Append(new (0, $810988d99afd3570$export$a7de6293698509b0)(this._agents.All).TextAlignLeft()// .AddColumn("Imię", x => `${x.Icon} ${x.Name} (${x.Phone})`)
            // .AddColumn("Stan", x => x.IsActive ? "✅ Aktywny" : "🔴 Nieaktywny")
            // .AddColumn("", x => new XPrimaryButton("Zadania", Icons.Calendar, () => this._router.GoToAgentTasks(x.Id)))
            // .AddColumn("", x => new Link("😴 Dezaktywuj").OnClick(() => x.IsActive = false))
            .AddColumn("Id", (x)=>x.Id.value).AddColumn("Icon", (x)=>new (0, $2s69t.TextInput)(x.Icon)).AddColumn("Name", (x)=>new (0, $2s69t.TextInput)(x.Name)).AddColumn("Phone", (x)=>new (0, $2s69t.TextInput)(x.Phone)).AddColumn("IsActive", (x)=>new (0, $2s69t.Checkbox)(x.IsActive)).AddColumn("", (x)=>new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Zapisz", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Save, async ()=>await this._agents.Save(x)))// .AddColumn("", x => new XPrimaryButton("Zadania", Icons.Calendar, () => this._router.GoToAgentTasks(x.Id)))
            .Build(), new (0, $ccab16682f88d5ed$export$8a19b280fefd0a15)("Dodaj agenta", (0, $e713613ae4567f75$export$4f13f83fd8bb1dac).Plus, async ()=>await this._agents.Add()));
        });
    }
}



var $2s69t = parcelRequire("2s69t");

var $2s69t = parcelRequire("2s69t");





var $2s69t = parcelRequire("2s69t");
class $2b75d1f3f4cead07$export$eb435fa4136c47cc extends (0, $2s69t.Div) {
    constructor(message){
        super();
        this.Style(`
            margin:32px;
            padding:32px;
            background-color: #f00;
            color: #fff;
            padding: 10px;
            border-radius: 5px;
        `);
        this.Text(message);
    }
}


class $926c0617c81bced7$export$830ed3eaa3bc6c1c extends (0, $2s69t.Div) {
    constructor(_manager, _agents, orders, filterByAgentId){
        super();
        if (!_agents.Get(filterByAgentId)) {
            this.Append(new (0, $2b75d1f3f4cead07$export$eb435fa4136c47cc)(`Agent o Id "${filterByAgentId}" nie istnieje`));
            return;
        }
        const stepsOrganizer = new (0, $435e5a76b8cbc27c$export$f98e131e69dbe944)();
        orders.Items.forEach((order)=>{
            order.OnChange(async ()=>{
                await _manager.Update(order);
                new (0, $2s69t.Snack)(`Zam\xf3wienie #${order.ShortId} zaktualizowane`);
            });
            const steps = order.Steps.Items;
            const markedSteps = (0, $2b9446962095951e$export$c036ee88a093a80c).Mark(steps);
            markedSteps.forEach((step)=>{
                const assignedAgentId = step.Step.Data.AssignedAgentId.value;
                stepsOrganizer.PutToBag(step);
            });
        });
        stepsOrganizer.Bags.map((bag)=>this.Append(new (0, $a6f9ac4860e2927f$export$4d82ce4c37371892)(bag.Title + ` (${bag.Size})`), new (0, $2s69t.Div)("blocks-container").Append(), bag.Size == 0 && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(`Brak zada\u{144} ${bag.Title.toLowerCase()}`).Italic().Color("#aaa")));
    }
}






class $62c0db3e1d791d34$export$351606a85e5d25ec extends (0, $225750fe3a94dddc$export$6955bcca4cd3539f) {
    constructor(_manager, _agents, agentId){
        super(`Zadania agenta ${agentId}`), this._manager = _manager, this._agents = _agents, this.agentId = agentId;
        this.Content(async (body)=>{
            const agent = this._agents.Get(this.agentId);
            if (!agent) {
                body.Append(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("Agent nie znaleziony", "Agent o ID ${this.agentId} nie istnieje"));
                return;
            }
            const orders = await this._manager.FetchAll((0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
            // orders.forEach(x => x.SelfSetup());
            const ordersCollection = new (0, $2s69t.Collection)(orders);
            body.Append(new (0, $a6f9ac4860e2927f$export$7f82016a969fb9d2)(`Zadania agenta ${agent.Name}`), new (0, $2s69t.Div)().ClearBoth(), new (0, $2s69t.Line)(), new (0, $926c0617c81bced7$export$830ed3eaa3bc6c1c)(this._manager, this._agents, ordersCollection, this.agentId));
        });
    }
}




class $6d5e54abe94229bf$export$f04a3ea04edc0e04 extends (0, $954c63c9dc3f7b9b$export$aff4fc93593c3bcf) {
    constructor(title, content){
        super(title, content, "#ff7795");
    }
}


(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))?.locale('pl');
(0, $2s69t.NumberInput).DefaultCssClasses = "uk-input uk-form-width-small";
(0, $2s69t.TextInput).DefaultCssClasses = "uk-input";
(0, $2s69t.Select).DefaultCssClasses = "uk-select";
(0, $2s69t.ModalWindow).DefaultCssClasses = "tf-modal-window";
(0, $2s69t.ModalWindow).Hook = (0, $2s69t.Root).Hook;
(0, $2s69t.MultilineInput).DefaultCssClasses = "uk-textarea";
(async ()=>{
    const root = new (0, $2s69t.Root)("body");
    try {
        const _env = new (0, $e213f992906f9c3a$export$7bc334c5772eb68c)();
        console.log("Environment: ", _env.Env, ", Clock: ", (0, $b4452d9087ebde99$export$761b8f8bbc165703).Now);
        let storage;
        if (_env.Env === (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Prod) {
            window.localStorage.setItem("app-rtc-fake", "false");
            window.localStorage.setItem("orders-set", (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
            storage = "https://storage.specteam.pl/v5/";
        } else if (_env.Env === (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Stage) {
            window.localStorage.setItem("app-rtc-fake", "false");
            window.localStorage.setItem("orders-set", (0, $7e7a2993af6be382$export$f3cfc706d4531aed).Open);
            storage = "https://stage.storage.specteam.pl/v5/";
        } else if (_env.Env === (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Local) {
            (0, $b4452d9087ebde99$export$761b8f8bbc165703).UseFake((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))("2025-02-05 12:00:00").toDate());
            (0, $b4452d9087ebde99$export$761b8f8bbc165703).UseFakeSwitch.Storable("app-rtc-fake");
            (0, $b4452d9087ebde99$export$761b8f8bbc165703)._now.Storable("app-rtc").OnChange((v)=>pagesSwitcher.Refresh());
            storage = "http://localhost/storageV5/";
        }
        const db = "Specteam";
        const _storage = new (0, $ae1a5cf54ffb33b6$export$5d991cdc62928edb)(storage, db);
        const _shopConverter = new (0, $22bf4abf66953369$export$29701ae0a05ea4be)();
        const _shopRepo = new (0, $75f1f7875a1df277$export$627789366574b89f)(_storage, "Shop", _shopConverter);
        const _agentsRepo = new (0, $75f1f7875a1df277$export$627789366574b89f)(_storage, "Agents", new (0, $fcd2bbe34e7586a6$export$eb219aab84de4915)());
        const _agents = new (0, $fcd2bbe34e7586a6$export$fff954b99dc26ba5)(_agentsRepo);
        await _agents.Init();
        const _stepFactory = new (0, $f017c95ae7521c79$export$f77d2c4be60c7eb6)(_agents);
        const _orderConverter = new (0, $94c672300ad3597b$export$ffc1669e9aabf849)(_stepFactory);
        const _orders = new (0, $58876721d3f329ea$export$33b832977b7a4586)(_storage, [
            "OpenOrders",
            "ClosedOrders"
        ], _orderConverter);
        const _ticketConverter = new (0, $32786e3a7ad3fec1$export$d73fce08fd84e72d)(_stepFactory);
        const _ticketsRepo = new (0, $75f1f7875a1df277$export$627789366574b89f)(_storage, "Tickets");
        const _bitcoinPriceProvider = new (0, $7aa14dd86653b561$export$f7e8c346445ef7be)();
        const _tickets = new (0, $17415602f8a6b568$export$30f3b99c5ac85dd8)(_ticketsRepo, _ticketConverter, _bitcoinPriceProvider);
        const _loginLogic = new (0, $3055e7e52e29e391$export$ef5f0cf0168d8c43)(_storage).OnLogin((user, autologin)=>{
            if (user.Role.toLowerCase().startsWith("admin")) window.location.hash = "orders";
        }).OnLogout(()=>{
            _loginLogic.ClearLoginInfo();
        // window.location.hash = "/";
        });
        await _loginLogic.TryAutoLogin();
        const _emailSender = new (0, $ddd3270a0c5ca78c$export$9b9bb80223f42bd1)();
        const _notifier = new (0, $f5b7e39314fbd69b$export$c962982833242e24)(_emailSender, _env);
        const hash = new (0, $2s69t.HashRef)().Storable("hash");
        const _router = new (0, $e13c3ababb4ac8b8$export$55185c17a0fcbe46)(hash);
        const _manager = new (0, $d6f9328a5971026b$export$78f811e9b2083add)(_orders, _tickets, _notifier);
        const pagesSwitcher = new (0, $2s69t.DestroyingPatternContentSwitcher)(hash).AddContent("login", ()=>new (0, $a29e0accec041044$export$f14c0e3f98d164c0)(_loginLogic)).AddContent("order/:orderId", ({ orderId: orderId })=>new (0, $07c5f95939e760d3$export$d294212a2467781a)(_manager, orderId)).AddContent("agent/:agentId/tasks", ({ agentId: agentId })=>new (0, $62c0db3e1d791d34$export$351606a85e5d25ec)(_manager, _agents, agentId));
        const _expansesRepo = new (0, $75f1f7875a1df277$export$627789366574b89f)(_storage, "Expanses", new (0, $f3bc05979579d1ac$export$cf2fd8b4b0fd611d)());
        const _expansesProvider = new (0, $f73ed3e19ec6eaba$export$5e8b634e523af342)(_expansesRepo);
        pagesSwitcher.AddContent("admin/agents", ()=>new (0, $b09be2e3368c4a30$export$344c3bc1fc12c3dd)(_router, _agents)).AddContent("orders", ()=>new (0, $ad2cf527d68e2da3$export$a0a410c8a79d52b9)(_manager, _router, _agents)).AddContent("admin/expanses", ()=>new (0, $f93878e18231845e$export$71cbf15472d22cc7)(_expansesProvider)).AddContent("order-creation/:id", ({ id: id })=>new (0, $4c1dc4e94dbb2144$export$27ac7d0fb8609e64)(_manager, _stepFactory, _shopRepo, id)).AddContent("order-creation", ()=>new (0, $4c1dc4e94dbb2144$export$27ac7d0fb8609e64)(_manager, _stepFactory, _shopRepo)).AddContent("admin/order/view/:orderId", ({ orderId: orderId })=>new (0, $6dbe8d516d0a5f1c$export$f0cfa2e7816d5089)(_manager, _router, _agents, orderId)).AddContent("admin/order/raw/:orderId", ({ orderId: orderId })=>new (0, $d3bd4eaa5763c9cf$export$b7eeec5db3309796)(_manager, orderId)).AddContent("admin/order/edit/:orderId", ({ orderId: orderId })=>new (0, $493d0ece97f0f37a$export$4b847dcea99313e)(_manager, _router, _stepFactory, _shopRepo, orderId));
        pagesSwitcher.AddDefaultContent(()=>new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("B\u0142\u0119dny adres", "Nic tu nie ma lub nie jeste\u015B zalogowany"));
        pagesSwitcher.Refresh();
        root.Class("main").Append(_storage.IsAuthorized && _env.Env === (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Prod && window.location.origin.includes("localhost") && new (0, $d5372390156ec6d7$export$1f54913ccc4368b1)(new (0, $e8b1084b28a2a5a4$export$aff4fc93593c3bcf)("\u26A0\uFE0F Produkcyjne dane na \u015Brodowisku testowym", "Uwaga! Jeste\u015B w \u015Brodowisku testowym, ale za\u0142adowane s\u0105 dane z produkcji. Wszystkie zmiany b\u0119d\u0105 widoczne dla klient\xf3w.").Margin(0), new (0, $2s69t.Checkbox)((0, $b4452d9087ebde99$export$761b8f8bbc165703).UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(), new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)((0, $b4452d9087ebde99$export$761b8f8bbc165703)._now).DisplayInlineBlock()), _storage.IsAuthorized && _env.Env === (0, $0c1fa2ba96dd2b8b$export$6c0517834721cef7).Stage && new (0, $dca4a10ada8bf906$export$e71c4d32a2263218)(new (0, $2s69t.Span)("@ " + _env.Env).FontSize(22).MarginRight(32), new (0, $2s69t.Checkbox)((0, $b4452d9087ebde99$export$761b8f8bbc165703).UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(), new (0, $83a2f85696aa83bc$export$d24d2f8bbf3c93d4)((0, $b4452d9087ebde99$export$761b8f8bbc165703)._now).DisplayInlineBlock().Background("#222").Color("#eee")).Background("#111").Color("#eee").Padding(8).WidthPercent(100), _storage.IsAuthorized && new (0, $5116e3bbc73ef3a9$export$42d18e13b35290c3)(_storage, _router), new (0, $2s69t.Div)("main__container").Append(pagesSwitcher));
    } catch (error) {
        console.error(error);
        root.Append(new (0, $6d5e54abe94229bf$export$f04a3ea04edc0e04)("B\u0142\u0105d", error.message));
    }
})();


//# sourceMappingURL=index.35789fa1.js.map
